{
  "reporting.title": "Custom Data Export",
  "reporting.description": "Choose your report, reporting period and columns, then download a spreadsheet-ready CSV.",
  "reporting.builder": "Back to report builder",
  "reporting.queue": "My Report Queue",
  "reporting.queueEmpty": "Your generated reports will appear here.",
  "reporting.design.emptyQueuePage": "There are no reports on this page.",
  "reporting.design.firstQueuePage": "Return to the first page",
  "reporting.reportType": "Report type",
  "reporting.layout": "CSV layout",
  "reporting.layout.SPREADSHEET": "Spreadsheet — tests in columns",
  "reporting.layout.RESULT_LIST": "Detailed list — results in rows",
  "reporting.layout.TABLE": "Table",
  "reporting.meaning.SPREADSHEET": "Tests appear as columns for each specimen. Repeated results use extra rows; unrelated repeat readings are kept separate.",
  "reporting.meaning.RESULT_LIST": "Each independent result appears on its own row. Repeated results are preserved.",
  "reporting.meaning.TABLE": "Each recorded occurrence appears on its own row.",
  "reporting.dateFrom": "Date from",
  "reporting.dateTo": "Date to",
  "reporting.dates.required": "Required",
  "reporting.dates.requiredFrom": "Choose a start date.",
  "reporting.dates.requiredTo": "Choose an end date.",
  "reporting.dates.invalid": "Choose a valid calendar date.",
  "reporting.dates.reversed": "End date must be on or after the start date.",
  "reporting.dates.tooLong": "Choose a period of {days} days or fewer, including both dates.",
  "reporting.dates.range": "Choose an ordered period within the maximum shown above.",
  "reporting.periodHelp": "Uses {dateMeaning} in {timezone}, including both dates. Maximum period: {days} days.",
  "reporting.dateAnchor.collectionDate": "specimen collection dates",
  "reporting.dateAnchor.requestDate": "referral request dates",
  "reporting.dateAnchor.sentDate": "referral sent dates",
  "reporting.dateAnchor.eventOrRecordedDate": "event dates when known, otherwise recorded dates (identified by Date Basis)",
  "reporting.dateAnchor.dateOfEvent": "non-conformance event dates",
  "reporting.dateAnchor.enteredDate": "recorded rejection dates",
  "reporting.labSections": "Lab sections",
  "reporting.allAccessibleSections": "All accessible lab sections",
  "reporting.tests": "Pemeriksaan",
  "reporting.allTests": "All tests",
  "reporting.resultStatuses": "Result statuses",
  "reporting.finalized": "Difinalisasi",
  "reporting.all": "Semua",
  "reporting.available": "Available columns",
  "reporting.search": "Search columns",
  "reporting.selected": "Selected columns",
  "reporting.selectedCount": "Selected columns ({count})",
  "reporting.group.sample": "Sample and order",
  "reporting.group.referrals": "Rujukan",
  "reporting.group.nonConformance": "Non-Conformance / Rejections",
  "reporting.group.patient": "Pasien",
  "reporting.group.result": "Result details",
  "reporting.group.tests": "Configured tests",
  "reporting.group.components": "Configured result components",
  "reporting.group.turnaround": "Turnaround time",
  "reporting.group.testTurnaround": "Turnaround by test",
  "reporting.group.componentTurnaround": "Turnaround by result component",
  "reporting.group.observations": "Additional questions",
  "reporting.headerPreview": "CSV header preview",
  "reporting.moveUp": "Move {field} up",
  "reporting.moveDown": "Move {field} down",
  "reporting.remove": "Remove {field}",
  "reporting.position": "{field}: position {position} of {count}",
  "reporting.review": "Review report",
  "reporting.edit": "Edit report",
  "reporting.generate": "Membuat File CSV",
  "reporting.submitting": "Submitting report…",
  "reporting.generating": "Preparing your CSV…",
  "reporting.download": "Download CSV",
  "reporting.loading": "Loading report options…",
  "reporting.currentReport": "Your current report",
  "reporting.previous": "Sebelumnya",
  "reporting.next": "Berikutnya",
  "reporting.rows": "{count, plural, one {# row} other {# rows}}",
  "reporting.state.QUEUED": "Queued",
  "reporting.state.GENERATING": "Generating",
  "reporting.state.READY": "Ready to download",
  "reporting.state.FAILED": "Gagal",
  "reporting.state.EXPIRED": "Kedaluwarsa",
  "reporting.state.CANCELLED": "Dibatalkan",
  "reporting.loadError": "Could not load reporting information",
  "reporting.submitError": "Could not generate the report",
  "reporting.requestError": "The request could not be completed. Your choices have been retained; try again.",
  "reporting.networkError": "The server could not be reached. Your choices have been retained; try again.",
  "reporting.request.invalid": "Check your reporting period, filters and selected columns, then try again.",
  "reporting.request.conflict": "This submission identifier was already used for different report choices. Start a new report.",
  "reporting.columns.stale": "Some selected columns are no longer available. Remove them and choose from the current catalog.",
  "reporting.jobs.limit": "You have reached the active-report limit. Wait for a report to finish, then try again.",
  "reporting.access.denied": "Your current OpenELIS access does not permit this report.",
  "reporting.access.scopeChanged": "Your access to the selected lab sections has changed. Review the report with your current access.",
  "reporting.access.noSections": "No accessible lab sections are available for this report.",
  "reporting.access.signIn": "Sign in to OpenELIS to continue.",
  "reporting.definition.changed": "The report definition has changed. Review the current report options before running again.",
  "reporting.definition.unavailable": "This report type is no longer available.",
  "reporting.tests.stale": "Some selected tests are no longer available. Review your test selection.",
  "reporting.status.invalid": "Choose an available result status.",
  "reporting.filters.unsupported": "Some requested filters are unavailable for this report. Review the current report options.",
  "reporting.filters.unavailable": "Some previous filters are unavailable for this report. Review the current filters before generating.",
  "reporting.job.generationFailed": "The CSV could not be generated. Your report request has been retained.",
  "reporting.job.expired": "This file has expired. Run the report again with a new reporting period.",
  "reporting.job.notReady": "This report is not ready to download yet.",
  "reporting.job.notFound": "This report could not be found.",
  "reporting.saved.library": "Shared reports",
  "reporting.saved.search": "Search shared reports",
  "reporting.saved.loading": "Loading shared reports…",
  "reporting.saved.loadError": "Could not load shared reports",
  "reporting.saved.empty": "No shared reports have been saved yet.",
  "reporting.saved.shared": "Available to everyone who can use reports.",
  "reporting.saved.open": "Buka",
  "reporting.saved.save": "Save report",
  "reporting.saved.update": "Update shared report",
  "reporting.saved.copy": "Save a copy",
  "reporting.saved.delete": "Delete shared report",
  "reporting.saved.name": "Report name",
  "reporting.saved.confirmSave": "Save shared report",
  "reporting.saved.confirmDelete": "Hapus",
  "reporting.saved.confirmUpdate": "Perbarui",
  "reporting.saved.cancel": "Batal",
  "reporting.saved.copyName": "Salinan dari {name}",
  "reporting.saved.created": "Saved as {name}.",
  "reporting.saved.updated": "Updated {name}.",
  "reporting.saved.freshDates": "Choose fresh dates before running this report.",
  "reporting.saved.deleteHelp": "Delete {name} from the shared report library? Existing generated files are retained.",
  "reporting.saved.updateHelp": "Replace {name} with the choices currently shown in the builder?",
  "reporting.saved.changed": "Someone changed this shared report after you opened it. Your choices are still here; reopen the current saved report or save a copy.",
  "reporting.saved.invalid": "Review the report choices before saving.",
  "reporting.saved.nameInvalid": "Enter a report name of 200 characters or fewer.",
  "reporting.saved.notFound": "This shared report is no longer available.",
  "reporting.saved.pageInvalid": "The shared report list request was invalid.",
  "accept.action.button": "Setuju",
  "accessDenied.message": "Anda tidak memiliki akses pada modul ini. Silahkan kontak admin sistem.",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Akses ditolak",
  "accession.entry": "Masukkan Nomor Registrasi",
  "activityReportByPanel": "Laporan aktivitas berdasarkan Panel",
  "activityReportByTest": "Laporan aktivitas berdasarkan Pemeriksaan",
  "activityReportByTestSection": "Laporan aktivitas berdasarkan Bagian Pemeriksaan",
  "add.age.range": "Tambah Rentang Umur lainnya +",
  "add.aliquot": "Tambah Alikuot",
  "add.new.dictionary.menu": "Tambah Menu Kamus Baru",
  "address.search.label": "Cari Alamat",
  "adjustment.button": "Sesuaikan Kuantitas",
  "adjustment.newQuantity": "Kuantitas Baru",
  "adjustment.notes": "Catatan",
  "adjustment.notes.placeholder": "Sedialan rincian penyesuaian ini",
  "adjustment.reason": "Alasan Penyesuaian",
  "adjustment.reason.select": "Pilih Alasan",
  "adjustment.success": "Kuantitas lot berhasil disesuaikan",
  "adjustment.title": "Sesuaikan Kuantitas Lot",
  "admin.dashboard.subtitle": "Pilih area administrasi untuk dikonfigurasi",
  "admin.dashboard.title": "Dasbor admin",
  "admin.formEntryConfig": "Konfigurasi Umum",
  "admin.programs.title": "Program",
  "admin.programs.subtitle": "The initiatives that orders are filed under — each with a domain, one or more lab units, and an optional order-entry questionnaire.",
  "admin.programs.add": "Tambah Program",
  "admin.programs.search": "Search by name",
  "admin.programs.selector.new": "Program Baru",
  "admin.programs.row.expand.aria": "Edit program",
  "admin.programs.row.actions.aria": "Program actions",
  "admin.programs.list.column.name": "Nama",
  "admin.programs.list.column.domain": "Domain",
  "admin.programs.list.column.active": "Status",
  "admin.programs.list.column.units": "Lab unit(s)",
  "admin.programs.list.status.active": "Aktif",
  "admin.programs.list.status.inactive": "Inaktif",
  "admin.programs.list.filter.domain.label": "Domain",
  "admin.programs.list.filter.domain.all": "Semua domain",
  "admin.programs.list.toggle.showDeactivated": "Tampilkan sudah inaktif",
  "admin.programs.action.deactivate": "Nonaktifkan",
  "admin.programs.action.reactivate": "Aktifkan Ulang",
  "admin.programs.deactivate.modal.title": "Deactivate this Program?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" has no orders and will simply stop appearing for new orders. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.confirm": "Nonaktifkan",
  "admin.programs.deactivate.modal.cancel": "Batal",
  "admin.programs.reactivate.success": "{programName} reactivated",
  "admin.programs.deactivate.success": "{programName} deactivated",
  "admin.programs.domain.confirm.heading": "Change Program Domain?",
  "admin.programs.domain.confirm.body": "Historical orders were evaluated against the {from} domain's rules. Changing to {to} is forward-looking: existing orders keep their program coding and are not re-coded, and the program will only be offered on {to} orders from now on.",
  "admin.programs.list.empty": "No programs match the current search and filters.",
  "admin.programs.basicInfo.labUnits.selectAll": "Select all",
  "admin.programs.basicInfo.labUnits.placeholder": "Type to filter lab units",
  "orderEntry.programPicker.empty": "No programs are currently active. An administrator can activate one under Admin › Programs.",
  "orderEntry.programPicker.empty.domain": "No {domain} programs are currently active. An administrator can activate one under Admin › Programs.",
  "admin.programs.basicInfo.programName.label": "Nama Program",
  "admin.programs.basicInfo.programName.placeholder": "e.g. HBV Antenatal Screening",
  "admin.programs.basicInfo.code.label": "Programme Code",
  "admin.programs.basicInfo.code.placeholder": "e.g. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Use letters, digits, spaces, or underscores only.",
  "admin.programs.basicInfo.programName.tooLong": "Use at most {max} characters.",
  "admin.programs.basicInfo.labUnits.label": "Lab unit(s)",
  "admin.programs.basicInfo.domain.label": "Domain",
  "admin.programs.basicInfo.domain.required": "Domain wajib diisi",
  "admin.programs.editor.status.label": "Status:",
  "admin.programs.guidance.domain.toggle.show": "What does each Domain mean?",
  "admin.programs.guidance.domain.toggle.hide": "Hide",
  "admin.programs.guidance.domain.clinical": "Patient testing — form captures patient identifiers, provider, prior history.",
  "admin.programs.guidance.domain.environmental": "Compliance/surveillance sampling (water, food, air). No patient fields.",
  "admin.programs.guidance.domain.vector": "Specimen surveillance (mosquito, tick) — species, pool manifest.",
  "admin.programs.guidance.gui.emptyState.body": "No questions yet — add questions one at a time, or paste a Questionnaire in JSON mode.",
  "admin.programs.guidance.gui.emptyState.action": "Add First Question",
  "admin.programs.guidance.json.referenceCard.format": "Format: FHIR R4 Questionnaire",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "— allowed item.type: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Visual Builder",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Question Text",
  "admin.programs.questionnaire.question.type.label": "Question Type",
  "admin.programs.questionnaire.question.addNew": "Add New Question",
  "admin.programs.questionnaire.question.actions.aria": "Question actions",
  "admin.programs.questionnaire.question.actions.delete": "Delete question",
  "admin.programs.questionnaire.answerOptions.section.title": "Answer options",
  "admin.programs.questionnaire.answerOptions.addOption": "Tambah opsi",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Delete option",
  "admin.programs.questionnaire.answerOptions.empty": "No options yet — add at least one so reception can pick a value.",
  "admin.programs.questionnaire.answerOptions.coded": "coded",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Coded options come from a terminology and are shown read-only here. Edit them in JSON mode.",
  "admin.programs.questionnaire.preview.label": "Contoh",
  "admin.programs.questionnaire.preview.empty": "No questions yet — start adding questions to see the preview.",
  "admin.programs.questionnaire.preview.untitled": "(untitled)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Yes ◯ No",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "number",
  "admin.programs.questionnaire.preview.quantity.unit": "unit",
  "admin.programs.questionnaire.json.validate": "Validate JSON",
  "admin.programs.questionnaire.json.reformat": "Reformat",
  "admin.programs.questionnaire.json.validated": "Validated — {count} question(s)",
  "admin.programs.questionnaire.json.error.title": "Invalid Questionnaire",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType must be \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item must be an array",
  "admin.programs.questionnaire.json.error.itemShape": "each item must have linkId, text, and type in [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "duplicate linkId \"{linkId}\" — each item must have a unique linkId",
  "admin.programs.guidance.json.referenceCard.advanced": "Advanced features (enableWhen, Quantity units via unit/unitOption, nested items) are edited here in JSON — the Visual Builder preserves them but does not surface them.",
  "admin.programs.basicInfo.domain.helper": "Controls where this program appears — reception only sees programs matching the order's domain.",
  "admin.programs.editor.status.noHardDelete": "No hard delete — deactivate preserves history.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. {orderCount, plural, one {Its # historical order keeps its program coding} other {Its # historical orders keep their program coding}} and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. Historical orders keep their program coding and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.questionnaire.question.unsupported": "This is a \"{type}\" item, which this builder does not edit. It is kept exactly as it is when you save. Edit it in JSON mode.",
  "admin.programs.questionnaire.question.type.boolean": "Yes / No",
  "admin.programs.questionnaire.question.type.choice": "Choice",
  "admin.programs.questionnaire.question.type.checkbox": "Checkbox",
  "admin.programs.questionnaire.question.type.integer": "Whole number",
  "admin.programs.questionnaire.question.type.decimal": "Decimal number",
  "admin.programs.questionnaire.question.type.date": "Tanggal",
  "admin.programs.questionnaire.question.type.time": "Waktu",
  "admin.programs.questionnaire.question.type.string": "Short text",
  "admin.programs.questionnaire.question.type.text": "Long text",
  "admin.programs.questionnaire.question.type.quantity": "Kuantitas",
  "admin.programs.questionnaire.question.typeExample.boolean": "Yes/no answer. Example: \"First antenatal visit?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "One option from a fixed list. Example: \"Specimen condition\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Multiple options can be selected. Example: \"Symptoms present\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Whole numbers only. Example: \"Gestational age (weeks)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Numbers with decimals. Example: \"Maternal weight (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Calendar date. Example: \"Date of last menstrual period\".",
  "admin.programs.questionnaire.question.typeExample.time": "Time of day. Example: \"Time of sample collection\".",
  "admin.programs.questionnaire.question.typeExample.string": "Short free-text. Example: \"Provider name\".",
  "admin.programs.questionnaire.question.typeExample.text": "Long free-text. Example: \"Clinical notes\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "A number plus a unit (e.g. \"Volume collected — 5 mL\"). The allowed unit(s) come from a FHIR extension set in JSON mode; a GUI-only Quantity accepts any unit.",
  "admin.config.logo.error.fileTooLarge": "Gambar terlalu besar. Ukuran maksimum 2 MB.",
  "admin.config.logo.formats": "Format: JPG, PNG, GIF (maks 2MB)",
  "admin.label": "Admin",
  "admin.labUnit.basicInfo.domain.clinical": "Klinis",
  "admin.labUnit.basicInfo.domain.environmental": "Lingkungan",
  "admin.labUnit.basicInfo.domain.label": "Domain",
  "admin.labUnit.basicInfo.domain.vector": "Vektor",
  "admin.labUnit.domain.confirm.body": "Pemesanan/hasil sebelumnya telah dievaluasi berdasarkan aturan domain sebelumnya. Pemesanan baru akan menggunakan aturan domain yang baru.",
  "admin.labUnit.domain.confirm.heading": "Mengubah Domain Instalasi Lab?",
  "admin.labUnit.edit.select": "Pilih Instalasi Lab",
  "admin.labUnit.edit.title": "Edit Instalasi Lab Domain",
  "admin.labUnit.list.filter.domain": "Saring berdasarkan Domain",
  "admin.legacy": "Admin Versi Lama",
  "button.back": "← Kembali ke Daftar",
  "button.labUnit.add": "Tambahkan Instalasi Lab",
  "button.labUnit.create": "Buat Instalasi Lab",
  "button.labUnit.creating": "Membuat...",
  "button.labUnit.tests.assign": "Menugaskan Pemeriksaan",
  "button.labUnit.tests.assign.confirm": "Assign {count, plural, one {# test} other {# tests}}",
  "button.labUnit.tests.reassign": "Mengalihkan tugas yang dipilih ({count})",
  "button.labUnit.tests.reassign.confirm": "Reassign {count, plural, one {# test} other {# tests}}",
  "configuration.labUnit.manage": "Manajemen Instalasi Lab",
  "error.labUnit.description.maxLength": "Deskripsi harus berisikan maksimal {max} karakter",
  "error.labUnit.domain.required": "Domain wajib diisi",
  "error.labUnit.list.load": "Terjadi kesalahan saat memuat Instalasi Lab",
  "error.labUnit.name.duplicate": "Nama unit praktikum ini sudah ada",
  "error.labUnit.name.maxLength": "Nama harus terdiri dari maksimal {max} karakter",
  "error.labUnit.name.required": "Wajb ada nama ",
  "heading.labUnit.add": "Tambah Instalasi Lab Baru",
  "heading.labUnit.editing": "Edit: {name}",
  "heading.labUnit.filtered": "Menampilkan {filtered} dari {total} Instalasi Lab",
  "heading.labUnit.management": "Manajemen Instalasi Lab",
  "heading.labUnit.subtitle": "Konfigurasi instalasi lab (bagian laboratorium), klasifikasi domain, penugasan tes, dan urutan tampilan.",
  "heading.labUnit.total": "Total: {total} Instalasi Lab",
  "helper.labUnit.description": "Deskripsi singkat mengenai instalasi lab ini untuk referensi staf laboratorium",
  "helper.labUnit.domain": "Menentukan kolom-kolom entri pesanan dan pengambilan sampel mana saja yang diterapkan untuk pesanan yang diteruskan ke instalasi lab ini.",
  "helper.labUnit.name": "Masukkan nama yang unik untuk Instalasi Lab ini (misalnya, \"Hematologi\", \"Mikrobiologi\")",
  "label.labUnit.actions": "Aksi",
  "label.labUnit.active": "Aktif",
  "label.labUnit.description": "Deskripsi",
  "label.labUnit.displayOrder": "Posisi",
  "label.labUnit.displayOrder.addHint": "Simpan dulu unit praktikum ini, lalu atur urutan tampilanya.",
  "label.labUnit.displayOrder.current": "Saat ini",
  "label.labUnit.displayOrder.intro": "Tempatkan instalasi lab ini di menu dan daftar tarik-turun instalasi lab di seluruh sistem. Masukkan posisi dan simpan — instalasi lab lainnya akan dinomori ulang secara otomatis.",
  "label.labUnit.displayOrder.loading": "Sedang memuat urutan tampilan...",
  "label.labUnit.displayOrder.saved": "Urutan tampilan telah disimpan",
  "label.labUnit.displayOrder.saveError": "Gagal menyimpan urutan tampilan",
  "label.labUnit.domain": "Domain",
  "label.labUnit.filterStatus": "Filter berdasarkan Status",
  "label.labUnit.list.loading": "Memuat instalasi lab...",
  "label.labUnit.loading": "Memuat instalasi lab...",
  "label.labUnit.name": "Nama",
  "label.labUnit.nameInLocale": "Nama ({language})",
  "error.labUnit.tests.action": "Tindakan penugasan pemeriksaan gagal",
  "heading.labUnit.tests.assign": "Tugaskan Pemeriksaan untuk Instalasi Lab Ini",
  "heading.labUnit.tests.reassign": "Menugaskan Ulang Pemeriksaan",
  "label.labUnit.tests.assign.explain": "Setiap tes hanya dapat tergabung dalam satu instalasi lab. Menugaskan tes di sini akan memindahkannya dari instalasi lab saat ini (yang ditampilkan di samping setiap tes).",
  "label.labUnit.tests.assign.none": "Tidak ditemukan pemeriksaan yang dapat ditugaskan.",
  "label.labUnit.tests.reassign.destination": "Instalasi Lab tujuan",
  "label.labUnit.tests.reassign.explain": "Penugasan ulang efektif segera. Pemesanan baru akan diteruskan ke instalasi lab tujuan; hasil yang selesai tetap mempertahankan data aslinya.",
  "label.labUnit.tests.reassign.moving": "{count, plural, one {# test} other {# tests}} will be moved:",
  "message.labUnit.tests.assigned": "Pemeriksaan yang ditugaskan untuk Instalasi Lab ini.",
  "message.labUnit.tests.reassigned": "Pemeriksaan telah dialihkan kembali dengan berhasil.",
  "placeholder.labUnit.tests.reassign.destination": "Pilih tujuan...",
  "placeholder.labUnit.tests.search": "Cari pemeriksaan...",
  "label.labUnit.section.assigned-tests": "Pemeriksaan Ditugaskan",
  "label.labUnit.section.basic-info": "Informasi Dasar",
  "label.labUnit.section.display-order": "Urutan tampilan",
  "label.labUnit.status": "Status",
  "label.labUnit.testCount": "Pemeriksaan",
  "label.labUnit.tests.addHint": "Simpan dulu instalasi lab ini, lalu tugaskan pemeriksaan ke dalamnya.",
  "label.labUnit.tests.count": "{count, plural, one {# test assigned} other {# tests assigned}}",
  "label.labUnit.tests.loadError": "Tidak dapat memuat pemeriksaan yang telah ditugaskan",
  "label.labUnit.tests.loading": "Sedang memuat Pemeriksaan yang telah ditugaskan...",
  "label.labUnit.tests.none": "Belum ada tugas yang ditugaskan untuk unit praktikum ini.",
  "label.labUnit.tests.testName": "Nama Pemeriksaan",
  "message.labUnit.add.success": "Instalasi Lab berhasil dibuat.",
  "message.labUnit.edit.success": "Instalasi Lab telah berhasil disimpan.",
  "message.labUnit.noResults": "Tidak ditemukan instalasi lab yang sesuai dengan kriteria Anda",
  "placeholder.labUnit.filter.domain": "Semua domain",
  "placeholder.labUnit.filter.status": "Semua status",
  "placeholder.labUnit.search": "Cari instalasi lab...",
  "sidenav.label.admin.labUnit.addingNew": "Menambahkan instalasi lab baru",
  "sidenav.label.admin.labUnit.backToList": "← Semua Instalasi Lab",
  "sidenav.label.admin.labUnit.editing": "Edit: {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Instalasi Lab pengeditan",
  "sidenav.label.admin.labUnit.sectionsHelper": "Klik sebuah instalasi lab untuk mengedit bagian-bagiannya",
  "sidenav.label.admin.labUnitManagement": "Instalasi Lab",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} other {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.}}",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Tambah",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Nonaktifkan",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Keluar",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modifikasi",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Simpan",
  "admin.page.configuration.formEntryConfigMenu.description": "Deskripsi",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Rekaman Edit",
  "admin.page.configuration.formEntryConfigMenu.name": "Nama",
  "admin.page.configuration.formEntryConfigMenu.select": "Pilih",
  "admin.page.configuration.formEntryConfigMenu.value": "Nilai",
  "admin.labelPresets.title": "Pengaturan Label",
  "admin.labelPresets.addButton": "Tambah Pengaturan",
  "admin.labelPresets.search.placeholder": "Cari pengaturan...",
  "admin.labelPresets.col.name": "Nama",
  "admin.labelPresets.col.barcodeType": "Jenis Kode QR",
  "admin.labelPresets.col.dimensions": "Dimensi",
  "admin.labelPresets.col.scope": "Ruang Lingkup",
  "admin.labelPresets.col.status": "Status",
  "admin.labelPresets.col.actions": "Aksi",
  "admin.labelPresets.systemTag": "Sistem",
  "admin.labelPresets.status.active": "Aktif",
  "admin.labelPresets.status.inactive": "Inaktif",
  "admin.labelPresets.scope.order": "Pemesanan",
  "admin.labelPresets.scope.sample": "Sampel",
  "admin.labelPresets.action.edit": "Sunting",
  "admin.labelPresets.action.duplicate": "Duplikasi",
  "admin.labelPresets.action.activate": "Aktifkan",
  "admin.labelPresets.action.deactivate": "Nonaktifkan",
  "admin.labelPresets.duplicateName": "Salinan dari {name}",
  "admin.labelPresets.duplicated": "Pengaturan diduplikasi",
  "admin.labelPresets.duplicateFailed": "Duplikasi gagal",
  "admin.labelPresets.activated": "Pengaturan diaktifkan",
  "admin.labelPresets.deactivated": "Pengaturan dinonaktifkan",
  "admin.labelPresets.toggleFailed": "Gagal merubah status",
  "admin.labelPresets.saveFailed": "Penyimpanan gagal",
  "admin.labelPresets.editor.titleAdd": "Tambah Pengaturan Label",
  "admin.labelPresets.editor.titleEdit": "Edit Pengaturan Label",
  "admin.labelPresets.editor.section.basicInfo": "Informasi Dasar",
  "admin.labelPresets.editor.section.dimensions": "Dimensi (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Pengaturan Kode QR",
  "admin.labelPresets.editor.section.printScope": "Ruang Lingkup & Kuantitas Pencetakan",
  "admin.labelPresets.field.name": "Nama Pengaturan",
  "admin.labelPresets.field.isActive": "Aktif",
  "admin.labelPresets.field.heightMm": "Tinggi (mm)",
  "admin.labelPresets.field.widthMm": "Lebar (mm)",
  "admin.labelPresets.field.barcodeType": "Jenis Kode QR",
  "admin.labelPresets.field.defaultPerOrder": "Default per Pemesanan",
  "admin.labelPresets.field.maxPerOrder": "Maks per Pemesanan",
  "admin.labelPresets.field.defaultPerSample": "Default per Sampel",
  "admin.labelPresets.field.maxPerSample": "Maks per Sampel",
  "admin.labelPresets.validation.name.required": "Wajb ada nama ",
  "admin.labelPresets.validation.name.toolong": "Nama tidak lebih dari 120 karakter",
  "admin.labelPresets.validation.dimension.range": "Dimensi harus antara 5 sampai 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Wajib ada jenis kode QR",
  "admin.labelPresets.validation.scope.required": "Setidaknya satu ruang lingkup pencetakan (Pemesanan atau Sample) harus dipilih",
  "admin.labelPresets.validation.max.lte": "Maks harus lebih dari atau sama dengan default",
  "advanced.search": "Pencarian Lanjutan",
  "alert.expired.title": "Barang Kedaluwarsa",
  "alert.expiring.title": "Segera Kedaluwarsa",
  "alert.lowStock.title": "Peringatan Stok Sedikit",
  "alerts.acknowledge.button": "Mengetahui",
  "alerts.acknowledge.comment": "Komentar Pemecahan Masalah",
  "alerts.acknowledge.comment.placeholder": "Jelaskan bagaimana peringatan diatasi...",
  "alerts.acknowledge.comment.required": "Komentar resolusi diperlukan untuk peringatan kritis",
  "alerts.acknowledge.error": "Gagal mengkonfirmasi peringatan",
  "alerts.acknowledge.success": "Berhasil mengkonfirmasi peringatan",
  "alerts.acknowledge.title": "Konfirmasi Peringatan",
  "alerts.autoRefresh": "Auto-refresh setiap 60 detik",
  "alerts.dashboard.title": "Dasbor peringatan",
  "alerts.empty": "Tidak ada peringatan untuk ditampilkan",
  "alerts.eqaDeadlineSummary.critical": "Kritis",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} deadline berikutnya",
  "alerts.eqaDeadlineSummary.subtitle": "Pengumpulan PME yang deadline dikelompokan berdasarkan penyelenggara",
  "alerts.eqaDeadlineSummary.title": "Ringkasan Deadline PME",
  "alerts.eqaDeadlineSummary.viewAll": "Lihat Semua",
  "alerts.filter.myAlerts": "Peringatan Saya",
  "alerts.filter.search": "Mencari peringatan...",
  "alerts.filter.severity": "Keparahan",
  "alerts.filter.status": "Status",
  "alerts.filter.type": "Jenis Peringatan",
  "alerts.severity.critical": "Kritis",
  "alerts.severity.warning": "Peringatan",
  "alerts.status.acknowledged": "Sudah diketahui",
  "alerts.status.open": "Buka",
  "alerts.status.resolved": "Selesai",
  "alerts.summary.critical": "Peringatan Kritis",
  "alerts.summary.eqaDeadlines": "Deadline PME",
  "alerts.summary.sampleExpiration": "Sampel segera kedaluwarsa",
  "alerts.summary.statOverdue": "Pemesanan STAT yang lewat tenggat",
  "alerts.summary.totalOpen": "Total Terbuka",
  "alerts.table.actions": "Aksi",
  "alerts.table.created": "Dibuat",
  "alerts.table.message": "Pesan",
  "alerts.table.severity": "Keparahan",
  "alerts.table.status": "Status",
  "alerts.table.type": "Jenis",
  "alerts.type.critical_result": "Critical Result",
  "alerts.type.equipment_failure": "Alat Gagal",
  "alerts.type.freezer_humidity": "Freezer Humidity",
  "alerts.type.freezer_offline": "Freezer Offline",
  "alerts.type.freezer_temperature": "Freezer Temperature",
  "alerts.type.inventory_low": "Inventory Low",
  "alerts.type.other": "Lainnya",
  "alerts.type.referral_critical_result": "Referral Critical Result",
  "alerts.type.referral_rejected": "Referral Rejected",
  "alerts.type.sample_tracking": "Sample Tracking",
  "alerts.type.critical_unacknowledged": "Batalkan Konfirmasi Kritis",
  "alerts.type.eqa_deadline": "Deadline PME",
  "alerts.type.microbiology_critical": "Mikrobiologi Kritis",
  "alerts.type.required_by_deadline": "Wajib Diserahkan Sebelum Tenggat",
  "alerts.type.sample_expiration": "Tanggal Kedaluwarsa Sampel",
  "alerts.type.stat_overdue": "STAT lewat tenggat",
  "alerts.type.stat_upcoming": "STAT segera tenggat",
  "aliquot": "Alikuot",
  "aliquot.analyses.count": "Analisis: {count}",
  "aliquot.id": "ID Alikuot",
  "aliquot.quantity": "Kuantitas Alikuot",
  "aliquot.quantity.not.balanced": "Jumlah tidak seimbang untuk jenis sampel",
  "aliquot.save.error": "Error saat menyimpan data alikuot.",
  "aliquot.save.success": "Data pembuatan alikuot sukses tersimpan.",
  "aliquot.tests.not.assigned": "Tidak menugaskan pemeriksaan pada jenis sampel",
  "aliquot.validation.errors": "Kesalahan Validasi",
  "aliquoting": "Pembuatan alikuot",
  "aliquoting.section": "Bagian pembuatan alikuot",
  "all.label": "Semua",
  "all.tests.assigned": "Semua pemeriksaan ditugaskan",
  "allocated.to.aliquots": "Dialokasikan pada Alikuot",
  "analysis.count": "Penghitungan Analisis",
  "analysis.details": "Rincian Analisis",
  "analyzer.action.add": "Tambah Alat",
  "analyzer.action.configureConnection": "Konfigurasi koneksi",
  "analyzer.action.deactivate": "Nonaktifkan",
  "analyzer.action.editSetup": "Edit pengaturan",
  "analyzer.action.qualityControl": "Kendali Mutu",
  "analyzer.action.reactivate": "Aktifkan Ulang",
  "analyzer.combinationName.notification": "Kombinasi alat dan nama pemeriksaan di alat harus unik",
  "analyzer.fhirImport.error.importFailed": "Gagal mengimpor FHIR bundle",
  "analyzer.fhirImport.error.invalidBundleType": "Jenis bundle harus berupa 'transaksi' atau 'batch', yang ditampilkan: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle tidak memiliki Observation dengan hasil",
  "analyzer.deliveryIssues.attention.review": "Review undelivered results",
  "analyzer.deliveryIssues.attention.subtitle": "The Analyzer Bridge is holding results it could not deliver to OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, one {# analyzer result was} other {# analyzer results were}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Aksi",
  "analyzer.deliveryIssues.column.analyzer": "Alat",
  "analyzer.deliveryIssues.column.detail": "Rincian",
  "analyzer.deliveryIssues.column.reason": "Alasan",
  "analyzer.deliveryIssues.column.received": "Diterima",
  "analyzer.deliveryIssues.column.status": "Status",
  "analyzer.deliveryIssues.description": "Results the Analyzer Bridge received but has not delivered to OpenELIS. Retry sends a result again once its cause is fixed; Dismiss hides it and keeps it in the Bridge for audit.",
  "analyzer.deliveryIssues.dismiss": "Tutup",
  "analyzer.deliveryIssues.empty": "The Bridge has no undelivered results.",
  "analyzer.deliveryIssues.error.actionFailed": "The action could not be completed. Reload and try again.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "The Analyzer Bridge sent a response OpenELIS could not read.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS has no Analyzer Bridge address configured.",
  "analyzer.deliveryIssues.error.bridgeRefused": "The Bridge refused this action ({reason}). Reload to see its current state.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.deliveryIssues.error.invalidId": "This result reference is not valid.",
  "analyzer.deliveryIssues.loadFailed": "Undelivered results could not be loaded from the Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Checking the Analyzer Bridge for undelivered results",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "More than one analyzer connection could own this message. Give each analyzer a distinct address, then retry.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "The analyzer sent over a connection type its setup does not accept.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS declined the result because of its own setup. Fix the analyzer setup, then retry.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS rejected the result.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS answered with a redirect, so the result was not delivered. Check the Bridge's OpenELIS address.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "The message contained no results to deliver.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "The Bridge could not convert the message for OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS stayed unreachable until every retry was used. The result is intact; retry once OpenELIS is reachable.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "The analyzer's connection has no analyzer type revision, so its results cannot be read.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "The sender matches no saved analyzer connection. Set up the analyzer, then retry.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS has not accepted the result yet; the Bridge keeps retrying.",
  "analyzer.deliveryIssues.reason.unknown": "The Bridge could not deliver this result ({code}).",
  "analyzer.deliveryIssues.retry": "Ulang",
  "analyzer.deliveryIssues.state.deadLettered": "Not delivered",
  "analyzer.deliveryIssues.state.retrying": "Retrying",
  "analyzer.deliveryIssues.title": "Undelivered analyzer results",
  "analyzer.deliveryIssues.unrecognizedSender": "Unrecognized sender {source}",
  "analyzer.importIssues.accession": "Nomor Registrasi",
  "analyzer.importIssues.action": "Aksi",
  "analyzer.importIssues.description": "Tinjau peristiwa pada alat analisis mikrobiologi yang tidak dapat dicocokkan atau diproses. Hasil yang ditahan ditinjau dalam daftar kerja hasil masing-masing alat analisis.",
  "analyzer.importIssues.empty": "Tidak ada kejadian kegagalan alat analisis mikrobiologi yang memerlukan perhatian",
  "analyzer.importIssues.event": "Acara",
  "analyzer.importIssues.event.astQcFail": "Kegagalan Kendali Mutu AST",
  "analyzer.importIssues.event.astResultAvailable": "Hasil AST sudah tersedia",
  "analyzer.importIssues.event.unknown": "Peristiwa Alat ({code})",
  "analyzer.importIssues.events.description": "Perbaiki pemetaan penganalisis atau informasi target sebelum sumber mengirimkan hasilnya kembali.",
  "analyzer.importIssues.events.title": "Peristiwa alat yang macet",
  "analyzer.importIssues.failure.astRunNotMatched": "Tidak ada proses AST yang cocok dengan pengidentifikasi alat analisis dan kartu tersebut.",
  "analyzer.importIssues.failure.processingFailed": "Peristiwa Alat tidak dapat diproses.",
  "analyzer.importIssues.failure.unknown": "Peristiwa Alat tidak dapat diproses ({code}).",
  "analyzer.importIssues.loadFailed": "Masalah impor Alat: tidak dapat dimuat",
  "analyzer.importIssues.loading": "Masalah saat mengimpor Alat analisis",
  "analyzer.importIssues.openMappings": "Pemetaan terbuka",
  "analyzer.importIssues.openResults": "Hasil analisis terbuka",
  "analyzer.importIssues.reason": "Alasan kegagalan",
  "analyzer.importIssues.received": "Diterima",
  "analyzer.importIssues.result": "Hasil",
  "analyzer.importIssues.source": "Identitas Sumber",
  "analyzer.importIssues.staging.description": "Baris hasil yang diimpor ini memerlukan konfigurasi penganalisis yang telah diperbaiki sebelum dilakukan validasi.",
  "analyzer.importIssues.staging.title": "Masalah hasil yang ditampilkan secara bertahap",
  "analyzer.importIssues.target": "Referensi target",
  "analyzer.importIssues.test": "Pemeriksaan",
  "analyzer.importIssues.title": "Masalah impor Alat",
  "analyzer.fieldCreation.acceptedUnits.label": "Satuan yang diterima",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Pilih satuan yang diterima",
  "analyzer.fieldCreation.cancel": "Batalkan",
  "analyzer.fieldCreation.confirmation": "Saya mengerti bidang ini akan tersedia untuk pemetaan segera setelah dibuat",
  "analyzer.fieldCreation.create": "Buat Bidang",
  "analyzer.fieldCreation.createNew": "Buat Bidang Baru",
  "analyzer.fieldCreation.description.label": "Deskripsi (Opsional)",
  "analyzer.fieldCreation.description.placeholder": "Masukkan deskripsi bidang",
  "analyzer.fieldCreation.entityType.label": "Jenis Entitas",
  "analyzer.fieldCreation.entityType.placeholder": "Pilih jenis entitas",
  "analyzer.fieldCreation.error.generic": "Gagal membuat bidang",
  "analyzer.fieldCreation.error.title": "Error saat membuat bidang",
  "analyzer.fieldCreation.fieldName.label": "Nama Bidang",
  "analyzer.fieldCreation.fieldName.placeholder": "Masukkan nama bidang",
  "analyzer.fieldCreation.fieldType.label": "Jenis Bidang",
  "analyzer.fieldCreation.fieldType.placeholder": "Pilih jenis bidang",
  "analyzer.fieldCreation.loincCode.label": "Kode LOINC (Opsional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Masukkan kode LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Buat bidang baru yang siap dipetakan segera",
  "analyzer.fieldCreation.modal.title": "Buat Bidang Baru SILNAS",
  "analyzer.fieldCreation.success.message": "Bidang sudah tersedia untuk pemetaan",
  "analyzer.fieldCreation.success.title": "Bidang berhasil dibuat",
  "analyzer.fieldCreation.validation.entityType.required": "Wajib ada jenis entitas",
  "analyzer.fieldCreation.validation.fieldName.required": "Wajib ada nama bidang",
  "analyzer.fieldCreation.validation.unique": "Bidang dengan nama ini sudah ada",
  "analyzer.fieldCreation.validation.units.required": "Satuan yang diterima wajib diisi untuk kolom numerik.",
  "analyzer.filter.lifecycleStage.all": "Semua Tahapan Siklus Hidup",
  "analyzer.filter.lifecycleStage.label": "Tahapan Siklus Hidup",
  "analyzer.filter.status": "Status",
  "analyzer.filter.status.all": "Semua Status",
  "analyzer.filter.status.label": "Status",
  "analyzer.filter.testUnit": "Instalasi Lab",
  "analyzer.filter.type": "Jenis Alat",
  "analyzer.form.activeStatus": "Status Aktif",
  "analyzer.form.activeStatus.description": "Aktifkan alat ini untuk koleksi data",
  "analyzer.form.addTitle": "Tambah Alat Baru",
  "analyzer.form.cancel": "Batalkan",
  "analyzer.form.communicationMode": "Mode Komunikasi",
  "analyzer.form.communicationMode.analyzerInitiated": "Alat → SIL (alat terkoneksi ke OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidireksional (dua arah)",
  "analyzer.form.communicationMode.help": "Yang memulai koneksi. Umumnya menggunakan Alat → SIL.",
  "analyzer.form.communicationMode.lisInitiated": "SIL → Alat (SIL terhubung ke alat)",
  "analyzer.form.createdBy": "Dibuat Oleh",
  "analyzer.form.createdDate": "Tanggal/Waktu Dibuat",
  "analyzer.form.defaults.error": "Gagal memuat konfigurasi default",
  "analyzer.form.defaults.loaded": "Konfigurasi default dimuat",
  "analyzer.form.defaults.loaded.subtitle": "Templat untuk {name} berhasil dimuat. Lakukan kustomisasi sebelum menyimpan.",
  "analyzer.form.editTitle": "Edit Alat",
  "analyzer.form.error.invalidCommunicationMode": "Mode komunikasi invalid: {value}. Nilai valid: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Versi protokol invalid: {value}. Nilai valid: {validValues}",
  "analyzer.form.error.save": "Gagal menyimpan alat",
  "analyzer.form.error.unknown": "Terjadi error yang tidak diketahui",
  "analyzer.form.fileProtocol.description": "Alat ini mengimpor hasil dari file. Pengaturan impor akan dikonfigurasi setelah menyimpan.",
  "analyzer.form.fileProtocol.title": "Protokol Impor File",
  "analyzer.form.identifierPattern": "Pola Pengidentifikasi",
  "analyzer.form.identifierPattern.helperText": "Pola Regex untuk mencocokkan pengidentfikasi pesan masuk untuk routing",
  "analyzer.form.identifierPattern.placeholder": "misalnya, ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "Alamat IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Tanggal/Waktu Modifikasi Terakhir",
  "analyzer.form.loadDefaultConfig": "Muat Konfigurasi Default",
  "analyzer.form.loadDefaultConfig.helperText": "Pengaturan cepat menggunakan templat alat pre-konfigurasi untuk plugin GenericASTM dan GenericHL7",
  "analyzer.form.loadDefaultConfig.placeholder": "Pilih templat alat pre-konfigurasi",
  "analyzer.form.name": "Nama Alat",
  "analyzer.form.name.placeholder": "misalnya, Hematology Analyzer 1",
  "analyzer.form.pluginType": "Jenis Plugin",
  "analyzer.form.pluginType.helperText": "Plugin alat yang akan menangani pesan masuk",
  "analyzer.form.pluginType.placeholder": "Pilih jenis plugin...",
  "analyzer.form.port": "Nomor Portal",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Versi Protokol",
  "analyzer.form.save": "Simpan",
  "analyzer.form.status": "Status",
  "analyzer.form.status.helperText": "Transisi status berdasarkan status alat. Pembatalan manual hanya untuk INAKTIF, PENGATURAN, dan VALIDASI.",
  "analyzer.form.subtitle": "Konfigurasi pengaturan koneksi alat dan instalasi lab",
  "analyzer.form.success.save": "Alat berhasil disimpan",
  "analyzer.form.testConnection": "Tes Koneksi",
  "analyzer.form.testConnection.error": "Koneksi Gagal",
  "analyzer.form.testUnits": "Penugasan Instalasi Lab",
  "analyzer.form.testUnits.helper": "Pilih satu atau lebih instalasi lab untuk alat ini",
  "analyzer.form.testUnits.placeholder": "Pilih instalasi lab...",
  "analyzer.form.type": "Jenis Alat",
  "analyzer.form.type.helperText": "Pilih Jenis Alat yang dapat digunakan kembali untuk koneksi yang telah dipasang ini.",
  "analyzer.form.type.invalidSelection": "Revisi Jenis Alat tersebut tidak tersedia atau sudah inaktif",
  "analyzer.form.type.loadError": "Jenis Alat tidak dapat dimuat",
  "analyzer.form.type.other": "Lainnya",
  "analyzer.form.type.placeholder": "Pilih jenis alat",
  "analyzer.form.type.revision": "{name}, revisi {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Format alamat IP tidak valid",
  "analyzer.form.validation.name.required": "Wajib mengisi nama alat",
  "analyzer.form.validation.type.required": "Wajib mengisi jenis alat",
  "analyzer.hl7.insertError": "Error memasukkan HL7",
  "analyzer.hl7.parseError": "Error saat mengurai HL7",
  "analyzer.hl7.unknownAnalyzer": "Tidak dapat mengidentifikasi dari HL7 MSH (aplikasi/fasilitas yang mengirim)",
  "analyzer.list.subtitle": "Kelola alat laboratorium dan pemetaan bidang",
  "analyzer.list.title": "Alat",
  "analyzer.lifecycle.deactivate.cancel": "Batalkan penonaktifan",
  "analyzer.lifecycle.deactivate.confirm": "Nonaktifkan alat analisis",
  "analyzer.lifecycle.deactivate.error": "Alat analisis tersebut tidak dapat dinonaktifkan.",
  "analyzer.lifecycle.deactivate.errorTitle": "Penonaktifan gagal",
  "analyzer.lifecycle.deactivate.message": "Nonaktifkan \"{name}\"? Penggunaan runtime baru akan dihentikan. Konfigurasi dan riwayatnya akan tetap disimpan, dan fitur ini dapat diaktifkan ulang nanti.",
  "analyzer.lifecycle.deactivate.title": "Nonaktifkan alat analisis",
  "analyzer.lifecycle.reactivate.blockedMessage": "Selesaii persyaratan pengaturan ini sebelum mengaktifkan ulang.",
  "analyzer.lifecycle.reactivate.blockedTitle": "Alat analisis belum siap",
  "analyzer.lifecycle.reactivate.cancel": "Batalkan reaktivasi",
  "analyzer.lifecycle.reactivate.confirm": "Aktifkan ulang alat analisis",
  "analyzer.lifecycle.reactivate.error": "Alat analisis tersebut tidak dapat diaktifkan ulang.",
  "analyzer.lifecycle.reactivate.errorTitle": "Aktifkan Ulang gagal",
  "analyzer.lifecycle.reactivate.message": "Aktifkan Ulang {name}? Pengaturannya akan diperiksa kembali sebelum dapat digunakan.",
  "analyzer.lifecycle.reactivate.title": "Aktifkan ulang alat analisis",
  "analyzer.connection.choice.select": "Pilih nilai",
  "analyzer.connection.field.apiToken": "Token API",
  "analyzer.connection.field.connectionRole": "Peran koneksi",
  "analyzer.connection.field.directory": "Daftar",
  "analyzer.connection.field.directory.help": "Direktori pada host Alat Bridge",
  "analyzer.connection.field.enabled": "Diaktifkan",
  "analyzer.connection.field.filePattern": "Pola File",
  "analyzer.connection.field.filePattern.help": "Pola nama file yang dipantau oleh Analyzer Bridge",
  "analyzer.connection.field.host": "Pembawa Acara",
  "analyzer.connection.field.host.help": "The analyzer's IP address. Optional when the analyzer connects to the Analyzer Bridge. Leave it blank if the analyzer reaches the bridge through NAT or a proxy, and use the instrument system name instead.",
  "analyzer.connection.field.port": "Portal",
  "analyzer.connection.field.senderId": "Instrument system name",
  "analyzer.connection.field.senderId.help": "The name this instrument sends in its messages (ASTM H.5 or HL7 MSH-3), such as the GeneXpert System Name. Needed only when several analyzers share this port and address.",
  "analyzer.connection.field.serialPort": "Perangkat serial",
  "analyzer.connection.field.transport": "Transportasi",
  "analyzer.connection.field.unavailable": "Pengaturan koneksi",
  "analyzer.connection.role.client": "Klien",
  "analyzer.connection.role.server": "Server",
  "analyzer.connection.reference.configured": "Koneksi jembatan telah dikonfigurasi",
  "analyzer.connection.reference.missing": "Pengaturan koneksi wajib",
  "analyzer.connection.transport.RS-232": "Serial (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Jaringan (TCP/IP)",
  "analyzer.connection.validation.invalid": "Periksa nilai ini.",
  "analyzer.connection.validation.required": "Bidang ini diperlukan.",
  "analyzer.setup.close": "Tutup pengaturan penganalisis",
  "analyzer.setup.connect.address.required": "Masukkan alamat alat analisis",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge belum mengetahui pengaturan persis seperti ini.",
  "analyzer.activation.blocker.connection": "Pengaturan koneksi belum lengkap atau tidak valid.",
  "analyzer.activation.blocker.dataFlow": "Alur data yang dipilih tidak didukung oleh jenis alat ini.",
  "analyzer.activation.blocker.labUnit": "Menugaskan setidaknya satu instalasi lab yang aktif.",
  "analyzer.activation.blocker.mappings": "Pemetaan alat analisis harus diverifikasi kembali.",
  "analyzer.activation.blocker.name": "Masukkan nama alat analisis.",
  "analyzer.activation.blocker.profile": "Revisi jenis alat yang dipilih tidak tersedia atau tidak lagi sesuai dengan alat ini.",
  "analyzer.activation.blocker.recognition": "Pengenalan kontrol harus diverifikasi kembali.",
  "analyzer.activation.blocker.transport": "Jenis koneksi yang dipilih tidak didukung oleh jenis alat ini.",
  "analyzer.setup.connect.activation.active": "Alat sedang aktif",
  "analyzer.setup.connect.activation.activating": "Aktifkan Alat analisis",
  "analyzer.setup.connect.activation.blockerUnknown": "Pengaturan alat analisis belum siap untuk diaktifkan.",
  "analyzer.setup.connect.activation.cancel": "Batal",
  "analyzer.setup.connect.activation.error": "Kesiapan alat analisis tidak dapat diperiksa.",
  "analyzer.setup.connect.activation.finish": "Selesai dan aktifkan",
  "analyzer.setup.connect.activation.loading": "Memeriksa kesiapan alat analisis",
  "analyzer.setup.connect.activation.readiness": "Kesiapan aktivasi",
  "analyzer.setup.connect.activation.ready": "Alat analisis sudah siap diaktifkan",
  "analyzer.setup.connect.activation.saveChanges": "Simpan Perubahan",
  "analyzer.setup.connect.activation.saveLater": "Simpan dan selesaikan nanti",
  "analyzer.setup.connect.activation.saving": "Alat analisis penyimpanan",
  "analyzer.setup.connect.activation.verifyMappings": "Verify mappings",
  "analyzer.setup.connect.analyzerAddress": "Alamat alat analisis",
  "analyzer.setup.connect.check.analyzer.address.missing": "No analyzer address is saved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "The analyzer address {host} could not be resolved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.reachable": "The Bridge reached the analyzer at {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "The Bridge could not reach the analyzer at {host}. Analyzers that connect to the Bridge often cannot be reached from it (a firewall, NAT, or a hosted server). Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "Mode koneksi ini tidak didukung oleh Bridge.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Masuk ke direktori berkas Alat sebelum melakukan pemeriksaan.",
  "analyzer.setup.connect.check.directory.not.directory": "Jalur yang dikonfigurasi bukanlah sebuah direktori.",
  "analyzer.setup.connect.check.directory.not.found": "Direktori yang telah dikonfigurasi tidak ditemukan.",
  "analyzer.setup.connect.check.directory.not.readable": "The Bridge tidak dapat membaca direktori yang telah melalui proses Konfigurasi.",
  "analyzer.setup.connect.check.directory.path.invalid": "Jalur direktori yang dikonfigurasi tidak valid.",
  "analyzer.setup.connect.check.directory.ready": "Daftar sudah siap.",
  "analyzer.setup.connect.check.http.configuration.missing": "Masukkan alamat web alat analisis sebelum melakukan pemeriksaan.",
  "analyzer.setup.connect.check.http.connection.error": "The Bridge tidak dapat menghubungkan diri ke alamat web Alat analisis.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "This analyzer sends files to the Bridge, so the Bridge cannot test the connection from here. A delivered file is the proof.",
  "analyzer.setup.connect.check.http.interrupted": "Pemeriksaan koneksi internet terputus.",
  "analyzer.setup.connect.check.http.ready": "Alamat web alat analisis tersebut dapat diakses.",
  "analyzer.setup.connect.check.http.server.error": "Alamat web alat analisis tersebut menampilkan kesalahan server.",
  "analyzer.setup.connect.check.http.timeout": "Alamat web alat analisis tersebut tidak merespons sebelum batas waktu habis.",
  "analyzer.setup.connect.check.http.url.invalid": "Alamat web Alat analisis tersebut tidak valid.",
  "analyzer.setup.connect.check.listener.configuration.missing": "Enter the Bridge listener port before testing.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "Alamat pendengar The Bridge tidak dikonfigurasi.",
  "analyzer.setup.connect.check.listener.not.listening": "Listener The Bridge tidak menerima koneksi.",
  "analyzer.setup.connect.check.listener.port.in.use": "Port pendengar Bridge yang telah dikonfigurasi sedang digunakan.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "Profil yang disematkan tidak mendefinisikan pendengar Bridge yang kompatibel.",
  "analyzer.setup.connect.check.listener.ready": "Pendengar jembatan sudah siap.",
  "analyzer.setup.connect.check.listener.timeout": "Pendengar The Bridge tidak merespons sebelum batas waktu habis.",
  "analyzer.setup.connect.check.remote.astm.ready": "Alat analisis tersebut telah selesai melakukan proses handshake ASTM.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "Alat analisis tersebut mengembalikan respons handshake ASTM yang tidak valid.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Masukkan alamat dan port alat sebelum melakukan pemeriksaan.",
  "analyzer.setup.connect.check.remote.connection.error": "The Bridge tidak dapat menghubungkan diri ke Alat.",
  "analyzer.setup.connect.check.remote.hl7.ready": "Alat analisis telah menyelesaikan proses handshake HL7.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "Alat analisis tersebut mengembalikan respons handshake HL7 yang tidak valid.",
  "analyzer.setup.connect.check.remote.host.unknown": "Alamat alat tidak dapat diidentifikasi.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "Protokol alat ini tidak mendukung pemeriksaan koneksi jarak jauh.",
  "analyzer.setup.connect.check.remote.refused": "Alat analisis menolak koneksi tersebut.",
  "analyzer.setup.connect.check.remote.timeout": "Alat analisis tersebut tidak merespons sebelum batas waktu habis.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Masukkan nomor seri alat penganalisis sebelum melakukan pemeriksaan.",
  "analyzer.setup.connect.check.serial.not.found": "Perangkat serial yang telah dikonfigurasi tidak ditemukan.",
  "analyzer.setup.connect.check.serial.not.readable": "The Bridge tidak dapat membaca perangkat serial yang telah dilakukan konfigurasi.",
  "analyzer.setup.connect.check.serial.path.invalid": "Jalur perangkat serial yang dikonfigurasi tidak valid.",
  "analyzer.setup.connect.check.serial.ready": "Perangkat serial alat penganalisis sudah siap.",
  "analyzer.setup.connect.checkKind.analyzer": "Analyzer (for information)",
  "analyzer.setup.connect.checkKind.directory": "Daftar",
  "analyzer.setup.connect.checkKind.http_endpoint": "Alamat situs web",
  "analyzer.setup.connect.checkKind.http_input": "Analyzer file upload",
  "analyzer.setup.connect.checkKind.listener": "Pendengar jembatan",
  "analyzer.setup.connect.checkKind.other": "Pemeriksaan koneksi",
  "analyzer.setup.connect.checkKind.remote_protocol": "Protokol alat",
  "analyzer.setup.connect.checkKind.serial_device": "Perangkat serial",
  "analyzer.setup.connect.checkStatus.failed": "Pemeriksaan koneksi gagal.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "Pengaturan koneksi belum lengkap.",
  "analyzer.setup.connect.checkStatus.passed": "Pemeriksaan koneksi lolos.",
  "analyzer.setup.connect.checkStatus.skipped": "This check could not be run.",
  "analyzer.setup.connect.checkStatus.timed_out": "Waktu tunggu pemeriksaan koneksi telah habis.",
  "analyzer.setup.connect.configureEndpoint": "Konfigurasi alat analisis agar menggunakan",
  "analyzer.setup.connect.dataFlow": "Aliran data",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Hanya hasil",
  "analyzer.setup.connect.dataFlow.twoWay": "Dua arah",
  "analyzer.setup.connect.directory": "Direktori berkas Alat",
  "analyzer.setup.connect.directory.required": "Masuk ke direktori file Alat",
  "analyzer.setup.connect.error": "Pengaturan koneksi tidak dapat disimpan atau diuji.",
  "analyzer.setup.connect.evidence": "Bukti koneksi",
  "analyzer.setup.connect.loadError": "Koneksi penganalisis yang telah disimpan tidak dapat dimuat.",
  "analyzer.setup.connect.loading": "Memuat koneksi alat penganalisis",
  "analyzer.setup.connect.outcome.failure": "Koneksi Gagal",
  "analyzer.setup.connect.outcome.missing_configuration": "Pengaturan koneksi belum lengkap",
  "analyzer.setup.connect.outcome.success": "Koneksi siap",
  "analyzer.setup.connect.outcome.timeout": "Waktu tunggu koneksi habis",
  "analyzer.setup.connect.port": "Port alat",
  "analyzer.setup.connect.port.invalid": "Masukkan nomor port dari 1 hingga 65535",
  "analyzer.setup.connect.sourceAddress": "Alamat sumber alat",
  "analyzer.setup.connect.test": "Tes Koneksi",
  "analyzer.setup.connect.testing": "Pemeriksaan koneksi",
  "analyzer.setup.connect.title": "Hubungkan",
  "analyzer.setup.connect.useResultsOnly": "Gunakan hanya hasil",
  "analyzer.setup.instrument.continue": "Lanjut Verifikasi",
  "analyzer.setup.instrument.labUnits": "Instalasi Lab",
  "analyzer.setup.instrument.labUnits.placeholder": "Pilih instalasi lab",
  "analyzer.setup.instrument.labUnits.required": "Pilih setidaknya satu instalasi lab",
  "analyzer.setup.instrument.name": "Nama Alat Analisis",
  "analyzer.setup.instrument.name.required": "Masukkan nama alat analisis",
  "analyzer.setup.instrument.notListed": "Alat yang dicari tidak tercantum?",
  "analyzer.setup.instrument.saveError": "Alat analisis tidak dapat disimpan. Silakan coba lagi.",
  "analyzer.setup.instrument.saving": "Alat analisis penyimpanan",
  "analyzer.setup.instrument.summary": "Rincian alat yang telah disimpan",
  "analyzer.setup.step.edit": "Edit {step}",
  "analyzer.setup.instrument.type": "Jenis",
  "analyzer.setup.instrument.type.helper": "Choose the listed type for your instrument, even if it will only send results. Whether it sends results only or also receives orders is set later, in Connect.",
  "analyzer.setup.instrument.type.placeholder": "Jenis Alat Analisis Pencarian",
  "analyzer.setup.instrument.type.required": "Pilih jenis alat analisis",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · revisi {revision}",
  "analyzer.setup.instrument.title": "Alat",
  "analyzer.setup.steps": "Langkah-langkah pengaturan Alat analisis",
  "analyzer.setup.title": "Siapkan alat baru",
  "analyzer.setup.verify.attention": "Verifikasi perlu diperhatikan",
  "analyzer.setup.verify.continue": "Lanjut Hubungkan",
  "analyzer.setup.verify.selecting": "Sedang menerapkan pemetaan...",
  "analyzer.setup.verify.selectionError": "Pemetaan yang telah ditinjau tidak dapat diterapkan. Muat ulang Verify dan coba lagi.",
  "analyzer.setup.verify.counts": "Kesiapan pemetaan",
  "analyzer.setup.verify.heading": "Meninjau pemetaan jenis alat",
  "analyzer.setup.verify.loadError": "Verifikasi pemetaan tidak dapat dimuat.",
  "analyzer.setup.verify.loading": "Memuat verifikasi pemetaan",
  "analyzer.setup.verify.profile": "{name} · {protocol} · revisi {revision}",
  "analyzer.setup.verify.resultsReady": "{ready} dari nilai hasil {total} sudah siap",
  "analyzer.setup.verify.summary": "Pemetaan yang telah ditinjau untuk pengaturan ini",
  "analyzer.setup.verify.summary.stale": "Mappings need to be verified again",
  "analyzer.setup.verify.review": "Tinjau pemetaan dalam Jenis Alat",
  "analyzer.setup.verify.testsReady": "{ready} dari tes \"{total}\" sudah siap",
  "analyzer.setup.verify.title": "Verifikasi",
  "analyzer.navigation.analyzerTypes": "Jenis Alat",
  "analyzer.navigation.analyzers": "Alat",
  "analyzer.navigation.analyzersList": "Daftar Alat",
  "analyzer.navigation.fieldMappings": "Pemetaan Bidang",
  "analyzer.navigation.qc": "Kendali Mutu",
  "analyzer.navigation.qcDashboard": "Dasbor QC",
  "analyzer.navigation.qcAlerts": "Peringatan dan Pelanggaran Kendali Mutu",
  "analyzer.navigation.qcCorrectiveActions": "Tindakan perbaikan",
  "analyzerType.action.deactivate": "Nonaktifkan",
  "analyzerType.action.editMappings": "Edit Pemetaan",
  "analyzerType.action.history": "Lihat Riwayat",
  "analyzerType.action.reactivate": "Aktifkan Ulang",
  "analyzerType.action.updateShared": "Perbarui",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, one {Analyzer using this type} other {Analyzers using this type}}",
  "analyzerType.affectedAnalyzers.updateAvailable": "Tersedia perbaruan",
  "analyzerType.actions.ariaLabel": "Aksi untuk {name}",
  "analyzerType.button.create": "Buat Jenis Alat Baru",
  "analyzerType.button.cancel": "Batal",
  "analyzerType.button.duplicate": "Profil Duplikasi",
  "analyzerType.button.publish": "Publikasikan Profil",
  "analyzerType.button.startUpdate": "Mulai perbaruan",
  "analyzerType.column.actions": "Aksi",
  "analyzerType.column.protocol": "Protokol",
  "analyzerType.column.resultsMapped": "Hasil yang ditampilkan pada peta",
  "analyzerType.column.status": "Status",
  "analyzerType.column.testsMapped": "Pemeriksaan yang telah dipetakan",
  "analyzerType.column.type": "Jenis",
  "analyzerType.column.usedBy": "Digunakan oleh",
  "analyzerType.dataFlow.resultsOnly": "Hanya hasil",
  "analyzerType.dataFlow.twoWay": "Dua arah",
  "analyzerType.duplicate.lineage.subtitle": "Profil baru ini dimulai dari revisi {name} dengan nomor {revision}. Perubahan-perubahan selanjutnya tidak memengaruhi profil sumber maupun Alat analisisnya.",
  "analyzerType.duplicate.lineage.title": "Profil baru dengan garis keturunan yang dipertahankan",
  "analyzerType.draft.created.subtitle": "Draf tersebut disimpan di Analyzer Bridge. Draf tersebut harus selesai dan diverifikasi terlebih dahulu sebelum dapat dipublikasikan untuk pengaturan alat analisis.",
  "analyzerType.draft.created.title": "Draf profil telah dibuat",
  "analyzerType.draft.loading": "Memuat draf profil",
  "analyzerType.draft.publish.ready.subtitle": "{name} memiliki identitas unik yang dimiliki oleh Bridge dan mempertahankan garis keturunan sumbernya.",
  "analyzerType.draft.publish.ready.title": "Siap dipublikasikan",
  "analyzerType.draft.publish.review.subtitle": "Periksa dan simpan perilaku pengenalan kontrol untuk {name} sebelum dipublikasikan.",
  "analyzerType.draft.publish.review.title": "Tinjauan profil selesai",
  "analyzerType.draft.update.loading": "Memuat draf pembaruan profil",
  "analyzerType.draft.update.subtitle": "Jenis Alat bersama tidak akan berubah hingga draf ini selesai dan diterbitkan. Alat yang sudah ada tetap terikat pada revisi mereka saat ini.",
  "analyzerType.draft.update.title": "Draf pembaruan profil telah dibuat",
  "analyzerType.empty.subtitle": "Sesuaikan kriteria pencarian atau filter untuk melihat jenis Alat lainnya.",
  "analyzerType.empty.title": "Tidak ada jenis alat yang cocok",
  "analyzerType.explainer.subtitle": "Alat yang identik dapat menggunakan satu jenis yang sama. Buat duplikasi suatu jenis jika suatu alat memerlukan perilaku yang berbeda; nonaktifkan jenis tersebut alih-alih menghapus riwayatnya.",
  "analyzerType.explainer.title": "Pengaturan alat analisis yang dapat digunakan kembali",
  "analyzerType.error.nameUnique": "Nama profil harus unik",
  "analyzerType.field.connectionTest": "Mendukung pemeriksaan koneksi",
  "analyzerType.field.dataFlow": "Aliran data",
  "analyzerType.field.fileFormat": "Format File",
  "analyzerType.field.filePattern": "Pola Nama File",
  "analyzerType.field.manufacturer": "Produsen",
  "analyzerType.field.model": "Model",
  "analyzerType.field.newProfileName": "Nama profil baru",
  "analyzerType.field.profileName": "Nama profil",
  "analyzerType.field.protocol": "Protokol",
  "analyzerType.field.resultColumn": "Kolom Hasil",
  "analyzerType.field.sampleColumn": "Kolom Nomor Identitas Sampel",
  "analyzerType.field.sourceProfile.placeholder": "Pilih jenis alat analisis",
  "analyzerType.field.sourceProfile": "Jenis Alat sumber",
  "analyzerType.field.testColumn": "Kolom kode pemeriksaan",
  "analyzerType.filter.all": "Semua",
  "analyzerType.filter.mapping": "Status pemetaan",
  "analyzerType.filter.protocol": "Protokol",
  "analyzerType.filter.showDeactivated": "Tampilkan sudah inaktif",
  "analyzerType.filter.source": "Dibuat",
  "analyzerType.history.action.created": "Dibuat",
  "analyzerType.history.action.deactivated": "Sudah inaktif",
  "analyzerType.history.action.duplicated": "Terduplikasi",
  "analyzerType.history.action.reactivated": "Aktifkan Ulang",
  "analyzerType.history.action.shipped": "Sudah dikirim",
  "analyzerType.history.action.updated": "Terbarui",
  "analyzerType.history.actor": "Diubah oleh",
  "analyzerType.history.change": "Perubahan",
  "analyzerType.history.loading": "Memuat riwayat profil",
  "analyzerType.history.revisionValue": "Revisi{revision}",
  "analyzerType.history.revision": "Revisi",
  "analyzerType.history.status": "Status",
  "analyzerType.history.time": "Diubah pada",
  "analyzerType.lineage": "Diambil dari {profileId} revisi {revision}",
  "analyzerType.loading": "Memuat jenis-jenis alat analisis",
  "analyzerType.mapping.complete": "Telah dipetakan sepenuhnya",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} ditandai sebagai \"Jangan Kirim\"",
  "analyzerType.mapping.incomplete": "Pemetaan kebutuhan",
  "analyzerType.mapping.notApplicable": "Tidak berlaku",
  "analyzerType.mapping.notStarted": "Belum dipetakan",
  "analyzerType.mappingEditor.alias": "Alias: {alias}",
  "analyzerType.mappingEditor.confirm": "Konfirmasi pemetaan dan pengenalan kontrol",
  "analyzerType.mappingEditor.confirmation.by": "Dikonfirmasi oleh {actor} di {date}",
  "analyzerType.mappingEditor.confirmation.current": "Konfirmasi saat ini",
  "analyzerType.mappingEditor.confirmation.stale": "Konfirmasi sudah kedaluwarsa",
  "analyzerType.mappingEditor.confirmation.summary.current": "Saat ini",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Basi",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Belum dikonfirmasi",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Belum dikonfirmasi",
  "analyzerType.mappingEditor.confirmation": "Konfirmasi",
  "analyzerType.mappingEditor.confirmed": "Pemetaan dan pengenalan kontrol telah dikonfirmasi",
  "analyzerType.mappingEditor.error.confirm": "Konfirmasi gagal",
  "analyzerType.mappingEditor.error.load": "Pemetaan Jenis Alat tidak dapat dimuat",
  "analyzerType.mappingEditor.error.route": "Wajib mengisi revisi Jenis Alat yang sah",
  "analyzerType.mappingEditor.error.save": "Pemetaan tidak dapat disimpan",
  "analyzerType.mappingEditor.excludeResult.short": "Jangan terima",
  "analyzerType.mappingEditor.excludeResult": "Jangan menerima email dari {value}",
  "analyzerType.mappingEditor.excludeTest": "Jangan menerima email dari {code}",
  "analyzerType.mappingEditor.incomplete": "Selesaikan atau kecualikan secara eksplisit setiap baris sumber sebelum Konfirmasi.",
  "analyzerType.mappingEditor.loading": "Memuat pemetaan jenis alat",
  "analyzerType.mappingEditor.normalized": "Identitas yang dinormalisasi",
  "analyzerType.mappingEditor.observed": "Terlihat pada hasil yang diperoleh",
  "analyzerType.mappingEditor.recognition.heading": "Pengenalan hasil pengendalian",
  "analyzerType.mappingEditor.recognition.none": "Jenis Alat ini secara eksplisit menyatakan bahwa antarmuka tersebut tidak mentransmisikan hasil kontrol apa pun.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Pilih hasil OpenELIS",
  "analyzerType.mappingEditor.resultPicker": "Hasil OpenELIS untuk {value}",
  "analyzerType.mappingEditor.results.empty": "Pemeriksaan ini tidak memiliki opsi hasil yang aktif",
  "analyzerType.mappingEditor.results.heading": "Hasil - {name}",
  "analyzerType.mappingEditor.results.loading": "Memuat opsi hasil",
  "analyzerType.mappingEditor.results.openCatalog": "Tambahkan opsi hasil di Katalog Pemeriksaan",
  "analyzerType.mappingEditor.results.testFirst": "Pilih Pemeriksaan OpenELIS sebelum memetakan hasilnya",
  "analyzerType.mappingEditor.results": "Hasil yang ditampilkan pada peta",
  "analyzerType.mappingEditor.return": "Jenis Alat",
  "analyzerType.mappingEditor.save": "Perbarui pemetaan bersama",
  "analyzerType.mappingEditor.saved": "Pemetaan telah disimpan",
  "analyzerType.mappingEditor.shared.subtitle": "Changes create a new mapping candidate for {count, plural, =0 {this Analyzer Type} one {# analyzer using this type} other {# analyzers using this type}}. Existing active configurations do not move until the candidate is confirmed and adopted.",
  "analyzerType.mappingEditor.shared.title": "Pemetaan Jenis Alat Bersama",
  "analyzerType.mappingEditor.sourceCode": "Kode alat penganalisis",
  "analyzerType.mappingEditor.state.bound": "Dipetakan",
  "analyzerType.mappingEditor.state.excluded": "Jangan terima",
  "analyzerType.mappingEditor.state.unresolved": "Pemetaan kebutuhan",
  "analyzerType.mappingEditor.subtitle": "{protocol} · revisi {revision}",
  "analyzerType.mappingEditor.suggestion": "Saran pertandingan: {name}",
  "analyzerType.mappingEditor.summary": "Ringkasan pemetaan",
  "analyzerType.mappingEditor.testPicker.placeholder": "Cari berdasarkan nama, kode, atau LOINC",
  "analyzerType.mappingEditor.testPicker": "Pemeriksaan OpenELIS untuk {code}",
  "analyzerType.mappingEditor.tests.heading": "Pemetaan pemeriksaan dan hasil",
  "analyzerType.mappingEditor.tests.help": "Tinjau setiap kode penganalisis secara terpisah. Hubungkan kode tersebut ke Pemeriksaan OpenELIS yang aktif atau kecualikan secara eksplisit.",
  "analyzerType.mappingEditor.tests": "Pemeriksaan yang telah dipetakan",
  "analyzerType.mappingEditor.title": "{name} pemetaan",
  "analyzerType.mappingEditor.unsaved": "Perubahan pemetaan yang tidak tersimpan",
  "analyzerType.mappingEditor.useSuggestion": "Gunakan pemeriksaan yang disarankan",
  "analyzerType.modal.deactivate.subtitle": "Alat analisis yang ada dan riwayat revisi tetap terhubung. Profil ini tidak akan lagi tersedia untuk pengaturan alat analisis baru.",
  "analyzerType.modal.deactivate.title": "Nonaktifkan {name}",
  "analyzerType.modal.history.title": "{name} Riwayat",
  "analyzerType.modal.reactivate.subtitle": "Profil ini akan tersedia kembali untuk pengaturan alat analisis baru. Alat analisis yang sudah ada tetap terikat pada revisi yang telah dipilih.",
  "analyzerType.modal.reactivate.title": "Aktifkan Ulang {name}",
  "analyzerType.modal.update.subtitle": "This starts a new immutable revision from revision {revision}. {count, plural, one {# analyzer remains pinned to its current revision.} other {# analyzers remain pinned to their current revisions.}}",
  "analyzerType.modal.update.title": "Perbaruan {name}",
  "analyzerType.notification.action.error.subtitle": "Coba lakukan aksi profil itu lagi.",
  "analyzerType.notification.action.error": "Aksi profil gagal",
  "analyzerType.notification.create.success": "Profil telah dibuat",
  "analyzerType.notification.deactivate.success": "Profil sudah inaktif",
  "analyzerType.notification.duplicate.success": "Profil duplikat",
  "analyzerType.notification.update.success": "Profil telah diperbarui",
  "analyzerType.notification.loadError.subtitle": "Periksa koneksi Analyzer Bridge, lalu coba lagi.",
  "analyzerType.notification.loadError": "Jenis Alat tidak dapat dimuat",
  "analyzerType.notification.reactivate.success": "Profil telah diaktifkan ulang",
  "analyzerType.page.subtitle": "Pengaturan yang dapat digunakan kembali di balik Alat analisis Anda.",
  "analyzerType.page.title": "Jenis Alat",
  "analyzerType.protocol.file": "Berkas datar",
  "analyzerType.recognition.none.affirmation": "Saya menegaskan bahwa antarmuka ini tidak mengirimkan hasil pengendalian",
  "analyzerType.recognition.none.subtitle": "Publikasikan profil ini hanya jika antarmuka penganalisis tidak mengirimkan hasil kontrol. Profil yang mengirimkan kontrol memerlukan aturan pengenalan yang eksplisit.",
  "analyzerType.recognition.none.title": "Tidak ada pengenalan hasil kontrol secara otomatis",
  "analyzerType.recognition.condition.add": "Tambah Kondisi",
  "analyzerType.recognition.condition.fieldValue": "{source} Nilai",
  "analyzerType.recognition.condition.new": "Syarat pengakuan baru",
  "analyzerType.recognition.condition.prefixValue": "Prefiks Identitas Spesimen",
  "analyzerType.recognition.condition.remove": "Hapus Kondisi",
  "analyzerType.recognition.condition.select.placeholder": "Pilih suatu kondisi",
  "analyzerType.recognition.condition.select": "Kondisi baru",
  "analyzerType.recognition.condition.sourceContains": "{source} berisi",
  "analyzerType.recognition.condition.sourceEquals": "{source} sama dengan",
  "analyzerType.recognition.condition.specimenPrefix": "Identitas spesimen dimulai dengan",
  "analyzerType.recognition.condition.summary.configuredPattern": "Identitas spesimen sesuai dengan pola yang telah dikonfigurasi",
  "analyzerType.recognition.condition.summary.contains": "{source} berisi {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} sama dengan {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} dimulai dengan {value}",
  "analyzerType.recognition.condition.summary.unknown": "Pengakuan hasil pengendalian",
  "analyzerType.recognition.error.load": "Pengenalan kontrol tidak dapat dimuat.",
  "analyzerType.recognition.error.save": "Pengenalan kontrol tidak dapat disimpan.",
  "analyzerType.recognition.error.title": "Pengenalan kontrol perlu mendapat perhatian",
  "analyzerType.recognition.heading": "Pengenalan hasil pengendalian",
  "analyzerType.recognition.loading": "Pengenalan kontrol pemuatan",
  "analyzerType.recognition.mode.none": "Antarmuka ini tidak mengirimkan hasil kontrol",
  "analyzerType.recognition.mode.none.short": "Tidak ada pengenalan hasil kontrol",
  "analyzerType.recognition.mode.rules": "Kenali elemen kontrol dengan menggunakan kondisi-kondisi berikut ini",
  "analyzerType.recognition.mode.rules.short": "Pengenalan kontrol berbasis aturan",
  "analyzerType.recognition.mode": "Bagaimana antarmuka ini mengidentifikasi hasil pengendalian?",
  "analyzerType.recognition.rules.help": "Sebuah hasil dianggap sebagai kontrol jika ada apa saja kondisi yang terpenuhi.",
  "analyzerType.recognition.save": "Simpan pengenalan kontrol",
  "analyzerType.recognition.saved": "Pengakuan kontrol telah disimpan",
  "analyzerType.recognition.source.specimenId": "Identitas Spesimen",
  "analyzerType.recognition.validation.title": "Draf profil masih perlu diperbaiki",
  "analyzerType.revision": "revisi {revision}",
  "analyzerType.search.label": "Jenis Alat Analisis Pencarian",
  "analyzerType.search.placeholder": "Cari jenis alat...",
  "analyzerType.source.shipped": "Sudah dikirim",
  "analyzerType.source.site": "Dibuat oleh situs ini",
  "analyzerType.status.active": "Aktif",
  "analyzerType.status.inactive": "Sudah inaktif",
  "analyzerType.summary.ariaLabel": "Ringkasan jenis alat analisis",
  "analyzerType.summary.deactivated": "Sudah inaktif",
  "analyzerType.summary.inUse": "Sedang Digunakan",
  "analyzerType.summary.needsAttention": "Perlu Perhatian",
  "analyzerType.summary.total": "Jenis Alat",
  "analyzerType.usedBy": "{count, plural, =0 {Not in use} one {# analyzer} other {# analyzers}}",
  "analyzer.navigation.qcControlLots": "Lot Kontrol",
  "analyzer.navigation.qcRuleConfig": "Konfigurasi Aturan",
  "analyzer.page.addButton": "Tambah Alat",
  "analyzer.page.hierarchy.list": "Daftar Alat",
  "analyzer.page.hierarchy.mappings": "Pemetaan Bidang",
  "analyzer.page.hierarchy.root": "Alat",
  "analyzer.page.title": "Alat",
  "analyzer.plugin.missing": "Plugin Tidak Ditemukan",
  "analyzer.qc.alerts.message": "Fitur peringatan dan pelanggaran akan segera tersedia.",
  "analyzer.qc.alerts.title": "Peringatan dan Pelanggaran Kendali Mutu",
  "analyzer.qc.corrective.message": "Fitur tindakan perbaikan akan segera tersedia.",
  "analyzer.qc.corrective.title": "Tindakan Perbaikan",
  "analyzer.qc.placeholder.message": "Fitur Kendali Mutu akan segera tersedia.",
  "analyzer.qc.placeholder.title": "Kendali Mutu",
  "analyzer.action.viewResults": "Lihat hasilnya",
  "analyzer.results.held.code": "Kode alat penganalisis: {code}",
  "analyzer.results.held.reviewMapping": "Ulasan Pemetaan Jenis Alat",
  "analyzer.results.held.subtitle": "Hasil yang ditahan tidak dapat diterima. Selesaikan pemetaan Jenis Alat agar hasil yang sesuai berikutnya dapat masuk ke alur kerja peninjauan biasa.",
  "analyzer.results.held.tag": "Diselenggarakan",
  "analyzer.results.held.title": "{count, plural, one {# analyzer result needs attention} other {# analyzer results need attention}}",
  "analyzer.qualitativeMapping.isDefault": "Standar",
  "analyzer.qualitativeMapping.mappings": "Pemetaan Nilai",
  "analyzer.qualitativeMapping.noValues": "Tidak ada nilai alat tersedia untuk pemetaan",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Pilih kode SILNAS",
  "analyzer.qualitativeMapping.subtitle": "Pemetaan nilai kualitatif untuk {fieldName}",
  "analyzer.qualitativeMapping.title": "Pemetaan Nilai Kualitatif",
  "analyzer.qualitativeMapping.validation.error": "Kesalahan Validasi",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Perbaiki error di bawah ini",
  "analyzer.qualitativeMapping.validation.noDefault": "Tidak ada nilai default",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Setidaknya satu pemetaan harus ditandai sebagai default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "Wajib mengisi kode SILNAS",
  "analyzer.query.button": "Kueri Alat",
  "analyzer.query.cancel": "Batal",
  "analyzer.query.modal.logs": "Log Koneksi",
  "analyzer.query.modal.noLogs": "Belum ada log",
  "analyzer.query.modal.progress": "Kemajuan",
  "analyzer.query.modal.state": "Status",
  "analyzer.query.modal.subtitle": "Ambil bidang yang tersedia dari alat",
  "analyzer.query.modal.title": "Kueri Alat",
  "analyzer.query.progress": "{percent}% selesai",
  "analyzer.search.label": "Cari",
  "analyzer.search.placeholder": "Cari Alat...",
  "analyzer.attention.review": "Meninjau hasil yang telah diperoleh",
  "analyzer.attention.subtitle": "Identifikasi pemeriksaan atau nilai hasil yang tidak diketahui sebelum menggunakan hasil tersebut dalam praktik klinis.",
  "analyzer.attention.tag": "Perlu diperhatikan",
  "analyzer.attention.title.many": "{count} Alat telah mencatat hasil analisisnya",
  "analyzer.attention.title.one": "{name} telah mengumumkan hasilnya",
  "analyzer.stat.active": "Aktif",
  "analyzer.stat.inactive": "Inaktif",
  "analyzer.stat.needsAttention": "Perlu diperhatikan",
  "analyzer.stat.setup": "Di Pengaturan",
  "analyzer.stat.total": "Total Alat",
  "analyzer.stats.active": "Alat Aktif",
  "analyzer.stats.inactive": "Alat Inaktif",
  "analyzer.stats.total": "Total Alat",
  "analyzer.status.active": "Aktif",
  "analyzer.status.deleted": "Hapus",
  "analyzer.status.error_pending": "Error Tertunda",
  "analyzer.status.inactive": "Inaktif",
  "analyzer.status.offline": "Offline",
  "analyzer.status.setup": "Pengaturan",
  "analyzer.status.validation": "Validasi",
  "analyzer.success.save": "Alat berhasil disimpan",
  "analyzer.table.actions": "Aksi",
  "analyzer.table.connection": "Koneksi",
  "analyzer.table.header.connection": "Koneksi",
  "analyzer.table.header.lastModified": "Dimodifikasi Terakhir",
  "analyzer.table.header.name": "Nama",
  "analyzer.table.header.status": "Status",
  "analyzer.table.header.testUnits": "Instalasi Lab",
  "analyzer.table.header.type": "Jenis",
  "analyzer.table.lastModified": "Dimodifikasi Terakhir",
  "analyzer.table.name": "Nama",
  "analyzer.table.status": "Status",
  "analyzer.table.testUnits": "Instalasi Lab",
  "analyzer.table.type": "Jenis",
  "analyzer.table.type.loading": "Memuat jenis alat penganalisis",
  "analyzer.table.type.unavailable": "Jenis Alat tidak tersedia",
  "analyzer.testUnits.count": "{count, plural, one {# unit} other {# units}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "Tidak dapat mencapai bridge health endpoint di {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge mengembalikan HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge tidak dikonfigurasi",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge respon unparsable (tidak dapat di parse)",
  "analyzer.testConnection.bridge.unreachable": "Tidak dapat mencapai bridge: {detail}",
  "analyzer.testConnection.close": "Tutup",
  "analyzer.testConnection.logs": "Log Koneksi",
  "analyzer.testConnection.requestBuildFailed": "Gagal membuat request: {detail}",
  "analyzer.testConnection.success": "Koneksi Berhasil",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge tidak dikonfigurasi, koneksi dengan alat tidak dapat diuji coba",
  "analyzer.testConnection.testAgain": "Uji Kembali",
  "analyzer.testConnection.testing": "Menguji koneksi...",
  "analyzer.testConnection.title": "Uji Koneksi",
  "analyzer.testMapping.activeMappings": "{count} pemetaan aktif",
  "analyzer.testMapping.analyzerInfo": "Informasi Alat",
  "analyzer.testMapping.analyzerName": "Nama Alat",
  "analyzer.testMapping.analyzerType": "Jenis Alat",
  "analyzer.testMapping.appliedMappings": "Pemetaan yang Diterapkan",
  "analyzer.testMapping.entityPreview": "Pratinjau Entitas SILNAS",
  "analyzer.testMapping.errors": "Error",
  "analyzer.testMapping.loading": "Memproses pratinjau...",
  "analyzer.testMapping.messageInput": "Sampel Pesan ASTM",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} karakter",
  "analyzer.testMapping.messageInput.helper": "Masukkan pesan sampel ASTM untuk pratinjau bagaimana interpretasinya",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sampel Pesan ASTM *",
  "analyzer.testMapping.noResults": "Belum ada hasil pratinjau. Masukkan sampel pesan ASTM dan klik Pratinjau Pemetaan.",
  "analyzer.testMapping.parsedFields": "Bidang yang diurai",
  "analyzer.testMapping.parsedFields.astmRef": "Referensi ASTM",
  "analyzer.testMapping.parsedFields.fieldName": "Nama Bidang",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretasi",
  "analyzer.testMapping.parsedFields.mappedTo": "Dipetakan ke",
  "analyzer.testMapping.parsedFields.rawValue": "Nilai Mentah",
  "analyzer.testMapping.pluginConfigSnapshot": "Snapshot Konfigurasi Plugin",
  "analyzer.testMapping.previewOptions": "Opsi Pratinjau",
  "analyzer.testMapping.previewOptions.detailedParsing": "Tunjukkan rincian tahapan penguraian",
  "analyzer.testMapping.previewOptions.validateAll": "Validasi semua pemetaan",
  "analyzer.testMapping.results": "Pratinjau Hasil",
  "analyzer.testMapping.saveTestCase": "Simpan sebagai Kasus Pengujian",
  "analyzer.testMapping.submit": "Pratinjau Pemetaan",
  "analyzer.testMapping.subtitle": "Pratinjau bagaimana sampel pesan ASTM akan diinterpretasi",
  "analyzer.testMapping.testAnother": "Uji Pesan Lainnya",
  "analyzer.testMapping.title": "Pemetaan Bidang Pemeriksaan",
  "analyzer.testMapping.validation.invalidFormat": "Format pesan ASTM invalid",
  "analyzer.testMapping.validation.messageRequired": "Pesan ASTM wajib ada",
  "analyzer.testMapping.validation.messageTooLarge": "Pesan ASTM melebihi maksimum 10KB",
  "analyzer.testMapping.warnings": "Peringatan",
  "analyzer.unitMapping.analyzerUnit": "Satuan Sumber (Alat)",
  "analyzer.unitMapping.analyzerUnit.helper": "Satuan yang dilaporkan oleh alat",
  "analyzer.unitMapping.conversionFactor": "Faktor Konversi",
  "analyzer.unitMapping.conversionFactor.helper": "Faktor untuk mengkonversi dari {from} ke {to} (misalnya, 0.0555 mg/dL ke mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Satuan Target (SILNAS)",
  "analyzer.unitMapping.openelisUnit.helper": "Satuan resmi digunakan di SILNAS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Pilih satuan target",
  "analyzer.unitMapping.rejectIfMismatch": "Tolak bila Satuan Tidak Cocok",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Tolak pesan bila satuan tidak cocok dan tidak ada faktor konversi yang tersedia",
  "analyzer.unitMapping.subtitle": "Konfigurasi pemetaan satuan untuk {fieldName}",
  "analyzer.unitMapping.title": "Pemetaan Satuan",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Satuan sumber wajib ada",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Faktor konversi harus angka positif",
  "analyzer.unitMapping.validation.conversionFactor.required": "Faktor konversi wajib ada jika satuan berbeda",
  "analyzer.unitMapping.validation.error": "Kesalahan Validasi",
  "analyzer.unitMapping.validation.error.subtitle": "Mohon perbaiki error di bawah",
  "analyzer.unitMapping.validation.openelisUnit.required": "Satuan target wajib ada",
  "analyzerTestName.header.analyzerName": "Alat - Nama Alat Uji",
  "analyzerTestName.modal.add.heading": "Tambah Nama Alat Uji",
  "analyzerTestName.modal.update.heading": "Perbarui Nama Alat Uji",
  "assigned.cytopathologist.label": "Ahli Sitopatologi ditugaskan",
  "assigned.pathologist.label": "Ahli Patologi ditugaskan",
  "assigned.technician.label": "Teknisi ditugaskan",
  "audittrail.table.heading.action": "Tindakan",
  "audittrail.table.heading.identifier": "Pengidentifikasi",
  "audittrail.table.heading.item": "Barang",
  "audittrail.table.heading.newvalue": "Nilai Baru",
  "audittrail.table.heading.oldvalue": "Nilai Lama",
  "audittrail.table.heading.time": "Waktu",
  "audittrail.table.heading.user": "Pengguna",
  "audittrail.table.title.patientResults": "Hasil Pasien",
  "availabletests.title": "Pemeriksaan Tersedia",
  "back.action.button": "Kembali",
  "banner.menu.administration": "Admin",
  "banner.menu.alerts": "Peringatan",
  "banner.menu.alerts.tooltip": "Dasbor peringatan dan penjaminan mutu",
  "banner.menu.aliquot": "Alikuot",
  "banner.menu.aliquot.tooltip": "Alikuot sampel",
  "banner.menu.billing": "Pembayaran",
  "banner.menu.billing.tooltip": "Pembayaran",
  "banner.menu.createDouble": "Entri Ganda",
  "banner.menu.createInitial": "Entri Awal",
  "banner.menu.eorders": "Pemesanan yang masuk",
  "banner.menu.eqa": "PME",
  "banner.menu.eqa.distribution": "Distribusi PME",
  "banner.menu.eqa.distribution.tooltip": "Buat dan kelola distribusi PME",
  "banner.menu.eqa.management": "Program PME",
  "banner.menu.eqa.management.tooltip": "Buat dan kelola program PME",
  "banner.menu.eqa.mgmt": "Pengelolaan PME",
  "banner.menu.eqa.mgmt.distributions": "Distribusi",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Buat dan kelola distribusi PME",
  "banner.menu.eqa.mgmt.participants": "Peserta",
  "banner.menu.eqa.mgmt.participants.tooltip": "Kelola pendaftaran organisasi di program PME",
  "banner.menu.eqa.mgmt.programs": "Program",
  "banner.menu.eqa.mgmt.programs.tooltip": "Buat dan kelola program PME",
  "banner.menu.eqa.mgmt.results": "Hasil & Analisis",
  "banner.menu.eqa.mgmt.results.tooltip": "Pengumpulan hasil PME dan analisis statistik",
  "banner.menu.eqa.mgmt.tooltip": "Kelola program, peserta, dan distribusi PME",
  "banner.menu.eqa.tests": "Pemeriksaan PME",
  "banner.menu.eqa.tests.myPrograms": "Program Saya",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Kelola pendaftaran pribadi untuk program PME eksternal",
  "banner.menu.eqa.tests.orders": "Pemesanan",
  "banner.menu.eqa.tests.orders.tooltip": "Lihat dan kelola pemesanan pemeriksaan PME",
  "banner.menu.eqa.tests.tooltip": "Pemesanan pemeriksaan PME dan pendaftaran program",
  "banner.menu.eqa.tooltip": "Pemantapan Mutu Eksternal",
  "banner.menu.generic.sample": "Sampel Generik",
  "banner.menu.generic.sample.edit": "Edit Sampel",
  "banner.menu.generic.sample.import": "Impor Sampel",
  "banner.menu.generic.sample.order": "Penerimaan Sampel",
  "banner.menu.generic.sample.results": "Masukkan Hasil",
  "banner.menu.help": "Bantuan",
  "banner.menu.help.about": "Tutorial Video",
  "banner.menu.help.contact": "Catatan rilis",
  "banner.menu.help.documents": "Dokumentasi Proses",
  "banner.menu.help.formDBS": "Formulir Dried Blood Spot",
  "banner.menu.help.formVL": "Formulir Viral Load",
  "banner.menu.help.usermanual": "Panduan Pengguna",
  "banner.menu.home": "Beranda",
  "banner.menu.inventory": "Inventaris",
  "banner.menu.inventory.catalog": "Kelola Katalog",
  "banner.menu.inventory.dashboard": "Dasbor",
  "banner.menu.inventory.list": "Barang Inventaris",
  "banner.menu.inventory.reports": "Laporan",
  "banner.menu.nonconformity": "Ketidaksesuaian",
  "banner.menu.nonconformity.correctiveActions": "Tindakan perbaikan",
  "banner.menu.nonconformity.dashboard": "Semua Kejadian Ketidaksesuaian",
  "banner.menu.nonconformity.report": "Laporan Kejadian Ketidaksesuaian",
  "banner.menu.nonconformity.view": "Lihat Kejadian Ketidaksesuaian Baru",
  "banner.menu.patient": "Pasien",
  "banner.menu.patient.Create": "Kajian",
  "banner.menu.patient.addOrEdit": "Tambah/Edit Pasien",
  "banner.menu.patient.merge": "Gabung Pasien",
  "banner.menu.patient.merge.tooltip": "Gabung duplikasi rekaman pasien",
  "banner.menu.patientConsult": "Lihat",
  "banner.menu.patientEdit": "Sunting",
  "banner.menu.patienthistory": "Riwayat Pasien",
  "banner.menu.printBarcode": "Kode QR",
  "banner.menu.referredOut": "Dirujuk keluar",
  "banner.menu.report.validation.backlog": "Validasi Tertunda",
  "banner.menu.reports": "Laporan",
  "banner.menu.reports.routine": "Rutin",
  "banner.menu.reports.study": "Kajian",
  "banner.menu.results": "Hasil",
  "banner.menu.results.CobasIntegra400": "Biokimia: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Imunologi: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Imunologi: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Imunologi: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biokimia: Pengimpor seluruh alat",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalisis",
  "banner.menu.results.SysmeXT": "Hematologi: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNLAnalyzer",
  "banner.menu.results.SysmexXNLanalyzer": "Alat Analisis SysmexXNL",
  "banner.menu.results.SysmexXPAnalyzer": "Sysmex XP Analyzer",
  "banner.menu.results.SysmexXPanalyzer": "Alat Analisis SysmexXP",
  "banner.menu.results.accession": "Berdasarkan Pemesanan",
  "banner.menu.results.analyzer": "Alat",
  "banner.menu.results.cobasc111analyzer": "Biokimia: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Berdasarkan Unit",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Pemesanan Program",
  "banner.menu.results.patient": "Berdasarkan Pasien",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Berdasarkan Pemeriksaan, Tanggal atau Status",
  "banner.menu.results.sysmexanalyzer": "Hematologi: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Hematologi: Pengimport Sysmex XT analyzer",
  "banner.menu.results.taqman48dbsanalyzer": "Virologi: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Berdasarkan Tanggal Pemeriksaan",
  "banner.menu.results.unified": "Entri Hasil",
  "banner.menu.results.unified.tooltip": "Daftar pekerjaan entri hasil terpadu",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validasi",
  "banner.menu.resultvalidation.bacteria": "Bakteri",
  "banner.menu.resultvalidation.bench": "Berdasarkan Meja Kerja",
  "banner.menu.resultvalidation.biochemistry": "Biokimia",
  "banner.menu.resultvalidation.cytobacteriology": "Sitobakteriologi",
  "banner.menu.resultvalidation.dnapcr": "PCR DNA",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endokrinologi",
  "banner.menu.resultvalidation.genotyping": "Genotiping",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-imunologi",
  "banner.menu.resultvalidation.hematology": "Hematologi",
  "banner.menu.resultvalidation.immunology": "Imunologi",
  "banner.menu.resultvalidation.immunology.Haiti": "Imuno-virologi",
  "banner.menu.resultvalidation.immunologyHematology": "Imuno - hematologi",
  "banner.menu.resultvalidation.liquidBio": "Cairan biologis",
  "banner.menu.resultvalidation.malaria": "Malaria",
  "banner.menu.resultvalidation.molecularBio": "Biologi Molekuler",
  "banner.menu.resultvalidation.mycobacteriology": "Mikobakteriologi",
  "banner.menu.resultvalidation.mycology": "Mikologi",
  "banner.menu.resultvalidation.parasitology": "Parasitologi",
  "banner.menu.resultvalidation.serology": "Serologi",
  "banner.menu.resultvalidation.serology-immunology": "Serologi-Imunologi",
  "banner.menu.resultvalidation.viralload": "Viral Load",
  "banner.menu.resultvalidation.virology": "Virologi",
  "banner.menu.resultvalidation_routine": "Rutin",
  "banner.menu.resultvalidation_study": "Kajian",
  "banner.menu.sample": "Pemesanan",
  "banner.menu.sample.shipment": "Pengiriman Sampel",
  "banner.menu.sampleAdd": "Tambah Pemesanan",
  "banner.menu.sampleBatchEntry": "Masukkan Pemesanan Batch",
  "banner.menu.sampleConsult": "Lihat",
  "banner.menu.sampleCreate": "Kajian",
  "banner.menu.sampleEdit": "Edit Pemesanan",
  "banner.menu.sampleManagement": "Pengelolaan Sampel",
  "banner.menu.sampleManagement.tooltip": "Menu Pengelolaan Sampel",
  "banner.menu.storage": "Penyimpanan",
  "banner.menu.storage.tooltip": "Pengelolaan Penyimpanan Sampel",
  "banner.menu.study.eorders": "Pemesanan Elektronik",
  "banner.menu.workplan": "Rencana Kerja",
  "banner.menu.workplan.batch": "Batch Workplan",
  "banner.menu.workplan.batch.tooltip": "Batch Workplan",
  "banner.menu.workplan.bench": "Berdasarkan Unit",
  "banner.menu.workplan.panel": "Berdasarkan Panel",
  "banner.menu.workplan.priority": "Berdasarkan Prioritas",
  "banner.menu.workplan.test": "Berdasarkan Jenis Pemeriksaan",
  "banner.menu.workplan.unit": "Berdasarkan Bagian Pemeriksaan",
  "barcode.additionalInvalidLevels.message": "Kode QR memiliki tingkatan di luar bagian yang valid. Hanya tingkatan valid yang diisi.",
  "barcode.additionalInvalidLevels.warning": "Tingkatan tidak valid lainnya terdeteksi",
  "barcode.autoOpenForm": "Membuka formulir lokasi dengan hirarki yang valid",
  "barcode.debounce.warning": "Silahkan tunggu sebelum memindai kode QR lain",
  "barcode.error": "Kode QR tidak valid",
  "barcode.firstMissingLevel": "Tingkatan pertama yang hilang: {level}",
  "barcode.format": "Format Kode QR",
  "barcode.header": "kode QR",
  "barcode.invalidFormat": "Format kode QR tidak valid. Aturan: RUANGAN-PERANGKAT atau RUANGAN-PERANGKAT-RAK-LACI-POSISI",
  "barcode.label.block": "Label blok",
  "barcode.label.freezer": "Label freezer",
  "barcode.label.helper.text": "Masukkan nilai dalam: mm",
  "barcode.label.order": "Label Pemesanan",
  "barcode.label.slide": "Label slide",
  "barcode.label.specimen": "Label spesimen",
  "barcode.label.info.blockCaseNumber": "Nomor Kasus Blok",
  "barcode.label.info.blockId": "ID Blok",
  "barcode.label.info.blockNumber": "Nomor Blok",
  "barcode.label.info.boxid": "ID Boks",
  "barcode.label.info.caseNumber": "Nomor Kasus",
  "barcode.label.info.collectedBy": "Dikumpulkan oleh",
  "barcode.label.info.collectionDate": "Tanggal Pengambilan",
  "barcode.label.info.collectionDateTime": "Tanggal dan Waktu Pengumpulan",
  "barcode.label.info.created": "Dibuat",
  "barcode.label.info.destination": "Tujuan",
  "barcode.label.info.expiryDate": "Tanggal Kedaluwarsa",
  "barcode.label.info.labNumber": "Nomor Registrasi",
  "barcode.label.info.patientDobFull": "Tanggal Lahir Pasien",
  "barcode.label.info.patientId": "NIK Pasien",
  "barcode.label.info.patientName": "Nama Pasien",
  "barcode.label.info.patientSexFull": "Jenis Kelamin Pasien",
  "barcode.label.info.samplecount": "Sampel",
  "barcode.label.info.siteId": "Identitas Situs",
  "barcode.label.info.slideId": "ID slide",
  "barcode.label.info.slideNumber": "Nomor Slide",
  "barcode.label.info.specimenType": "Jenis Spesimen",
  "barcode.label.info.stainType": "Jenis Pewarnaan",
  "barcode.label.info.storageLocation": "Lokasi Penyimpanan",
  "barcode.label.info.temperature": "Suhu",
  "barcode.label.info.tests": "Pemeriksaan",
  "barcode.labels.order.row": "Label pemesanan",
  "barcode.labels.running.total": "Total pengerjaan",
  "barcode.labels.sample.row": "Contoh label spesimen {sampleNumber}",
  "barcode.labels.section.title": "Kuantitas label",
  "barcode.locationNotFound": "Lokasi tidak ditemukan",
  "barcode.notification.save": "Konfigurasi kode QR telah disimpan",
  "barcode.partialMatch": "Kecocokan parsial - beberapa komponen valid",
  "barcode.print.button": "Cetak",
  "barcode.print.dialog.quantityFor": "Kuantitas yang akan dicetak {label}",
  "barcode.print.dialog.title": "Cetak label",
  "barcode.print.done": "Selesai",
  "barcode.print.individual.button": "Cetak Label",
  "barcode.print.later": "Loncat — Cetak Nanti",
  "barcode.print.preprint": "Kode QR pra-cetak",
  "barcode.print.preprint.button": "Label pra-cetak",
  "barcode.print.preprint.note": "Catatan: Bila ada penambahan institusi dan/atau sampel dan pemeriksaan, data tersebut akan dicetak di SEMUA label",
  "barcode.print.reprint.dialog": "Cetak ulang label",
  "barcode.print.section.set": "Pengaturan cetak",
  "barcode.print.set.button": "Pengaturan Cetak",
  "barcode.print.set.instruction": "Pengaturan cetak untuk label (2 label pemesanan pemeriksaan+ 1 label per spesimen)",
  "barcode.print.skip": "Lewati",
  "barcode.print.title": "Cetak Label Kode QR",
  "barcode.ready": "Siap untuk memindai",
  "barcode.scan": "Pindai kode QR",
  "barcode.scan.error": "Pemesanan tidak ditemukan",
  "barcode.scan.placeholder": "Pindai Kode QR atau masukkan nomor lab...",
  "barcode.scan.success": "Pemesanan berhasil dimuat",
  "barcode.scanning": "Memindai...",
  "barcode.scanOrType": "Pindai kode QR atau ketik lokasi",
  "barcode.success": "Lokasi ditemukan",
  "barcode.validHierarchyPrefilled": "Tingkatan hirarki yang valid telah terisi",
  "barcode.validation.altPrefix": "Input harus alphanumeric dan mengandung maksimum 4 karakter.",
  "barcode.validationFailed": "Validasi kode QR gagal",
  "barcodeconfiguration.browse.title": "Konfigurasi Kode QR",
  "breadcrumb.home": "Beranda",
  "breadcrumb.caseView": "Lihat Tampilan Kasus",
  "breadcrums.admin.managment": "Pengelolaan Admin",
  "calendar.management.title": "Pengelolaan Kalender",
  "calendar.management.description": "Kelola libur nasional dan konfigurasi akhir pekan untuk penghitungan TAT di jam kerja",
  "calendar.management.addHoliday": "Tambah hari libur",
  "calendar.management.editHoliday": "Edit hari libur",
  "calendar.management.deleteConfirm": "Apakah Anda mau menghapus hari libur ini?",
  "calendar.management.holidayName": "Nama Hari Libur",
  "calendar.management.date": "Tanggal",
  "calendar.management.recurring": "Pengulangan",
  "calendar.management.annual": "Tahunan",
  "calendar.management.oneTime": "Sekali",
  "calendar.management.active": "Aktif",
  "calendar.management.inactive": "Inaktif",
  "calendar.management.weekend": "Akhir pekan",
  "calendar.management.weekendDays": "Hari Akhir Pekan (dikeluarkan dari Jam Kerja)",
  "calendar.management.weekendSaved": "Konfigurasi akhir pekan disimpan",
  "calendar.management.importCsv": "Impor CSV",
  "calendar.management.exportCsv": "Ekspor CSV",
  "calendar.management.importPreview": "Pratinjau Impor",
  "calendar.management.year": "Tahun",
  "calendar.management.noHolidays": "Tidak ada Hari Libur dikonfigurasi untuk {year}. Klik \"Tambah Hari Libur\" untuk mulai.",
  "calendar.management.duplicateDate": "Hari Libur sudah ada di tanggal ini",
  "calendar.management.imported": "{count} hari libur diimpor",
  "calendar.management.skipped": "{count} hari libur diloncat",
  "calendar.management.holidayCount": "{count} hari libur dikonfigurasi untuk {year}",
  "calendar.management.saveError": "Error menyimpan hari libur",
  "calendar.management.loadError": "Error menyimpan hari libur",
  "calendar.management.save": "Simpan",
  "calendar.management.cancel": "Batal",
  "calendar.management.actions": "Aksi",
  "calendar.management.status": "Status",
  "calendar.management.column.date": "Tanggal",
  "calendar.management.column.holidayName": "Nama Hari Libur",
  "calendar.management.column.recurring": "Pengulangan",
  "calendar.management.column.status": "Status",
  "calendar.management.column.actions": "Aksi",
  "calendar.management.day.sun": "Min",
  "calendar.management.day.mon": "Sen",
  "calendar.management.day.tue": "Sel",
  "calendar.management.day.wed": "Rab",
  "calendar.management.day.thu": "Kam",
  "calendar.management.day.fri": "Jum",
  "calendar.management.day.sat": "Sab",
  "calendar.management.chooseFile": "Pilih file CSV",
  "calendar.management.csvColumns": "Kolom: tanggal, nama, pengulangan (true/false)",
  "calendar.management.rowsFound": "{count} baris ditemukan",
  "calendar.management.column.csvDate": "Tanggal",
  "calendar.management.column.csvName": "Nama",
  "calendar.management.column.csvRecurring": "Pengulangan",
  "calendar.management.importing": "Mengimpor...",
  "caseView.action.discard": "Discard changes",
  "caseView.action.saveDraft": "Save draft",
  "caseView.banner.unsavedChanges": "This case has unsaved changes. Leave the page and lose them?",
  "caseView.badge.notApplicable": "N/A",
  "caseView.badge.readOnly": "Read only",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "Perkembangan kasus",
  "caseView.label.caseSummary": "Case summary",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "— not recorded",
  "caseView.label.unsavedChanges": "Perubahan tidak tersimpan",
  "caseView.locked.awaitingStage": "Available once the case reaches {stage}",
  "caseView.locked.prerequisite": "Available once this case's earlier steps are complete",
  "column.qc.accession": "Sampel QC",
  "column.qc.detail": "Detail",
  "column.qc.result": "Hasil",
  "column.qc.test": "Pemeriksaan",
  "column.qc.type": "Tipe",
  "compliance.dashboard.chart.comparison.title": "Perbandingan Lokasi — Persentase Kepatuhan Periode Saat Ini",
  "compliance.dashboard.chart.drilldown.title": "Analisis Mendalam Situs — Tren per Parameter",
  "compliance.dashboard.chart.trend.title": "Tren Tingkat Kepatuhan — Semua Tempat",
  "compliance.dashboard.descriptive.excluded": "Parameter deskriptif yang tidak dimasukkan dalam grafik tren",
  "compliance.dashboard.drilldown.placeholder": "Pilih tempat…",
  "compliance.dashboard.empty": "Tidak ada data yang sesuai dengan filter yang dipilih",
  "compliance.dashboard.export.pdf": "Ekspor PDF",
  "compliance.dashboard.filter.allStandards": "Semua Standar",
  "compliance.dashboard.filter.dateRange": "Rentang Tanggal",
  "compliance.dashboard.filter.dateRangeEnd": "Tanggal Selesai",
  "compliance.dashboard.filter.drilldownSite": "Lakukan analisis mendalam oleh lokasi",
  "compliance.dashboard.filter.sites": "Tempat Pengambilan Sampel",
  "compliance.dashboard.filter.standard": "Baku Mutu",
  "compliance.dashboard.kpi.complianceRate": "Tingkat Kepatuhan",
  "compliance.dashboard.kpi.exceedances": "Jumlah Pelanggaran Batas",
  "compliance.dashboard.kpi.sitesMonitored": "Situs yang Dipantau",
  "compliance.dashboard.kpi.totalOrders": "Jumlah Pemesanan",
  "compliance.dashboard.loading.comparison": "Sedang memuat perbandingan…",
  "compliance.dashboard.loading.drilldown": "Sedang memuat detail lebih lanjut…",
  "compliance.dashboard.loading.exceedances": "Memuat data pelampauan batas…",
  "compliance.dashboard.loading.generating": "Sedang membuat…",
  "compliance.dashboard.loading.trend": "Memuat tren…",
  "compliance.dashboard.lowData": "Data rendah (< 3 pemesanan)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Tanggal",
  "compliance.dashboard.table.col.labNumber": "Lab #",
  "compliance.dashboard.table.col.parameter": "Parameter",
  "compliance.dashboard.table.col.result": "Hasil",
  "compliance.dashboard.table.col.site": "Situs",
  "compliance.dashboard.table.col.status": "Status",
  "compliance.dashboard.table.col.threshold": "Ambang batas",
  "compliance.dashboard.table.exceedances.title": "Ringkasan Pelampauan",
  "compliance.dashboard.title": "Dasbor Kepatuhan Lingkungan",
  "error.referOut.emailFormat": "Masukkan alamat email yang valid (misalnya, lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Tanggal/Waktu Serah Terima wajib diisi untuk proses pengiriman.",
  "error.referOut.maxLength": "Maksimal {max} karakter.",
  "error.referOut.phoneFormat": "Masukkan nomor telepon yang valid beserta prefiks kode negara (misalnya +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Pilih Lab Rujukan.",
  "error.validation.qc.ackFailed": "Gagal mencatat konfirmasi QC. Silakan coba lagi.",
  "holding.time.exceeded.message": "Waktu penahanan maksimum sesuai SOP telah terlampaui untuk: {tests}",
  "holding.time.exceeded.note": "PERINGATAN: Hasil dimasukkan setelah batas waktu penyimpanan maksimum sesuai SOP terlampaui.",
  "holding.time.exceeded.title": "Waktu Penahanan Telah Melebihi Batas",
  "instructions.results.entry.unified.route": "Jika diaktifkan, daftar kerja Entri Hasil terpadu akan menggantikan halaman entri hasil versi lama: menu Hasil akan menampilkan satu item Entri Hasil, dan tautan entri hasil versi lama akan dialihkan ke sana. Nonaktifkan untuk mengembalikan halaman versi lama.",
  "label.button.edit.details": "Edit detail",
  "label.expand.poolDetails": "Perluas detail kolam renang",
  "label.pool.collapse": "Sembunyikan spesimen tertentu",
  "label.pool.expand": "Tampilkan spesimen satu per satu",
  "label.pool.expansion.next": "Berikutnya",
  "label.pool.expansion.page": "Halaman {page} dari {total}",
  "label.pool.expansion.prev": "Sebelumnya",
  "label.pool.expansion.title": "{animal} Spesimen ({count})",
  "label.qc.fail": "Gagal",
  "label.qc.pass": "Lewati",
  "label.referOut.action.dispatch": "Pengiriman",
  "label.referOut.action.edit": "Sunting",
  "label.referOut.action.referOut": "Dirujuk keluar",
  "label.referOut.action.save": "Simpan Rujukan",
  "label.referOut.action.view": "Lihat",
  "label.referOut.column.actions": "Aksi",
  "label.referOut.column.referringLab": "Lab Rujukan",
  "label.referOut.column.sampleId": "Nomor Identitas Sampel",
  "label.referOut.column.sampleType": "Jenis Sampel",
  "label.referOut.column.status": "Status Subkontrak",
  "label.referOut.column.tests": "Pemeriksaan",
  "label.referOut.dispatch.error": "Gagal mengirimkan rujukan.",
  "label.referOut.dispatch.notSaved": "Simpan rujukan tersebut sebelum dikirim.",
  "label.referOut.dispatch.success": "Rujukan telah dikirim.",
  "label.referOut.empty.subtitle": "Sampel akan muncul di sini setelah disimpan. Simpan pesanan terlebih dahulu untuk merujuk spesimen.",
  "label.referOut.empty.title": "Tidak ada sampel yang tersedia untuk rujukan",
  "label.referOut.field.agreementReference": "Nomor Perjanjian",
  "label.referOut.field.cocContactEmail": "Alamat Email Kontak Rantai Pengawasan",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Nama Kontak Rantai Pengawasan",
  "label.referOut.field.cocContactPhone": "Nomor Telepon Kontak Rantai Pengawasan",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Tanggal Kembalinya yang Diperkirakan",
  "label.referOut.field.handoffDate": "Tanggal Serah Terima",
  "label.referOut.field.handoffDatetime": "Tanggal/Waktu Serah Terima",
  "label.referOut.field.handoffTime": "Waktu Serah Terima",
  "label.referOut.field.handoffTime.placeholder": "jam:menit",
  "label.referOut.field.notes": "Catatan",
  "label.referOut.field.referringLab": "Lab Rujukan",
  "label.referOut.field.referringLab.placeholder": "Pilih Lab Rujukan",
  "label.referOut.save.error": "Gagal menyimpan rujukan.",
  "label.referOut.save.success": "Rujukan telah disimpan.",
  "label.referOut.section.description": "Kirimkan spesimen ke laboratorium eksternal. Setiap sampel dilengkapi dengan metadata rantai pengawasan yang lengkap.",
  "label.referOut.section.title": "Dirujuk keluar / Subkontrak",
  "label.referOut.status.cancelled": "Dibatalkan",
  "label.referOut.status.closed": "Ditutup",
  "label.referOut.status.completed": "Selesai",
  "label.referOut.status.dispatched": "Telah dikirim",
  "label.referOut.status.draft": "Draf",
  "label.referOut.status.inProgress": "Dalam pengerjaan",
  "label.referOut.status.notReferred": "Di dalam perusahaan",
  "label.referOut.status.received": "Diterima",
  "label.referOut.status.rejected": "Ditolak",
  "label.referOut.status.requested": "Diminta",
  "label.referOut.status.resultsReturned": "Hasil yang Ditampilkan",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "Sampel klien",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "Saya telah meninjau kegagalan QC dan mengevaluasi dampaknya terhadap penerbitan hasil",
  "label.validation.qc.ack.heading": "Pernyataan Pengakuan Wajib",
  "label.validation.qc.banner.subtitle": "Silakan tinjau dan ketahui hal-hal di bawah ini sebelum mempublikasikan hasilnya.",
  "label.validation.qc.banner.title": "Terdeteksi kegagalan QC — {count} Sampel QC tidak memenuhi kriteria penerimaan",
  "label.validation.qc.failedSamples": "Sampel yang Gagal dalam QC",
  "label.validation.qc.justification": "Alasan",
  "label.validation.checkBeforeRelease": "Periksa sebelum dirilis",
  "label.validation.triage.filterLabel": "Filter oleh sinyal",
  "label.validation.filter.all": "Semua",
  "label.validation.filter.needsReview": "Perlu ditinjau",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "Gagal QC",
  "label.validation.filter.modified": "Dimodifikasi",
  "label.validation.filter.ackPending": "Tanggapan tertunda",
  "label.validation.filter.critical": "Kritis",
  "label.validation.filter.abnormal": "Tidak normal",
  "label.validation.lane.clear": "Kosongkan",
  "label.validation.lane.needsReview": "Perlu ditinjau",
  "label.validation.signal.nce": "NCE terbuka",
  "label.validation.signal.qcFail": "Gagal QC",
  "label.validation.signal.modified": "Dimodifikasi",
  "label.validation.signal.ackPending": "Tanggapan tertunda",
  "label.validation.signal.nonconforming": "Tidak Sesuai",
  "label.validation.signal.critical": "Kritis",
  "label.validation.review.result": "Hasil",
  "label.validation.review.units": "Unit",
  "label.validation.review.normalRange": "Rentang referensi",
  "label.validation.review.criticalRange": "Rentang kritis",
  "label.validation.review.method": "Metode",
  "label.validation.review.analyzer": "Alat",
  "label.validation.review.performedAt": "Performed at",
  "label.validation.review.enteredBy": "Dimasukkan oleh",
  "label.validation.review.enteredDate": "Dimasukkan pada",
  "label.validation.review.collected": "Diambil",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC lolos",
  "label.validation.review.qc.FAIL": "QC gagal",
  "label.validation.review.notRecorded": "Tidak terekam",
  "label.validation.review.beforeRelease": "Sebelum merilis, periksa:",
  "label.validation.review.components": "Komponen",
  "label.validation.review.component": "Komponen",
  "label.validation.review.flag": "Bendera",
  "label.validation.review.primary": "Primer",
  "label.validation.review.reference": "Referensi",
  "label.validation.review.notes": "Catatan",
  "label.validation.review.notes.summary": "{count} Catatan",
  "label.validation.review.notes.empty": "Tidak ada catatan",
  "label.validation.review.notes.add": "Catatan validasi",
  "label.validation.review.notes.placeholder": "Tambahkan catatan validasi…",
  "label.validation.review.notes.visibility": "Visibilitas",
  "label.validation.review.notes.internal": "Internal",
  "label.validation.review.notes.external": "Kirim beserta hasilnya",
  "label.validation.review.notes.externalWarning": "Catatan ini akan tercantum dalam laporan pasien.",
  "label.validation.review.notes.contextHint": "Konteks: Validasi (direkam secara otomatis).",
  "label.validation.review.notes.context.result": "Catatan hasil",
  "label.validation.review.modify.reason": "Alasan perubahan",
  "label.validation.review.modify.reasonRequired": "Alasan wajib untuk mengubah suatu hasil.",
  "label.validation.review.modify.newValue": "Hasil terbaru",
  "label.validation.review.modify.notEditable": "Jenis hasil ini diedit di halaman Entri Hasil.",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "Batch reagen dan Lot Kontrol untuk analisis ini ditinjau pada halaman Entri Hasil.",
  "label.validation.review.action.release": "Validasi & merilis",
  "label.validation.review.action.modify": "Ubah hasil",
  "label.validation.review.action.saveModification": "Simpan perubahan",
  "label.validation.review.action.cancel": "Batal",
  "label.validation.review.action.refer": "Rujuk pemeriksaan ini",
  "label.validation.review.release.qcAckFirst": "Mengetahui masalah QC yang gagal di bawah ini sebelum merilis.",
  "label.validation.review.error.notAwaitingValidation": "Hasil ini telah berubah sejak halaman dimuat. Silakan muat ulang halaman dan periksa kembali.",
  "label.validation.review.error.qcAcknowledgmentRequired": "Produk yang gagal dalam pengendalian mutu (QC) dalam batch ini harus diketahui sebelum dilepas ke pasar.",
  "label.validation.review.error.modificationReasonRequired": "Alasan wajib untuk mengubah suatu hasil.",
  "label.validation.review.error.modifyRoleRequired": "Peran Anda tidak memungkinkan untuk melakukan modifikasi terhadap hasil.",
  "label.validation.review.error.resultRequired": "Masukkan nilai hasil sebelum menyimpan.",
  "label.validation.review.error.invalidResult": "Hasilnya belum lengkap; periksa nilai yang memenuhi syarat.",
  "label.validation.review.error.generic": "Aksi tersebut tidak dapat diselesaikan.",
  "label.validation.review.success.released": "Hasil telah divalidasi dan diterbitkan.",
  "label.validation.review.success.modified": "Hasil telah diubah. Hasil tersebut tetap berada dalam antrian Validasi.",
  "esig.context.validateSingle": "Melakukan validasi dan merilis {test} untuk akses {accession}",
  "label.validation.bulk.releaseAllClear": "Laporan \"{count}\"",
  "label.validation.bulk.heading": "Rilis semua hasil yang dinyatakan aman",
  "label.validation.bulk.body": "Hasil pengujian \"{count}\" ini berada di jalur \"Clear\": dalam rentang yang ditentukan, lolos QC, tidak ada ketidaksesuaian, tidak dimodifikasi, dan tidak kritis. Proses pelepasan (release) menghasilkan satu tanda tangan elektronik untuk seluruh set; hasil yang tidak lagi memenuhi kriteria \"Clear\" sebelum pelepasan akan dilewati.",
  "label.validation.bulk.disabled": "Fitur pelepasan massal dinonaktifkan untuk Laboratorium Ini.",
  "label.validation.emptyState.signals": "{count} results in this queue carry something to check before release.",
  "label.validation.emptyState.signalsDetail": "Most common: {signals}.",
  "label.validation.emptyState.noReference": "{count} results are for tests with no reference value recorded in the test catalogue, so they cannot be judged as normal.",
  "label.validation.emptyState.noReferenceHint": "Record an expected normal value for these tests in the Test Catalogue to let their results clear.",
  "label.validation.emptyState.queueEmpty": "Nothing is waiting for validation.",
  "label.validation.release.scope": "Clearance checks the reference range, result flags, non-conformities, edits after save and critical acknowledgment, and stops any result with a recorded quality-control failure. It does not confirm that quality control was performed.",
  "label.validation.bulk.none": "Tidak ada hasil yang jelas untuk diumumkan.",
  "label.validation.bulk.column.accession": "No Registrasi.",
  "label.validation.bulk.success": "{count} hasil yang jelas telah diumumkan.",
  "label.validation.bulk.partial": "{released} dirilis; {skipped} dilewati karena isinya sudah tidak jelas lagi.",
  "label.validation.bulk.error.bulkReleaseDisabled": "Fitur pelepasan massal dinonaktifkan untuk Laboratorium Ini.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "Produk yang gagal dalam pengendalian mutu (QC) dalam batch ini harus diketahui sebelum dilepas ke pasar.",
  "label.validation.bulk.error.nothingReleased": "Tidak ada satu pun dari hasil yang terpilih itu yang sudah jelas; belum ada yang diumumkan.",
  "label.validation.bulk.error.generic": "Proses pelepasan massal tidak selesai.",
  "label.validation.review.action.review": "Ulasan →",
  "esig.context.releaseAllClear": "{count} hasil yang jelas untuk {accession}",
  "instructions.validation.bulk.release": "Jika diaktifkan, halaman Validasi menampilkan opsi \"Rilis semua sekaligus\", yang hanya merilis hasil di jalur Clear (dalam rentang, lolos QC, tidak ada sinyal) dengan satu tanda tangan elektronik. Nonaktifkan opsi ini jika Anda ingin setiap hasil dirilis satu per satu setelah ditinjau.",
  "instructions.validation.retest.note": "Jika fitur ini diaktifkan, seorang validator yang mengirimkan hasil kembali untuk Pemeriksaan Ulang harus menulis catatan untuk tim penguji.",
  "label.validation.review.action.retest": "Kirim untuk Pemeriksaan Ulang",
  "label.validation.review.action.reject": "Tolak (berkas NCE)",
  "label.validation.review.retest.note": "Catatan untuk bangku cadangan",
  "label.validation.review.retest.noteRequired": "Catatan wajib untuk mengirimkan hasil Pemeriksaan Ulang.",
  "label.validation.review.retest.hint": "Hasil tersebut dikembalikan ke \"Entri Hasil\" dan alur proses dimulai kembali dari level 1.",
  "label.validation.review.reject.hint": "Penolakan file merupakan kejadian ketidaksesuaian; isi formulir ini untuk mencatatnya.",
  "label.validation.review.reject.disabled": "Fitur penolakan hasil dinonaktifkan untuk laboratorium ini.",
  "label.validation.review.error.stale": "Hasil ini telah diubah oleh {who} di {when}. Sedang memuat ulang antrian…",
  "label.validation.review.error.retestNoteRequired": "Catatan wajib untuk mengirimkan hasil Pemeriksaan Ulang.",
  "label.validation.review.error.rejectionDisabled": "Fitur penolakan hasil dinonaktifkan untuk laboratorium ini.",
  "label.validation.review.success.retest": "Hasil dikirim untuk Pemeriksaan Ulang.",
  "label.validation.review.success.rejected": "Hasil ditolak; kejadian ketidaksesuaian dicatat.",
  "label.validation.bulk.error.stale": "Antrean telah berubah saat Anda sedang memeriksanya. Sedang dimuat ulang…",
  "label.validation.autoValidated.toggle": "Sertakan validasi otomatis",
  "label.validation.autoValidated.heading": "Hasil yang divalidasi secara otomatis ({count})",
  "label.validation.autoValidated.tag": "Divalidasi secara otomatis",
  "label.validation.autoValidated.empty": "Tidak ada hasil yang divalidasi secara otomatis untuk akses ini.",
  "label.validation.autoValidated.hint": "Diterbitkan saat entri hasil tanpa validator; ditampilkan hanya untuk ditinjau.",
  "label.validation.autoValidated.releasedOn": "Dirilis pada",
  "laporanHasil.action.generatePdf": "Membuat PDF",
  "laporanHasil.action.regeneratePdf": "Membuat ulang PDF",
  "laporanHasil.col.actions": "Aksi",
  "laporanHasil.col.collectionDate": "Tanggal Pengambilan",
  "laporanHasil.col.compliance": "Kepatuhan",
  "laporanHasil.col.labNumber": "Nomor Registrasi",
  "laporanHasil.col.lastGenerated": "Terakhir Dibuat",
  "laporanHasil.col.site": "Situs",
  "laporanHasil.col.standard": "Standar",
  "laporanHasil.col.tests": "Pemeriksaan",
  "laporanHasil.detail.ambientTemp": "Suhu Lingkungan",
  "laporanHasil.detail.collectionDateTime": "Tanggal/Waktu Pengambilan",
  "laporanHasil.detail.collectionMethod": "Metode Pengambilan",
  "laporanHasil.detail.complianceSummary": "Ringkasan Kepatuhan",
  "laporanHasil.detail.conditions": "Kondisi Pengambilan",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Analis Laboratorium",
  "laporanHasil.detail.labManager": "Manajer Laboratorium",
  "laporanHasil.detail.parameter": "Parameter",
  "laporanHasil.detail.ppNo": "PP No.",
  "laporanHasil.detail.preservation": "Pelestarian",
  "laporanHasil.detail.result": "Hasil",
  "laporanHasil.detail.signatures": "Tanda Tangan",
  "laporanHasil.detail.site": "Situs",
  "laporanHasil.detail.siteInfo": "Pengaturan Informasi Aplikasi",
  "laporanHasil.detail.standard": "Standar",
  "laporanHasil.detail.status": "Status",
  "laporanHasil.detail.threshold": "Ambang batas",
  "laporanHasil.detail.waterTemp": "Suhu Air",
  "laporanHasil.detail.weather": "Cuaca",
  "laporanHasil.empty": "Pemesanan tidak ditemukan untuk filter yang dipilih.",
  "laporanHasil.error": "Gagal memuat laporan. Silakan coba lagi.",
  "laporanHasil.filter.all": "Semua",
  "laporanHasil.filter.allSites": "Semua Tempat",
  "laporanHasil.filter.allStandards": "Semua Standar",
  "laporanHasil.filter.complianceStatus": "Status Kepatuhan",
  "laporanHasil.filter.dateFrom": "Tanggal Mulai",
  "laporanHasil.filter.dateTo": "Tanggal Sampai",
  "laporanHasil.filter.generated": "Dihasilkan",
  "laporanHasil.filter.generationStatus": "Status Generasi",
  "laporanHasil.filter.notGenerated": "Belum Dibuat",
  "laporanHasil.filter.samplingSite": "Tempat Pengambilan Sampel",
  "laporanHasil.filter.standard": "Baku Mutu",
  "laporanHasil.loading": "Sedang memuat laporan kepatuhan...",
  "laporanHasil.status.borderline": "Garis ambang",
  "laporanHasil.status.compliant": "Sesuai Kepatuhan",
  "laporanHasil.status.ineligible": "Tidak ada tautan standar",
  "laporanHasil.status.nonCompliant": "Tidak Sesuai Kepatuhan",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Membuat sertifikat kepatuhan untuk pesanan lingkungan yang telah diverifikasi",
  "laporanHasil.tile.generated": "Dihasilkan",
  "laporanHasil.tile.ineligible": "Tidak memenuhi syarat",
  "laporanHasil.tile.ineligible.desc": "Tidak tervalidasi atau tidak ada standar yang terkait",
  "laporanHasil.tile.notGenerated": "Belum Dibuat",
  "laporanHasil.title": "Laporan Kepatuhan",
  "lhu.amendment.error.generic": "Gagal menerbitkan ulang laporan tersebut. Silakan coba lagi.",
  "lhu.amendment.modal.description": "Anda sedang menerbitkan ulang LHU untuk nomor laboratorium {labNumber}. Laporan yang diterbitkan ulang tersebut akan dianggap sebagai amandemen terhadap sertifikat yang telah diterbitkan sebelumnya.",
  "lhu.amendment.modal.heading": "Penerbitan Ulang LHU dengan Perubahan",
  "lhu.amendment.modal.submit": "Cetak Ulang & Unduh PDF",
  "lhu.amendment.reason.helper": "Jelaskan alasan mengapa laporan asli tersebut direvisi (wajib untuk kepatuhan terhadap ISO 17025 §7.8.8).",
  "lhu.amendment.reason.label": "Alasan perubahan",
  "lhu.amendment.reason.placeholder": "misalnya: Hasil pH yang salah — alat tidak dikalibrasi",
  "lhu.amendment.reason.required": "Alasan perubahan wajib dicantumkan",
  "lhu.amendment.reissue": "Penerbitan Ulang dengan Perubahan",
  "lhu.amendment.submitting": "Menerbitkan ulang…",
  "nce.close.error": "Gagal menutup NCE",
  "nce.close.success": "NCE telah ditutup dengan berhasil",
  "nce.correctiveAction.error": "Gagal meningkatkan status NCE",
  "nce.correctiveAction.success": "NCE telah beralih ke Tindakan Perbaikan",
  "notificationtrigger.activetriggers.heading": "Pemicu Aktif",
  "notificationtrigger.activetriggers.subtitle": "Setiap baris mengontrol satu jenis peristiwa notifikasi. Aktifkan dengan menggeser tombol ke posisi \"On\". Pengaturan saluran dan penerima hanya diterapkan jika pemicu diaktifkan.",
  "notificationtrigger.channel.email": "Email",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.column.channels": "Channel",
  "notificationtrigger.column.enabled": "Diaktifkan",
  "notificationtrigger.column.eventcode": "Kode Acara",
  "notificationtrigger.column.override": "Penyesuaian per Instalasi Lab",
  "notificationtrigger.column.recipients": "Penerima",
  "notificationtrigger.column.trigger": "Pemicu",
  "notificationtrigger.config.subtitle": "Aktifkan atau nonaktifkan pemicu notifikasi, pilih saluran pengiriman, dan lakukan konfigurasi jenis penerima untuk setiap peristiwa.",
  "notificationtrigger.config.title": "Konfigurasi Trigger Pemberitahuan",
  "notificationtrigger.disabled.hint": "Aktifkan pemicu ini untuk melakukan konfigurasi saluran dan penerima.",
  "notificationtrigger.override.comingsoon": "Fitur penggantian nilai per satuan laboratorium tidak tersedia.",
  "notificationtrigger.override.configure": "Konfigurasi",
  "notificationtrigger.recipient.coccontact": "Kontak CoC",
  "notificationtrigger.recipient.orderingprovider": "Penyelenggara Layanan Pemesanan",
  "notificationtrigger.recipient.submittinguser": "Pengguna yang Kirimkan",
  "notificationtrigger.referralout.defaultoff": "Pengaturan default: Matikan — harus diaktifkan secara eksplisit.",
  "notificationtrigger.referralout.description": "Terkirim saat sampel dirujuk ke laboratorium eksternal.",
  "notificationtrigger.referralout.firesoncenote": "Dikirim sekali untuk setiap rujukan yang disimpan. Jika satu pesanan berisi rujukan ke dua laboratorium yang berbeda, maka akan dikirimkan dua notifikasi.",
  "notificationtrigger.referralout.name": "Rujukan Keluar",
  "notificationtrigger.sentmessages.action.resend": "Kirim ulang",
  "notificationtrigger.sentmessages.action.viewlog": "Lihat Log",
  "notificationtrigger.sentmessages.channel.failed": "Gagal",
  "notificationtrigger.sentmessages.channel.sent": "Dikirim",
  "notificationtrigger.sentmessages.column.actions": "Aksi",
  "notificationtrigger.sentmessages.column.channels": "Channel",
  "notificationtrigger.sentmessages.column.datetime": "Tanggal/Waktu",
  "notificationtrigger.sentmessages.column.recipient": "Penerima",
  "notificationtrigger.sentmessages.column.reference": "Referensi",
  "notificationtrigger.sentmessages.column.status": "Status",
  "notificationtrigger.sentmessages.column.type": "Tipe",
  "notificationtrigger.sentmessages.count": "{count} dari pesan-pesan \"{total}\"",
  "notificationtrigger.sentmessages.empty.heading": "Tidak ada notifikasi yang terkirim.",
  "notificationtrigger.sentmessages.filter.status.all": "Semua Status",
  "notificationtrigger.sentmessages.filter.status.failed": "Gagal",
  "notificationtrigger.sentmessages.filter.status.label": "Status",
  "notificationtrigger.sentmessages.filter.status.sent": "Terkirim",
  "notificationtrigger.sentmessages.filter.type.all": "Semua Jenis",
  "notificationtrigger.sentmessages.filter.type.label": "Tipe",
  "notificationtrigger.sentmessages.heading": "Pesan yang Terkirim",
  "notificationtrigger.sentmessages.resend.disclaimer": "Dengan mengirim ulang, byte pesan asli dan alamat penerima akan dikirim kembali. Untuk mengirim ke alamat yang berbeda, edit catatan pasien dan buat peristiwa baru.",
  "notificationtrigger.sentmessages.resend.failure": "Pengiriman ulang gagal. Lihat log server untuk detailnya.",
  "notificationtrigger.sentmessages.resend.success": "Notifikasi telah dikirim ulang.",
  "notificationtrigger.sentmessages.status.failed": "Gagal",
  "notificationtrigger.sentmessages.status.sent": "Terkirim",
  "notificationtrigger.sentmessages.subtitle": "Semua pemberitahuan keluar yang dikirimkan oleh OpenELIS, dari semua tipe trigger dan channel.",
  "notificationtrigger.sentmessages.viewlog.channels": "Hasil Saluran",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Upaya",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Saluran",
  "notificationtrigger.sentmessages.viewlog.column.error": "Kesalahan",
  "notificationtrigger.sentmessages.viewlog.column.status": "Status",
  "notificationtrigger.sentmessages.viewlog.heading": "Riwayat Notifikasi",
  "notificationtrigger.sentmessages.viewlog.message": "Isi Pesan",
  "notificationtrigger.sentmessages.viewlog.subject": "Subjek",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "Terkirim ketika sampel telah dikirimkan secara fisik ke laboratorium penerima.",
  "notificationtrigger.subcontractdispatched.name": "Subkontrak Telah Dikirim",
  "notificationtrigger.tabs.sentmessages": "Pesan yang Terkirim",
  "notificationtrigger.tabs.sentmessages.placeholder": "Pesan yang terkirim — akan hadir pada pembaruan mendatang.",
  "notificationtrigger.tabs.templates": "Templat",
  "notificationtrigger.tabs.templates.placeholder": "Editor templat — akan hadir pada versi mendatang.",
  "notificationtrigger.tabs.triggers": "Pemicu",
  "notificationtrigger.templates.body.help": "Teks bebas dengan bidang penggabungan. Template ini tidak dikelola oleh i18n — silakan edit langsung.",
  "notificationtrigger.templates.body.label": "Isi Pesan",
  "notificationtrigger.templates.button.reset": "Atur Ulang ke Default",
  "notificationtrigger.templates.button.save": "Simpan Template",
  "notificationtrigger.templates.channel.help": "Setiap saluran memiliki bidang templatnya masing-masing. Beralihlah ke saluran lain untuk mengeditnya secara terpisah.",
  "notificationtrigger.templates.channel.label": "Saluran",
  "notificationtrigger.templates.heading": "Konfigurasi Template Notifikasi",
  "notificationtrigger.templates.mergefields.heading": "Bidang Gabungan yang Tersedia",
  "notificationtrigger.templates.mergefields.help": "Bidang-bidang di bawah ini khusus untuk acara \"{eventCode}\". Klik sebuah bidang untuk memasukkannya di posisi kursor.",
  "notificationtrigger.templates.mergefields.optionalnote": "Jika [expectedReturn] tidak ditetapkan pada rujukan, kolom tersebut akan ditampilkan kosong — tanpa pesan kesalahan.",
  "notificationtrigger.templates.preview.label": "Pratinjau yang Telah Dirender",
  "notificationtrigger.templates.referralout.description": "Dikirimkan kepada kontak pelanggan (Penyedia Pemesanan) dan/atau staf internal (Pengguna yang Mengirimkan) saat rujukan disimpan.",
  "notificationtrigger.templates.subcontractdispatched.description": "Terkirim kepada kontak CoC di laboratorium penerima dan kepada pelanggan saat sampel dikirimkan secara fisik ke laboratorium penerima.",
  "notificationtrigger.templates.subject.label": "Subjek",
  "notificationtrigger.templates.subtitle": "Buat templat pesan untuk setiap jenis peristiwa notifikasi. Templat tersebut berupa teks bebas yang dilengkapi dengan bidang penggabungan.",
  "order.clinicalInfo.helper": "Konteks opsional untuk memandu pemilihan tes dan pelaporan — tidak terekam sebagai diagnosis yang telah dikonfirmasi.",
  "order.complete.processing.description": "{labNumber} Saat ini berstatus \"{status}\" dan akan muncul dalam daftar pekerjaan Identifikasi Vektor V-03.",
  "order.complete.processing.description.plain": "{labNumber} Saat ini berstatus \"Sedang Diproses\" dan akan muncul dalam daftar pekerjaan Identifikasi Vektor V-03.",
  "order.complete.processing.title": "Pemesanan Selesai — Sedang Diproses",
  "order.context.poolOf": "Kumpulan foto {count} {animal}",
  "order.paymentStatus.helper": "Bagaimana proses pembayaran untuk pemesanan ini akan dilakukan.",
  "order.priority.helper": "Rutin: waktu penyelesaian standar. STAT: segera diproses.",
  "order.referral.sampleType.ambiguous": "Permintaan rujukan ini meminta tes \"{items}\", namun jenis sampel tidak dapat ditentukan secara otomatis. Silakan pilih jenis sampel di bawah ini, lalu pilih pengujian yang diminta.",
  "order.requester.section.helper": "Pilih lembaga yang memesan pemeriksaan tersebut dan penyelenggara yang bertanggung jawab.",
  "panel.domain.clinical": "Klinis",
  "panel.domain.environmental": "Lingkungan",
  "panel.domain.eqa": "PME",
  "panel.domain.vector": "Vektor",
  "panel.filter.domain": "Domain",
  "panel.organism.flea": "Kutu",
  "panel.organism.fly": "Terbang",
  "panel.organism.mosquito": "Nyamuk",
  "panel.organism.rodent": "Hewan pengerat",
  "panel.organism.selectPlaceholder": "Pilih Grup Organisme",
  "panel.organism.tick": "Centang",
  "patient.search.section.helper": "Cari berdasarkan kombinasi bidang apa saja — pencocokan sebagian diperbolehkan. Fitur 'Pencarian Eksternal' melakukan pencarian di Daftar Klien dan membutuhkan setidaknya nama serta Tanggal Lahir.",
  "placeholder.validation.qc.justification": "Wajib diisi (maks. 500 karakter)",
  "provider.add.new": "+ Tambah Penyelenggara baru \"{name}\"",
  "providerTitle.abbreviation": "Abbreviation",
  "providerTitle.add": "Add Title",
  "providerTitle.confirm.activate": "Activate \"{title}\"?",
  "providerTitle.confirm.activate.body": "It will be offered again when choosing a provider's title.",
  "providerTitle.confirm.deactivate": "Deactivate \"{title}\"?",
  "providerTitle.confirm.deactivate.body": "It will no longer be offered for new selections. The {count} provider(s) already carrying it keep it.",
  "providerTitle.duplicate": "\"{value}\" is already in the list",
  "providerTitle.edit": "Edit Title",
  "providerTitle.edit.warning": "Changing a title changes how it displays on every provider using it.",
  "providerTitle.empty": "No provider titles are configured yet.",
  "providerTitle.filter.status": "Status",
  "providerTitle.filter.status.active": "Aktif",
  "providerTitle.filter.status.all": "Semua",
  "providerTitle.filter.status.inactive": "Inaktif",
  "providerTitle.inUse": "Sedang Digunakan",
  "providerTitle.search": "Search titles",
  "providerTitle.sortOrder": "Sortir Pemesanan",
  "providerTitle.summary": "{total} title(s): {active} active, {inactive} inactive.",
  "providerTitle.title": "Judul",
  "providerTitle.titles": "Provider Titles",
  "provider.email.field": "Email Penyelenggara",
  "provider.fax.field": "No. Telp Penyelenggara Layanan",
  "provider.title.field": "Judul",
  "provider.title.inName": "That looks like a title. Consider moving it to the Title field so lists sort by surname.",
  "provider.title.filter": "Filter by title",
  "provider.title.filter.all": "All titles",
  "provider.title.placeholder": "Select a title...",
  "provider.firstName.field": "Nama Depan",
  "provider.lastName.field": "Nama Belakang",
  "provider.new.helper": "Akan dibuat sebagai penyelenggara baru saat pesanan ini disimpan.",
  "provider.new.tag": "Baru",
  "provider.no.match": "Tidak ditemukan penyelenggara yang sesuai.",
  "provider.phone.field": "Telepon",
  "qc.add.blank": "+ QC Kosong",
  "qc.add.control": "+ Pengendalian QC",
  "qc.add.duplicate": "+ Pemeriksaan Kualitas (QC) Duplikasi",
  "qc.collect.inheritsFromParent": "Rincian koleksi yang diwarisi dari Sampel Induk",
  "qc.expectedValue.placeholder": "misalnya 50,0",
  "qc.samples.label": "Sampel QC:",
  "qc.samples.numericOnly": "Saat ini, QC hanya didukung untuk tes dengan hasil numerik. Pemeriksaan yang dipilih telah diberi kode — pilih pemeriksaan numerik untuk mengaktifkan QC.",
  "qc.samples.thresholdsMissing": "Konfigurasikan ambang batas QC untuk \"{tests}\" di bagian Administrasi → Konfigurasi Pengujian sebelum menambahkan sampel QC.",
  "qc.status.current": "Current QC Status",
  "qc.status.failed.warning.message": "Lots that fail QC are excluded from testing and from stock available for use.",
  "qc.status.failed.warning.title": "This lot will not be usable",
  "qc.status.new": "New QC Status",
  "qc.status.notes": "Catatan QC",
  "qc.status.notes.placeholder": "Reason for the QC result, test performed, or reference",
  "qc.type.blank": "QC: Kosong",
  "qc.type.control": "QC: Pengendalian",
  "qc.type.duplicate": "QC: Duplikasi",
  "referral.accept.error": "Hasilnya tidak dapat diterima. Silakan coba lagi.",
  "referral.action.accept": "Terima",
  "referral.action.acceptToAnalysis": "Terima untuk Dianalisis",
  "referral.action.clearFilters": "Hapus filter",
  "referral.action.enterResult": "Masukkan hasil",
  "referral.action.markLost": "Tanda Hilang",
  "referral.action.notifyReferenceLab": "Beritahukan Lab Rujukan",
  "referral.action.openResultEntry": "Buka di Entri Hasil",
  "referral.action.reject": "Tolak",
  "referral.banner.filterToStuck": "Filter hanya yang macet",
  "referral.banner.stuckReferralsSubtitle": "{count} Rujukan tersebut telah berada di Lab Rujukan selama lebih dari {threshold} hari.",
  "referral.banner.stuckReferralsTitle": "Terdeteksi rujukan yang macet",
  "referral.box.cannotReconcileMessage": "Kotak tidak dapat direkonsiliasi — sampel dari {count} masih menunggu rekonsiliasi hasil. Lihat Hasil Laboratorium Rujukan.",
  "referral.box.viewBlockedReferrals": "Lihat di Hasil Lab Rujukan",
  "referral.breadcrumb.referenceLabResults": "Hasil Laboratorium Rujukan",
  "referral.chip.ariaLabel": "Tampilan hasil laboratorium Lab Rujukan",
  "referral.chip.history": "Riwayat",
  "referral.chip.outstanding": "Luar Biasa",
  "referral.chip.returned": "Telah dikembalikan — perlu ditindaklanjuti",
  "referral.column.actions": "Aksi",
  "referral.column.boxId": "ID Boks",
  "referral.column.closedDate": "Tanggal penutupan",
  "referral.column.daysOutstanding": "Jumlah hari piutang",
  "referral.column.daysTotal": "Jumlah hari",
  "referral.column.labNumber": "Nomor Registrasi",
  "referral.column.outcome": "Hasil",
  "referral.column.patient": "Pasien",
  "referral.column.priority": "Prioritas",
  "referral.column.referenceLab": "Lab Rujukan",
  "referral.column.requestor": "Pemohon awal",
  "referral.column.resultSummary": "Ringkasan hasil",
  "referral.column.returnedDate": "Tanggal Pengembalian",
  "referral.column.sentDate": "Tanggal Dikirim",
  "referral.column.status": "Status",
  "referral.column.tests": "Pemeriksaan",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} other {# years}}",
  "referral.expand.detail.boxId": "ID Boks",
  "referral.expand.detail.boxReceivedDate": "Telah diterima di Lab Rujukan",
  "referral.expand.detail.collected": "Diambil",
  "referral.expand.detail.currentStatus": "Status saat ini",
  "referral.expand.detail.daysOutstanding": "Jumlah hari piutang",
  "referral.expand.detail.dispatched": "Telah dikirim",
  "referral.expand.detail.fhirTask": "Tugas FHIR",
  "referral.expand.detail.labNumber": "Nomor Registrasi",
  "referral.expand.detail.patient": "Pasien",
  "referral.expand.detail.priority": "Prioritas",
  "referral.expand.detail.referenceLab": "Lab Rujukan",
  "referral.expand.detail.requestor": "Pemohon awal",
  "referral.expand.detail.sampleType": "Jenis sampel",
  "referral.expand.detail.tests": "Pemeriksaan",
  "referral.expand.noResultPayload": "Lab Rujukan tidak memberikan hasil yang terstruktur.",
  "referral.expand.originalOrderContext": "Konteks pemesanan asli",
  "referral.expand.outcomeDetail": "Rincian hasil",
  "referral.expand.receptionAction": "Aksi penerimaan",
  "referral.expand.receptionHint": "Periksa hasil yang dikembalikan di bawah ini, lalu pilih \"Terima\" untuk menyimpannya ke dalam rekam medis pasien, atau pilih \"Tolak\" jika hasil tersebut tidak dapat digunakan.",
  "referral.expand.referenceLabTransit": "Pengiriman sampel ke Lab Rujukan",
  "referral.expand.result": "Hasil",
  "referral.expand.statusDetail": "Rincian status",
  "referral.filter.allPriorities": "Semua Prioritas",
  "referral.filter.allRefLabs": "Semua Lab Rujukan",
  "referral.filter.dateRange": "Rentang Tanggal",
  "referral.filter.daysOutstandingBucket": "Jumlah hari piutang",
  "referral.filter.daysOutstandingBucket.stuck": "Terjebak (> {threshold} hari)",
  "referral.filter.priority": "Prioritas",
  "referral.filter.referenceLab": "Lab Rujukan",
  "referral.markLost.cancelButton": "Batal",
  "referral.markLost.confirmButton": "Tandai sebagai Hilang",
  "referral.markLost.description": "Hal ini menandai bahwa rujukan tersebut hilang dalam transit dan menghapusnya dari daftar \"Belum Selesai\". Tim klinis perlu mengambil kembali sampel tersebut dan merujuknya kembali.",
  "referral.markLost.modalTitle": "Tandai rujukan sebagai hilang",
  "referral.markLost.reasonLabel": "Alasan",
  "referral.markLost.reasonPlaceholder": "Misalnya: Kurir telah melakukan konfirmasi kehilangan. Kotak tersebut tidak pernah sampai di Lab Rujukan.",
  "referral.markLost.reasonRequired": "Alasan wajib.",
  "referral.metric.outstanding": "Luar Biasa",
  "referral.metric.reconciledToday": "Telah direkonsiliasi hari ini",
  "referral.metric.rejectedThisWeek": "Ditolak minggu ini",
  "referral.metric.returned": "Telah dikembalikan — perlu ditindaklanjuti",
  "referral.notification.accepted": "Hasil telah diterima dalam rekam medis pasien.",
  "referral.notification.rejected": "Hasil ditolak. Dokter telah diberi tahu untuk mengambil sampel kembali.",
  "referral.notify.errorRetry": "Gagal memberi tahu Lab Rujukan. Coba lagi.",
  "referral.notify.toast": "Lab Rujukan telah diberi tahu.",
  "referral.page.title": "Hasil Laboratorium Rujukan",
  "referral.reject.cancelButton": "Batal",
  "referral.reject.confirmButton": "Tolak dan beri tahu tenaga medis",
  "referral.reject.description": "Penolakan akan menutup pemeriksaan yang bersangkutan secara permanen dan memberi tahu tenaga medis untuk mengambil kembali sampel serta merujuknya kembali.",
  "referral.reject.error": "Hasilnya tidak dapat ditolak. Silakan coba lagi.",
  "referral.reject.modalTitle": "Tolak hasil yang dikembalikan",
  "referral.reject.reason.clotted": "Menggumpal",
  "referral.reject.reason.damagedContainer": "Wadah yang rusak",
  "referral.reject.reason.hemolyzed": "Hemolisis",
  "referral.reject.reason.insufficientVolume": "Volume tidak cukup",
  "referral.reject.reason.mislabeled": "Salah label",
  "referral.reject.reason.other": "Lainnya",
  "referral.reject.reason.temperatureDeviation": "Penyimpangan suhu",
  "referral.reject.reason.wrongSampleType": "Jenis Sampel Salah",
  "referral.reject.reasonLabel": "Alasan",
  "referral.reject.reasonTextLabel": "Rincian",
  "referral.reject.reasonTextPlaceholder": "Jelaskan mengapa hasil yang diperoleh ini tidak dapat digunakan.",
  "referral.reject.reasonTextRequired": "Rincian lebih lanjut wajib.",
  "referral.reject.warningTitle": "Aksi ini tidak dapat dibatalkan",
  "referral.result.interp.Abnormal": "Tidak normal",
  "referral.result.interp.Critical": "Kritis",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Dibatalkan",
  "referral.status.completed": "Hasil yang ditampilkan",
  "referral.status.draft": "Draf",
  "referral.status.inProgress": "Dalam Pengerjaan di Lab Rujukan",
  "referral.status.received": "Di Lab Rujukan",
  "referral.status.reconciled": "Direkonsiliasi",
  "referral.status.rejected": "Ditolak oleh Lab Rujukan",
  "referral.status.requested": "Terkirim — sedang menunggu persetujuan",
  "referral.table.count": "{count, plural, =0 {No referrals} one {# referral} other {# referrals}}",
  "referral.table.history.title": "Riwayat",
  "referral.table.outstanding.title": "Rujukan yang belum diselesaikan",
  "referral.table.returned.title": "Telah dikembalikan — perlu ditindaklanjuti",
  "referral.tag.manuallyEntered": "Dimasukkan secara manual",
  "reports.tat.title": "Laporan Waktu Penyelesaian",
  "reports.tat.description": "Analisis waktu penyelesaian laboratorium setiap milestone pekerjaan",
  "reports.tat.generateReport": "Membuat Laporan",
  "reports.tat.clearFilters": "Hapus filter",
  "reports.tat.segment.orderToCollection": "Pemesanan sampai Pengambilan",
  "reports.tat.segment.collectionToReceipt": "Pengambilan sampai Diterima",
  "reports.tat.segment.receiptToTesting": "Pengambilan sampai Pengujian Dimulai",
  "reports.tat.segment.receiptToResult": "Diterima sampai Entri Hasil",
  "reports.tat.segment.receiptToValidation": "Diterima sampai Validasi",
  "reports.tat.segment.resultToValidation": "Entri Hasil sampai Validasi",
  "reports.tat.segment.overall": "Waktu Penyelesaian (TAT) keseluruhan",
  "reports.tat.calendarTime": "Waktu Kalender",
  "reports.tat.workingTime": "Jam Kerja",
  "reports.tat.workingTimeInfo": "Mode Jam Kerja: Selain {weekendDays} dan {holidayCount} libur nasional di kisaran tanggal ini",
  "reports.tat.configuredWeekends": "akhir pekan yang dikonfigurasi",
  "reports.tat.noHolidaysWarning": "Tidak ada konfigurasi libur nasional. Konfigurasi libur nasional dapat dilakukan di Admin > Pengelolaan Kalender",
  "reports.tat.manageCalendar": "Kelola Kalender",
  "reports.tat.totalResults": "Hasil Total",
  "reports.tat.meanTat": "Rata-rata TAT",
  "reports.tat.medianTat": "Median Waktu Penyelesaian (TAT)",
  "reports.tat.percentile90": "Presentil 90",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Maks TAT",
  "reports.tat.stdDeviation": "Simpangan Baku",
  "reports.tat.distribution": "Distribusi TAT",
  "reports.tat.breakdownBy": "Breakdown berdasarkan",
  "reports.tat.clickRowHint": "Klik baris untuk melihat hasil individual",
  "reports.tat.summary": "Ringkasan",
  "reports.tat.detailList": "Daftar Rinci",
  "reports.tat.trends": "Tren",
  "reports.tat.noResults": "Hasil tidak ditemukan untuk filter ini. Coba mengatur rentang tanggal atau kriteria filter.",
  "reports.tat.insufficientData": "Data tidak cukup",
  "reports.tat.loadError": "Error memuat data laporan",
  "reports.tat.dateRange": "Rentang Tanggal",
  "reports.tat.labUnit": "Instalasi Lab",
  "reports.tat.testPanel": "Pemeriksaan / Panel",
  "reports.tat.priority.all": "Semua",
  "reports.tat.priority.routine": "Rutin",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Jenis Sampel",
  "reports.tat.orderingSite": "Institusi Pemesan",
  "reports.tat.priority": "Prioritas",
  "reports.tat.includeCancelled": "Sertakan pembatalan/penolakan",
  "reports.tat.export": "Ekspor",
  "reports.tat.exportCsv": "Ekspor CSV",
  "reports.tat.exportPdf": "Ekspor PDF",
  "reports.tat.labNumber": "Nomor Lab",
  "reports.tat.patient": "Pasien",
  "reports.tat.test": "Pemeriksaan",
  "reports.tat.orderCreated": "Pemesanan Dibuat",
  "reports.tat.collected": "Diambil",
  "reports.tat.received": "Diterima",
  "reports.tat.testingStarted": "Pemeriksaan Dimulai",
  "reports.tat.resultEntered": "Hasil Dimasukkan",
  "reports.tat.validated": "Divalidasi",
  "reports.tat.selectedTat": "TAT yang dipilih",
  "reports.tat.overallTat": "TAT keseluruhan",
  "reports.tat.columns": "Kolom",
  "reports.tat.rowsPerPage": "Baris per halaman",
  "reports.tat.showing": "Menampilkan {from}-{to} dari {total} hasil",
  "reports.tat.trend": "Tren",
  "reports.tat.aggregation": "Agregasi",
  "reports.tat.daily": "Harian",
  "reports.tat.weekly": "Mingguan",
  "reports.tat.monthly": "Bulanan",
  "reports.tat.compareBy": "Bandingkan berdasarkan",
  "reports.tat.showVolume": "Tampilkan volume pemesanan",
  "reports.tat.mean": "Rata-rata",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Rentang Tanggal (Dari)",
  "reports.tat.dateRangeTo": "Rentang Tanggal (Sampai)",
  "reports.tat.tatSegment": "Segmen TAT",
  "reports.tat.metrics": "Metrik",
  "reports.tat.compareNone": "Tidak ada",
  "reports.tat.comparePriority": "Prioritas",
  "reports.tat.column.labNumber": "Nomor Lab",
  "reports.tat.column.test": "Pemeriksaan",
  "reports.tat.column.labUnit": "Instalasi Lab",
  "reports.tat.column.priority": "Prioritas",
  "reports.tat.column.ordered": "Dipesan",
  "reports.tat.column.collected": "Diambil",
  "reports.tat.column.received": "Diterima",
  "reports.tat.column.started": "Dimulai",
  "reports.tat.column.resulted": "Dihasilkan",
  "reports.tat.column.validated": "Divalidasi",
  "reports.tat.column.selectedTat": "TAT yang dipilih",
  "reports.tat.column.overallTat": "TAT keseluruhan",
  "reports.tat.column.name": "Nama",
  "reports.tat.column.count": "Jumlah",
  "reports.tat.column.mean": "Rata-rata",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "Hari ke-90 \"%i\"",
  "reports.tat.column.max": "Maks",
  "reports.tat.home": "Beranda",
  "reports.tat.all": "Semua",
  "reports.tat.preset.today": "Hari ini",
  "reports.tat.preset.7days": "7 hari terakhir",
  "reports.tat.preset.30days": "30 hari terakhir",
  "reports.tat.preset.90days": "90 hari terakhir",
  "reports.tat.preset.thisMonth": "Bulan ini",
  "reports.tat.preset.lastMonth": "Bulan lalu",
  "reports.tat.preset.thisQuarter": "Triwulan ini",
  "button.cancel": "Batal",
  "button.activate": "Aktifkan",
  "button.adjust": "Sesuaikan",
  "button.deactivate": "Nonaktifkan",
  "button.dispose": "Musnahkan",
  "button.edit": "Sunting",
  "button.generate": "Membuat",
  "button.label.genarateReport": "Membuat Laporan",
  "button.label.loadnext": "Memuat Bundel Berikutnya",
  "button.label.loadprevious": "Memuat Bundel Sebelumnya",
  "button.label.showHidePram": "Tunjukkan/Sembunyikan Parameter Laporan",
  "button.record": "Rekam",
  "button.save": "Simpan",
  "button.save.draft": "Simpan draf",
  "button.save.next": "Simpan & Lanjut",
  "button.save.stay": "Simpan",
  "button.send": "Kirim",
  "button.update": "Perbarui",
  "calculatedTests": "Perhitungan Pemeriksaan",
  "catalog.item.activate.success": "Barang di katalog berhasil diaktifkan",
  "catalog.item.category": "Kategori",
  "catalog.item.code": "Kode",
  "catalog.item.code.hint": "Stable identifier used by integrations. Leave blank and we'll generate one from the name, like PAR-500MG-001.",
  "catalog.item.code.locked": "Code is locked once saved so integrations and existing references keep working.",
  "catalog.item.code.placeholder": "Leave blank to auto-generate from name",
  "catalog.item.code.preview": "Will be saved as {code}",
  "catalog.item.compatibleAnalyzers": "Alat yang Kompatibel",
  "catalog.item.deactivate.confirm.button": "Nonaktifkan",
  "catalog.item.deactivate.confirm.message": "Apakah Anda yakin akan menonaktifkan {itemName}?",
  "catalog.item.deactivate.confirm.title": "Konfirmasi Penonaktifan",
  "catalog.item.deactivate.implications.1": "Barang ini tidak akan muncul lagi di daftar barang aktif",
  "catalog.item.deactivate.implications.2": "Lot tersisa untuk barang ini masih dapat diakses",
  "catalog.item.deactivate.implications.3": "Anda dapat mengaktifkan ulang barang ini kembali saat diperlukan",
  "catalog.item.deactivate.implications.title": "Implikasi:",
  "catalog.item.deactivate.label": "Barang Dinonaktifkan",
  "catalog.item.deactivate.success": "Barang berhasil dinonaktifkan",
  "catalog.item.error.saveGeneric": "Error menyimpan barang di katalog",
  "catalog.item.error.stabilityRequired": "Stability after opening is required for reagents",
  "catalog.item.form.title.add": "Tambah Barang Baru di Katalog",
  "catalog.item.form.title.edit": "Edit Barang di Katalog",
  "catalog.item.lowStockThreshold": "Ambang Batas Stok Sedikit",
  "catalog.item.manufacturer": "Produsen",
  "catalog.item.minimumStock": "Level Stok Minimum",
  "catalog.item.name": "Nama Barang",
  "catalog.item.reorderLevel": "Level Pemesanan Ulang",
  "catalog.item.reorderQuantity": "Kuantitas yang dipesan ulang",
  "catalog.item.save.error": "Error menyimpan barang di katalog",
  "catalog.item.save.success": "Barang di katalog berhasil disimpan",
  "catalog.item.stabilityAfterOpening": "Stabilitas Setelah Dibuka (hari)",
  "catalog.item.status": "Status",
  "catalog.item.storageRequirements": "Persyaratan Penyimpanan",
  "catalog.item.testTypes": "Jenis Pemeriksaan",
  "catalog.item.testsPerCartridge": "Pemeriksaan Per Katrid",
  "catalog.item.testsPerKit": "Pemeriksaan Per Kit",
  "catalog.item.type": "Jenis Barang",
  "catalog.item.units": "Unit",
  "catalog.search.placeholder": "Cari berdasarkan nama barang",
  "choose.availablepanel": "Pilih Panel yang Tersedia",
  "coldStorage.action.createSuccess": "Tindakan perbaikan berhasil dibuat",
  "coldStorage.action.retractSuccess": "Tindakan perbaikan berhasil dibatalkan",
  "coldStorage.action.updateSuccess": "Tindakan perbaikan berhasil diperbarui",
  "coldStorage.actions": "Aksi",
  "coldStorage.activated": "sudah aktif",
  "coldStorage.addDevicesMessage": "Tambah perangkat di Pengelolaan Perangkat untuk mengkonfigurasi ambang batas suhu",
  "coldStorage.addNewDevice": "Tambah Perangkat Baru",
  "coldStorage.alert.acknowledged": "Berhasil mengkonfirmasi peringatan",
  "coldStorage.alert.actionFailed": "Tidak dapat mengakses {action}, peringatan {alertId}",
  "coldStorage.alert.equipment": "Alat Gagal",
  "coldStorage.alert.equipment.description": "Peringatan malfungsi atau masalah koneksi alat",
  "coldStorage.alert.inventory": "Peringatan Inventaris",
  "coldStorage.alert.inventory.description": "Peringatan inventaris hampir habis atau pengelolaan stok ",
  "coldStorage.alert.resolved": "Peringatan telah selesai dengan berhasil",
  "coldStorage.alert.saveFailed": "Gagal menyimpan pilihan notifikasi:",
  "coldStorage.alert.saveSuccess": "Pilihan notifikasi berhasil disimpan. Setiap jenis peringatan memiliki metode notifikasi sesuai konfigurasinya.",
  "coldStorage.alert.temperature": "Peringatan Suhu",
  "coldStorage.alert.temperature.description": "Peringatan akan dipicu saat suhu freezer melebihi ambang batas",
  "coldStorage.alert.type": "Jenis Peringatan",
  "coldStorage.alertConfiguration": "Konfigurasi Peringatan",
  "coldStorage.autoEscalate": "Otomatis lakukan eskalasi peringatan yang tidak terselesaikan",
  "coldStorage.button.delete": "Hapus",
  "coldStorage.configuredDevices": "Perangkat yang dikonfigurasi",
  "coldStorage.correctiveAction.column.actionId": "ID Aksi",
  "coldStorage.correctiveAction.column.created": "Dibuat",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Pembaruan Terakhir",
  "coldStorage.correctiveAction.column.performedBy": "Dibawakan Oleh",
  "coldStorage.correctiveAction.edited": "Diedit",
  "coldStorage.correctiveAction.status.cancelled": "Dibatalkan",
  "coldStorage.correctiveAction.status.completed": "Selesai",
  "coldStorage.correctiveAction.status.inProgress": "Dalam Pengerjaan",
  "coldStorage.correctiveAction.status.pending": "Tertunda",
  "coldStorage.correctiveAction.status.retracted": "Ditarik kembali",
  "coldStorage.correctiveAction.type.calibration": "Kalibrasi",
  "coldStorage.correctiveAction.type.calibration.description": "Kalibrasi peralatan atau sensor",
  "coldStorage.correctiveAction.type.equipmentRepair": "Perbaikan Peralatan",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Memperbaiki atau mengganti peralatan",
  "coldStorage.correctiveAction.type.itemReorder": "Pemesanan Ulang Barang",
  "coldStorage.correctiveAction.type.itemReorder.description": "Menata ulang barang inventaris",
  "coldStorage.correctiveAction.type.maintenance": "Pemeliharaan",
  "coldStorage.correctiveAction.type.maintenance.description": "Melakukan tugas-tugas pemeliharaan",
  "coldStorage.correctiveAction.type.other": "Lainnya",
  "coldStorage.correctiveAction.type.other.description": "Tindakan Perbaikan lainnya atau yang disesuaikan",
  "coldStorage.correctiveAction.type.sampleRelocation": "Sampel Relokasi",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Memindahkan sampel ke lokasi lain",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Penyesuaian Suhu",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Menyesuaikan pengaturan suhu",
  "coldStorage.criticalThreshold": "Ambang Batas Kritis (°C)",
  "coldStorage.dashboard.acknowledge": "Mengetahui",
  "coldStorage.dashboard.activeAlerts": "Peringatan Aktif ({count})",
  "coldStorage.dashboard.column.currentTemp": "Suhu Saat Ini",
  "coldStorage.dashboard.column.currentTemp2": "Sensor Suhu 2",
  "coldStorage.dashboard.column.device": "Perangkat",
  "coldStorage.dashboard.column.duration": "Durasi",
  "coldStorage.dashboard.column.humidity": "Kelembapan",
  "coldStorage.dashboard.column.lastReading": "Pembacaan Terakhir",
  "coldStorage.dashboard.column.location": "Lokasi",
  "coldStorage.dashboard.column.severity": "Keparahan",
  "coldStorage.dashboard.column.started": "Dimulai",
  "coldStorage.dashboard.column.targetTemp": "Suhu Target",
  "coldStorage.dashboard.column.temperature": "Suhu",
  "coldStorage.dashboard.column.unitId": "ID Unit",
  "coldStorage.dashboard.column.unitName": "Nama Unit",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} Unit penyimpanan yang mengalami fluktuasi suhu yang kritis",
  "coldStorage.dashboard.criticalAlertTitle": "Peringatan Kritis",
  "coldStorage.dashboard.deviceTypeFilter": "Jenis Perangkat",
  "coldStorage.dashboard.kpi.critical": "Peringatan Kritis",
  "coldStorage.dashboard.kpi.normal": "Status Normal",
  "coldStorage.dashboard.kpi.totalUnits": "Jumlah Unit Penyimpanan",
  "coldStorage.dashboard.kpi.warnings": "Peringatan",
  "coldStorage.dashboard.lastUpdate": "Pembaruan Terakhir: {time}",
  "coldStorage.dashboard.loadingUnits": "Sedang memuat unit penyimpanan…",
  "coldStorage.dashboard.noActiveAlerts": "Tidak ada peringatan yang aktif",
  "coldStorage.dashboard.noUnitsFound": "Tidak ditemukan unit penyimpanan.",
  "coldStorage.dashboard.online": "Online",
  "coldStorage.dashboard.refresh": "Segarkan",
  "coldStorage.dashboard.refreshing": "Menyegarkan",
  "coldStorage.dashboard.refreshingEllipsis": "Menyegarkan...",
  "coldStorage.dashboard.searchLabel": "Cari berdasarkan ID Unit atau Nama",
  "coldStorage.dashboard.statusFilter": "Status",
  "coldStorage.dashboard.storageUnitsTitle": "Unit Penyimpanan",
  "coldStorage.dashboard.subtitle": "Pemantauan suhu secara real-time & Kepatuhan",
  "coldStorage.dashboard.systemStatus": "Status Sistem: {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Tindakan Perbaikan",
  "coldStorage.dashboard.tab.dashboard": "Dasbor",
  "coldStorage.dashboard.tab.historicalTrends": "Tren Historis",
  "coldStorage.dashboard.tab.reports": "Laporan",
  "coldStorage.dashboard.tab.settings": "Pengaturan",
  "coldStorage.dashboard.viewAlertDetails": "Lihat rincian peringatan",
  "coldStorage.deactivated": "sudah inaktif",
  "coldStorage.description": "Deskripsi",
  "coldStorage.device.activate": "Aktivasi perangkat",
  "coldStorage.device.activateMessage": "Mengaktivasi perangkat ini akan mengaktivasi pemantauan dan pengumpulan data.",
  "coldStorage.device.changeStatus": "Ubah Status Perangkat",
  "coldStorage.device.changeStatusOf": "Ubah status {name}:",
  "coldStorage.device.created": "Perangkat berhasil dibuat",
  "coldStorage.device.createdSuccess": "Perangkat \"{name}\" berhasil dibuat",
  "coldStorage.device.deactivate": "Inaktivasi perangkat",
  "coldStorage.device.deactivateMessage": "Menginaktivasi perangkat ini akan menghentikan pemantauan dan pengumpulan data. Riwayat data akan tersimpan.",
  "coldStorage.device.delete": "Hapus Perangkat",
  "coldStorage.device.deleteConfirm": "Apakah Anda yakin akan menghapus {name}?",
  "coldStorage.device.deleteWarning": "Aksi ini akan menandai perangkat sebagai inaktif dan menghapusnya dari pemantauan aktif. Riwayat data akan tersimpan.",
  "coldStorage.device.deleted": "Perangkat \"{name}\" berhasil dihapus",
  "coldStorage.device.deviceStatus": "Status Perangkat",
  "coldStorage.device.edit": "Edit perangkat",
  "coldStorage.device.id": "ID perangkat",
  "coldStorage.device.ipAddress": "Alamat IP",
  "coldStorage.device.port": "Portal",
  "coldStorage.device.protocol": "Protokol",
  "coldStorage.device.registerCount": "Register per Nilai",
  "coldStorage.device.registerCount.help": "1 untuk nilai 16-bit, 2 untuk nilai 32-bit yang mencakup dua register",
  "coldStorage.device.roomFacility": "Ruangan/Fasilitas",
  "coldStorage.device.rs485": "RS-485 Setengah-Duplex (Opsional)",
  "coldStorage.device.rs485.delayAfter": "Penundaan Setelah Pengiriman (ms)",
  "coldStorage.device.rs485.delayBefore": "Waktu Tunda Sebelum Pengiriman (ms)",
  "coldStorage.device.rs485.mode": "Aktifkan pengaturan waktu pengaktifan driver RS-485",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS aktif tinggi selama transmisi",
  "coldStorage.device.rs485.rxDuringTx": "Aktifkan penerima selama proses transmisi",
  "coldStorage.device.rs485.termination": "Fitur titik akhir bus telah diaktifkan",
  "coldStorage.device.secondProbe": "Sensor Suhu Kedua (Opsional)",
  "coldStorage.device.secondProbe.offset": "Suhu Dasar 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Pergeseran dasar untuk probe kedua",
  "coldStorage.device.secondProbe.register": "Pencatat Suhu 2",
  "coldStorage.device.secondProbe.registerHelp": "Alamat register Modbus untuk probe suhu kedua yang independen. Pembacaan suhunya dicatat dan ditampilkan dalam grafik; peringatan ambang batas dipicu berdasarkan data dari probe pertama.",
  "coldStorage.device.secondProbe.scale": "Skala Suhu 2",
  "coldStorage.device.secondProbe.scaleHelp": "Faktor penskalaan (misalnya, 0,1 untuk membagi dengan 10)",
  "coldStorage.device.statusChanged": "Perangkat \"{name}\" berhasil {status}",
  "coldStorage.device.type": "Jenis",
  "coldStorage.device.updated": "Perangkat berhasil diperbarui",
  "coldStorage.device.wordOrder": "Urutan Kata",
  "coldStorage.device.wordOrder.bigEndian": "Big-endian (kata yang paling signifikan terlebih dahulu)",
  "coldStorage.device.wordOrder.help": "Urutan kedua register dalam nilai 32-bit; diabaikan saat membaca satu register",
  "coldStorage.device.wordOrder.littleEndian": "Little endian (kata yang paling tidak signifikan terlebih dahulu)",
  "coldStorage.deviceHistory.averageMetric": "{metric} rata-rata",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Sudah diketahui / Dilaksanakan Oleh",
  "coldStorage.deviceHistory.column.date": "Tanggal",
  "coldStorage.deviceHistory.column.eventId": "Identitas Peristiwa",
  "coldStorage.deviceHistory.column.eventType": "Jenis Acara",
  "coldStorage.deviceHistory.column.summaryTitle": "Ringkasan / Judul",
  "coldStorage.deviceHistory.column.time": "Waktu",
  "coldStorage.deviceHistory.correctiveActions": "Tindakan Perbaikan",
  "coldStorage.deviceHistory.dataPoints": "Titik Data",
  "coldStorage.deviceHistory.exportCsv": "Ekspor CSV",
  "coldStorage.deviceHistory.loadingEvents": "Memuat riwayat acara...",
  "coldStorage.deviceHistory.loadingTemperature": "Sedang memuat data suhu...",
  "coldStorage.deviceHistory.maxMetric": "Maks {metric}",
  "coldStorage.deviceHistory.metric": "Satuan metrik:",
  "coldStorage.deviceHistory.minMetric": "Min{metric}",
  "coldStorage.deviceHistory.noEventsFound": "Tidak ditemukan acara.",
  "coldStorage.deviceHistory.noTemperatureData": "Tidak ada data suhu yang tersedia untuk rentang waktu yang dipilih.",
  "coldStorage.deviceHistory.searchEvents": "Cari acara",
  "coldStorage.deviceHistory.searchPlaceholder": "Cari berdasarkan ID acara, Ringkasan, atau Pengguna...",
  "coldStorage.deviceHistory.tab.eventHistory": "Riwayat Acara",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Tren Suhu",
  "coldStorage.deviceHistory.timeRange": "Rentang Waktu:",
  "coldStorage.deviceHistory.title": "Riwayat Perangkat - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Jumlah Peringatan",
  "coldStorage.deviceHistory.totalEvents": "Jumlah Acara",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Notifikasi Email & SMS",
  "coldStorage.error.createAction": "Gagal membuat tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.createDevice": "Gagal membuat perangkat:",
  "coldStorage.error.createRoom": "Gagal membuat ruangan:",
  "coldStorage.error.deleteDevice": "Gagal menghapus perangkat:",
  "coldStorage.error.loadActions": "Gagal memuat tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.loadAuditTrail": "Tidak dapat memuat jejak audit",
  "coldStorage.error.loadAuditTrailDetail": "Terjadi kesalahan tak terduga saat memuat catatan audit.",
  "coldStorage.error.loadDevices": "Gagal memuat perangkat:",
  "coldStorage.error.loadExcursions": "Tidak dapat memuat riwayat perjalanan",
  "coldStorage.error.loadExcursionsDetail": "Terjadi error tak terduga saat memuat daftar wisata.",
  "coldStorage.error.loadFailed": "Tidak dapat memuat data pemantauan Penyimpanan Dingin.",
  "coldStorage.error.loadLocations": "Gagal memuat lokasi:",
  "coldStorage.error.loadUsers": "Gagal membuat daftar pengguna. Silahkan coba beberapa saat lagi.",
  "coldStorage.error.noCurrentUser": "Tidak dapat mengidentifikasi pengguna saat ini. Silakan masuk kembali.",
  "coldStorage.error.retractAction": "Gagal membatalkan tindakan perbaikan. Silahkan coba lagi.",
  "coldStorage.error.saveThreshold": "Gagal menyimpan konfigurasi ambang batas:",
  "coldStorage.error.toggleStatus": "Gagal mengganti status perangkat:",
  "coldStorage.error.updateAction": "Gagal memuat tindakan perbaikan. Silahkan coba beberapa saat lagi.",
  "coldStorage.error.updateDevice": "Gagal memperbarui perangkat:",
  "coldStorage.error.updateFailed": "Tidak dapat memperbarui data penyimpanan cold storage",
  "coldStorage.escalationDelay": "Penundaan Eskalasi (menit)",
  "coldStorage.escalationDelayHelper": "Waktu tunggu sebelum eskalasi peringatan yang tidak terselesaikan",
  "coldStorage.escalationRules": "Aturan Eskalasi",
  "coldStorage.filter.activeOnly": "Hanya yang Aktif",
  "coldStorage.filter.all": "Semua Perangkat",
  "coldStorage.filter.inactiveOnly": "Hanya yang Inaktif",
  "coldStorage.footer": "Pemantauan Penyimpanan Dingin v2.1.0 | Sesuai dengan pedoman CAP, CLIA, FDA, dan WHO | Pengelolaan Data yang Sesuai dengan HIPAA",
  "coldStorage.granularNotificationControl": "Kendali Notifikasi Granular",
  "coldStorage.granularNotificationControlDesc": "Konfigurasi notifikasi email dan SMS untuk setiap jenis peringatan. Aktifkan metode notifikasi yang diinginkan untuk setiap jenis kategori peringatan.",
  "coldStorage.howNotificationsWork": "Bagaimana notifikasi bekerja",
  "coldStorage.howNotificationsWorkDesc": "Saat peringatan terpicu (pelanggaran ambang batas suhu, kegagalan perangkat, dll.), sistem akan:",
  "coldStorage.loadingDevices": "Memuat perangkat...",
  "coldStorage.loadingPrefs": "Memuat pilihan notifikasi...",
  "coldStorage.name": "Nama",
  "coldStorage.noConfigFound": "Konfigurasi tidak ditemukan",
  "coldStorage.noDevicesConfigured": "Tidak ada perangkat yang dikonfigurasi",
  "coldStorage.notification.createRecord": "Membuat rekaman peringatan di sistem (tampil di Dasbor)",
  "coldStorage.notification.logAttempt": "Log percobaan notifikasi untuk kepentingan proses jejak audit",
  "coldStorage.notification.sendEmail": "Kirim notifikasi via EMAIL jika diaktifkan (untuk penerima yang di tetapkan)",
  "coldStorage.notification.sendSms": "Kirim notifikasi SMS jika diaktifkan (untuk nomor telepon yang ditetapkan)",
  "coldStorage.pollInterval": "Interval Poll (detik)",
  "coldStorage.reports.column.action": "Aksi",
  "coldStorage.reports.column.details": "Rincian",
  "coldStorage.reports.column.excursionId": "ID Wisata",
  "coldStorage.reports.column.freezer": "Lemari Pembeku",
  "coldStorage.reports.column.freezerId": "Nomor Identitas Freezer",
  "coldStorage.reports.column.startTime": "Waktu Mulai",
  "coldStorage.reports.column.temperatureRange": "Rentang Suhu",
  "coldStorage.reports.column.timestamp": "Cap waktu",
  "coldStorage.reports.column.user": "Pengguna",
  "coldStorage.reports.downloadReport": "Unduh Laporan “{format}”",
  "coldStorage.reports.endDate": "Tanggal Selesai",
  "coldStorage.reports.excursionHistory": "Riwayat Fluktuasi Suhu",
  "coldStorage.reports.exportFormat": "Format Ekspor",
  "coldStorage.reports.footer": "Pemantauan Penyimpanan Dingin v2.1.0 | Sesuai dengan standar CAP, CLIA, FDA, dan WHO | Pengelolaan data yang sesuai dengan HIPAA",
  "coldStorage.reports.freezer": "Lemari Pembeku",
  "coldStorage.reports.generateReport": "Membuat Laporan",
  "coldStorage.reports.loadingAudit": "Sedang memuat entri audit…",
  "coldStorage.reports.loadingExcursions": "Memuat daftar wisata…",
  "coldStorage.reports.noAuditActivity": "Tidak ada aktivitas audit untuk filter yang dipilih.",
  "coldStorage.reports.noAuditMatch": "Tidak ada entri audit yang sesuai dengan pencarian Anda.",
  "coldStorage.reports.noExcursions": "Tidak ada wisata yang tersedia untuk filter yang dipilih.",
  "coldStorage.reports.regulatoryCompliance": "Kepatuhan terhadap Peraturan",
  "coldStorage.reports.regulatoryComplianceDesc": "Laporan-laporan tersebut mengikuti pedoman CAP (College of American Pathologists), CLIA (Clinical Laboratory Improvement Amendments), FDA (Food and Drug Administration), dan WHO (World Health Organization) mengenai penyimpanan dengan pengaturan suhu.",
  "coldStorage.reports.reportType": "Jenis Laporan",
  "coldStorage.reports.searchAuditTrail": "Cari jejak audit...",
  "coldStorage.reports.startDate": "Tanggal Mulai",
  "coldStorage.reports.tab.auditTrail": "Jejak Audit",
  "coldStorage.reports.tab.excursions": "Fluktuasi Suhu",
  "coldStorage.reports.title": "Laporan Kepatuhan",
  "coldStorage.room.addNew": "Tambah Ruangan Baru",
  "coldStorage.room.create": "Buat Ruangan",
  "coldStorage.room.created": "Ruangan berhasil dibuat",
  "coldStorage.room.description": "Deskripsi",
  "coldStorage.room.descriptionPlaceholder": "Masukkan deskripsi ruangan (opsional)",
  "coldStorage.room.name": "Nama Ruangan *",
  "coldStorage.room.namePlaceholder": "Masukkan nama ruangan (misalnya, Ruangan Penyimpanan Lab A)",
  "coldStorage.saveNotificationPrefs": "Menyimpan Pilihan Notifikasi",
  "coldStorage.saveThresholdConfig": "Simpan Konfigurasi Ambang Batas",
  "coldStorage.saving": "Menyimpan...",
  "coldStorage.search.placeholder": "Cari berdasarkan ID atau nama perangkat",
  "coldStorage.selectType": "Pilih jenis",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Status",
  "coldStorage.status.active": "AKTIF",
  "coldStorage.status.inactive": "INAKTIF",
  "coldStorage.status.noData": "Tidak ada data",
  "coldStorage.status.offline": "Offline",
  "coldStorage.status.unknown": "Tidak diketahui",
  "coldStorage.supervisorEmail": "Email Penyelia",
  "coldStorage.supervisorEmailHelper": "Alamat email untuk mengirim peringatan tereskalasi",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Target Suhu (°C)",
  "coldStorage.threshold.saveSuccess": "Konfigurasi ambang batas berhasil disimpan",
  "coldStorage.thresholdConfiguration": "Konfigurasi Ambang Batas Suhu",
  "coldStorage.trends.averageMetric": "{metric} rata-rata",
  "coldStorage.trends.axis.humidity": "Kelembapan (%)",
  "coldStorage.trends.axis.temperature": "Suhu (°C)",
  "coldStorage.trends.axis.temperature2": "Suhu - Probe 2 (°C)",
  "coldStorage.trends.maxMetric": "Maks {metric}",
  "coldStorage.trends.metric": "Metrik",
  "coldStorage.trends.metric.humidity": "Kelembapan",
  "coldStorage.trends.metric.temperature": "Suhu",
  "coldStorage.trends.metric.temperature2": "Suhu (Sensor 2)",
  "coldStorage.trends.minMetric": "Min{metric}",
  "coldStorage.usingDefaults": "Menggunakan pengaturan notifikasi default. Simpan untuk membuat konfigurasi.",
  "coldStorage.validation.error": "Kesalahan Validasi",
  "coldStorage.validation.retractionReason": "Masukkan alasan pembatalan",
  "coldStorage.validation.selectActionType": "Mohon pilih jenis aksi",
  "coldStorage.validation.selectDevice": "Mohon pilih perangkat",
  "coldStorage.validation.selectRoom": "Mohon pilih ruangan/lokasi untuk perangkat ini",
  "coldStorage.warningThreshold": "Peringatan Ambang Batas (°C)",
  "collect.addSample.button": "Tambah Sampel",
  "collect.assign.addToSample": "Tambah ke sampel yang ada",
  "collect.assign.button": "Tugaskan Pemeriksaan",
  "collect.assign.description": "Tugaskan pemeriksaan ke tube sampel",
  "collect.assign.newSample": "Buat sampel baru",
  "collect.assign.newSampleHelp": "Masukkan jenis sampel ke tube baru",
  "collect.assign.noExisting": "Tidak ada sampel tersebut",
  "collect.assign.title": "Penugasan Pemeriksaan",
  "collect.multiSampleExample.description": "Jika dibutuhkan jenis sample lebih dari satu",
  "collect.multiSampleExample.result": "Buat tube terpisah untuk setiap jenis",
  "collect.multiSampleExample.title": "Contoh Pengambilan Multi-Sampel",
  "collect.noSampleYet": "Sampel belum diambil",
  "collect.noTestsOrdered": "Pemeriksaan belum dipesan",
  "collect.noTestsWarning.subtitle": "Tambah sample dengan pemeriksaan di Step 1 sebelum lanjut",
  "collect.noTestsWarning.title": "Tidak ada pemeriksaan yang diambil",
  "collect.printMoreLabels.button": "Cetak Label Lagi",
  "collect.printMoreLabels.helper": "Cetak label tambahan untuk sampel ini",
  "collect.requestedTests.info": "Pemeriksaan diminta untuk pemesanan ini",
  "collect.requestedTests.title": "Pemeriksaan yang diminta",
  "collect.sample.assignedTests": "Pemeriksaan Ditugaskan",
  "collect.sample.collectionConditions": "Kondisi Pengambilan",
  "collect.sample.collectionConditions.placeholder": "Catat kondisi khusus...",
  "collect.sample.collectionDate": "Tanggal Pengambilan",
  "collect.sample.collectionMethod": "Metode Pengambilan",
  "collect.addTests.title": "Add Tests or Panels",
  "collect.addTests.helper": "Add a test the clinician asked for after the order was entered, or one that only becomes appropriate with the specimen in hand.",
  "collect.consentRequired.title": "Informed consent is required",
  "collect.consentRequired.subtitle": "This laboratory requires consent to be recorded before a collection can proceed.",
  "sample.holdingLimit": "Holding time: {limit}",
  "sample.holdingLimit.testBy": "test by {deadline}",
  "env.sample.receivedAtLab": "Diterima di Lab",
  "collect.sample.specimenOrigin": "Specimen Origin",
  "collect.sample.temperature": "Suhu Sampel",
  "collect.sample.temperature.placeholder": "e.g. 4 C",
  "collect.sample.collectionDate.helper": "Tanggal saat sampel diambil",
  "collect.sample.collectionDateBeforeAdmission": "Tanggal Pengambilan tidak boleh lebih awal dari tanggal masuk.",
  "collect.sample.collectionTime": "Waktu Pengambilan",
  "collect.sample.collector": "Pengambil sampel",
  "collect.sample.header": "Sampel {number}",
  "collect.sample.labPerformedSampling": "Pengambilan sampel yang dilakukan di laboratorium",
  "collect.sample.nce.link": "Laporan Kejadian Ketidaksesuaian",
  "collect.sample.noTests": "Tidak ada pemeriksaan yang ditugaskan untuk sampel ini",
  "collect.sample.printLabels": "Cetak label",
  "collect.sample.quantity": "Kuantitas",
  "collect.sample.receivedAtLab": "Diterima di Lab",
  "collect.sample.receivedAtLab.helper": "Periksa jika sampel sudah diterima di laboratorium",
  "collect.sample.receivedDate": "Tanggal Diterima",
  "collect.sample.receivedTime": "Waktu Diterima",
  "collect.sample.remove": "Hapus Sampel",
  "collect.samples.title": "Sampel",
  "collect.table.compatibleTypes": "Jenis Sampel Yang Kompatibel",
  "collect.table.sampleAssignments": "Penugasan Sampel",
  "collect.table.testPanel": "Pemeriksaan / Panel",
  "heading.informedConsent.sectionTitle": "Persetujuan yang Didahului dengan Informasi",
  "heading.informedConsent.auditRecord": "Rekaman Audit Consent",
  "label.informedConsent.consentGiven": "Pasien sudah memberi tanda tangan consent",
  "label.informedConsent.formReference": "Nomor Referensi Form Consent",
  "label.informedConsent.recordedBy": "Direkam oleh",
  "label.informedConsent.recordedAt": "Direkam pada",
  "label.informedConsent.statusTag": "Consent sudah Direkam",
  "label.informedConsent.notRecorded": "Tidak terekam",
  "placeholder.informedConsent.formReference": "mis. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "mis. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Referensi form consent tidak lebih dari 100 karakter",
  "error.informedConsent.formReferenceInvalidChars": "Hanya boleh menggunakan abjad, angka, hyphen, dan spasi",
  "coldstorage.label.dashboard": "Dasbor Penyimpanan Beku",
  "collection.date": "Tanggal Pengambilan",
  "collector": "Pengambil sampel",
  "collector.label": "Pengambil sampel",
  "column.actions": "Aksi",
  "column.name.accept": "Terima",
  "column.name.analyzerResult": "Hasil dari Alat",
  "column.name.currentResult": "Hasil Saat Ini",
  "column.name.ignore": "Abaikan",
  "column.name.normalRange": "Rentang Normal",
  "column.name.notes": "Catatan",
  "column.name.pastNotes": "Catatan Sebelumnya",
  "column.name.qcDetail": "Detail",
  "column.name.qcStatus": "Status QC",
  "column.name.reject": "Tolak",
  "column.name.result": "Hasil",
  "column.name.retest": "Pemeriksaan Ulang",
  "column.name.sampleInfo": "Informasi Sampel",
  "column.name.sampleKind": "Jenis Sampel",
  "column.name.save": "Simpan",
  "column.name.statusPerRegulation": "Status — Sesuai Peraturan",
  "column.name.testDate": "Tanggal Pemeriksaan",
  "column.name.testId": "Identitas Pemeriksaan",
  "column.name.testName": "Nama Pemeriksaan",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "Code must contain at least one letter, digit, or underscore.",
  "common.properties.title": "Properti Umum",
  "configuration.batch.test.reassignment": "Penugasan kembali dan pembatalan pemeriksaan kelompok",
  "configuration.method": "Pengelolaan Metode",
  "configuration.method.create": "Buat Metode Baru",
  "configuration.method.explain": "Untuk membuat metode baru, mengaktifkan atau menonaktifkan metode",
  "configuration.method.rename": "Ganti nama metode yang ada",
  "configuration.method.rename.explain": "Gunakan untuk mengkoreksi nama metode",
  "configuration.panel.assign": "Penugasan Pemeriksaan",
  "configuration.panel.assign.explain": "Klik untuk memilih nama pemeriksaan yang akan ditugaskan pada panel; nama pemeriksaan yang baru akan muncul di bagian bawah panel",
  "configuration.panel.confirmation.explain": "Panel ini tidak aktif sampai ada satu pemeriksaan yang ditugaskan",
  "configuration.panel.create": "Buat panel baru",
  "configuration.panel.create.duplicate": "Jenis panel dengan nama yang sama ditemukan. Batalkan dan gunakan nama lain.",
  "configuration.panel.manage": "Kelola Panel",
  "configuration.panel.manage.explain": "Untuk membuat, mengatur tampilan pemesanan atau menugaskan pemeriksaan pada panel",
  "configuration.panel.order": "Mengatur Urutan Panel",
  "configuration.panel.order.explain": "Menyortir panel dengan mengklik dan menyeret ke urutan yang tepat",
  "configuration.panel.order.explain.limits": "Hanya panel dengan pemeriksaan yang ditugaskan dapat dipesan. Untuk panel baru, mohon menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.panel.rename": "Menamai ulang panel yang ada",
  "configuration.panel.rename.explain": "Gunakan nama yang tepat untuk panel yang ada",
  "configuration.sampleType.assign.explain": "Pilih pemeriksaan yang akan ditugaskan pada jenis sampel dengan mengklik nama pemeriksaan; pemeriksaan baru akan tampilan di bawah jenis sampel yang ditugaskan",
  "configuration.sampleType.assign.new.type": "Tugaskan ke jenis sampel",
  "configuration.sampleType.confirmation.explain": "Jenis sampel ini tidak akan aktif sampai setidaknya satu pemeriksaan telah ditugaskan.",
  "configuration.sampleType.create": "Buat Jenis Sampel Baru",
  "configuration.sampleType.create.duplicate": "Jenis sampel dengan nama yang sama ditemukan. Mohon membatalkan atau menggunakan nama lain",
  "configuration.sampleType.manage": "Kelola Jenis Sampel",
  "configuration.sampleType.manage.explain": "Gunakan untuk membuat, mengatur tampilan pemesanan atau menugaskan pemeriksaan pada jenis sampel",
  "configuration.sampleType.order": "Mengatur Urutan Jenis Sampel",
  "configuration.sampleType.order.explain": "Menyortir jenis sampel dengan mengklik dan menyeret ke urutan yang tepat",
  "configuration.sampleType.order.explain.limits": "Hanya jenis sampel dengan penugasan pemeriksaan yang dapat dipesan. Untuk jenis sampel baru, mohon menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.selectList.add": "Tambah daftar pilihan hasil",
  "configuration.selectList.add.alert": "Untuk mengubah ejaan entri daftar hasil saat ini, gunakan opsi Ganti nama daftar hasil yang ada.",
  "configuration.selectList.add.explain": "Untuk membuat daftar pilihan hasil untuk hasil pemeriksaan",
  "configuration.selectList.assign.description": "Entri baru dapat ditugaskan ke pemeriksaan atau dapat disimpan tanpa penugasan. Pilih satu atau lebih pemeriksaan untuk ditugaskan, lalu sesuaikan urutan tampilan. Jika entri baru berupa nilai rentang normal untuk pemeriksaan yang dipilih, centang kotak berlabel `Normal`. Jika diinginkan, petugas dapat memasukkan teks untuk lebih memperjelas hasil, dan centang kotak berlabel `Dapat Diperjelas`. Misalnya; jika pilihannya adalah daftar organisme dan pilihan terakhir adalah `Lainnya`, maka pengguna dapat memasukkan organisme yang tidak ada dalam daftar.",
  "configuration.selectList.assign.header": "Tugaskan pilihan hasil baru ke pemeriksaan",
  "configuration.selectList.assign.new": "Opsi daftar pilihan baru",
  "configuration.selectList.confirmChange": "Nilai normal akan diubah dari %oldvalue% ke%newvalue%, apakah anda yakin akan lanjut?",
  "configuration.selectList.description": "Masukkan English dan French ke opsi pilihan baru. Bila terjemahan tidak diketahui, maka istilah akan digunakan untuk kedua bahasa tersebut.",
  "configuration.selectList.header": "Buat opsi pilihan hasil baru",
  "configuration.selectList.rename": "Namai ulang opsi daftar hasil yang ada",
  "configuration.selectList.rename.explain": "Namai ulang opsi daftar hasil yang ada",
  "configuration.test.activate": "Aktif/nonaktifkan pemeriksaan",
  "configuration.test.activate.explain": "Untuk mengaktifkan atau menonaktifkan pemeriksaan yang ada",
  "configuration.test.add": "Menambah pemeriksaan baru",
  "configuration.test.add.explain": "Untuk menambah pemeriksaan baru ke sistem. Modifikasi pemeriksaan yang ada harus dilakukan melalui tautan Kelola pemeriksaan lainnya",
  "configuration.test.catalog": "Lihat Katalog Pemeriksaan",
  "configuration.test.catalog.explain": "Melihat Katalog Pemeriksaan saat ini",
  "configuration.test.management.ocl": "Impor OCL Concept",
  "configuration.test.management.organization": "Pengaturan Pemeriksaan",
  "configuration.test.management.spelling": "Koreksi Penamaan",
  "configuration.test.modify": "Modifikasi pemeriksaan",
  "configuration.test.modify.explain": "Untuk memodifikasi pemeriksaan yang ada dalam sistem",
  "configuration.test.modify.tab.configuration": "Konfigurasi",
  "configuration.test.modify.tab.compliance": "Ambang Kepatuhan",
  "configuration.test.modify.filter.instruction": "Pilih Jenis Sampel atau Bagian Sampel untuk menampilkan pemeriksaan",
  "configuration.test.modify.filter.noTestsFound": "Tidak ada pemeriksaan yang cocok untuk kriteria yang dipilih",
  "configuration.test.modify.filter.selectToBegin": "Silahkan pilih Jenis Sampel atau Bagian Sampel untuk mulai menampilkan pemeriksaan",
  "configuration.test.orderable": "Mengaktifkan/menonaktifkan ketersediaan pemeriksaan",
  "configuration.test.orderable.explain": "Pemeriksaan yang tersedia dapat dipesan pada saat penerimaan pasien. Jika tidak tersedia, maka dapat dipesan sebagai pemeriksaan refleks.",
  "configuration.test.rename": "Menamai ulang pemeriksaan yang ada",
  "configuration.test.rename.explain": "Untuk menamai ulang pemeriksaan yang ada. Pemeriksaan tidak berubah, hanya ada perubahan pada tampilan pengguna di sistem dan pada laporan. ",
  "configuration.testSection.rename": "Menamai ulang Bagian Pemeriksaan yang ada",
  "configuration.testSection.rename.explain": "Untuk mengkoreksi nama bagian pemeriksaan yang sudah ada",
  "configuration.testUnit.assign.new.unit": "Menugaskan ke bagian pemeriksaan",
  "configuration.testUnit.confirmation.explain": "Instalasi Lab ini tidak aktif sampai setidaknya satu pemeriksaan ditugaskan",
  "configuration.testUnit.create": "Buat Instalasi Lab baru",
  "configuration.testUnit.create.duplicate": "Instalasi Lab dengan nama yang sama ditemukan. Batalkan atau gunakan nama lain.",
  "configuration.testUnit.manage": "Kelola Instalasi Lab",
  "configuration.testUnit.manage.explain": "Untuk membuat, mengatur urutan tampilan atau menugaskan pemeriksaan ke Instalasi Lab",
  "configuration.testUnit.order": "Mengatur Urutan Unit Pemeriksaan",
  "configuration.testUnit.order.explain": "Menyortir unit laboratorium dengan mengklik dan menyeret unit ke urutan yang tepat",
  "configuration.testUnit.order.explain.limits": "Hanya bagian pemeriksaan dengan pemeriksaan yang ditugaskan yang dapat dipesan. Untuk bagian baru, silahkan menugaskan pemeriksaan sebelum melakukan pemesanan.",
  "configuration.type.rename": "Menamai ulang jenis sampel yang ada",
  "configuration.type.rename.explain": "Untuk mengkoreksi nama panel yang ada",
  "heading.sampleType.management": "Editor Jenis Sampel",
  "heading.sampleType.subtitle": "Konfigurasikan jenis sampel, urutan tampilan pemeriksaan, hubungan pemeriksaan, dan klasifikasi domain.",
  "heading.sampleType.editing": "Edit: {name}",
  "label.sampleType.domain": "Sampel Domain",
  "label.domain.CLINICAL": "Klinis",
  "label.domain.ENVIRONMENTAL": "Lingkungan",
  "label.domain.VECTOR": "Vektor",
  "label.sampleType.domain.clinical": "Klinis",
  "label.sampleType.domain.environmental": "Lingkungan",
  "label.sampleType.domain.helper": "Menentukan mode alur kerja mana (Klinis atau Lingkungan) yang akan menampilkan jenis sampel ini.",
  "label.sampleType.filterDomain": "Saring berdasarkan domain",
  "label.sampleType.testCount": "Pemeriksaan",
  "label.sampleType.actions": "Aksi",
  "label.sampleType.status": "Status",
  "placeholder.sampleType.search": "Cari jenis sampel...",
  "placeholder.sampleType.filter.domain": "Semua domain",
  "button.sampleType.add": "Tambah Jenis Sampel",
  "configuration.uom.create": "Buat Satuan Pengukuran Baru",
  "configuration.uom.manage": "Kelola Satuan Pengukuran",
  "configuration.uom.manage.explain": "Untuk membuat Satuan Pengukuran",
  "configuration.uom.rename": "Menamai ulang entri Satuan Pengukuran yang ada",
  "configuration.uom.rename.explain": "Untuk mengkoreksi nama entri satuan pengukuran yang ada.",
  "configure.labNumber.title": "Pengelolaan Nomor Registrasi",
  "confirmation.rename": "Konfirmasi perubahan yang dibuat",
  "currentests.title": "Pemeriksaan saat ini",
  "cytology.label.cellabnomality": "Abnormalitas Sel Epitel",
  "cytology.label.confirmSelect": "Bila opsi ini dipilih, semua informasi diagnosis saat ini akan dihapus",
  "cytology.label.dashboard": "Dasbor Sitologi",
  "cytology.label.glandular": "Kelenjar",
  "cytology.label.negative": "Negatif lesi intraepitelial atau keganasan",
  "cytology.label.neoplastic": "Keragaman sel non-neoplastik",
  "cytology.label.organisms": "Organisme",
  "cytology.label.other": "Neoplasma ganas lainnya",
  "cytology.label.otherResult": "Hasil diagnosis lainnya",
  "cytology.label.reactive": "Perubahan sel reaktif",
  "cytology.label.review": "Menunggu tinjauan dari ahli sitopatologi",
  "cytology.label.specimen": "Kecukupan spesimen",
  "cytology.label.squamous": "Skuamosa",
  "cytology.label.title": "Sitologi",
  "dashboard.avg.turn.around.label": "Rerata waktu penyelesaian",
  "dashboard.avg.turn.around.reception.to.result.label": "Waktu Rerata Penerimaan Sampai Hasil",
  "dashboard.avg.turn.around.reception.to.validation.label": "Waktu Rerata Penerimaan Sampai Validasi",
  "dashboard.avg.turn.around.result.to.validation.label": "Waktu Rerata Hasil Sampai Validasi",
  "dashboard.avg.turn.around.subtitle.label": "Penerimaan sampai validasi",
  "dashboard.complete.orders.label": "Pemesanan selesai hari ini",
  "dashboard.in.progress.label": "Dalam Pengerjaan",
  "dashboard.in.progress.subtitle.label": "Menunggu entri hasil",
  "dashboard.metrics.loadFailed": "Dashboard counts could not be loaded.",
  "dashboard.partially.completed.label": "Sebagian selesai hari ini",
  "dashboard.partially.completed.subtitle.label": "Menunggu Pemeriksaan yang Belum Selesai",
  "dashboard.rejected.orders": "Pemesanan ditolak",
  "dashboard.turn.around.label": "Waktu penyelesaian tertunda",
  "dashboard.turn.around.subtitle.label": "Lebih dari 96 jam",
  "dashboard.unprints.results.label": "Hasil belum dicetak",
  "dashboard.user.orders.label": "Pemesanan yang dimasukkan pengguna",
  "dashboard.user.orders.today.label": "Pemesanan dimasukkan oleh pengguna hari ini",
  "dashboard.validation.ready.label": "Siap untuk validasi",
  "dashboard.validation.ready.subtitle.label": "Menunggu tinjauan",
  "dataexport.status.actions": "Aksi",
  "dataexport.status.attempt.duration": "Durasi",
  "dataexport.status.attempt.endTime": "Waktu Selesai",
  "dataexport.status.attempt.startTime": "Waktu Mulai",
  "dataexport.status.attempt.status": "Status",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "Tidak ada pelanggan FHIR yang dikonfigurasi. Atur org.openelisglobal.fhir.subscriber di Properti Umum dan mulai ulang server untuk mendaftarkan satu pelanggan.",
  "dataexport.status.endpoint": "Titik akhir",
  "dataexport.status.failed24h": "Gagal / Total (24 jam)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Interval retry",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Coba terakhir",
  "dataexport.status.lastRefreshed": "Refresh terakhir",
  "dataexport.status.lastStatus": "Status Terakhir",
  "dataexport.status.lastSuccess": "Sukses Terakhir",
  "dataexport.status.loadingAttempts": "Memuat riwayat percobaan...",
  "dataexport.status.never": "Tidak pernah",
  "dataexport.status.noAttempts": "Belum ada percobaan",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Segarkan",
  "dataexport.status.retry": "Ulangi sekarang",
  "dataexport.status.retryInFlight": "Men-trigger…",
  "dataexport.status.title": "Status Ekspor Data FHIR",
  "datasubmission.siteid": "Identitas Situs",
  "database.clean": "Pembersihan Database",
  "database.clean.button": "Kosongkan Database",
  "database.clean.confirm.message": "Apakah Anda yakin akan mengosongkan database? Ini akan menghapus semua data pasien dan pemeriksaan",
  "database.clean.confirm.title": "Konfirmasi Pengosongan Database",
  "database.clean.confirm.warning": "Aksi ini tidak dapat dibatalkan!",
  "database.clean.error": "Gagal mengosongkan database.",
  "database.clean.not.training": "Pembersihan database hanya tersedia di instalasi pelatihan.",
  "database.clean.success": "Database berhasil dikosongkan.",
  "database.clean.warning": "Ini akan menghapus permanen semua data pasien, sampel dan hasil dari database.",
  "date.created": "Tanggal Dibuat",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Error saat menghapus",
  "delete.success.msg": "Berhasil dihapus",
  "description.active": "Jika pemeriksaan sedang aktif, maka dapat dipesan melalui formulir pemesanan atau sebagai bagian algoritma pemeriksaan. Jika pemeriksaan tidak aktif, maka tidak dapat dipesan atau dijadikan bagian algoritma pemeriksaan.",
  "description.ageRange": "Jika rentang usia (dalam bulan) penting untuk nilai yang diberikan, maka akan ditentukan di sini.",
  "description.name": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis.",
  "description.normalRange": "Rentang numerik yang diharapkan dari orang sehat.",
  "description.note": "n/a berarti tidak tersedia. Nilai tidak dispesifikasi.",
  "description.orderable": "Jika pemeriksaan aktif dan dapat dipesan, maka pemeriksaan dapat dipesan melalui formulir pemesanan. Jika pemeriksaan aktif tetapi tidak dapat dipesan, maka pemeriksaan hanya akan dilakukan jika merupakan rujukan dari pemeriksaan lain.",
  "description.panel": "Jika pemeriksaan adalah bagian dari panel pemeriksaan, maka panel akan disebut di sini.",
  "description.referenceValue": "Nilai pilihan untuk orang sehat. Hanya untuk daftar hasil yang dipilih.",
  "description.reportName": "Nama pemeriksaan yang tampil pada laporan. Tampil dalam Bahasa Inggris maupun Perancis",
  "description.resultLimits": "Batas hasil normal dan valid untuk pemeriksaan numerik. Nilai tergantung umur dan jenis kelamin pasien.",
  "description.resultType": "Jenis hasil untuk pemeriksaan ini:",
  "description.resultType.alphanumeric": "A - Alfanumerik:",
  "description.resultType.alphanumericDesc": "Menerima nilai numerik atau teks dalam kotak teks. Nilai tidak akan dievaluasi apakah normal atau valid.",
  "description.resultType.cascadingMultiSelectList": "C - Daftar pilihan berganda bertingkat:",
  "description.resultType.cascadingMultiSelectListDesc": "Serupa dengan pilihan berganda, tapi pengguna dapat memilih lebih dari satu kelompok dari pilihan dropdown.",
  "description.resultType.kind": "Jenis hasil untuk pemeriksaan ini:",
  "description.resultType.multiSelectList": "M - Daftar pilihan berganda:",
  "description.resultType.multiSelectListDesc": "Pengguna dapat memilih satu atau lebih nilai dari daftar dropdown. Nilai referensi tidak dispesifikasi.",
  "description.resultType.numeric": "N - Numerik:",
  "description.resultType.numericDesc": "Hanya menerima hasil numerik dalam kotak teks. Hasil dapat dievaluasi dalam rentang normal atau valid.",
  "description.resultType.selectList": "D - Daftar pilihan:",
  "description.resultType.selectListDesc": "Pengguna dapat memilih dari daftar dropdown. Nilai normal akan ditentukan sebagai nilai referensi.",
  "description.resultType.textArea": "R-Teks bebas:",
  "description.resultType.textAreaDesc": "Menerima lebih dari 200 karakter dalam area teks. Tidak dievaluasi apakah normal atau valid.",
  "description.sampleType": "Jenis sampel yang dapat diuji. Jika petugas yang menerima dapat memilih jenis sampel setelah pemesanan pemeriksaan, maka akan ditandai sebagai \"pengguna\", untuk menunjukkan bahwa pengguna memilih jenis sampel tersebut.",
  "description.selectValues": "Hanya ditentukan untuk hasil pilihan tunggal, pilihan ganda, atau pilihan ganda bertingkat. Ini adalah pilihan yang tersedia terlihat oleh pengguna. Jika pilihan ditandai sebagai 'dapat memenuhi syarat', maka pengguna dapat memasukkan informasi tambahan di kotak teks.",
  "description.sex": "Jika jenis kelamin pasien berpengaruh pada nilai, maka akan disebutkan disini.",
  "description.significantDigits": "Jumlah digit signifikan untuk hasil numerik. Hasil yang dimasukkan akan dibulatkan atau ditambahkan angka di depan hingga mencapai jumlah digit yang benar. Rentang normal akan ditampilkan dengan jumlah angka signifikan yang benar.",
  "description.testUnit": "Bagian lab yang melakukan pemeriksaan. Disebut juga sebagai bagian pemeriksaan.",
  "description.uom": "Satuan pengukuran pemeriksaan. Biasanya berlaku hanya untuk jenis hasil numerik atau alfanumerik.",
  "description.validRange": "Hasil numerik di luar rentang ini adalah indikasi pemeriksaan tidak dilakukan dengan benar.",
  "dictionary.category.isActive": "Aktif",
  "dictionary.category.label": "Kategori Kamus",
  "dictionary.category.localAbbreviation": "Singkatan lokal",
  "dictionary.category.name": "Kategori",
  "dictionary.dictEntry": "Entri kamus",
  "dictionary.label.modify": "Menu kamus",
  "dictionary.loincCode": "Kode LOINC",
  "dictionary.loincCode.help": "Masukkan kode LOINC standar",
  "dictionary.loincCode.helpText": "Pengenal standar observasi laboratorium",
  "dictionary.loincCode.invalid": "Format LOINC tidak valid (contoh yang benar: 12345-6 or LP12345-6)",
  "dictionary.loincCode.placeholder": "misalnya, 12345-6",
  "dictionary.menu.deactivate.fail": "Penonaktifan menu kamus gagal",
  "dictionary.menu.deactivate.success": "Penonaktifan menu kamus sukses",
  "dictionary.modal.add.heading": "Tambah Kamus",
  "dictionary.modal.edit.heading": "Edit Kamus",
  "dictionary.number.label": "Nomor Kamus",
  "disposal.button": "Musnahkan Lot",
  "disposal.notes": "Catatan Pemusnahan",
  "disposal.notes.placeholder": "Sediakan rincian pemusnahan (metode pemusnahan, saksi, dll.)",
  "disposal.reason": "Alasan Pemusnahan",
  "disposal.reason.select": "Pilih alasan",
  "disposal.success": "Lot berhasil dimusnahkan",
  "disposal.title": "Musnahkan Lot",
  "disposal.warning.message": "Aksi ini tidak dapat dibatalkan. Lot akan ditandai dimusnahkan atau dihapus dari inventaris aktif.",
  "disposal.warning.title": "Peringatan",
  "emergencyContactInfo.title": "Informasi Kontak Darurat",
  "english.current": "Bahasa Inggris saat ini",
  "english.label": "Bahasa Inggris",
  "enterText.label": "Masukkan hasil teks",
  "eorder.allInfo": "Semua Informasi",
  "eorder.button.editOrder": "Edit Pemesanan",
  "eorder.button.enterOrder": "Masukkan Pemesanan",
  "eorder.buttons": " ",
  "eorder.date.end": "Tanggal Selesai",
  "eorder.date.start": "Tanggal Mulai",
  "eorder.facility.requesting": "Lembaga Pemohon",
  "eorder.header": "Cari Pemesanan Pemeriksaan Yang Masuk",
  "eorder.id.national": "NIK",
  "eorder.id.subjectNumber": "Nomor Subyek",
  "eorder.instructions.enter1": "Kecocokan Pencarian Permintaan Pemeriksaan - Dalam",
  "eorder.instructions.enter2": "menu, tambah nomor registrasi dan pilih",
  "eorder.instructions.enter3": "menerima permintaan seperti apa adanya, atau pilih",
  "eorder.instructions.enter4": "membuat perubahan",
  "eorder.labNumber": "Nomor Registrasi",
  "eorder.labnumber.referring": "Nomor Lab Perujuk",
  "eorder.name.first": "Nama Depan",
  "eorder.name.last": "Nama Belakang",
  "eorder.passport.number": "Nomor Paspor",
  "eorder.priority": "Prioritas",
  "eorder.requestDate": "Tanggal Permintaan",
  "eorder.search.noresults": "Nomor Permintaan Elektronik",
  "eorder.search1.text": "Cari berdasar Nama Belakang, NIK, Nomor Lab Perujuk, atau Nomor Paspor",
  "eorder.search2.text": "Cari berdasarkan Tanggal, dan Status rentang tanggal permintaan pemeriksaan. Pencarian akan dilakukan berdasarkan tanggal dirujuk, atau tanggal permintaan elektronik.",
  "eorder.searchValue": "Cari Nilai",
  "eorder.status": "Status",
  "eorder.test.name": "Nama Pemeriksaan",
  "eqa.action.deactivate": "Nonaktifkan",
  "eqa.action.edit": "Sunting",
  "eqa.action.enterResults": "Masukkan Hasil",
  "eqa.action.enterViewResults": "Masukkan/Lihat Hasil",
  "eqa.action.reactivate": "Aktifkan Ulang",
  "eqa.action.viewOrder": "Lihat Pemesanan",
  "eqa.action.viewResults": "Lihat Hasil",
  "eqa.admin.addProgram": "Tambah Program",
  "eqa.admin.col.actions": "Aksi",
  "eqa.admin.col.category": "Kategori",
  "eqa.admin.col.frequency": "Frekuensi",
  "eqa.admin.col.participants": "Peserta yang terdaftar",
  "eqa.admin.col.programName": "Nama Program",
  "eqa.admin.col.provider": "Penyelenggara",
  "eqa.admin.delete": "Hapus",
  "eqa.admin.form.addHeading": "Tambah Program PME Baru",
  "eqa.admin.form.category.placeholder": "Pilih Kategori",
  "eqa.admin.form.description.placeholder": "Deskripsi dan tujuan program...",
  "eqa.admin.form.editHeading": "Edit Program PME",
  "eqa.admin.form.frequency.placeholder": "Pilih Frekuensi",
  "eqa.admin.form.name.placeholder": "mis., Kultur TB & Sensitivitas",
  "eqa.admin.form.provider.placeholder": "Pilih penyelenggara",
  "eqa.admin.form.subtitle": "Daftar di program PME baru",
  "eqa.admin.programs.subtitle": "Kelola program dan penyelenggara PME yang terdaftar",
  "eqa.admin.programs.title": "Program PME",
  "eqa.admin.provider.placeholder": "mis., WHO",
  "eqa.admin.subtitle": "Kelola program, pengguna dan pengaturan sistem PME",
  "eqa.admin.systemSettings.placeholder": "Pengaturan sistem segera ada.",
  "eqa.admin.tab.participants": "Peserta",
  "eqa.admin.tab.programs": "Program PME",
  "eqa.admin.tab.systemSettings": "Pengaturan Sistem",
  "eqa.admin.tab.userManagement": "Pengelolaan Pengguna",
  "eqa.admin.tile.acrossAllPrograms": "Seluruh program",
  "eqa.admin.tile.activePrograms": "Program Aktif",
  "eqa.admin.tile.canManageEqa": "Dapat mengelola PME",
  "eqa.admin.tile.enrolledParticipants": "Peserta yang terdaftar",
  "eqa.admin.tile.systemUsers": "Pengguna Sistem",
  "eqa.admin.tile.totalParticipants": "Total Peserta",
  "eqa.admin.tile.totalPrograms": "{count} total program",
  "eqa.admin.title": "Administrasi Program",
  "eqa.admin.userManagement.placeholder": "Pengelolaan pengguna segera ada",
  "eqa.column.actions": "Aksi",
  "eqa.deadline.label": "Tenggat Pemeriksaan",
  "eqa.distribution.action.continue": "Lanjut",
  "eqa.distribution.action.ship": "Kirim",
  "eqa.distribution.action.track": "Lacak",
  "eqa.distribution.action.viewReport": "Lihat Laporan",
  "eqa.distribution.advance": "Status Lanjutan",
  "eqa.distribution.backToDashboard": "Kembali ke Distribusi",
  "eqa.distribution.barcodes": "Buat Kode QR",
  "eqa.distribution.col.actions": "Aksi",
  "eqa.distribution.col.deadline": "Tenggat",
  "eqa.distribution.col.participants": "Peserta",
  "eqa.distribution.col.program": "Program",
  "eqa.distribution.col.responses": "Respon",
  "eqa.distribution.col.round": "Bulat",
  "eqa.distribution.col.samples": "Sampel",
  "eqa.distribution.col.shipmentId": "ID Pengiriman",
  "eqa.distribution.col.status": "Status",
  "eqa.distribution.create": "Buat Distribusi",
  "eqa.distribution.createError": "Gagal membuat distribusi",
  "eqa.distribution.createShipment": "Buat Pengiriman Baru",
  "eqa.distribution.createSuccess": "Distribusi berhasil dibuat.",
  "eqa.distribution.dashboard.subtitle": "Distribusi sampel PME ke laboratorium peserta",
  "eqa.distribution.dashboard.title": "Distribusi PME",
  "eqa.distribution.deadline": "Tenggat Penyerahan",
  "eqa.distribution.detail.title": "Rincian Distribusi",
  "eqa.distribution.empty": "Distribusi tidak ditemukan",
  "eqa.distribution.filter.allShipments": "Semua Pengiriman",
  "eqa.distribution.filter.program": "Filter berdasarkan Program",
  "eqa.distribution.filter.status": "Filter berdasarkan Status",
  "eqa.distribution.list.title": "Distribusi PME",
  "eqa.distribution.manageParticipants": "Kelola Peserta",
  "eqa.distribution.name": "Nama Distribusi",
  "eqa.distribution.name.placeholder": "mis, Round 1 - Kimia 2026",
  "eqa.distribution.network.active": "Peserta Aktif",
  "eqa.distribution.network.active.sub": "Yang terdaftar saat ini",
  "eqa.distribution.network.responseRate": "Rerata Kecepatan Respon",
  "eqa.distribution.network.responseRate.sub": "4 triwulan terakhir",
  "eqa.distribution.network.subtitle": "Ringkasan laboratorium peserta yang terdaftar",
  "eqa.distribution.network.title": "Jejaring Peserta",
  "eqa.distribution.network.total": "Total Peserta",
  "eqa.distribution.network.total.sub": "Seluruh negara",
  "eqa.distribution.participants": "Organisasi Peserta",
  "eqa.distribution.participants.min": "Wajib setidaknya 2 organisasi peserta",
  "eqa.distribution.participants.none": "Tidak ada organisasi yang terdaftar di program tersebut. Daftarkan peserta sebelum membuat distribusi.",
  "eqa.distribution.participants.select": "Pilih organisasi",
  "eqa.distribution.program": "Program PME",
  "eqa.distribution.program.select": "Pilih program",
  "eqa.distribution.responseRate": "kecepatan respon",
  "eqa.distribution.shipments.subtitle": "Lacak distribusi sampel PME dan respon peserta",
  "eqa.distribution.shipments.title": "Pengiriman PME",
  "eqa.distribution.shipped": "Sudah dikirim",
  "eqa.distribution.status.completed": "Selesai",
  "eqa.distribution.status.draft": "Draf",
  "eqa.distribution.status.prepared": "Disiapkan",
  "eqa.distribution.status.shipped": "Sudah dikirim",
  "eqa.distribution.step.confirmation": "Konfirmasi",
  "eqa.distribution.step.details": "Program & Rincian",
  "eqa.distribution.step.participants": "Peserta",
  "eqa.distribution.summary.completed": "Selesai",
  "eqa.distribution.summary.completed.sub": "Semua respon sudah diterima",
  "eqa.distribution.summary.draft": "Draf Pengiriman",
  "eqa.distribution.summary.draft.sub": "Tengah disiapkan",
  "eqa.distribution.summary.participants": "Peserta",
  "eqa.distribution.summary.participants.sub": "Sudah terdaftar",
  "eqa.distribution.summary.shipped": "Sudah dikirim",
  "eqa.distribution.summary.shipped.sub": "Menunggu respon",
  "eqa.enrollment.allStatuses": "Semua Status",
  "eqa.enrollment.alreadyEnrolled": "Yang terdaftar saat ini",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organisasi yang terdaftar",
  "eqa.enrollment.confirmWithdraw": "Konfirmasi Penarikan",
  "eqa.enrollment.created.success": "Pendaftaran program berhasil dibuat",
  "eqa.enrollment.deactivated": "Pendaftaran program berhasil dinonaktifkan",
  "eqa.enrollment.description": "Deskripsi",
  "eqa.enrollment.district": "Kabupaten",
  "eqa.enrollment.editing": "Edit: {name}",
  "eqa.enrollment.empty": "Tidak ada pendaftaran ditemukan untuk program ini",
  "eqa.enrollment.enroll": "Daftar",
  "eqa.enrollment.enrollParticipant": "Daftarkan Peserta",
  "eqa.enrollment.enrollSelected": "Daftarkan yang Dipilih",
  "eqa.enrollment.enrollmentDate": "Tanggal Pendaftaran",
  "eqa.enrollment.error": "The enrollment was not saved. Try again.",
  "eqa.enrollment.labUnits": "Instalasi Lab",
  "eqa.enrollment.new": "Pendaftaran Program PME Baru",
  "eqa.enrollment.organizationCode": "Kode Organisasi",
  "eqa.enrollment.organizationName": "Nama Organisasi",
  "eqa.enrollment.panels": "Panel",
  "eqa.enrollment.programName": "Nama Program",
  "eqa.enrollment.programName.placeholder": "Masukkan nama program",
  "eqa.enrollment.provider": "Penyelenggara",
  "eqa.enrollment.provider.placeholder": "Masukkan nama penyelenggara",
  "eqa.enrollment.reactivate": "Aktifkan Ulang",
  "eqa.enrollment.reactivated": "Pendaftaran program diaktifkan ulang",
  "eqa.enrollment.save": "Simpan Pendaftaran",
  "eqa.enrollment.saveChanges": "Simpan Perubahan",
  "eqa.enrollment.searchOrgs": "Cari organisasi...",
  "eqa.enrollment.searchPlaceholder": "Cari organisasi berdasarkan nama atau kode...",
  "eqa.enrollment.selectLabUnits": "Pilih instalasi lab...",
  "eqa.enrollment.selectOrg": "Pilih organisasi...",
  "eqa.enrollment.selectOrgsPrompt": "Pilih organisasi untuk mendaftar",
  "eqa.enrollment.selectPanels": "Pilih panel...",
  "eqa.enrollment.selectProgram": "Pilih Program",
  "eqa.enrollment.selectProgramPrompt": "Pilih program untuk melihat pendaftaran",
  "eqa.enrollment.selectTests": "Pilih pemeriksaan...",
  "eqa.enrollment.selected": "dipilih",
  "eqa.enrollment.status": "Status",
  "eqa.enrollment.status.active": "Aktif",
  "eqa.enrollment.status.suspended": "Ditangguhkan",
  "eqa.enrollment.status.withdrawn": "Ditarik",
  "eqa.enrollment.success": "Pendaftaran Berhasil",
  "eqa.enrollment.suspend": "Ditangguhkan",
  "eqa.enrollment.tests": "Pemeriksaan",
  "eqa.enrollment.thisLab": "Lab ini",
  "eqa.enrollment.updated.success": "Pendaftaran program berhasil diperbarui",
  "eqa.enrollment.withdraw": "Tarik",
  "eqa.enrollment.withdrawReason": "Alasan Penarikan",
  "eqa.enrollment.withdrawReasonPlaceholder": "Masukkan alasan penarikan peserta ini...",
  "eqa.filter.allPriorities": "Semua Prioritas",
  "eqa.filter.allPrograms": "Semua Program",
  "eqa.filter.allStatuses": "Semua Status",
  "eqa.filter.eqaOnly": "Hanya Sampel PME",
  "eqa.filter.priority": "Prioritas",
  "eqa.filter.program": "Program",
  "eqa.filter.status": "Status",
  "eqa.management.action.enterResults": "Masukkan Hasil",
  "eqa.management.action.submit": "Kirim",
  "eqa.management.bulkUpload": "Unggah Hasil Bulk",
  "eqa.management.col.accession": "Aksesi #",
  "eqa.management.col.actions": "Aksi",
  "eqa.management.col.deadline": "Tenggat",
  "eqa.management.col.progress": "Kemajuan",
  "eqa.management.col.provider": "Penyelenggara/Program",
  "eqa.management.col.sampleId": "Nomor Identitas Sampel",
  "eqa.management.col.status": "Status",
  "eqa.management.daysLeft": "hari tersisa",
  "eqa.management.distributions.title": "Distribusi",
  "eqa.management.filter.allSamples": "Semua Sampel",
  "eqa.management.overdue": "Lewat tenggat",
  "eqa.management.participants.subtitle": "Kelola pendaftaran organisasi di program PME",
  "eqa.management.participants.title": "Peserta",
  "eqa.management.performance.onTime": "Penyerahan Tepat Waktu",
  "eqa.management.performance.participation": "Keikutsertaan",
  "eqa.management.performance.participation.sub": "Semua program terdaftar",
  "eqa.management.performance.subtitle": "Metrik kinerja PME laboratorium Anda",
  "eqa.management.performance.title": "Ringkasan Kinerja",
  "eqa.management.performance.zScore": "Rerata Z-Score",
  "eqa.management.performance.zScore.sub": "Dalam rentang dapat diterima",
  "eqa.management.programs.subtitle": "Kelola program yang didistribusi oleh laboratorium ini",
  "eqa.management.programs.title": "Program PME",
  "eqa.management.results.title": "Hasil & Analisis",
  "eqa.management.samples.empty": "Tidak ada sampel PME ditemukan",
  "eqa.management.samples.subtitle": "Kelola sampel PME yang diterima dan kirim hasil",
  "eqa.management.samples.title": "Sampel PME",
  "eqa.management.status.completed": "Selesai",
  "eqa.management.status.completed.sub": "Siap untuk mengirim",
  "eqa.management.status.inProgress": "Dalam Pengerjaan",
  "eqa.management.status.inProgress.sub": "Pemeriksaan dalam pengerjaan",
  "eqa.management.status.in_progress": "Dalam Pengerjaan",
  "eqa.management.status.overdue": "Lewat tenggat",
  "eqa.management.status.pending": "Tertunda",
  "eqa.management.status.pending.sub": "Belum dimulai",
  "eqa.management.status.submitted": "Dikirim",
  "eqa.management.status.submitted.sub": "Hasil dikirim",
  "eqa.management.subtitle": "Terima dan kelola sampel PME dari penyelenggara eksternal",
  "eqa.management.title": "Pengelolaan PME",
  "eqa.management.viewPerformance": "Lihat Kinerja",
  "eqa.myProgram.helperText": "Memilih pendaftaran akan secara otomatis mengisi pemeriksan dan panel",
  "eqa.myProgram.label": "Pendaftaran Program Saya",
  "eqa.myProgram.prePopulated.subtitle": "{tests} pemeriksaan dan {panels} panel yang telah dipilih sebelumnya dari pendaftaran",
  "eqa.myProgram.prePopulated.title": "Pemeriksaan/panel terisi otomatis",
  "eqa.myProgram.select": "Memilih pendaftaran untuk mengisi pemeriksan dan panel secara otomatis...",
  "eqa.myPrograms.action.deactivate": "Nonaktifkan",
  "eqa.myPrograms.action.edit": "Sunting",
  "eqa.myPrograms.action.reactivate": "Aktifkan Ulang",
  "eqa.myPrograms.description": "Deskripsi",
  "eqa.myPrograms.enrollButton": "Daftar Program",
  "eqa.myPrograms.enrollInProgram": "Daftar Program",
  "eqa.myPrograms.labUnits": "Instalasi Lab",
  "eqa.myPrograms.panels": "Panel",
  "eqa.myPrograms.programName": "Nama Program",
  "eqa.myPrograms.provider": "Penyelenggara",
  "eqa.myPrograms.search.placeholder": "Cari program...",
  "eqa.myPrograms.status": "Status",
  "eqa.myPrograms.status.active": "Aktif",
  "eqa.myPrograms.status.inactive": "Inaktif",
  "eqa.myPrograms.subtitle": "Program yang diikuti laboratorium ini",
  "eqa.myPrograms.testMapping": "Pemetaan Pemeriksaan (Opsional)",
  "eqa.myPrograms.testMappingHint": "Pilih pemeriksaan dan panel untuk otomatis mengisi Entri Pemesanan saat program dipilih",
  "eqa.myPrograms.tests": "Pemeriksaan",
  "eqa.myPrograms.title": "Program PME Saya",
  "eqa.order.deadline": "Tenggat Hasil",
  "eqa.order.form.title": "Informasi Sampel PME",
  "eqa.order.participantId": "ID Peserta",
  "eqa.order.priority": "Prioritas PME",
  "eqa.order.programme": "Program",
  "eqa.order.provider": "Penyelenggara",
  "eqa.order.providerSampleId": "ID Sampel Penyelenggara",
  "eqa.orders.completedThisMonth": "Selesai Bulan Ini",
  "eqa.orders.enterNewTest": "Masukkan Pemeriksaan PME Baru",
  "eqa.orders.inProgress": "Dalam Pengerjaan",
  "eqa.orders.overdue": "Lewat tenggat",
  "eqa.orders.pending": "Tertunda",
  "eqa.orders.search.placeholder": "Cari berdasarkan nomor lab atau program...",
  "eqa.participant.id": "ID Peserta",
  "eqa.priority.critical": "Kritis",
  "eqa.priority.label": "Prioritas",
  "eqa.priority.standard": "Standar",
  "eqa.priority.urgent": "Mendesak",
  "eqa.program.activate": "Aktifkan",
  "eqa.program.active": "Aktif",
  "eqa.program.addProgram": "Tambah Program",
  "eqa.program.cancel": "Batal",
  "eqa.program.create": "Buat Program",
  "eqa.program.createTitle": "Buat Program PME",
  "eqa.program.deactivate": "Nonaktifkan",
  "eqa.program.description": "Deskripsi",
  "eqa.program.description.placeholder": "Deskripsi Program PME...",
  "eqa.program.edit": "Edit Program",
  "eqa.program.editTitle": "Edit Program PME",
  "eqa.program.empty": "Program PME tidak ditemukan",
  "eqa.program.inactive": "Inaktif",
  "eqa.program.label": "Program PME",
  "eqa.program.management.title": "Pengelolaan Program PME",
  "eqa.program.name": "Nama Program",
  "eqa.program.name.placeholder": "mis., Uji Profisiensi Kimia",
  "eqa.program.name.required": "Nama program wajib ada",
  "eqa.program.provider.required": "Penyelenggara wajib ada",
  "eqa.program.participantCount": "Peserta yang terdaftar",
  "eqa.program.provider": "Penyelenggara",
  "eqa.program.required": "Program PME wajib ada saat mendaftarkan sampel PME",
  "eqa.program.save": "Simpan Program",
  "eqa.program.select": "Pilih Program PME",
  "eqa.program.status": "Status",
  "eqa.program.tests": "Pemeriksaan Ditugaskan",
  "eqa.program.tests.assign": "Tugaskan Pemeriksaan",
  "eqa.program.tests.select": "Pilih pemeriksaan untuk ditugaskan",
  "eqa.provider.label": "Organisasi Penyelenggara PME",
  "eqa.provider.sampleId": "ID Sampel Penyelenggara",
  "eqa.provider.select": "Pilih Penyelenggara PME",
  "eqa.results.acceptable": "Dapat diterima",
  "eqa.results.batch.import": "Impor Batch",
  "eqa.results.col.deadline": "Tenggat",
  "eqa.results.col.labNumber": "Nomor Lab",
  "eqa.results.col.priority": "Prioritas",
  "eqa.results.col.programme": "Program",
  "eqa.results.col.provider": "Penyelenggara",
  "eqa.results.col.status": "Status",
  "eqa.results.import.confirm": "Konfirmasi Impor",
  "eqa.results.import.errors": "{count} baris ada error",
  "eqa.results.import.success": "{count} hasil berhasil diimpor",
  "eqa.results.import.upload": "Unggah file CSV",
  "eqa.results.manual.entry": "Entri Hasil Manual",
  "eqa.results.mean": "Rata-rata",
  "eqa.results.minimum.participants": "Minimal 5 peserta diperlukan untuk analisis statistik",
  "eqa.results.noResults": "Hasil pemeriksaan PME tidak ditemukan.",
  "eqa.results.organization": "Organisasi",
  "eqa.results.organization.select": "Pilih organisasi",
  "eqa.results.participant.count": "Jumlah Peserta",
  "eqa.results.performance": "Kinerja",
  "eqa.results.questionable": "Dipertanyakan",
  "eqa.results.report.downloading": "Mengunduh laporan...",
  "eqa.results.report.generate": "Buat Laporan",
  "eqa.results.search.placeholder": "Cari berdasarkan nomor lab, program, atau penyelenggara...",
  "eqa.results.standardDeviation": "Simpangan Baku",
  "eqa.results.statistics": "Statistik",
  "eqa.results.submit": "Kirim Hasil",
  "eqa.results.test": "Pemeriksaan",
  "eqa.results.test.select": "Pilih Pemeriksaan",
  "eqa.results.title": "Hasil & Analisis PME",
  "eqa.results.unacceptable": "Tidak dapat diterima",
  "eqa.results.value": "Nilai Hasil",
  "eqa.results.zscore": "Skor Z",
  "eqa.sample.badge": "PME",
  "eqa.sample.checkbox": "Sampel PME",
  "eqa.sample.checkbox.helper": "Periksa jika ini sampel Pemantapan Mutu Eksternal",
  "eqa.sample.demographics.disabled": "Demografi tidak diaktifkan untuk sampel PME",
  "eqa.sample.patient.readonly.body": "Bidang demografi pasien diatur otomatis untuk sampel PME dan tidak dapat diedit.",
  "eqa.sample.patient.readonly.title": "Sampel PME — Info Pasien Dikunci",
  "eqa.section.title": "Rincian Sampel PME",
  "eqa.settings.integration.apiKey": "Kunci API",
  "eqa.settings.integration.apiUrl": "URL Dasar API",
  "eqa.settings.integration.fhir": "Integrasi API FHIR",
  "eqa.settings.integration.fhir.desc": "Aktifkan API FHIR R4 untuk pertukaran data PME eksternal",
  "eqa.settings.integration.subtitle": "Konfigurasi integrasi sistem eksternal",
  "eqa.settings.integration.title": "Pengaturan Integrasi",
  "eqa.settings.loading": "Memuat pengaturan...",
  "eqa.settings.notifications.email": "Notifikasi Email",
  "eqa.settings.notifications.email.desc": "Kirim notifikasi email untuk peringatan kritis dan tenggat",
  "eqa.settings.notifications.eqaDeadline": "Peringatan Tenggat PME",
  "eqa.settings.notifications.eqaDeadline.desc": "Terima peringatan saat tenggat penyerahan PME sudah dekat",
  "eqa.settings.notifications.stat": "Peringatan Permintaan STAT",
  "eqa.settings.notifications.stat.desc": "Peringatan saat permintaan STAT lewat tenggat",
  "eqa.settings.notifications.subtitle": "Konfigurasi preferensi peringatan dan notifikasi",
  "eqa.settings.notifications.threshold": "Peringatan Ambang (hari sebelum tenggat)",
  "eqa.settings.notifications.title": "Pengaturan Notifikasi",
  "eqa.settings.performance.autoZScore": "Penghitungan Z-Score Otomatis",
  "eqa.settings.performance.autoZScore.desc": "Z-Score dihitung otomatis saat hasil dikirim",
  "eqa.settings.performance.generateReports": "Buat Laporan Kinerja",
  "eqa.settings.performance.generateReports.desc": "Buat laporan kinerja otomatis setelah setiap round",
  "eqa.settings.performance.subtitle": "Konfigurasi parameter analisis kinerja PME",
  "eqa.settings.performance.title": "Analisis Kinerja",
  "eqa.settings.performance.zScoreMax": "Z-Score Maksimum Dapat Diterima",
  "eqa.settings.performance.zScoreMin": "Z-Score Minimum Dapat Diterima",
  "eqa.settings.saveError": "Gagal menyimpan pengaturan",
  "eqa.settings.saveSuccess": "Pengaturan berhasil disimpan",
  "eqa.settings.saving": "Menyimpan...",
  "eqa.status.active": "Aktif",
  "eqa.status.completed": "Selesai",
  "eqa.status.inProgress": "Dalam Pengerjaan",
  "eqa.status.inactive": "Inaktif",
  "eqa.status.inprogress": "Dalam Pengerjaan",
  "eqa.status.overdue": "Lewat tenggat",
  "eqa.status.pending": "Tertunda",
  "eqa.submission.audit": "Penyerahan Jejak Audit",
  "eqa.submission.date": "Tanggal Penyerahan",
  "eqa.submission.error": "Penyerahan gagal",
  "eqa.submission.fhir": "Kirim lewat FHIR",
  "eqa.submission.fhir.description": "Kirim hasil ke penyelenggara PME eksternal melalui FHIR R4",
  "eqa.submission.late.approve": "Setujui Penyerahan Terlambat",
  "eqa.submission.late.justification": "Justifikasi Penyerahan Terlambat",
  "eqa.submission.late.justification.placeholder": "Masukkan alasan keterlambatan penyerahan...",
  "eqa.submission.late.supervisor": "ID Pengguna Penyelia",
  "eqa.submission.late.warning": "Tenggat penyerahan sudah lewat. Wajib ada persetujuan penyelia.",
  "eqa.submission.method": "Metode Penyerahan",
  "eqa.submission.success": "Hasil berhasil diserahkan",
  "eqa.submission.title": "Penyerahan Hasil",
  "eqa.tests.action.enterResults": "Masukkan Hasil",
  "eqa.tests.action.viewOrder": "Lihat Pemesanan",
  "eqa.tests.action.viewResults": "Lihat Hasil",
  "eqa.tests.dateEntered": "Tanggal Masuk",
  "eqa.tests.deadline": "Tenggat",
  "eqa.tests.enterNew": "Masukkan Pemeriksaan PME Baru",
  "eqa.tests.labNumber": "Nomor Lab",
  "eqa.tests.orders.subtitle": "Pemesanan uji profisiensi untuk laboratorium ini",
  "eqa.tests.orders.title": "Pemesanan PME",
  "eqa.tests.priority": "Prioritas",
  "eqa.tests.program": "Program PME",
  "eqa.tests.provider": "Penyelenggara",
  "eqa.tests.searchPlaceholder": "Cari berdasarkan # registrasi, program, atau penyelenggara...",
  "eqa.tests.status": "Status",
  "eqa.tests.status.completed": "Selesai",
  "eqa.tests.status.inProgress": "Dalam Pengerjaan",
  "eqa.tests.status.overdue": "Lewat tenggat",
  "eqa.tests.status.pending": "Tertunda",
  "eqa.tests.summary.completedThisMonth": "Selesai Bulan Ini",
  "eqa.tests.summary.inProgress": "Dalam Pengerjaan",
  "eqa.tests.summary.overdue": "Lewat tenggat",
  "eqa.tests.summary.pending": "Tertunda",
  "eqa.validation.deadline.required": "Wajib ada Tenggat Pemeriksaan",
  "eqa.validation.program.required": "Wajib ada Program PME",
  "eqa.validation.provider.required": "Wajib ada Organisasi Penyelenggara PME",
  "error.add.edited.msg": "Error saat mengedit/menambah",
  "error.barcode.dimension.positive": "Dimensi label harus bilangan positif",
  "error.barcode.labelcount.default.lte.max": "Jumlah label default tidak boleh melebihi maksimum untuk jenis label ini",
  "error.delete.msg": "Error saat menghapus",
  "error.duplicate.calculationname": "Duplikasi Nama Penghitungan atau Error saat menyimpan",
  "error.fetch.boxDetails": "Gagal menarik rincian boks",
  "error.fetch.boxes": "Gagal menarik boks pengiriman",
  "error.fetch.facilities": "Gagal menarik fasilitas",
  "error.fetch.unassignedSamples": "Gagal menarik sampel yang tidak ditugaskan",
  "error.field.required": "Bidang ini diperlukan",
  "error.import.patient": "Error saat mengimpor Pasien ke sistem",
  "error.invalid.email": "Email tidak valid",
  "error.invalidcredentials": "Nama Pengguna atau Kata Kunci salah",
  "error.locale.format": "Format invalid. Gunakan: en, fr, es, atau en-US, fr-CA, dll.",
  "error.no.patient.data": "Tidak ada Data Pasien yang dapat diimpor",
  "error.nonconform.report": "Silahkan Masukkan Nilai",
  "error.report.csv.date": "Silahkan pilih jenis tanggal.",
  "error.report.csv.study": "Silahkan pilih jenis kajian.",
  "error.report.status": "Error saat membuat laporan",
  "error.report.linkIncomplete": "The link does not say which {0} to open, so the report cannot be shown. Choose it from the report lists instead.",
  "error.report.linkIncomplete.title": "This report link is incomplete",
  "error.required.destination": "Wajib ada lembaga tujuan",
  "error.results.loadFailed": "Daftar pekerjaan hasil tidak dapat dimuat",
  "error.results.loadFailed.detail": "Ini bukanlah daftar pekerjaan yang kosong — permintaan tersebut gagal, sehingga pekerjaan yang masih tertunda di sini tidak ditampilkan. Silakan coba lagi, dan laporkan kepada administrator jika masalah ini terus berlanjut.",
  "error.results.precision": "Pemeriksaan ini menampilkan hasil hingga {0} desimal. Masukkan nilai dengan presisi tersebut, atau nilai yang tercatat dan nilai yang ditampilkan akan berbeda.",
  "error.results.staleSave": "Hasil ini diperbarui oleh {0} di {1} — segarkan halaman untuk melihat nilai terbaru",
  "error.load.failed": "Could not load this list. Reload to try again.",
  "error.save.failed": "Gagal menyimpan",
  "error.save.msg": "Error saat menyimpan",
  "error.save.order": "Error saat menyimpan pemesanan",
  "error.save.patient": "Error saat menyimpan Pasien",
  "error.title": "Kesalahan",
  "errorBoundary.reload": "Muat ulang",
  "errorBoundary.route.patientResultsViewer.message": "Ada kesalahan saat menampilkan hasil pasien ini. Coba muat ulang.",
  "errorBoundary.route.patientResultsViewer.title": "Hasil pasien tidak bisa dimuat ulang",
  "errorBoundary.route.resultsSearch.message": "Ada kesalahan pada halaman hasil. Coba muat ulang.",
  "errorBoundary.route.resultsSearch.title": "Hasil tidak bisa dimuat",
  "errorBoundary.route.orderEntry.message": "Something went wrong on the order entry page. Reload to try again.",
  "errorBoundary.route.orderEntry.title": "Order entry could not be loaded",
  "errorBoundary.route.samplePatientEntry.message": "Ada kesalahan pada halaman entri sampel. Coba muat ulang.",
  "errorBoundary.route.samplePatientEntry.title": "Entri sampel tidak bisa dimuat",
  "errorBoundary.route.storage.message": "Ada kesalahan pada halaman ini. Coba muat ulang, atau gunakan menu untuk pindah halaman.",
  "errorBoundary.route.storage.title": "Penyimpanan tidak bisa dimuat",
  "errorBoundary.route.analyzers.message": "Ada kesalahan pada saat memuat halaman ini. Coba muat ulang.",
  "errorBoundary.route.analyzers.title": "Modul alat tidak dapat dimuat",
  "errorBoundary.route.analyzerResults.message": "Ada kesalahan pada saat memuat hasil. Coba muat ulang.",
  "errorBoundary.route.analyzerResults.title": "Hasil dari alat tidak dapat dimuat",
  "errors.no.sample": "Select the appropriate sample for each test.",
  "errors.requester.org.or.requestor.required": "Enter at least one of Requesting Organization or Requester contact.",
  "esig.button.certify": "Sertifikasi & Lanjut",
  "esig.button.reject": "Tolak",
  "esig.button.saveAndSign": "Simpan",
  "esig.button.sign": "Tanda tangan",
  "esig.button.validate": "Validasi",
  "esig.certification.acknowledge": "Saya sudah membaca dan mengerti pernyataan di atas",
  "esig.certification.intro": "Sebelum menggunakan tanda tangan elektronik, Anda harus menyatakan bahwa tanda tangan elektronik Anda setara dengan tanda tangan tertulis yang sah secara hukum.",
  "esig.error.disabled": "Tanda tangan elektronik tidak diaktifkan",
  "esig.error.generic": "Terjadi error",
  "esig.error.invalidCredentials": "Kredensial invalid",
  "esig.error.keycloakNotSupported": "Keycloak authentication belum tersedia untuk tanda tangan elektronik",
  "esig.error.loadingStatus": "Gagal memuat status tanda tangan",
  "esig.error.mustAcknowledge": "Anda harus menyetujui pernyataan sertifikasi",
  "esig.error.passwordRequired": "Kata kunci diperlukan",
  "esig.error.rejectionReasonRequired": "Wajib ada alasan penolakan",
  "esig.error.title": "Kesalahan",
  "esig.error.usernameRequired": "Nama pengguna diperlukan",
  "esig.info.fullAuth": "Ini adalah tanda tangan pertama Anda untuk sesi ini. Masukkan nama pengguna dan kata kunci Anda untuk mengotentikasi.",
  "esig.info.legalBinding": "Dengan memasukkan kredensial, Anda membuat tanda tangan elektronik yang mengikat secara hukum berdasarkan 21 CFR Part 11.",
  "esig.info.passwordOnly": "Anda memiliki sesi tanda tangan aktif. Masukkan kata kunci untuk melanjutkan.",
  "esig.label.context": "Aksi:",
  "esig.label.meaning": "Arti Tanda Tangan:",
  "esig.label.password": "Kata kunci",
  "esig.label.rejectionReason": "Alasan Penolakan",
  "esig.label.signingAs": "Menandatangani sebagai: {userName}",
  "esig.label.username": "Nama pengguna",
  "esig.meaning.authored": "Dibuat oleh",
  "esig.meaning.modified": "Dimodifikasi",
  "esig.meaning.rejected": "Ditolak",
  "esig.meaning.validatedAndReleased": "Divalidasi dan Diterbitkan",
  "esig.placeholder.password": "Masukkan kata kunci untuk mengkonfirmasi",
  "esig.placeholder.rejectionReason": "Masukkan alasan penolakan",
  "esig.placeholder.username": "Masukkan nama pengguna Anda",
  "esig.title.certification": "Sertifikasi Tanda Tangan Elektronik",
  "esig.title.signature": "Tanda Tangan Elektronik",
  "example": "Contoh",
  "external.id": "Identitas Eksternal",
  "external.referrals.report": "Laporan Rujukan Eksternal",
  "externalReferredOutTests.title": "Laporan Rujukan Eksternal",
  "externalconnections.active": "Aktif",
  "externalconnections.add.title": "Tambah Koneksi Eksternal",
  "externalconnections.authtype": "Tipe Otentikasi",
  "externalconnections.authtype.basic.password": "Kata kunci",
  "externalconnections.authtype.basic.username": "Nama pengguna",
  "externalconnections.browse.title": "Koneksi Eksternal",
  "externalconnections.deactivate.success": "Koneksi eksternal berhasil dinonaktifkan.",
  "externalconnections.description": "Deskripsi",
  "externalconnections.edit.title": "Edit Koneksi Eksternal",
  "externalconnections.name": "Nama",
  "externalconnections.name.placeholder": "Masukkan nama koneksi",
  "externalconnections.programmedconnection": "Tipe Koneksi",
  "externalconnections.save.success": "Koneksi eksternal berhasil disimpan.",
  "externalconnections.search": "Cari koneksi eksternal",
  "externalconnections.search.placeholder": "Cari berdasarkan nama atau tipe",
  "externalconnections.select": "Pilih",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "mis. https://server:port",
  "false.label": "Salah",
  "field.active": "Aktif/Tidak Aktif",
  "field.ageRange": "Rentang Umur",
  "field.dictionaryValues": "Nilai Kamus",
  "field.loinc": "LOINC",
  "field.name": "Nama",
  "field.normalRange": "Rentang normal",
  "field.note": "Catatan",
  "field.orderable": "Permintaan dapat/tidak dapat dilakukan",
  "field.panel": "Panel",
  "field.referenceValue": "Nilai referensi",
  "field.reportName": "Nama Laporan",
  "field.resultLimits": "Batas hasil",
  "field.resultType": "Jenis hasil",
  "field.sampleType": "Jenis sampel",
  "field.select.testSection": "Pilih Bagian Pemeriksaan",
  "field.selectValues": "Pilih nilai",
  "field.sex": "Jenis kelamin",
  "field.significantDigits": "Digit signifikan",
  "field.testSection": "Bagian pemeriksaan",
  "field.testUnit": "Instalasi Lab",
  "field.uom": "Satuan pengukuran",
  "field.validRange": "Rentang valid",
  "file.import.configuration.active": "Aktif",
  "file.import.configuration.analyzer": "Alat",
  "file.import.configuration.analyzer.emptyState": "Tidak ada plugin impor file yang diinstal",
  "file.import.configuration.analyzer.placeholder": "Pilih Alat",
  "file.import.configuration.cancel": "Batal",
  "file.import.configuration.columnMappings": "Pemetaan Kolom",
  "file.import.configuration.columnMappings.helperText": "Pemetaan JSON untuk kolom CSV ke bidang SILNAS (misalnya, {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Pemisah",
  "file.import.configuration.delimiter.helperText": "Karakter delimiter CSV (default: koma)",
  "file.import.configuration.error.save": "Gagal menyimpan konfigurasi impor file",
  "file.import.configuration.error.unknown": "Terjadi error yang tidak diketahui",
  "file.import.configuration.fileFormat": "Format File",
  "file.import.configuration.fileFormat.placeholder": "Pilih format file",
  "file.import.configuration.filePattern": "Pola File",
  "file.import.configuration.filePattern.helperText": "Pola glob untuk file yang cocok (misalnya, *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Baris yang memiliki Header",
  "file.import.configuration.importDirectory": "Direktori Impor",
  "file.import.configuration.importDirectory.helperText": "Direktori untuk melihat file baru",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Simpan",
  "file.import.configuration.success.created": "Konfigurasi impor file berhasil dibuat",
  "file.import.configuration.success.updated": "Konfigurasi impor file berhasil diperbarui",
  "file.import.configuration.title.add": "Tambah Konfigurasi Impor File",
  "file.import.configuration.title.edit": "Edit Konfigurasi Impor File",
  "file.import.configuration.validation.analyzerId.required": "Alat wajib ada",
  "file.import.configuration.validation.columnMappings.invalid": "Format JSON invalid untuk pemetaan kolom",
  "file.import.configuration.validation.importDirectory.required": "Direktori impor wajib ada",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filter",
  "freezer.alert.detail.acknowledge": "Mengetahui",
  "freezer.alert.detail.acknowledgedAt": "Sudah diketahui",
  "freezer.alert.detail.acknowledgedBy": "DIketahui Oleh",
  "freezer.alert.detail.acknowledgmentNotes": "Catatan Ucapan Terima Kasih",
  "freezer.alert.detail.actions": "Aksi yang Telah Dilakukan",
  "freezer.alert.detail.close": "Tutup",
  "freezer.alert.detail.correctiveAction": "Tindakan Perbaikan",
  "freezer.alert.detail.correctiveActionDescription": "Deskripsi",
  "freezer.alert.detail.correctiveActionFailed": "Gagal mencatat Tindakan Perbaikan",
  "freezer.alert.detail.correctiveActionType": "Jenis tindakan",
  "freezer.alert.detail.delete": "Hapus Peringatan",
  "freezer.alert.detail.deleteConfirm": "Apakah Anda ingin menghapus peringatan ini secara permanen?",
  "freezer.alert.detail.deleteFailed": "Gagal menghapus peringatan",
  "freezer.alert.detail.deletePermanently": "Hapus secara permanen",
  "freezer.alert.detail.deleteWarning": "Waktu Mulai, tingkat keparahan, konfirmasi, dan catatan dihapus tanpa jejak audit dan tidak dapat dipulihkan.",
  "freezer.alert.detail.freezer": "Lemari Pembeku",
  "freezer.alert.detail.id": "ID Peringatan",
  "freezer.alert.detail.logCorrectiveAction": "Catat tindakan perbaikan",
  "freezer.alert.detail.message": "Pesan",
  "freezer.alert.detail.method": "Metode",
  "freezer.alert.detail.notes": "Catatan",
  "freezer.alert.detail.notesPlaceholder": "Tambah catatan mengenai peringatan ini...",
  "freezer.alert.detail.notifications": "Notifikasi Terkirim",
  "freezer.alert.detail.overview": "Gambaran Umum Peringatan",
  "freezer.alert.detail.recipient": "Penerima",
  "freezer.alert.detail.resolutionNotes": "Catatan Pemecahan Masalah",
  "freezer.alert.detail.resolve": "Selesai",
  "freezer.alert.detail.resolvedAt": "Selesai",
  "freezer.alert.detail.resolvedBy": "Selesai",
  "freezer.alert.detail.sentAt": "Terkirim pada",
  "freezer.alert.detail.severity": "Keparahan",
  "freezer.alert.detail.startTime": "Waktu Mulai",
  "freezer.alert.detail.status": "Status",
  "freezer.alert.detail.summary": "Ringkasan",
  "freezer.alert.detail.takenAt": "Diambil di",
  "freezer.alert.detail.takenBy": "Diambil oleh",
  "freezer.alert.detail.title": "Rincian Peringatan",
  "freezer.alert.severity.critical": "Kritis",
  "freezer.alert.severity.warning": "Peringatan",
  "freezer.alert.status.acknowledged": "Sudah diketahui",
  "freezer.alert.status.closed": "Ditutup",
  "freezer.alert.status.escalated": "Meningkat",
  "freezer.alert.status.open": "Buka",
  "freezer.alert.status.resolved": "Selesai",
  "freezer.nav.corrective": "Tindakan Perbaikan",
  "freezer.nav.corrective.tooltip": "Kelola tindakan perbaikan",
  "freezer.nav.dashboard": "Dasbor",
  "freezer.nav.dashboard.tooltip": "Lihat dasbor pemantauan penyimpanan dingin",
  "freezer.nav.reports": "Laporan",
  "freezer.nav.reports.tooltip": "Membuat laporan penyimpanan dingin",
  "freezer.nav.settings": "Pengaturan",
  "freezer.nav.settings.tooltip": "Konfigurasi pengaturan penyimpanan dingin",
  "freezer.nav.trends": "Tren Historis",
  "freezer.nav.trends.tooltip": "Lihat tren suhu berdasarkan waktu",
  "french.current": "PERANCIS saat ini",
  "french.label": "Perancis",
  "from.title": "Dari",
  "genericSample.edit.success": "Sample berhasil diperbarui",
  "genericSample.edit.title": "Edit Sampel",
  "genericSample.field.by": "Oleh",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Tanggal",
  "genericSample.field.from": "Dari",
  "genericSample.field.id": "Identitas",
  "genericSample.field.labPersonReceived": "Diterima petugas lab",
  "genericSample.field.project": "Proyek",
  "genericSample.field.storageLocation": "# Freezer penyimpanan dan lokasi",
  "genericSample.field.type": "Jenis",
  "genericSample.notebook.selection.title": "Pemilihan Proyek (Opsional)",
  "genericSample.order.error.labNoRequired": "Mohon membuat Nomor Registrasi sebelum menyimpan.",
  "genericSample.order.generateLabNo": "Membuat Nomor Registrasi",
  "genericSample.order.labNo.placeholder": "Klik untuk \"Membuat Nomor Registrasi\"",
  "genericSample.order.success.details": "Rincian Sampel",
  "genericSample.order.success.message": "Pemesanan sampel berhasil dibuat dengan nomor registrasi: {accessionNumber}",
  "genericSample.order.title": "Penerimaan Sampel",
  "gps.accuracy.display": "±{accuracy}m akurasi",
  "gps.accuracy.warning.message": "Akurasi GPS {accuracy}m, melebihi ambang batas wajib {required}m. Mohon mengambil lokasi lagi dengan mengubah posisi.",
  "gps.accuracy.warning.title": "Peringatan Akurasi GPS",
  "gps.button.clear": "Kosongkan",
  "gps.button.getting.location": "Mengambil Lokasi...",
  "gps.button.location.captured": "Lokasi Diambil",
  "gps.button.use.my.location": "Gunakan Lokasi Saya",
  "gps.collapse": "Ciutkan bagian GPS",
  "gps.config.accuracy.helper": "Maksimum akurasi GPS yang dapat diterima dalam meter. Atur ke 0 untuk menginaktifkan pemeriksaan akurasi.",
  "gps.config.accuracy.label": "Akurasi yang diperlukan (meter)",
  "gps.config.enabled.description": "Jika diaktifkan, bidang koordinat GPS akan muncul di alur kerja Entri Pesanan untuk menarik lokasi pengambilan sampel.",
  "gps.config.enabled.label": "Aktifkan Koordinat GPS",
  "gps.config.error.load": "Gagal memuat konfigurasi GPS",
  "gps.config.save.error": "Gagal menyimpan konfigurasi GPS",
  "gps.config.save.success": "Konfigurasi GPS berhasil disimpan",
  "gps.config.saving": "Menyimpan...",
  "gps.config.section.general": "Pengaturan GPS",
  "gps.config.timeout.helper": "Waktu maksimum untuk menunggu lokasi GPS dalam detik.",
  "gps.config.timeout.label": "Waktu habis (detik)",
  "gps.config.title": "Konfigurasi Koordinat GPS",
  "gps.config.unsaved.changes": "Anda memiliki perubahan belum tersimpan. Apakah Anda yakin untuk menutup?",
  "gps.config.unsaved.subtitle": "Ingat untuk menyimpan perubahan sebelum meninggalkan halaman.",
  "gps.config.unsaved.title": "Perubahan Tidak Tersimpan",
  "gps.config.validation.accuracy.negative": "Akurasi wajib tidak boleh negatif",
  "gps.config.validation.accuracy.too.high": "Akurasi wajib tidak boleh lebih dari 10.000 meter",
  "gps.config.validation.timeout.too.high": "Waktu habis tidak boleh lebih dari 120 detik",
  "gps.config.validation.timeout.too.low": "Waktu habis harus setidaknya 1 detik",
  "gps.coordinates.captured.via": "Diambil dengan {method}",
  "gps.coordinates.current": "Koordinat saat ini",
  "gps.error.not.supported": "GPS tidak didukung dengan peramban ini",
  "gps.error.permission.denied": "Akses GPS ditolak. Mohon mengaktifkan izin lokasi dan coba lagi.",
  "gps.error.position.unavailable": "Lokasi GPS tidak tersedia. Mohon periksa pengaturan lokasi perangkat Anda.",
  "gps.error.timeout": "Waktu permintaan GPS habis. Silahkan coba lagi.",
  "gps.error.title": "Kesalahan GPS",
  "gps.error.unknown": "Terjadi error GPS yang tidak diketahui. Mohon coba lagi.",
  "gps.info.description": "Koordinat GPS merekam lokasi geografis lokasi sampel, untuk mendukung surveilans epidemiologi dan pemetaan penyakit.",
  "gps.info.title": "Koordinat GPS",
  "gps.latitude.helper": "Derajat Utara (+) atau Selatan (-), antara -90 dan 90",
  "gps.latitude.invalid": "Garis lintang harus di antara -90 dan 90 derajat",
  "gps.latitude.label": "Garis Lintang",
  "gps.latitude.placeholder": "misalnya, -1.286389",
  "gps.longitude.helper": "Derajat Timur (+) atau Barat (-), antara -180 dan 180",
  "gps.longitude.invalid": "Garis bujur harus di antara -180 dan 180 derajat",
  "gps.longitude.label": "Garis bujur",
  "gps.longitude.placeholder": "misalnya, 36.817223",
  "gps.manual.entry.off": "Matikan",
  "gps.manual.entry.on": "Nyalakan",
  "gps.manual.entry.title": "Masukkan koordinat manual",
  "gps.manual.entry.toggle": "Entri koordinat manual",
  "gps.not.captured": "Tidak tertangkap",
  "gps.section.description": "Menangkap lokasi geografis pengambilan sampel untuk pelacakan epidemiologi",
  "gps.section.title": "Lokasi Pengambilan (GPS)",
  "gps.status.captured": "Ditangkap",
  "gps.status.optional": "Opsional",
  "gps.tile.collapse": "Ciutkan bagian GPS",
  "gps.tile.expand": "Kembangkan untuk menambah koordinat GPS",
  "gps.warning.partial.coordinates": "Garis lintang dan garis bujur harus menunjukkan lokasi valid.",
  "header.ID": "Identitas",
  "header.assign": "Menugaskan",
  "header.cancel.test": "Membatalkan Pemeriksaan",
  "header.formname": "Nama Formulir",
  "header.icon.help": "Bantuan",
  "header.icon.lang": "Bahasa",
  "header.icon.menu.close": "Tutup menu",
  "header.icon.menu.open": "Buka menu",
  "header.icon.menu.pin": "Sematkan menu",
  "header.icon.menu.unpin": "Lepaskan penandaan menu",
  "header.icon.notifications": "Notifikasi",
  "header.icon.search": "Cari",
  "header.icon.user": "Pengguna",
  "header.label.ARV": "ARV-awal",
  "header.label.EID": "Diagnosis anak-anak dengan DBS-PCR",
  "header.label.changeLab": "Pilih Lab",
  "header.label.followup": "ARV-Tindak-lanjut",
  "header.label.intialFollowup": "ARV-->Awal-TindakLanjut-VL",
  "header.label.logout": "Keluar",
  "header.label.nonconformityByDate": "Laporan Ketidaksesuaian berdasarkan Tanggal",
  "header.label.selectLab": "Pilih Lab",
  "header.label.selectlocale": "Pilih Lokal",
  "header.label.specialRequest": "Permintaan khusus",
  "header.label.study.ciexport": "Ekspor file CSV berdasarkan Tanggal",
  "header.label.study.vlloadtrends": "Laporan Ekspor Data Viral Load",
  "header.label.version": "Versi:",
  "header.reject": "Tolak",
  "header.rejection.reason": "Alasan penolakan",
  "header.results.recorded": "Hasil terekam",
  "hide.aliquoting": "Sembunyikan pengalikuotan",
  "holder.choose.availabletest": "Pilih Pemeriksaan yang tersedia",
  "home.label": "Beranda",
  "immunohistochemistry.label.addreport": "Tambah Laporan",
  "immunohistochemistry.label.averageChrom": "Rerata Sinyal Kromosom 17 per nukleus",
  "immunohistochemistry.label.averageHer2": "Rerata HER2 per nukleus",
  "immunohistochemistry.label.cellIntensity": "Intensitas. Skor Allred",
  "immunohistochemistry.label.cellPercent": "% sel yang menujukkan pewarnaan nukleus dengan",
  "immunohistochemistry.label.dashboard": "Dasbor Imunohistokimia",
  "immunohistochemistry.label.her2Assesment": "Penilaian protein HER2 adalah",
  "immunohistochemistry.label.her2Pattern": "Pola pewarnaan CerbB2/HER2",
  "immunohistochemistry.label.her2ScoreOf": "dengan skor",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnosis histologis",
  "immunohistochemistry.label.ihcRatio": "Rasio Sinyal HER2/Neu terhadap Kromosom 17",
  "immunohistochemistry.label.ihcScore": "IHK (Skor Cerb2)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Indeks Proliferatif): ",
  "immunohistochemistry.label.molecularType": "Subtipe Molekuler",
  "immunohistochemistry.label.numberOfCancer": "Jumlah Nukleus Kanker",
  "immunohistochemistry.label.outOf8": "dari 8",
  "immunohistochemistry.label.report": "Laporan",
  "immunohistochemistry.label.reports": "Laporan",
  "immunohistochemistry.label.review": "Menunggu Tinjauan Imunohistokimia",
  "immunohistochemistry.label.title": "Imunohistokimia",
  "immunohistochemistry.label.tumorCells": "dari positif sel tumor (cut off 20%)",
  "import.autoGenerated": "Dibuat secara otomatis",
  "import.created": "Dibuat",
  "import.error.failed": "Impor gagal",
  "import.error.importFile": "Gagal mengimpor file",
  "import.error.selectFile": "Pilih file terlebih dahulu",
  "import.error.validateFile": "Gagal memvalidasi file",
  "import.error.validateFirst": "Silahkan validasi file terlebih dahulu dan perbaiki kesalahan yang ada",
  "import.error.validationFailed": "Validasi gagal. Silahkan periksa kesalahan di bawah.",
  "import.failed": "Impor Gagal",
  "import.failedCount": "Gagal",
  "import.header.collectionDate": "Tanggal Pengambilan",
  "import.header.errorMessage": "Pesan Kesalahan",
  "import.header.field": "Bidang",
  "import.header.from": "Dari",
  "import.header.labNo": "No Registrasi",
  "import.header.quantity": "Kuantitas",
  "import.header.row": "Baris",
  "import.header.sampleType": "Jenis Sampel",
  "import.header.samplesToCreate": "Sampel yang akan dibuat",
  "import.importing": "Mengimpor...",
  "import.invalidRows": "Baris Invalid",
  "import.selectFile": "Pilih file",
  "import.status.invalid": "Tidak sah",
  "import.status.valid": "Validasi",
  "import.success": "Impor Berhasil",
  "import.totalRows": "Baris total",
  "import.totalSamplesToCreate": "Total Sampel yang akan Dibuat",
  "import.uploadFile": "Unggah file",
  "import.uploadFileDesc": "Unggah file CSV atau Excel ({types})",
  "import.validRows": "Baris Valid",
  "import.validating": "Memvalidasi...",
  "import.validationStatus": "Status Validasi",
  "input.error.same.panel.type": "Jenis panel yang ada dengan nama yang sama ditemukan. Batalkan atau gunakan nama lain.",
  "input.placeholder.labNo": "Masukkan Nomor Registrasi",
  "input.placeholder.patientFirstName": "Masukkan Nama Depan Pasien",
  "input.placeholder.patientId": "Masukkan Identitas Pasien",
  "input.placeholder.patientLastName": "Masukkan Nama Belakang Pasien",
  "input.placeholder.prevLabNumber": "Masukkan Nomor Registrasi Sebelumnya",
  "input.placeholder.providerEmail": "Masukkan Email Pemohon",
  "input.placeholder.providerFax": "Masukkan Nomor Faks Pemohon",
  "input.placeholder.providerWorkPhone": "Masukkan Nomor Telepon Pemohon",
  "input.placeholder.provisionalClinicalDiagnosis": "Masukkan Diagnosis Klinis Sementara",
  "input.placeholder.requesterFirstName": "Masukkan Nama Depan Pemohon",
  "input.placeholder.requesterLastName": "Masukkan Nama Belakang Pemohon",
  "input.placeholder.searchTestName": "Cari Nama Pemeriksaan di sini",
  "input.placeholder.selectPanel": "Pilih Jenis Panel",
  "input.placeholder.selectPriority": "Pilih Prioritas",
  "input.placeholder.selectTest": "Pilih Jenis Pemeriksaan",
  "input.placeholder.selectTestSection": "Pilih Jenis Unit",
  "instructions.copy.labnum": "Salin Nomor Registrasi ",
  "instructions.order.entry.eqa.enabled": "Bila aktif, akan ada kotak centang di layar Entri Pemesanan, dan petugas dapat menandai sampel sebagai sampel PME (Pemantapan Mutu Eksternal). Demografi pasien akan otomatis terisi dengan N/A dan dikunci.",
  "instructions.order.entry.requester": "Jika diaktifkan, kolom \"Pencari\", \"Nama Depan Pencari\", dan \"Nama Belakang Pencari\" akan menjadi kolom yang wajib diisi pada layar \"Tambah Pemesanan\". Jika dinonaktifkan (pengaturan default), ketiga kolom tersebut bersifat opsional.",
  "instructions.test.activation": "Pemeriksaan Aktif: kotak centang menunjukkan pemeriksaan yang sudah aktif. Untuk mengaktifkan pemeriksaan, centang kotak; untuk menonaktifkan, hapus centang. Semua jenis sampel tanpa pemeriksaan aktif akan dinonaktifkan dan muncul di bagian bawah, di bawah 'Jenis Sampel Tidak Aktif'. Jika salah satu pemeriksaan diaktifkan, jenis sampel tersebut akan diaktifkan.",
  "instructions.test.activation.confirm": "Verifikasi perubahan yang akan dibuat. Simpan jika sudah benar. Gunakan tombol kembali untuk memperbaiki perubahan.",
  "instructions.test.activation.sort": "Urutan tampilan: Daftar jenis sampel yang mempunyai pemeriksaan yang baru diaktivasi. Sortir pemeriksaan untuk mengatur tampilan di layar entri permintaan. Sortir dilakukan dengan menyeret ke posisi yang diinginkan",
  "instructions.test.order": "Permintaan dapat dilakukan untuk pemeriksaan yang dicentang. Ubah tanda centang untuk mengubah status. Agar permintaan pemeriksan dapat dilakukan, pemeriksaan tersebut harus aktif dan dapat dipesan. Pemeriskaan yang aktif tetapi tidak dapat dipesan dapat diminta sebagai bagian dari pemeriksaan refleks.",
  "invalid.json": "JSON tidak valid",
  "inventory.add.button": "Tambah Lot Baru",
  "inventory.addItem.button": "Tambah Barang Katalog",
  "inventory.consume.error.noLots": "No stock available for {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "No QC-passed stock for {name} ({code}): {count} lot(s) with stock are awaiting QC. Mark QC as passed to use them.",
  "inventory.consume.error.noLotsQcFailed": "No usable stock for {name} ({code}): {count} lot(s) with stock failed QC",
  "inventory.consume.error.noLotsQuarantined": "No usable stock for {name} ({code}): {count} lot(s) with stock are quarantined",
  "inventory.dashboard.title": "Dasbor Inventaris",
  "inventory.export.button": "Ekspor",
  "inventory.filter.all": "Semua",
  "inventory.filter.status": "Filter berdasarkan Status",
  "inventory.filter.type": "Filter berdasarkan Jenis",
  "inventory.itemType.CARTRIDGE": "Analyzer Cartridge",
  "inventory.itemType.HIV_KIT": "HIV Test Kit",
  "inventory.itemType.RDT": "RDT (Rapid Diagnostic Test)",
  "inventory.itemType.REAGENT": "Reagent",
  "inventory.itemType.SYPHILIS_KIT": "Syphilis Test Kit",
  "inventory.item.error.duplicateCode": "An inventory item with code \"{code}\" already exists.",
  "inventory.item.error.codeGenerationExhausted": "Could not find a free code for prefix \"{prefix}\". Enter a code manually.",
  "inventory.list.title": "Barang Inventaris",
  "inventory.lot.error.duplicateBarcode": "Barcode \"{barcode}\" is already assigned to lot {lotNumber}",
  "inventory.lot.search.placeholder": "Search by item name, lot number or barcode",
  "inventory.metrics.expired": "Kedaluwarsa",
  "inventory.metrics.expiringSoon": "Segera Kedaluwarsa",
  "inventory.metrics.lowStock": "Stok Sedikit",
  "inventory.metrics.totalLots": "Lot Total",
  "inventory.tab.catalog": "Katalog",
  "inventory.tab.dashboard": "Dasbor",
  "inventory.tab.reports": "Laporan",
  "inventory.title": "Pengelolaan Inventaris",
  "label.action": "Aksi",
  "labNumber.format.current": "Format saat ini",
  "labNumber.format.new": "Format baru",
  "labNumber.prefix": "Prefiks",
  "labNumber.type": "Jenis Nomor Registrasi ",
  "labNumber.usePrefix": "Gunakan prefiks",
  "label.actions": "Aksi",
  "label.active": "Aktif",
  "label.actualTestName": "Nama pemeriksaan aktual",
  "label.add": "Tambah",
  "label.add.notification": "Tambah notifikasi pop up ke pengguna",
  "label.all": "Semua",
  "label.analysisNotStarted": "Analisis belum dimulai",
  "label.any": "Apa saja",
  "label.audittrail": "No Registrasi",
  "label.audittrail.Reports": "Laporan Jejak Audit",
  "label.audittrail.labNo.invalidaccessionnumber": "Nomor Registrasi Invalid",
  "label.audittrail.labNo.missing": "Perlu No Registrasi!",
  "label.audittrailreport.nextvisitdate": "Tanggal Kunjungan Berikutnya",
  "label.audittrailreport.priority": "Prioritas",
  "label.audittrailreport.program": "Program",
  "label.audittrailreport.receiveddate": "Tanggal Diterima",
  "label.audittrailreport.requestdate": "Tanggal Permintaan",
  "label.audittrailreport.requester": "Pemohon",
  "label.audittrailreport.requester.firstname": "Nama Depan Pemohon",
  "label.audittrailreport.requester.lastname": "Nama Belakang Pemohon",
  "label.audittrailreport.sitename": "Nama Tempat",
  "label.autoFilledFromServer": "Auto terisi dari server",
  "label.barcode": "Kode QR",
  "label.barcode.labelsets": "Jumlah Set Label",
  "label.barcode.orderlabel": "Jumlah Label yang dipesan per set",
  "label.barcode.specimenlabel": "Jumlah label spesimen per set",
  "label.barcode.totallabel": "Jumlah label untuk dicetak",
  "label.button.action": "Aksi",
  "label.button.add": "Tambah",
  "label.button.add.question": "Tambah pertanyaan baru",
  "label.button.cancel": "Batal",
  "label.button.close": "Tutup",
  "label.button.changepassword": "Ganti Kata Kunci",
  "label.button.clear": "Kosongkan",
  "label.button.confirm": "Konfirmasi",
  "label.button.confirmAction": "Konfirmasi aksi",
  "label.button.confirmDelete": "Konfirmasi hapus",
  "label.button.confirmTitle": "Apakah Anda yakin?",
  "label.button.delete": "Hapus",
  "label.button.descritpion": "Deskripsi",
  "label.button.edit": "Sunting",
  "label.button.activate": "Aktifkan",
  "label.button.deactivate": "Nonaktifkan",
  "label.button.exit": "Keluar",
  "label.button.externalsearch": "Pencarian Eksternal",
  "label.button.field": "Bidang",
  "label.button.finish": "Selesai",
  "label.button.finished": "Selesai",
  "label.button.generatePrintableVersion": "Buat versi cetak",
  "label.button.import": "Impor",
  "label.button.login": "Masuk",
  "label.button.login.sso": "Masuk Sekali",
  "label.button.newEntry": "Entri baru",
  "label.button.ok": "Oke",
  "label.button.previous": "Sebelumnya",
  "label.button.range": "Rentang",
  "label.button.remove": "Hapus",
  "label.button.remove.block": "Hapus Blok",
  "label.button.remove.report": "Hapus Laporan",
  "label.button.remove.slide": "Hapus slide",
  "label.button.reset": "Atur Ulang",
  "label.button.sample": "Sampel",
  "label.button.save": "Simpan",
  "label.button.saveconfig": "SImpan Konfigurasi",
  "label.button.search": "Cari",
  "label.button.select": "Pilih",
  "label.button.select.pathologist": "Pilih Ahli Patologi",
  "label.button.select.status": "Pilih Status",
  "label.button.select.technician": "Pilih Petugas",
  "label.button.select.test": "Pilih Pemeriksaan",
  "label.button.start": "Mulai",
  "label.button.submit": "Kirim",
  "label.button.update": "Perbarui",
  "label.button.uploadfile": "Unggah file",
  "label.button.validate": "Validasi",
  "label.button.viewReport": "Lihat Laporan",
  "label.cancel": "Batal",
  "label.cancel.test.no.replace": "Batalkan pemeriksaan untuk nomor registrasi terpilih, jangan menugaskan pemeriksaan baru",
  "label.checkedWillBeModified": "No Lab yang dicentang akan dimodifikasi",
  "label.clear": "Hapus filter",
  "label.content": "Konten Label",
  "label.confirm": "Konfirmasi",
  "label.created.samples": "Sampel yang Dibuat",
  "label.critical.range": "Rentang kritis",
  "label.currentTest": "Pemeriksaan saat ini",
  "label.days": "hari",
  "label.default.result": "Hasil default",
  "label.delete": "Hapus",
  "label.description": "Deskripsi",
  "label.edit": "Sunting",
  "label.electronic.orders": "Permintaan elektronik",
  "label.equals": "sama dengan",
  "label.error": "Kesalahan",
  "label.existing.methods": "Metode yang ada",
  "label.existing.test.sets": "Set pemeriksaan yang ada",
  "label.filters.mycases": "Kasus saya",
  "label.filters.status": "Status",
  "label.field.required": "Bidang ini diperlukan",
  "label.status": "Status",
  "label.form.searchby": "Cari berdasarkan",
  "label.id": "ID",
  "label.import.errors": "Error saat Impor",
  "label.inactive": "Inaktif",
  "label.inactive.methods": "Metode inaktif. Tugaskan pemeriksaan untuk mengaktivasi",
  "label.includeInactiveTests": "Sertakan pemeriksaan inaktif",
  "label.inside.normalrange": "adalah dalam rentang normal",
  "label.lastPrinted": "Pencetakan terakhir: {date} {time} oleh {user}",
  "label.loading": "Memuat...",
  "label.loinc": "LOINC",
  "label.management.title": "Pengelolaan Label",
  "label.no": "Tidak",
  "label.no.options.available": "Tidak ada opsi tersedia",
  "label.none": "Kosong (tidak ada filter)",
  "label.notValidated": "Tidak tervalidasi",
  "label.notequals": "tidak sama dengan",
  "label.order.labNrPrefix": "Nomor Laboratorium",
  "label.order.patientPrefix": "Pasien",
  "label.order.scan.text": "Pindai ATAU masukkan manual ATAU",
  "label.orderable": "Dapat dipesan",
  "label.outside.normalrange": "adalah di luar rentang normal",
  "label.page.patientHistory": "Riwayat Pasien",
  "label.preview.data": "Pratinjau Data",
  "label.print": "Cetak Label",
  "label.print.error": "Error saat membuat label. Silahkan coba lagi.",
  "label.print.error.popupBlocked": "Popup diblokir. Izinkan popup untuk situs ini agar dapat mencetak label.",
  "label.print.openDirectly": "Open the labels in a new tab",
  "label.print.generating": "Membuat...",
  "label.print.success": "Pencetakan label berhasil",
  "label.print.description": "Cetak label untuk pemesanan dan sampel",
  "label.print.helper": "Pilih jenis dan kuantitas label untuk dicetak",
  "label.print.success.count": "{count} label berhasil dicetak",
  "label.print.title": "Cetak label",
  "label.printAll": "Cetak Semua Label",
  "label.printAll.success": "Semua label berhasil dicetak",
  "label.printConfirmation.message": "Cetak label untuk {name}{code}?",
  "label.printConfirmation.title": "Cetak Label",
  "label.printHistory": "Cetak Riwayat",
  "label.printHistory.byUser": "Oleh {user}",
  "label.printHistory.count": "{count} label",
  "label.printHistory.loading": "Memuat riwayat cetak...",
  "label.printHistory.never": "Belum pernah dicetak",
  "label.printHistory.unknownUser": "Tidak diketahui",
  "label.printHistory.viewAll": "Lihat Riwayat",
  "label.printLabel": "Cetak Label",
  "label.program": "Program",
  "label.qualifiers": "Pengkualifikasi",
  "label.quantity": "Kuantitas",
  "label.readonly": "Hanya Baca",
  "label.reference.value": "Nilai referensi",
  "label.refertest.referencelab": "Rujuk ke lab rujukan",
  "label.rejectedByBiologist": "Ditolak oleh ahli biologi",
  "label.rejectedByTechnician": "Ditolak oleh petugas",
  "label.remove": "Hapus",
  "label.replaceWith": "Ganti dengan",
  "label.report.byNationalId": "Berdasarkan NIK",
  "label.reporting.range": "Rentang pelaporan",
  "label.result.order": "Pemesanan hasil",
  "label.resultSelectList": "Daftar pilihan hasil",
  "label.results.actions": "Aksi",
  "label.results.anotherUser": "Pengguna lain",
  "label.results.date": "Tanggal Pemeriksaan",
  "label.results.domain": "Klinis",
  "label.results.domain.env": "Kualitas Air",
  "label.results.domain.vector": "Surveilans Vektor",
  "label.results.edit": "Sunting",
  "label.results.inReviewBy": "Sedang ditinjau oleh {0}",
  "label.results.labUnit": "Instalasi Lab",
  "label.results.load": "Muat hasil",
  "label.results.loading": "Loading results...",
  "label.results.range": "Rentang Referensi",
  "label.results.range.env": "Batas Regulasi",
  "label.results.range.vector": "Interpretasi",
  "label.results.reflexTriggered": "Pemeriksaan Refleks/Perhitungan Pemeriksaan telah ditambahkan untuk:",
  "label.results.refresh": "Segarkan",
  "label.results.result": "Hasil",
  "label.results.resultFor": "Hasil pencarian untuk \"{0}\"",
  "label.results.retry": "Coba lagi",
  "label.results.save": "Simpan",
  "label.results.search": "Cari berdasarkan Nomor Registrasi",
  "label.results.searchByPatient": "Cari berdasarkan Pasien",
  "label.results.selectAnotherPatient": "Pilih pasien lain",
  "label.results.selectedPatient": "Pasien yang Dipilih",
  "label.results.selectedPatient.none": "Tidak ada",
  "label.results.status": "Status",
  "label.results.status.all": "Semua",
  "label.results.subject": "Sampel / Pasien",
  "label.results.subject.env": "Sampel / Lokasi",
  "label.results.subject.vector": "Sampel / Perangkap",
  "label.results.table.caption": "Daftar pekerjaan hasil",
  "label.results.test": "Pemeriksaan",
  "label.results.titer.placeholder": "e.g. 1:10",
  "label.results.method": "Metode",
  "label.results.analyzer": "Alat",
  "label.results.analyzer.none": "Bukan dari alat musik",
  "label.results.fromAnalyzer": "Dari Alat Analisis",
  "label.results.methodAnalyzerHint": "Metode adalah jenis alat analisis; Alat Analisis adalah instrumen tertentu.",
  "label.results.expandRow": "Perluas baris",
  "label.results.collapseRow": "Lipat baris",
  "label.results.referredOut": "Dirujuk keluar",
  "label.results.notes": "Catatan",
  "label.results.note.context": "Konteks",
  "label.results.note.context.entry": "Entri",
  "label.results.note.context.modification": "Modifikasi",
  "label.results.note.context.auto": "Disetel secara otomatis dari aktivitas yang sedang Anda lakukan.",
  "label.results.note.visibility": "Visibilitas",
  "label.results.note.internal": "Hanya di lab",
  "label.results.note.external": "Kirim beserta hasilnya",
  "label.results.note.analysisLevel": "Tingkat analisis",
  "label.results.note.externalWarning": "Catatan ini akan tercantum dalam laporan pasien.",
  "label.results.note.placeholder": "Tambah Catatan…",
  "label.results.dilution.measured": "Nilai yang diukur",
  "label.results.dilution.factor": "Faktor pengenceran",
  "label.results.dilution.reported": "Nilai yang dilaporkan: {0}",
  "label.results.saveHint": "Fungsi Simpan akan menyimpan tanda tangan elektronik Anda. Konfirmasi kritis tidak akan pernah menghalangi proses Simpan.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Tidak normal",
  "label.results.flag.critical": "Kritis",
  "label.results.flag.invalid": "Tidak sah",
  "label.results.sample": "Sampel",
  "label.results.flag": "Bendera",
  "label.results.order.clinician": "Dokter yang meresepkan",
  "label.results.order.phone": "Telepon",
  "label.results.order.site": "Meminta situs",
  "label.results.order.priority": "Prioritas",
  "label.results.order.collection": "Koleksi",
  "label.results.section.program": "Info program",
  "label.results.program.name": "Program",
  "label.results.program.eqa": "PME",
  "label.results.program.readonly": "Kolom-kolom program di sini bersifat hanya baca — lakukan pengeditan pada pesanan asalnya.",
  "label.results.section.storage": "Penyimpanan & pembuangan sampel",
  "label.results.storage.location": "Lokasi",
  "label.results.storage.position": "Posisi",
  "label.results.storage.notes": "Catatan",
  "label.results.storage.unassigned": "Tidak ada penugasan penyimpanan",
  "label.results.storage.assignLocation": "Tempatkan di Lokasi",
  "label.results.storage.moveLocation": "Pindah ke Lokasi",
  "label.results.program.capturedData": "Data program",
  "label.results.sampleStatus.title": "Status sampel",
  "label.results.sampleStatus.volume": "Volume: {0} tersisa dari {1} · status {2}.",
  "label.results.sampleStatus.noVolume": "Status {0}.",
  "label.results.sampleStatus.available": "Tersedia",
  "label.results.sampleStatus.usedUp": "habis (kelelahan)",
  "label.results.sampleStatus.disposed": "Dimusnahkan",
  "label.results.sampleStatus.recordUse": "Jumlah yang digunakan mencapai rekor tertinggi",
  "label.results.sampleStatus.markUsedUp": "Mark telah menghabiskan",
  "label.results.sampleStatus.startDisposal": "Mulai proses pembuangan",
  "label.results.sampleStatus.amountUsed": "Jumlah yang digunakan dalam pemeriksaan ini",
  "label.results.sampleStatus.record": "Rekam",
  "label.results.sampleStatus.recordHint": "Mengurangi volume yang tersisa — sampel tidak dibuang sampai habis atau secara eksplisit ditandai sebagai telah habis.",
  "label.results.sampleStatus.usedUpNote": "Sampel telah habis dan dimasukkan ke dalam antrian untuk alur kerja pembuangan. Rekam pembuangan mencatat siapa, kapan, dan metodenya.",
  "label.results.sampleStatus.disposalReason": "Alasan Pemusnahan",
  "label.results.sampleStatus.disposalMethod": "Metode pembuangan",
  "label.results.sampleStatus.disposalNotes": "Catatan",
  "label.results.sampleStatus.confirmDisposal": "Konfirmasi pembuangan",
  "label.results.sampleStatus.reason.expired": "Kedaluwarsa",
  "label.results.sampleStatus.reason.contaminated": "Terkontaminasi",
  "label.results.sampleStatus.reason.patient_request": "Permohonan Pasien",
  "label.results.sampleStatus.reason.testing_complete": "Pemeriksaan Telah Selesai",
  "label.results.sampleStatus.reason.other": "Lainnya",
  "label.results.sampleStatus.method.autoclave": "Autoklaf untuk Limbah Berbahaya",
  "label.results.sampleStatus.method.neutralization": "Netralisasi Kimia",
  "label.results.sampleStatus.method.incineration": "Pembakaran",
  "label.results.sampleStatus.method.other": "Lainnya",
  "label.results.sampleStatus.footnote": "Penggunaan sebagian rekam jumlah yang telah dikonsumsi berdasarkan volume sisa item sampel; habis total (atau tanda \"habis\") memicu proses pembuangan.",
  "label.results.section.reagents": "Reagen, QC & Kontrol",
  "label.results.reagents.summary.analyzer": "lot yang dilaporkan oleh Alat analisis",
  "label.results.reagents.summary.manual": "perekaman manual",
  "label.results.reagents.mode.analyzer": "mode pengambilan: dilaporkan oleh Alat analisis",
  "label.results.reagents.mode.manual": "mode pengambilan gambar: manual (opsional)",
  "label.results.reagents.analyzerNote": "Dilaporkan oleh {0} dalam muatan hasilnya — hanya baca.",
  "label.results.reagents.lotsUsed": "Nomor batch reagen yang digunakan",
  "label.results.reagents.noneLinked": "Tidak ada reagen yang terkait dengan pemeriksaan ini — tautan-tautan tersebut telah dikonfigurasi di Katalog Pemeriksaan.",
  "label.results.reagents.noLots": "Tidak ada stok yang tersedia untuk reagen ini dalam inventaris.",
  "label.results.reagents.perTest": "{0} {1} per pemeriksaan",
  "label.results.reagents.fefo": "Saran FEFO",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} sisanya",
  "label.results.reagents.quantityUsed": "Kuantitas yang Digunakan",
  "label.results.reagents.recordUse": "Penggunaan rekor",
  "label.results.reagents.recorded": "Tercatat {0} {1} — penerapan FEFO antar-lot.",
  "label.results.reagents.recordFailed": "Tidak dapat mencatat penggunaan reagen.",
  "label.results.reagents.amountInvalid": "Kuantitas yang digunakan harus berupa bilangan positif.",
  "label.results.reagents.consumeNote": "Rekaman penggunaan mengurangi inventaris (FEFO) dan mencatat transaksi konsumsi yang terkait dengan analisis ini.",
  "label.results.control.title": "Hasil pemeriksaan",
  "label.results.control.noneConfigured": "Tidak ada Lot Kontrol yang dikonfigurasi untuk pemeriksaan dan Alat ini.",
  "label.results.control.viewResults": "Lihat hasil pemeriksaan",
  "label.results.control.capture.controlLine": "Control line",
  "label.results.control.capture.valid": "Validasi",
  "label.results.control.capture.invalid": "Tidak sah",
  "label.results.control.capture.kitLot": "Kit lot",
  "label.results.control.capture.outcome": "Hasil",
  "label.results.control.capture.lot": "Control lot",
  "label.results.control.capture.measured": "Nilai yang diukur",
  "label.results.control.capture.expected": "Expected value",
  "label.results.control.capture.uncertainty": "Uncertainty (±)",
  "label.results.control.capture.record": "Record control result",
  "label.results.control.capture.recorded": "Control result recorded.",
  "label.results.control.capture.recordedBlocked": "Control result recorded. Reporting is blocked for covered results until a passing repeat is recorded.",
  "label.results.control.capture.blockedHint": "A failing control blocks reporting for covered results — a repeat run is expected.",
  "label.results.control.capture.noBenchLots": "No bench control lot is configured for this test — add one under QC → Control Lots before recording a quantitative control.",
  "label.results.control.capture.incomplete": "Complete the control result fields before recording.",
  "label.results.control.capture.failed": "Recording the control result failed.",
  "label.results.dilution.title": "Pengenceran",
  "label.results.section.attachments": "Lampiran",
  "label.results.attachments.summary": "{0} file(s)",
  "label.results.attachments.none": "Tidak ada",
  "label.results.attachments.empty": "Belum ada lampiran pada pemesanan ini.",
  "label.results.attachments.add": "Tambah lampiran",
  "label.results.attachments.tooLarge": "Ukuran file melebihi batas 10 MB.",
  "label.results.attachments.uploadFailed": "Unggah gagal — PDF, JPG, PNG, atau TIFF dengan ukuran maksimal 10 MB.",
  "label.results.attachments.resultsScope": "Hasil",
  "label.results.attachments.orderScope": "Pencatatan Pemesanan",
  "label.results.attachments.view": "Lihat",
  "label.results.attachments.download": "Unduh",
  "label.results.section.interpretation": "Interpretasi",
  "label.results.interpretation.summary": "masukkan melalui aturan atau teks bebas",
  "label.results.interpretation.ruleFired": "aturan diaktifkan ({0}) · buka otomatis",
  "label.results.interpretation.autoOpen": "aturan dipicu · buka otomatis",
  "label.results.interpretation.ruleBanner": "Kesesuaian aturan (dikonfigurasi pada pengujian): nilai yang dimasukkan {0} termasuk dalam kategori {1}. Pilih sebuah kategori untuk menerapkan teks penjelasannya, lalu edit sesuai kebutuhan.",
  "label.results.interpretation.match": "sesuai dengan nilai",
  "label.results.interpretation.freeText": "Interpretasi (teks bebas)",
  "label.results.interpretation.footnote": "Interpretasi dapat ditentukan melalui aturan yang dikonfigurasi pada tes (kelompok kategorikal, yang secara otomatis disesuaikan dengan nilai) atau teks bebas. Teks aturan hanyalah saran yang tidak mengikat sampai diterapkan atau diedit. Saat disimpan, teks tersebut akan dikirimkan bersama hasil ke dalam laporan.",
  "label.results.nce.disposition": "Penanganan hasil",
  "label.results.nce.disposition.hint": "Terapkan saat NCE dikirim. Rujukan ke pihak lain merupakan aksi baris terpisah, bukan keputusan.",
  "label.results.nce.disposition.none": "Tidak ada",
  "label.results.nce.disposition.none.detail": "Ajukan NCE tanpa mengubah hasilnya.",
  "label.results.nce.disposition.cancel": "Batalkan hasil",
  "label.results.nce.disposition.cancel.detail": "Dibatalkan. Tidak ada nilai yang dilaporkan. Hal ini umum terjadi pada NCE pra-analisis.",
  "label.results.nce.disposition.reject": "Tolak + alasan",
  "label.results.nce.disposition.reject.detail": "Kosongkan nilai dan rekam alasannya. Terapkan melalui tanda tangan elektronik Anda. Simpan.",
  "label.results.nce.disposition.retest": "Pemeriksaan Ulang",
  "label.results.nce.disposition.retest.detail": "Memerintahkan pengulangan pemeriksaan yang sama pada sampel ini; pengulangan tersebut akan muncul sebagai \"tertunda\".",
  "label.results.nce.disposition.rejectArmed": "Penolakan telah diaktifkan pada baris tersebut — Simpan (tanda tangan elektronik) untuk menerapkannya.",
  "label.results.nce.disposition.cancelled": "Hasil dibatalkan.",
  "label.results.nce.disposition.retested": "Dipesan untuk melakukan Pemeriksaan Ulang.",
  "label.results.critical.range": "Kritis",
  "label.results.critical.banner.title": "Nilai kritis — wajib memberitahu dokter",
  "label.results.critical.banner.body": "Dokter yang bertanggung jawab harus diberi tahu. Konfirmasi tersebut direkam pada Dasbor peringatan dan tidak akan pernah menghalangi proses penyimpanan.",
  "label.results.critical.acknowledge": "Saya Mengetahui",
  "label.results.critical.acknowledged": "Sudah diketahui",
  "label.results.critical.comment": "Komentar ucapan terima kasih",
  "label.results.critical.comment.placeholder": "misalnya: Dokter diberi tahu oleh Telepon",
  "label.results.section.history": "Riwayat (analisis ini)",
  "label.results.history.summary": "{0} acara",
  "label.results.history.summary.unloaded": "revisi · status · Pemeriksaan Ulang",
  "label.results.history.when": "Ketika",
  "label.results.history.event": "Acara",
  "label.results.history.detail": "Detail",
  "label.results.history.by": "Oleh",
  "label.results.history.event.CREATED": "Dibuat",
  "label.results.history.event.STATUS": "Status",
  "label.results.history.event.RESULT": "Hasil",
  "label.results.history.event.NOTE": "Catatan",
  "label.results.history.event.RETEST": "Pemeriksaan Ulang",
  "label.results.history.event.REFLEX": "Refleks",
  "label.results.history.event.OTHER": "Acara",
  "label.results.history.empty": "Tidak ada peristiwa yang tercatat untuk analisis ini.",
  "label.results.history.footnote": "Analisis ini hanya mencakup — revisi, perubahan status, Pemeriksaan Ulang, koreksi, catatan, dan entri audit. Tren pasien tersimpan dalam rekam medis pasien; Westgard Rule terdapat di Dasbor QC.",
  "label.results.nce.report": "Laporkan Ketidaksesuaian",
  "label.results.reject.result": "Tolak hasil",
  "label.results.reject.reason": "Alasan Penolakan",
  "label.results.reject.hint": "Menyimpan dengan status penolakan akan menghapus nilainya, rekam alasannya, dan menandai analisis tersebut sebagai “Ditolak Secara Teknis”.",
  "label.results.referral.refer": "Rujuk pemeriksaan ini",
  "label.results.referral.editing": "Rujukan tertunda — edit",
  "label.results.referral.organization": "Laboratorium rujukan",
  "label.results.referral.reason": "Alasan merujuk",
  "label.results.referral.date": "Tanggal rujukan",
  "label.results.referral.reportDate": "Reference lab report date",
  "label.results.referral.reportDate.placeholder": "dd/mm/yyyy",
  "label.results.referral.hint": "Rujukan tersebut akan tercatat saat Anda menyimpan baris ini dan kemudian ditampilkan di dasbor Rujukan.",
  "label.results.referral.cancel": "Buang",
  "label.results.section.aliquots": "Alikuot",
  "label.results.aliquots.summary": "{0} alikuot",
  "label.results.aliquots.summary.unloaded": "daftar · buat",
  "label.results.aliquots.labNo": "No Registrasi",
  "label.results.aliquots.quantity": "Kuantitas",
  "label.results.aliquots.createdDate": "Dibuat",
  "label.results.aliquots.empty": "Belum ada alikuot untuk sampel ini.",
  "label.results.aliquots.count": "Jumlah alikuot",
  "label.results.aliquots.totalQuantity": "Total Kuantitas yang akan Dipindahkan",
  "label.results.aliquots.notes": "Catatan",
  "label.results.aliquots.create": "Buat alikuot",
  "label.results.aliquots.created": "Alikuot telah dibuat.",
  "label.results.aliquots.failed": "Tidak dapat membuat alikuot.",
  "label.results.aliquots.remaining": "Kuantitas Sisa Induk",
  "label.results.history.event.REFERRAL": "Dirujuk",
  "label.results.history.event.NCE": "Ketidaksesuaian",
  "label.results.referenceZone": "Referensi & konteks",
  "label.results.layoutRemembered": "Tata letak disimpan",
  "label.results.resetLayout": "Atur Ulang tata letak",
  "label.results.section.orderInfo": "Info pemesanan",
  "label.results.sampleType": "Jenis sampel",
  "label.results.testDate": "Tanggal Pemeriksaan",
  "label.results.receivedDate": "Diterima",
  "label.results.technician": "Petugas",
  "label.routine.Reports": "Laporan Rutin",
  "label.sample.types.activate": "Jenis sampel berikut akan diaktivasi:",
  "label.sample.types.deactivate": "Jenis sampel berikut akan dinonaktifkan karena tidak memiliki pemeriksaan:",
  "label.save": "Simpan",
  "label.saving": "Menyimpan...",
  "label.search.available.targetest": "Cari pemeriksaan tersedia",
  "label.search.availablepanel": "Cari panel tersedia",
  "label.search.labno.family": "Cari berdasarkan LabNo atau Nama Belakang",
  "label.search.patient": "Cari Pasien",
  "label.select": "Pilih",
  "label.select.dateRange": "Pilih Rentang Tanggal untuk laporan yang diinginkan",
  "label.select.list.options": "Pilih opsi daftar",
  "label.selectTestSectionCatalog": "Pilih bagian pemeriksaan untuk melihat katalog bagian tersebut",
  "label.sex.dependent": "Tergantung jenis kelamin",
  "label.shortCode": "Kode Pendek",
  "label.shortCode.error.invalidChars": "Kode pendek hanya dapat mengandung huruf, angka, hyphen atau underscore",
  "label.shortCode.error.maxLength": "Kode pendek harus kurang dari atau sama dengan 10 karakter",
  "label.shortCode.error.network": "Tidak dapat memverifikasi keunikan. Silahkan periksa manual.",
  "label.shortCode.error.save": "Error saat menyimpan kode pendek: {error}",
  "label.shortCode.error.startChar": "Kode pendek harus dimulai dengan huruf atau angka",
  "label.shortCode.helper": "Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.optional.helper": "Opsional (kode akan digunakan jika ≤10 karakter). Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.required.helper": "Wajib jika kode > 10 karakter. Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "label.shortCode.update.success": "Pembaruan kode pendek berhasil",
  "label.shortCodeRequired": "Kode pendek diwajibkan untuk pencetakan label. Silahkan buat pengaturan kode pendek di formulir Edit terlebih dahulu.",
  "label.shortCodeWarning": "Mengubah kode pendek akan membatalkan validasi label yang ada",
  "label.showChildren": "Tunjukan Elemen Anak",
  "label.study.Reports": "Laporan kajian",
  "label.test.activate": "Pemeriksaan ini akan diaktivasi",
  "label.test.add": "Tambahkan Pemeriksaan",
  "label.test.batch.cancel.finish": "Tidak dapat dibalik",
  "label.test.batch.cancel.start": "Anda telah memilih untuk membatalkan pemeriksaan",
  "label.test.batch.no.change.finish": "Pemeriksaan tidak dapat diubah",
  "label.test.batch.replace.start": "Berikut ini",
  "label.test.deactivate": "Pemeriksaan berikut akan diinaktivasi",
  "label.test.display.order": "Urutan tampilan pemeriksaan",
  "label.test.order.confirm": "Verifikasi: aktivasi/inaktivasi pemeriksaan yang dapat dipesan",
  "label.test.orderable": "Pemeriksaan berikut ini dapat dipesan dengan formulir permintaan",
  "label.test.results": "Hasil Pemeriksaan",
  "label.test.resultsData": "Data Hasil Pemeriksaan",
  "label.test.unorderable": "Pemeriksaan berikut ini tidak dapat dipesan dengan formulir permintaan. Hanya bisa dipesan sebagai pemeriksaan refleks",
  "label.testActivate": "Aktivasi Pemeriksaan",
  "label.testName": "Nama pemeriksaan",
  "label.text.generate": "Hasilkan",
  "label.total.tests": "Pemeriksaan total",
  "label.type": "Jenis Label",
  "label.type.order": "Label Pemesanan",
  "label.type.pool": "Kumpulan foto {count} {animal}",
  "label.type.sample": "Label Sampel",
  "label.unit": "Unit",
  "label.user.notestsection": "Pengguna tidak memiliki Instalasi Lab yang ditugaskan. Hubungi Admin",
  "label.validation.errors": "Kesalahan Validasi",
  "label.validation.results": "Hasil Validasi",
  "label.view": "Lihat",
  "label.viewtestCatalog": "Katalog Pemeriksaan",
  "label.warning": "Peringatan",
  "label.yes": "Ya",
  "labno.alt.prefix.instruction": "Prefiks untuk label kode QR pra-cetak (4 karakter):",
  "labno.alt.prefix.note": "CATATAN: Jika prefiks ini telah digunakan, penomoran akan berlanjut dari nomor terakhir yang dihasilkan.",
  "labno.alt.prefix.use": "Gunakan format yang sama untuk nomor registrasi dan kumpulan nomor yang ada seperti pada Pembuatan Entri Permintaan.",
  "language.select.label": "Indonesia",
  "legend.search.availabletests": "Mencari dari pemeriksaan yang ada",
  "loading": "Memuat...",
  "loading.boxes": "Memuat boks...",
  "loading.description": "Memuat...",
  "location.collection.title": "Lokasi Pengambilan",
  "location.environmentalConditions": "Kondisi Lingkungan",
  "location.environmentalConditions.placeholder": "mis. 25°C, cuaca cerah",
  "location.gps.error": "Gagal mengambil lokasi",
  "location.gps.getCurrent": "Ambil Lokasi Saat",
  "location.gps.getting": "Mengambil Lokasi...",
  "location.gps.latitude": "Garis Lintang GPS",
  "location.gps.longitude": "Garis bujur GPS",
  "location.gps.notSupported": "Geolokasi tidak didukung dengan peramban ini",
  "location.gps.permissionDenied": "Izin lokasi ditolak",
  "location.gps.timeout": "Permintaan lokasi time out",
  "location.gps.unavailable": "Informasi lokasi tidak tersedia",
  "location.helper": "Hirarki Lokasi (Kabupaten Kota / Kecamatan / Kelurahan-Desa) menggunakan sistem struktur Lokasi yang ada. Jika perlu pengaturan baris yang lebih sederhana/pendek, profil alur kerja Lingkungan memungkinkan beberapa baris tidak dilabel.",
  "location.requesterReference": "Referensi Pemohon",
  "location.requesterReference.placeholder": "mis. Metode EPA 524.2",
  "location.select.placeholder": "Pilih {levelName}...",
  "location.siteDescription": "Deskripsi Tempat Pengambilan",
  "location.siteDescription.placeholder": "mis. titik masuk pasokan air kabupaten",
  "locale.active": "Aktif",
  "locale.add": "Tambah Bahasa",
  "locale.add.title": "Tambah Bahasa",
  "locale.code": "Kode Lokal",
  "locale.code.helper": "mis., en, fr, es, pt",
  "locale.create.success": "Bahasa berhasil dibuat",
  "locale.delete.confirm.message": "Apakah Anda yakin akan menghapus bahasa ini? Aksi ini tidak dapat dibatalkan.",
  "locale.delete.confirm.title": "Hapus Bahasa",
  "locale.delete.error": "Gagal menghapus bahasa",
  "locale.delete.fallback.error": "Tidak dapat menghapus bahasa alternatif. Atur bahasa lain sebagai alternatif terlebih dahulu.",
  "locale.delete.success": "Bahasa berhasil dihapus",
  "locale.displayName": "Nama di Tampilan",
  "locale.displayName.helper": "mis., English, Français, Español",
  "locale.edit.title": "Edit Bahasa",
  "locale.fallback": "Bahasa Alternatif",
  "locale.fallback.error": "Gagal mengatur bahasa alternatif",
  "locale.fallback.success": "Bahasa alternatif diperbarui",
  "locale.management.description": "Kelola bahasa yang ada untuk terjemahan metadata.",
  "locale.management.title": "Pengelolaan Bahasa",
  "locale.setFallback": "Atur sebagai Bahasa Alternatif",
  "locale.sortOrder": "Sortir Pemesanan",
  "locale.status": "Status",
  "locale.update.success": "Bahasa berhasil diperbarui",
  "log.submitting.aliquot.data": "Submit data alikuot:",
  "log.submitting.aliquot.data2": "Submit data alikuot (JSON):",
  "logging.management.apply": "Terapkan Level Log",
  "logging.management.description": "Ubah level logging backend saat runtime. Ini berguna untuk mendebug masalah tanpa perlu me-restart server. Perubahan akan berlaku segera tetapi tidak akan bertahan setelah server di-restart.",
  "logging.management.label": "Konfigurasi Logging",
  "logging.management.level": "Level Log",
  "logging.management.logger": "Nama Logger",
  "logging.management.logger.helper": "mis., org.openelisglobal, root",
  "logging.management.success": "Level log diatur ke {level} untuk {logger}",
  "login.account.disabled": "Akun dinon-aktifkan",
  "login.account.locked": "Akun terkunci",
  "login.complexity.message": "Kata kunci harus:",
  "login.complexity.message.1": "Setidaknya 7 karakter",
  "login.complexity.message.2": "Memiliki huruf besar dan kecil, atau angka",
  "login.complexity.message.3": "Memiliki setidaknya 1 karakter berikut ini: *, $, #, !",
  "login.complexity.message.4": "Tidak mengandung karakter lainnya",
  "login.complexity.new.message": "Kata kunci baru harus:",
  "login.complexity.new.message.1": "Tidak boleh sama dengan kata kunci saat ini",
  "login.error.account.disable": "Akun Anda telah dinonaktifkan. Silakan hubungi administrator sistem.",
  "login.error.password.current.incorrect": "Kata kunci yang Anda masukkan saat ini salah. Silakan coba lagi.",
  "login.error.password.expired": "Kata kunci Anda telah kedaluwarsa. Silakan hubungi administrator sistem.",
  "login.error.update.message": "Perbaruan kata kunci gagal. Silakan coba lagi.",
  "login.login.": "Ulang kata kunci",
  "login.login.current.password": "Kata kunci saat ini",
  "login.login.first": "Nama depan",
  "login.login.last": "Nama belakang",
  "login.login.name": "Nama login",
  "login.login.new.password": "Kata kunci baru",
  "login.login.password": "Kata kunci",
  "login.login.repeat.password": "Ulang kata kunci",
  "login.msg.password": "Kata kunci",
  "login.msg.password.missing": "Kata kunci diperlukan",
  "login.msg.username": "Nama pengguna",
  "login.msg.username.missing": "Nama pengguna diperlukan",
  "login.notice.message": "Pemberitahuan: Akses ke layanan ini hanya untuk personel yang berwenang. Jika Anda tidak memiliki wewenang dari administrator, Anda harus keluar sekarang. Organisasi ini melarang akses tanpa wewenang, pengungkapan, penggandaan, modifikasi, pengalihan, pemusnahan, penghilangan, penyalahgunaan, atau pencurian informasi tanpa izin.",
  "login.password.expired.date": "Tanggal kadaluarsa kata kunci",
  "login.password.expired.date.placeholder": "(dd/mm/yyyy)",
  "login.redirecting.sso": "Mengarahkan ke Single Sign-On...",
  "login.subtitle": "Masuk",
  "login.timeout": "Pengguna Time Out (menit)",
  "login.timeout.placeholder": "Masukkan dalam ms",
  "login.title": "Masuk",
  "lot.barcode": "Kode QR",
  "lot.barcode.assign": "This lot has no barcode yet. Enter one now; it is locked once saved.",
  "lot.barcode.hint": "Leave blank to generate one from the item code and lot number.",
  "lot.barcode.locked": "Barcode is locked once saved so printed labels keep working.",
  "lot.barcode.placeholder": "Leave blank to auto-generate",
  "lot.barcode.placeholder.assign": "Enter a barcode",
  "lot.calculatedExpiry": "Perhitungan Kedaluwarsa",
  "lot.currentQuantity": "Kuantitas Saat Ini",
  "lot.dateOpened": "Tanggal Dibuka",
  "lot.details.no.movements": "No movements recorded for this lot",
  "lot.details.no.transactions": "Tidak ada transaksi terekam untuk lot ini",
  "lot.details.no.usage": "Tidak riwayat penggunaan untuk lot ini",
  "lot.details.section.basic": "Informasi Dasar",
  "lot.details.section.dates": "Tanggal Penting",
  "lot.details.section.movements": "Movement History",
  "lot.details.section.quantities": "Kuantitas",
  "lot.details.section.storage": "Lokasi Penyimpanan",
  "lot.details.section.transactions": "Riwayat Transaksi",
  "lot.details.section.usage": "Riwayat Penggunaan",
  "lot.details.tab.info": "Informasi",
  "lot.details.tab.transactions": "Transaksi",
  "lot.details.tab.usage": "Riwayat Penggunaan",
  "lot.details.title": "Rincian Lot",
  "lot.details.view": "Tampilkan Rincian",
  "lot.expirationDate": "Tanggal Kedaluwarsa",
  "lot.form.title.add": "Menerima Lot Inventaris Baru",
  "lot.form.title.edit": "Edit Lot Inventaris",
  "lot.initialQuantity": "Kuantitas Awal",
  "lot.label.print": "Print label",
  "lot.label.print.failed": "Could not generate the label. Please try again.",
  "lot.number": "Nomor Lot",
  "lot.number.hint": "Stable identifier for this lot. Leave blank and we'll generate one from the item code and today's date.",
  "lot.number.placeholder": "Leave blank to auto-generate",
  "lot.qcStatus.FAILED": "Gagal",
  "lot.qcStatus.PASSED": "Lolos",
  "lot.qcStatus.PENDING": "Tertunda",
  "lot.qcStatus.QUARANTINED": "Quarantined",
  "lot.qcStatus.hint": "Lots stay unusable for testing until QC is marked Passed.",
  "lot.qcStatus": "Status QC",
  "lot.receiptDate": "Tanggal Penerimaan",
  "lot.save.error": "Error saat menyimpan lot",
  "lot.save.error.locationAfterCreate": "The lot was created, but assigning its storage location failed. Press Save again to retry the assignment only, so the lot is not received twice. {reason}",
  "lot.save.success": "Lot berhasil disimpan",
  "lot.selectItem": "Pilih Barang di Katalog",
  "lot.selectLocation": "Tambah Lokasi Penyimpanan",
  "lot.status": "Status",
  "lot.status.ACTIVE": "Aktif",
  "lot.status.CONSUMED": "Habis",
  "lot.status.DISPOSED": "Dimusnahkan",
  "lot.status.EXPIRED": "Kedaluwarsa",
  "lot.status.IN_USE": "Sedang Digunakan",
  "lot.status.QUARANTINED": "Quarantined",
  "lot.storageLocation": "Lokasi Penyimpanan",
  "manage.testing.algorithms.add.reflex.tests": "Kelola Algoritma Pemeriksaan dan Pemeriksaan Refleks",
  "master.lists.page": "Halaman daftar master",
  "master.lists.page.analyzer": "Menu Nama Pemeriksaan di Alat",
  "master.lists.page.barcode": "Konfigurasi kode QR",
  "master.lists.page.batchtest": "Penugasan ulang dan pembatalan pemeriksaan batch",
  "master.lists.page.external.connections": "Menu Koneksi Eksternal",
  "master.lists.page.field": "Konfigurasi Validasi Field",
  "master.lists.page.list": "Daftar Plugin",
  "master.lists.page.menu": "Konfigurasi menu",
  "master.lists.page.notification": "Konfigurasi Notifikasi Pemeriksaan",
  "master.lists.page.order.entry": "Konfigurasi Entri Permintaan",
  "master.lists.page.org": "Menu Organisasi",
  "master.lists.page.patient": "Konfigurasi Entri Pasien",
  "master.lists.page.printed": "Konfigurasi Laporan Cetak",
  "master.lists.page.provider": "Penyelenggara",
  "master.lists.page.report.result": "Konfigurasi Pelaporan Hasil",
  "master.lists.page.result": "Konfigurasi Entri Hasil",
  "master.lists.page.site": "Pengaturan Informasi Aplikasi",
  "master.lists.page.test.management": "Pengelolaan Pemeriksaan",
  "master.lists.page.user": "Pengelolaan Pengguna",
  "master.lists.page.work.plan": "Konfigurasi Rencana Kerja",
  "menu.accession.validation": "Berdasarkan Permintaan",
  "menu.accession.validation.range": "Berdasarkan Rentang Nomor Permintaan",
  "menu.billing.active": "Menu Pembayaran Aktif",
  "menu.billing.address": "URL Pembayaran",
  "menu.billing.title": "Pengelolaan Menu Pembayaran",
  "menu.genericSample": "Sampel Generik",
  "menu.genericSample.edit": "Edit Sampel",
  "menu.genericSample.import": "Impor",
  "menu.genericSample.order": "Penerimaan Sampel",
  "menu.global.title": "Pengelolaan Menu Global",
  "menu.label.filter": "Filter :",
  "menu.label.filter.active": "Hanya Aktif",
  "menu.label.filter.admin": "Hanya Administrator",
  "menu.label.filter.role": "Berdasarkan Peran Unit Lab",
  "menu.nonconform.active": "Menu Ketidaksesuaian Aktif",
  "menu.nonconform.title": "Pengelolaan Menu Ketidaksesuaian",
  "menu.patient.active": "Menu Pasien Aktif",
  "menu.patient.title": "Pengelolaan Menu Pasien",
  "menu.results.range": "Berdasarkan Rentang Nomor Permintaan",
  "menu.sidenav.active": "Navigasi Sisi Aktif",
  "menu.study.active": "Menu Kajian Aktif",
  "menu.study.title": "Konfigurasi Menu Kajian",
  "menu.validation.date": "Berdasarkan Tanggal",
  "message.method.activation": "Unit metode ini tidak aktif kecuali setidaknya satu pemeriksaan ditugaskan",
  "message.propertiesupdate.success": "Properti berhasil diperbarui",
  "method.browse.title": "Bagian Metode",
  "method.methodName": "Nama Metode",
  "method.modal.add.heading": "Tambah Metode Baru",
  "modal.add.method": "Tambah Metode Baru",
  "move.back": "Kembalikan",
  "move.to.aliquot": "Pindahkan ke Alikuot",
  "new.patient.label": "Pasien Baru",
  "next.action.button": "Berikutnya",
  "nextLabel.action.button": "Label Berikutnya",
  "no.aliquots": "Tidak ada alikuot tersedia",
  "no.analysis.found": "Tidak ada analisis ditemukan",
  "no.data.found": "Tidak ada data ditemukan",
  "no.option": "Tidak",
  "noTestsFound.matching": "Tidak ada pemeriksaan ditemukan",
  "nonconform.add.new.date": "Tambah tanggal baru",
  "nonconform.corrective.action": "Rencana atau rekomendasi tindakan perbaikan",
  "nonconform.corrective.actionType": "Jenis tindakan",
  "nonconform.corrective.comment": "Komentar",
  "nonconform.corrective.control": "Rencana atau rekomendasi tindakan pencegahan, perbaikan atau pengendalian simultan:",
  "nonconform.corrective.title": "Tindakan perbaikan kejadian ketidaksesuaian",
  "nonconform.date.completed": "Tanggal selesai",
  "nonconform.date.discussion.nce": "Tanggal diskusi dengan Petugas Kejadian Ketidaksesuaian",
  "nonconform.date.event": "Tanggal Kejadian",
  "nonconform.description.nce": "Deskripsi Kejadian Ketidaksesuaian",
  "nonconform.field.date": "Tanggal Kejadian Ketidaksesuaian",
  "nonconform.field.reporting.data": "Tanggal Pelaporan",
  "nonconform.goToNceForm": "Pergi ke formulir Kejadian Ketidaksesuaian",
  "nonconform.lab.componenet.nce": "Komponen Lab dimana Kejadian Ketidaksesuaian terjadi",
  "nonconform.label.highseverity": "9 = Keparahan sangat tinggi -- perlu tindakan segera",
  "nonconform.label.lowseverity": "1 = Keparahan sangat rendah -- tidak perlu tindakan segera",
  "nonconform.label.prescibernamesite": "Nama dan Lokasi Dokter yang mengeluarkan resep",
  "nonconform.label.proposed.action": "Tindakan yang diusulkan",
  "nonconform.label.reportingunit": "Unit yang melapor",
  "nonconform.label.suspected.cause.nce": "Penyebab dugaan Kejadian Ketidaksesuaian",
  "nonconform.nce.concurrent.control.action": "Tindakan pengendalian simultan",
  "nonconform.nce.number": "Nomor Kejadian Ketidaksesuaian",
  "nonconform.nce.preventive.action": "Tindakan pencegahan",
  "nonconform.nce.resolution": "Penyelesaian Kejadian Ketidaksesuaian",
  "nonconform.nce.resolution.description": "Apakah tindakan korektif dan pengendalian pencegahan/simultan efektif dalam menyelesaikan Kejadian Ketidaksesuaian dan mencegahnya terulang kembali?",
  "nonconform.nce.turnaround.time": "Waktu Penyelesaian",
  "nonconform.order.save.fail": "Penyimpanan gagal",
  "nonconform.order.save.success": "Penyimpanan berhasil",
  "nonconform.person.reporting.different": "Nama petugas yang melaporkan Kejadian Ketidaksesuaian (bila berbeda)",
  "nonconform.person.responsible": "Petugas yang bertanggungjawab",
  "nonconform.report": "Lapor Kejadian Ketidaksesuaian",
  "nonconform.report.field.date": "Tanggal Laporan",
  "nonconform.severity.score": "Skor Keparahan",
  "nonconform.view.comments": "Komentar",
  "nonconform.view.corrective.action.description": "Deskripsi tindakan perbaikan yang akan diambil",
  "nonconform.view.event.date": "Tanggal Kejadian",
  "nonconform.view.event.description": "Deskripsi Kejadian",
  "nonconform.view.lab.component": "Komponen Laboratorium",
  "nonconform.view.nce.category": "Kategori Kejadian Ketidaksesuaian",
  "nonconform.view.nce.likely.occur": "Seberapa besar kemungkinan Kejadian Ketidaksesuaian akan terulang?",
  "nonconform.view.nce.severity": "Keparahan",
  "nonconform.view.nce.type": "Jenis Kejadian Ketidaksesuaian",
  "nonconform.view.preventive.description": "Jika ada, jelaskan tindakan pencegahan atau pengendalian simultan",
  "nonconform.view.report": "Lihat Kejadian Ketidaksesuaian Baru",
  "nonconform.view.reporting.person": "Petugas yang melapor",
  "nonconform.view.severe.consequences": "Bagaimana tingkat keparahan konsekuensi atau pengaruh dari Kejadian Ketidaksesuaian?",
  "nonconform.view.specimen": "Spesimen",
  "nce.attachment.dropzone": "Tarik dan lepaskan file disini atau klik untuk mengunggah",
  "nce.attachment.error.maxFiles": "Maksimum {maxFiles} file dibolehkan",
  "nce.attachment.error.size": "Ukuran file melebihi maksimum {maxSize}",
  "nce.attachment.error.type": "Tipe file tidak didukung. Tipe yang diterima: {types}",
  "nce.attachment.error.upload": "Error saat mengunggah file",
  "nce.attachment.files": "file",
  "nce.attachment.hint": "(Opsional - maks {maxFiles} file, masing-masing 10MB)",
  "nce.attachment.uploading": "Mengunggah...",
  "nce.category.administrative": "Administratif",
  "nce.category.analytical": "Analisis",
  "nce.category.postanalytical": "Pasca-analisis",
  "nce.category.preanalytical": "Pra- analisis",
  "nce.field.attachments": "Lampiran",
  "nce.field.notes": "Catatan",
  "nce.field.description.placeholder": "Jelaskan apa yang terjadi, kapan terdeteksi, dan hal relevan lainnya...",
  "nce.field.immediateAction": "Tindakan Segera Diambil",
  "nce.field.immediateAction.placeholder": "Tindakan perbaikan apa yang akan segera diambil...",
  "nce.field.linkedItems": "Sampel/Hasil Terkait",
  "nce.field.severity": "Keparahan",
  "nce.field.title": "Judul",
  "nce.field.title.placeholder": "Deskripsi singkat kejadian...",
  "nce.severity.critical": "Kritis",
  "nce.severity.critical.description": "Resiko keselamatan pasien, pelanggaran peraturan",
  "nce.severity.major": "Mayor",
  "nce.severity.major.description": "Dampat signifikan pada mutu atau operasional",
  "nce.severity.minor": "Kecil",
  "nce.severity.minor.description": "Dampak terbatas, mudah diperbaiki",
  "nce.severity.low": "Rendah",
  "nce.severity.low.description": "Dampak minimal, tidak ada tindakan perbaikan diperlukan",
  "nce.status.open": "Buka",
  "nce.status.underInvestigation": "Dalam Investigasi",
  "nce.tree.empty": "Tidak ada pemesanan ditemukan. Cari nomor lab untuk mulai.",
  "nce.tree.loading": "Memuat pemesanan...",
  "nce.tree.order": "Pemesanan",
  "nce.tree.search": "Filter berdasarkan pemeriksaan atau sampel...",
  "nce.tree.selected": "{sampleCount} sampel, {resultCount} hasil dipilih",
  "nce.trigger.order_cancellation": "Pembatalan pesanan dapat memerlukan dokumen KTS",
  "nce.trigger.partial_sample_rejection": "Penolakan sampel parsial memerlukan dokumentasi KTS",
  "nce.trigger.pathology_rejection": "Penolakan kasus patologi dapat memerlukan dokumentasi KTS",
  "nce.trigger.premature_disposal": "Pemusnahan sebelum waktunya dapat memerlukan dokumen KTS",
  "nce.trigger.qc_invalidation": "Invalidasi QC memerlukan dokumentasi KTS",
  "nce.trigger.referral_rejection": "Penolakan rujukan memerlukan dokumentasi KTS",
  "nce.trigger.result_rejection_no_retest": "Penolakan hasil tanpa pengujian ulang memerlukan dokumentasi KTS",
  "nce.trigger.result_rejection_retest": "Penolakan hasil tanpa pengujian ulang dapat memerlukan dokumentasi KTS",
  "nce.trigger.sample_rejection": "Penolakan sampel memerlukan dokumentasi KTS",
  "nce.trigger.test_cancel_no_results": "Pembatalan pengujian memerlukan dokumen KTS",
  "nce.trigger.test_cancel_with_results": "Pembatalan pengujian dengan hasil memerlukan dokumen KTS",
  "nce.type.calibration_failure": "Kegagalan kalibrasi",
  "nce.type.communication_failure": "Kegagalan komunikasi",
  "nce.type.contamination": "Kontaminasi",
  "nce.type.documentation_error": "Kesalahan dokumentasi",
  "nce.type.equipment_malfunction": "Malfungsi alat",
  "nce.type.labeling_error": "Kesalahan pelabelan",
  "nce.type.patient_id_mismatch": "Salah mencocokkan identitas pasien",
  "nce.type.policy_violation": "Pelanggaran kebijakan",
  "nce.type.procedure_deviation": "Penyimpangan prosedur",
  "nce.type.qc_failure": "Kegagalan QC",
  "nce.type.reagent_issue": "Masalah reagen",
  "nce.type.report_delay": "Laporan terlambat",
  "nce.type.report_distribution_error": "Kesalahan distribusi laporan",
  "nce.type.requisition_incomplete": "Permintaan pemeriksaan tidak lengkap",
  "nce.type.resource_shortage": "Kurang sumber daya",
  "nce.type.result_interpretation_error": "Kesalahan interpretasi hasil",
  "nce.type.sample_collection_error": "Kesalahan pengambilan sampel",
  "nce.type.staff_competency_issue": "Masalah kompetensi pegawai",
  "nce.type.storage_error": "Kesalahan penyimpanan",
  "nce.type.system_error": "Kesalahan sistem",
  "nce.type.training_gap": "Kesenjangan pelatihan",
  "nce.type.transcription_error": "Kesalanan transkripsi",
  "nce.type.transport_issue": "Masalah transportasi",
  "nce.type.request_form_error": "Kesalahan formulir permintaan",
  "nce.type.equipment_failure": "Kegagalan alat",
  "nce.type.procedure_error": "Kesalahan prosedur",
  "nce.type.calibration_error": "Kesalahan kalibrasi",
  "nce.type.cross_contamination": "Kontaminasi silang",
  "nce.type.result_transcription_error": "Kesalahan transkripsi hasil",
  "nce.type.report_delivery_error": "Kesalahan pengiriman hasil",
  "nce.type.critical_value_not_reported": "Nilai kritis tidak dilaporkan",
  "nce.type.delayed_result": "Hasil terlambat",
  "nce.type.result_amendment": "Amendemen hasil",
  "nce.type.training_issue": "Masalah pelatihan",
  "nce.button.createNce": "Buat KTS",
  "nce.button.skip": "Lewati",
  "nce.creating": "Membuat KTS...",
  "nce.description.placeholder": "Deskripsikan kejadian ketidaksesuaian...",
  "nce.error.create.failed": "Gagal membuat KTS",
  "nce.error.severity.required": "Keparahan wajib ada",
  "nce.trigger.mandatory.message": "Anda harus membuat KTS sebelum dapat lanjut dengan aksi ini.",
  "nce.trigger.mandatory.title": "KTS wajib ada",
  "nce.trigger.order_cancellation.message": "Pembatalan pesanan dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.order_cancellation.title": "Pembatalan Pemesanan - KTS",
  "nce.trigger.partial_sample_rejection.message": "Penolakan sampel parsial memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.partial_sample_rejection.title": "Penolakan Sampel Parsial - Wajib Ada KTS",
  "nce.trigger.pathology_rejection.message": "Penolakan kasus patologi dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.pathology_rejection.title": "Penolakan Patologi - KTS",
  "nce.trigger.premature_disposal.message": "Pemusnahan sebelum waktunya dapat memerlukan dokumen kejadian ketidaksesuaian.",
  "nce.trigger.premature_disposal.title": "Pemusnahan Sebelum Waktunya - KTS",
  "nce.trigger.qc_invalidation.message": "Invalidasi QC memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.qc_invalidation.title": "Invalidasi QC - Wajib Ada KTS",
  "nce.trigger.referral_rejection.message": "Penolakan rujukan memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.referral_rejection.title": "Penolakan Rujukan - Wajib Ada KTS",
  "nce.trigger.result_rejection_no_retest.message": "Penolakan hasil tanpa pengujian ulang memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.result_rejection_no_retest.title": "Penolakan Hasil - Wajib Ada KTS",
  "nce.trigger.result_rejection_retest.message": "Penolakan hasil dengan pengujian ulang dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.result_rejection_retest.title": "Penolakan Hasil - KTS",
  "nce.trigger.sample_rejection.message": "Penolakan sampel memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.sample_rejection.title": "Penolakan Sampel - Wajib Ada KTS",
  "nce.trigger.test_cancel_no_results.message": "Pembatalan pemeriksaan dapat memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.test_cancel_no_results.title": "Pembatalan Pemeriksaan - KTS",
  "nce.trigger.test_cancel_with_results.message": "Pembatalan pemeriksaan dengan hasil memerlukan dokumentasi kejadian ketidaksesuaian.",
  "nce.trigger.test_cancel_with_results.title": "Pembatalan Pemeriksaan - KTS wajib ada",
  "nce.admin.trigger.config.title": "Konfigurasi Trigger Ketidaksesuaian",
  "nce.admin.trigger.config.description": "Konfigurasi pembuatan Kejadian Ketidaksesuaian secara otomatis",
  "nce.admin.trigger.behaviors.title": "Perilaku Trigger",
  "nce.admin.rejection.mappings.title": "Pemetaan Alasan Penolakan",
  "nce.admin.rejection.mappings.description": "Pemetaan alasan penolakan terhadap kategori KTS untuk mengisi otomatis.",
  "nce.trigger.behavior.mandatory": "Wajib",
  "nce.trigger.behavior.prompted": "Dipicu",
  "nce.trigger.behavior.disabled": "Dinonaktifkan",
  "nce.trigger.column.type": "Tipe Trigger",
  "nce.trigger.column.description": "Deskripsi",
  "nce.trigger.column.behavior": "Perilaku",
  "nce.trigger.column.active": "Aktif",
  "nce.trigger.type.sampleRejection": "Penolakan Sampel",
  "nce.trigger.type.resultRejection": "Penolakan Hasil",
  "nce.trigger.type.qaEvent": "Acara QA",
  "nce.trigger.type.manual": "Panduan",
  "nce.trigger.update.success": "Konfigurasi trigger diperbarui",
  "nce.trigger.update.error": "Gagal memperbarui konfigurasi trigger",
  "nce.mapping.add": "Tambah Pemetaan",
  "nce.mapping.edit": "Edit Pemetaan",
  "nce.mapping.column.rejectionReason": "Alasan Penolakan",
  "nce.mapping.column.category": "Kategori KTS",
  "nce.mapping.column.type": "Jenis KTS",
  "nce.mapping.column.severity": "Keparahan Default",
  "nce.mapping.column.active": "Aktif",
  "nce.mapping.noData": "Tidak ada konfigurasi pemetaan penolakan",
  "nce.mapping.validation.error": "Wajib ada alasan dan kategori penolakan",
  "nce.mapping.save.success": "Pemetaan berhasil disimpan",
  "nce.mapping.active": "Aktif",
  "nce.field.category": "Kategori",
  "nce.field.type": "Jenis",
  "nce.select.category": "Pilih Kategori",
  "nce.select.type": "Pilih jenis",
  "nce.error.dateOfEvent.required": "Wajib ada tanggal kejadian",
  "nce.error.reportingUnit.required": "Instalasi yang melaporkan wajib ada",
  "nce.error.description.required": "Deksripsi wajib ada",
  "nce.error.suspectedCauses.required": "Penyebab suspek wajib ada",
  "nce.error.proposedAction.required": "Tindakan yang diusulkan wajib ada",
  "nce.error.category.required": "Kategori wajib ada",
  "nce.attachment.saveFirst": "Simpan kejadian KTS untuk mengaktifkan lampiran file",
  "nce.attachment.error.noEvent": "Mohon simpan kejadian KTS terlebih dahulu sebelum mengunggah lampiran",
  "nce.attachment.download": "Unduh",
  "nce.attachment.delete": "Hapus",
  "requester.add.new.restricted": "Fitur penambahan organisasi baru telah dinonaktifkan oleh administrator Anda.",
  "requester.add.new.restricted.organization.contact": "Fitur untuk memasukkan informasi kontak organisasi baru telah dinonaktifkan oleh administrator Anda. Silakan cari organisasi yang sudah ada di bagian atas.",
  "requester.add.new.restricted.provider": "Fitur penambahan penyelenggara baru telah dinonaktifkan oleh administrator Anda.",
  "requester.add.new.restricted.provider.contact": "Fitur pengisian informasi kontak untuk penyelenggara layanan baru telah dinonaktifkan oleh administrator Anda. Silakan cari penyelenggara yang sudah ada di bagian atas.",
  "requester.add.new.restricted.requestor": "Penambahan pemohon baru telah dinonaktifkan oleh administrator Anda. Silakan cari pemohon yang sudah ada di atas.",
  "requester.contact.search": "Cari Pemohon",
  "requester.contact.search.helper": "Cari nama kontak yang mengajukan permintaan Pemeriksaan ini, atau masukkan nama kontak baru di bawah ini. Setidaknya salah satu dari \"Organisasi Pemohon\" atau \"Pemohon\" wajib diisi.",
  "requester.organization.add.new": "+ Tambah organisasi baru \"{name}\"",
  "requester.organization.email": "Alamat Email Organisasi",
  "requester.organization.fax": "No. Telp Organisasi",
  "requester.organization.new.helper": "Akan dibuat sebagai organisasi baru saat pesanan ini disimpan.",
  "requester.organization.new.tag": "Baru",
  "requester.organization.no.match": "Tidak ditemukan organisasi yang sesuai.",
  "requester.organization.phone": "Nomor Telepon Organisasi",
  "requester.organization.search": "Pencarian Organisasi Pemohon",
  "requestor.add.new": "+ Tambah pemohon baru \"{name}\"",
  "requestor.add.new.restricted": "Fitur penambahan pemohon baru telah dinonaktifkan oleh administrator Anda.",
  "requestor.department": "Departemen",
  "requestor.email": "Email",
  "requestor.fax": "No. Telp",
  "requestor.firstName": "Nama Depan",
  "requestor.lastName": "Nama Belakang",
  "requestor.name": "Nama Pemohon",
  "requestor.name.placeholder": "Masukkan nama pemohon",
  "requestor.new.helper": "Akan dibuat sebagai pemohon baru saat pesanan ini disimpan.",
  "requestor.new.tag": "Baru",
  "requestor.no.match": "Tidak ditemukan pemohon yang sesuai.",
  "requestor.phone": "Telepon",
  "requestor.search.helper": "Jenis minimal 2 karakter untuk melakukan pencarian otomatis.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "Semua lot",
  "result.pool.filter.allPools": "Semua kolam renang",
  "result.pool.filter.clear": "Hapus filter",
  "result.pool.filter.count": "Menampilkan {shown} dari {total} hasil",
  "result.pool.filter.lot": "Filter oleh lot",
  "result.pool.filter.pool": "Saring berdasarkan kolam renang",
  "result.pool.intake": "Kolam penampungan",
  "result.pool.subpool": "Sub-kelompok {n}",
  "result.vectorPool.label": "Kumpulan foto {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Ketidakpastian harus berupa bilangan non-negatif.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Sampel",
  "sample.priority.ASAP": "ASAP",
  "sample.priority.FUTURE_STAT": "Future STAT",
  "sample.priority.ROUTINE": "Rutin",
  "sample.priority.STAT": "STAT (Urgent)",
  "sample.priority.TIMED": "Timed",
  "sample.referToReferenceLab.helper": "Tandai jika sampel ini wajib diuji di laboratorium rujukan eksternal.",
  "sampleAcceptance.action.moveDown": "Geser ke bawah",
  "sampleAcceptance.action.moveUp": "Geser ke atas",
  "sampleAcceptance.banner.resampledFrom": "Ini adalah versi pengganti yang dibuat melalui proses resampling dari sampel nomor{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Sampel pengganti",
  "sampleAcceptance.banner.resampledTo": "Sampel ini ditolak dan diambil ulang. Urutan penggantian: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Diambil sampel ulang",
  "sampleAcceptance.button.addItem": "Tambah barang",
  "sampleAcceptance.col.active": "Aktif",
  "sampleAcceptance.col.label": "Label",
  "sampleAcceptance.col.order": "Pemesanan",
  "sampleAcceptance.col.statusForDomain": "Status domain ini",
  "sampleAcceptance.domain.all": "Semua domain",
  "sampleAcceptance.domain.clinical": "Klinis",
  "sampleAcceptance.domain.environmental": "Lingkungan",
  "sampleAcceptance.domain.vector": "Vektor",
  "sampleAcceptance.enforcement.help": "Penegakan aturan ditetapkan per domain, bukan per instalasi lab — seorang petugas resepsionis melayani banyak instalasi lab.",
  "sampleAcceptance.enforcement.label": "Penegakan daftar periksa — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Wajib — tahan Langkah 3 hingga selesai",
  "sampleAcceptance.enforcement.off": "Matikan — sembunyikan daftar periksa",
  "sampleAcceptance.enforcement.optional": "Opsional — rekam tetapi jangan blokir",
  "sampleAcceptance.gate.blocked": "Penerimaan spesimen wajib dilakukan untuk bidang ini — terima setiap spesimen (atau laporkan NCE / ambil spesimen ulang) sebelum pemesanan ini dapat dilanjutkan.",
  "sampleAcceptance.labWide.heading": "Ketentuan yang berlaku di seluruh laboratorium (terapkan kecuali jika ada ketentuan di tingkat domain yang menggantikannya)",
  "sampleAcceptance.labWide.inherited": "Item yang berlaku di seluruh lab — diwarisi (fallback aktif)",
  "sampleAcceptance.labWide.superseded": "Item yang berlaku di seluruh laboratorium — digantikan di sini (diedit dari “Semua domain”)",
  "sampleAcceptance.notify.enforcementSaved": "Penegakan hukum terbarui",
  "sampleAcceptance.notify.itemAdded": "Item daftar periksa telah ditambah",
  "sampleAcceptance.notify.itemSaved": "Item daftar periksa telah disimpan",
  "sampleAcceptance.notify.recordFailed": "Gagal mencatat persetujuan",
  "sampleAcceptance.notify.rejectFailed": "Gagal ditolak",
  "sampleAcceptance.notify.resampleFailed": "Gagal melakukan resampling",
  "sampleAcceptance.ownItems.empty": "Belum ada item — domain ini akan dialihkan ke daftar untuk seluruh laboratorium di bawah ini.",
  "sampleAcceptance.ownItems.heading": "{domain} item",
  "sampleAcceptance.qa.accepted.success": "Penerimaan telah dicatat",
  "sampleAcceptance.qa.answer.fail": "Gagal",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Lewati",
  "sampleAcceptance.qa.button.accept": "Terima sampel",
  "sampleAcceptance.qa.button.reject": "Tolak",
  "sampleAcceptance.qa.button.resample": "Resampling",
  "sampleAcceptance.qa.context.collected": "Diambil",
  "sampleAcceptance.qa.context.longTransit": "waktu transit yang lama — terserah Anda",
  "sampleAcceptance.qa.context.note": "Transit hanya ditampilkan sebagai referensi — sistem ini tidak melakukan penilaian otomatis apa pun. Daftar aktif: {domain}.",
  "sampleAcceptance.qa.context.received": "Diterima",
  "sampleAcceptance.qa.context.transit": "Waktu transit",
  "sampleAcceptance.qa.empty": "Tidak ada daftar periksa penerimaan yang dikonfigurasi untuk domain ini.",
  "sampleAcceptance.qa.failHint": "Sampel ini gagal pemeriksaan — laporkan sebagai NCE atau ambil sampel ulang, jangan diterima.",
  "sampleAcceptance.qa.noSample": "Simpan koleksi untuk melakukan proses penerimaan spesimen ini.",
  "sampleAcceptance.qa.note.label": "Catatan (Opsional)",
  "sampleAcceptance.qa.note.placeholder": "Opsional — catat kondisi apa saja yang diamati",
  "sampleAcceptance.qa.status.accepted": "Diterima",
  "sampleAcceptance.qa.status.pending": "Tertunda",
  "sampleAcceptance.qa.status.rejected": "Ditolak",
  "sampleAcceptance.qa.status.review": "Ulasan",
  "sampleAcceptance.qa.subtitle": "Selesaii daftar periksa penerimaan untuk sampel ini",
  "sampleAcceptance.qa.subtitle.rejected": "Spesimen ini ditolak dan diambil sampelnya kembali — hanya untuk dibaca.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "Penangkapan ini ditolak — hanya baca.",
  "sampleAcceptance.qa.title": "Penerimaan pendaftaran",
  "sampleAcceptance.reject.commit": "Penolakan commit",
  "sampleAcceptance.reject.info": "Tolak hasil tangkapan ini karena tidak layak pakai. Hasil tangkapan ini tidak dapat ditangkap kembali, sehingga tidak dibuat pesanan pengganti.",
  "sampleAcceptance.reject.reason.label": "Alasan (sudah terisi otomatis dari item yang gagal — dapat diedit)",
  "sampleAcceptance.reject.reason.required": "Alasan wajib",
  "sampleAcceptance.reject.success": "Sampel ditolak.",
  "sampleAcceptance.reject.title": "Tolak — {labNumber}",
  "sampleAcceptance.resample.commit": "Lakukan resampling",
  "sampleAcceptance.resample.info": "Tolak sampel ini dan buat pesanan pengambilan baru untuk pengambilan ulang. Pemohon akan diberi tahu.",
  "sampleAcceptance.resample.reason.label": "Alasan (sudah terisi otomatis dari item yang gagal — dapat diedit)",
  "sampleAcceptance.resample.reason.required": "Alasan wajib",
  "sampleAcceptance.resample.success": "Resample telah dibuat — pemesanan baru {accession}. Pemohon telah diberi tahu.",
  "sampleAcceptance.resample.title": "Resample — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Persyaratan Kelayakan",
  "sampleAcceptance.review.col.labNo": "Lab #",
  "sampleAcceptance.review.col.sampleType": "Jenis sampel",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "Tidak ada spesimen yang dikumpulkan untuk ditinjau.",
  "sampleAcceptance.review.subtitle": "Pilih sebuah sampel untuk menyelesaikannya",
  "sampleAcceptance.review.title": "Penerimaan Pendaftaran",
  "sampleAcceptance.status.active": "Aktif",
  "sampleAcceptance.status.inactive": "Inaktif",
  "sampleAcceptance.status.inheritedActive": "Aktif (diwariskan)",
  "sampleAcceptance.status.superseded": "Digantikan",
  "sampleAcceptance.title": "Contoh Daftar Periksa Penerimaan",
  "sidenav.label.admin.nceTriggerConfig": "Konfigurasi Trigger",
  "sidenav.label.admin.nceCategoryType": "Kategori & Jenis",
  "sidenav.label.admin.nceConfig": "Konfigurasi Ketidaksesuaian",
  "nce.admin.categorytype.title": "Konfigurasi Kategori dan Jenis Ketidaksesuaian",
  "nce.admin.categorytype.description": "Kelola kategori dan jenis yang ada untuk Kejadian Ketidaksesuaian.",
  "nce.admin.tab.categories": "Kategori",
  "nce.admin.tab.types": "Jenis",
  "nce.admin.category.add": "Tambah Kategori",
  "nce.admin.category.edit": "Edit Kategori",
  "nce.admin.category.name.required": "Nama kategori wajib ada",
  "nce.admin.category.save.success": "Kategori berhasil disimpan",
  "nce.admin.category.save.error": "Gagal menyimpan kategori",
  "nce.admin.type.add": "Tambah Jenis",
  "nce.admin.type.edit": "Edit Jenis",
  "nce.admin.type.validation.error": "Nama dan jenis kategori wajib ada",
  "nce.admin.type.save.success": "Jenis berhasil disimpan",
  "nce.admin.type.save.error": "Gagal menyimpan jenis",
  "nce.admin.column.name": "Nama",
  "nce.admin.column.displayKey": "Tombol Tampilan",
  "nce.admin.column.typesCount": "Jumlah Jenis",
  "nce.admin.column.category": "Kategori",
  "nce.admin.column.actions": "Tindakan",
  "nce.admin.field.name": "Nama",
  "nce.admin.field.displayKey": "Display Key (untuk i18n)",
  "nce.admin.field.displayKey.helper": "Opsional. Digunakan untuk terjemahan.",
  "nce.admin.field.category": "Kategori",
  "nce.admin.delete.confirm.title": "Konfirmasi Penghapusan",
  "nce.admin.delete.confirm.message": "Apakah Anda yakin mau menghapus '{name}'? Aksi ini tidak dapat dibatalkan.",
  "nce.admin.delete.success": "Berhasil dihapus",
  "nce.inline.title": "Lapor Kejadian Ketidaksesuaian",
  "nce.inline.context": "KONTEKS (Auto-populated)",
  "nce.dashboard.title": "Semua KTS",
  "nce.dashboard.subtitle": "Semua KTS yang terbuka di semua instalasi",
  "nce.button.reportNce": "Lapor KTS",
  "nce.search.placeholder": "Cari KTS...",
  "nce.filter.allStatus": "Semua Status",
  "nce.filter.allCategories": "Semua Kategori",
  "nce.filter.allSeverities": "Semua Keparahan",
  "nce.filter.clearAll": "Hapus Semua",
  "nce.summary.critical": "Kritis",
  "nce.summary.major": "Mayor",
  "nce.summary.minor": "Kecil",
  "nce.summary.overdue": "Lewat tenggat",
  "nce.tag.overdue": "Lewat tenggat",
  "nce.tab.eventDetails": "Rincian Kejadian",
  "nce.tab.investigation": "Investigasi",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "Riwayat",
  "nce.field.suspectedCauses": "Penyebab Diduga",
  "nce.field.proposedAction": "Tindakan Yang Diusulkan",
  "nce.field.trigger": "Pemicu",
  "nce.capReason.time_24h": "{count} samples linked — capped at 24h window",
  "nce.capReason.count_50": "{count} samples linked — capped at 50 most recent",
  "nce.capa.noItems": "Belum ada tindakan perbaikan/pencegahan yang terekam.",
  "nce.capa.dueDate": "Due Date",
  "nce.history.noItems": "Tidak ada riwayat tersedia.",
  "nce.history.system": "Sistem",
  "nce.action.acknowledge": "Mengetahui",
  "nce.action.assignTo": "Ditugaskan Ke",
  "nce.action.addNote": "Tambah Catatan",
  "nce.action.close": "Tutup NCE",
  "nce.action.startCorrectiveAction": "Mulai Tindakan Perbaikan",
  "nce.link.duplicate.warning": "Spesimen ini sudah terkait ke KTS ini",
  "nce.list.empty": "Tidak ada KTS yang cocok dengan kriteria Anda.",
  "nce.modal.addNote": "Tambah Catatan",
  "nce.modal.addNoteDescription": "Tambah catatan ke KTS {nceNumber}",
  "nce.modal.notePlaceholder": "Masukkan catatatn Anda...",
  "nce.modal.assign": "Tugaskan KTS",
  "nce.modal.assignDescription": "Tugaskan KTS {nceNumber} ke pengguna",
  "nce.modal.selectUser": "Pilih Pengguna",
  "nce.modal.searchUser": "Cari pengguna...",
  "nce.assign.selectUser": "Pilih pengguna untuk menugaskan",
  "nce.assign.success": "KTS berhasil ditugaskan",
  "nce.assign.error": "Gagal menugaskan KTS",
  "nce.acknowledge.success": "KTS berhasil diketahui",
  "nce.acknowledge.error": "Gagal mengetahui KTS",
  "nce.note.empty": "SIlahkan masukan catatan",
  "nce.note.success": "Catatan berhasil ditambah",
  "nce.note.error": "Gagal menambah catatan",
  "nce.attachment.downloadError": "Gagal mengunduh lampiran",
  "nce.attachment.viewError": "Gagal melihat lampiran",
  "not.available": "Tidak tersedia",
  "not.specified": "Tidak dispesifikasi",
  "notAuthenticated": "Tidak diotentikasi",
  "notebook.attachments.title": "Lampiran",
  "notebook.attachments.uploadPrompt": "Klik untuk mengunggah file",
  "notebook.auditTrail.action.archived": "Diarsipkan",
  "notebook.auditTrail.action.created": "Dibuat",
  "notebook.auditTrail.action.finalized": "Difinalisasi",
  "notebook.auditTrail.action.locked": "Terkunci",
  "notebook.auditTrail.action.submitted": "Dikirim",
  "notebook.auditTrail.action.updated": "Terbarui",
  "notebook.auditTrail.comingSoon": "Fungsionalitas Jejak Audit akan segera tersedia.",
  "notebook.auditTrail.none.subtitle": "Entri Jejak Audit untuk Notebook ini tidak tersedia.",
  "notebook.auditTrail.none.title": "Jejak Audit tidak tersedia",
  "notebook.auditTrail.title": "Jejak Audit",
  "notebook.button.edit": "Sunting",
  "notebook.button.editResults": "Edit Hasil",
  "notebook.button.enterResults": "Masukkan Hasil",
  "notebook.button.newLabNotebook": "Proyek",
  "notebook.button.view": "Lihat",
  "notebook.comments.add.button": "Tambah Komentar",
  "notebook.comments.add.label": "Tambah Komentar",
  "notebook.comments.none.subtitle": "Komentar belum ditambah.",
  "notebook.comments.none.title": "Belum ada komentar",
  "notebook.comments.title": "Komentar",
  "notebook.error.notAssigned": "Anda tidak ditugaskan pada proyek ini",
  "notebook.heading.allEntries": "Semua Entri",
  "notebook.heading.notebooks": "Proyek",
  "notebook.icon.edit": "Sunting",
  "notebook.instruments.title": "Alat",
  "notebook.label.addpage": "Tambah Laman",
  "notebook.label.author": "Pengarang",
  "notebook.label.basicinfo": "Informasi Dasar",
  "notebook.label.content": "Isi Utama",
  "notebook.label.dashboard": "Dasbor Notebook",
  "notebook.label.drafts": "Draf",
  "notebook.label.entry": "Entri di Buku Catatan",
  "notebook.label.entryFiles": "File Entri",
  "notebook.label.instanceEntry": "Entri Instansi Notebook",
  "notebook.label.entryTags": "Tag Entri",
  "notebook.label.experimentDoc": "Dokumen Eksperimen",
  "notebook.label.experimentType": "Jenis Eksperimen",
  "notebook.label.filter.types": "Jenis Eksperimen",
  "notebook.label.finalized": "Difinalkan minggu ini",
  "notebook.label.formEntry": "Entri Formulir Notebook",
  "notebook.label.objective": "Tujuan",
  "notebook.label.pages": "Halaman Alur Kerja",
  "notebook.label.pending": "Tinjauan Tertunda",
  "notebook.label.project": "Proyek",
  "notebook.label.project.title": "Judul Proyek",
  "notebook.label.projectFiles": "File Proyek",
  "notebook.label.projectTags": "Tag Proyek",
  "notebook.label.protocol": "Nomor Protokol",
  "notebook.label.questionnaire": "Kuesioner",
  "notebook.label.sampleManagement": "Pengelolaan Sampel",
  "notebook.label.status": "Status",
  "notebook.label.technician": "Petugas",
  "notebook.label.title": "Judul Entri",
  "notebook.label.total": "Entri Total",
  "notebook.page.completed": "Selesai",
  "notebook.page.content": "Isi:",
  "notebook.page.instructions": "Petunjuk:",
  "notebook.page.markComplete": "Tandai sebagai Selesai",
  "notebook.page.modal.add.errorRequired": "Judul dan isi diperlukan.",
  "notebook.page.modal.add.title": "Tambah Halaman Baru",
  "notebook.page.modal.content.label": "Isi",
  "notebook.page.modal.edit.title": "Edit Halaman",
  "notebook.page.modal.instructions.label": "Petunjuk",
  "notebook.page.modal.title.label": "Judul",
  "notebook.page.title": "Buku catatan",
  "notebook.pages.none.subtitle": "Klik untuk menambah Halaman",
  "notebook.pages.none.title": "Tidak ada Halaman yang ditambah",
  "notebook.project.definition.form.title": "Formulir Definisi Proyek",
  "notebook.project.entry.form.title": "Formulir Entri Proyek",
  "notebook.results.modal.title": "Hasil untuk {accession}",
  "notebook.results.noAccession": "Sampel ini tidak memiliki nomor registrasi",
  "notebook.results.none.subtitle": "Hasil tidak ditemukan untuk nomor registrasi yang diberikan.",
  "notebook.results.none.title": "Hasil tidak ditemukan",
  "notebook.results.title": "Hasil",
  "notebook.sample.result.dateCreated": "Tanggal dibuat",
  "notebook.samples.available": "Sampel yang tersedia",
  "notebook.samples.none.subtitle": "Pencarian Sampel berdasarkan Pasien atau Nomor Registrasi",
  "notebook.samples.none.subtitle.selected": "Klik untuk menambah sampel",
  "notebook.samples.none.title": "Tidak ada sampel yang tersedia",
  "notebook.samples.none.title.selected": "Tidak ada sampel yang dipilih",
  "notebook.samples.resultsRecorded": "Hasil yang terekam:",
  "notebook.samples.selected": "Sampel yang dipilih",
  "notebook.search.byAccession": "Cari berdasarkan Aksesi",
  "notebook.search.byPatient": "Cari berdasarkan Pasien",
  "notebook.select.label": "Pilih Notebook",
  "notebook.status.archived": "Entri arsip",
  "notebook.status.assignment.title": "Status dan Penugasan",
  "notebook.status.draft": "Simpan draf",
  "notebook.status.finalized": "Finalisasi Entri",
  "notebook.status.locked": "Kunci Entri",
  "notebook.status.metadata.title": "Status & Metadata",
  "notebook.status.submitted": "Kirim untuk Peninjauan",
  "notebook.tab.attachments": "Lampiran",
  "notebook.tab.auditTrail": "Jejak Audit",
  "notebook.tab.comments": "Komentar",
  "notebook.tab.content": "Isi",
  "notebook.tab.entryDetails": "Rincian Entri",
  "notebook.tab.metadata": "MetaData",
  "notebook.tab.results": "Hasil",
  "notebook.tab.samples": "Sampel",
  "notebook.tab.workflow": "Alur Kerja",
  "notebook.table.header.entries": "Entri",
  "notebook.tag.placeholder": "Masukkan Tag",
  "notebook.tags.add": "Tambah Tag",
  "notebook.tags.modal.add.errorRequired": "Tag diperlukan",
  "notebook.tags.modal.add.label": "Tag",
  "notebook.tags.modal.add.title": "Tambah Tag Baru",
  "notebook.tags.title": "Tag",
  "notebook.validation.content.required": "Isi Utama diperlukan.",
  "notebook.validation.objective.required": "Tujuan diperlukan.",
  "notebook.validation.project.required": "Proyek diperlukan.",
  "notebook.validation.protocol.required": "Nomor protokol diperlukan.",
  "notebook.validation.title.required": "Judul diperlukan.",
  "notebook.validation.type.required": "Jenis eksperimen diperlukan.",
  "notification.error": "Kesalahan",
  "notification.info": "Informasi",
  "notification.invalid.confirm.password": "Kata Kunci tidak sama dengan di atas.",
  "notification.invalid.loginName": "Masukkan nilai alfanumerik tanpa spasi.",
  "notification.invalid.name": "Hanya masukkan nilai alfanumerik.",
  "notification.invalid.password": "Masukkan Kata Kunci sesuai petunjuk.",
  "notification.login.generic.error": "Error saat login",
  "notification.login.syntax.error": "Terjadi error saat mencoba masuk - Tidak dapat mengurai respons ke JSON",
  "notification.organization.post.delete.success": "Organisasi berhasil dinonaktifkan.",
  "notification.organization.post.internetAddress": "Masukkan URL organisasi yang valid.",
  "notification.organization.post.save.success": "Penambahan Informasi Organisasi Berhasil.",
  "notification.organization.post.success": "Pembaruan Informasi Organisasi Berhasil.",
  "notification.password.change.fail": "Perubahan Kata Kunci gagal",
  "notification.password.change.success": "Kata Kunci berhasil diubah",
  "notification.response.syntax.error": "Error -  Tidak dapat mengurai respon ke JSON",
  "notification.resultSelectList.post.save.success": "Result select list saved successfully.",
  "notification.resultSelectList.post.update.success": "Result select list updated successfully.",
  "notification.slideover.button.hideread": "Sembunyikan dibaca",
  "notification.slideover.button.markallasread": "Tandai semua sebagai dibaca",
  "notification.slideover.button.markasread": "Tandai sebagai dibaca",
  "notification.slideover.button.reload": "Muat ulang",
  "notification.slideover.button.showread": "Tampilkan dibaca",
  "notification.slideover.button.subscribe": "Berlangganan di Perangkat ini",
  "notification.slideover.button.subscribe.fail": "Berlangganan gagal",
  "notification.slideover.button.subscribe.success": "Berlangganan berhasil",
  "notification.slideover.button.unsubscribe": "Berhenti berlangganan",
  "notification.slideover.button.unsubscribe.fail": "Berhenti berlangganan gagal",
  "notification.slideover.button.unsubscribe.success": "Berhenti berlangganan berhasil",
  "notification.slideover.empty.header": "Semua sudah dibaca",
  "notification.sliderover.empty.message": "Tidak ada notifikasi saat ini",
  "notification.success": "Berhasil",
  "notification.title": "Pesan notifikasi",
  "notification.user.add.success": "User information added successfully.",
  "notification.user.post.delete.success": "Penguna berhasil dinonaktifkan.",
  "notification.user.post.save.success": "Informasi Pengguna berhasil ditambah.",
  "notification.user.update.success": "User information updated successfully.",
  "notify.error": "Pengguna dan Pesan diperlukan",
  "notify.main.title": "Beri tahu Pengguna",
  "notify.message": "Pesan",
  "notify.user.by": "Pengguna yang akan dinotifikasi",
  "notify.user.success.notification": "Notifikasi berhasil terkirim",
  "of": "dari",
  "openreports.activity.title": "Laporan Kegiatan",
  "openreports.aggregate.title": "Laporan Agregat",
  "openreports.all.test.summary.title": "Ringkasan Laporan Pemeriksaan",
  "openreports.all.tests.aggregate": "Ringkasan Semua Pemeriksaan",
  "openreports.hiv.aggregate": "Ringkasan Pemeriksaan HIV",
  "openreports.management.title": "Laporan Manajemen",
  "openreports.mgt.nonconformity.date": "Laporan Ketidaksesuaian berdasarkan Tanggal",
  "openreports.mgt.nonconformity.section": "Laporan Ketidaksesuaian berdasarkan Unit dan Alasan",
  "openreports.mgt.rejection": "Laporan Penolakan",
  "openreports.patient.EID.version1": "EID Versi 1",
  "openreports.patient.EID.version2": "EID Versi 2",
  "openreports.patient.VL.version1": "VL Versi Nasional",
  "openreports.patientTestStatus": "Laporan Status Pasien",
  "openreports.patientreports.title": "Laporan Status Pasien",
  "openreports.stat.aggregate": "Laporan Statistik",
  "order.accept": "Terima",
  "order.accept.error": "Gagal menerima pemesanan",
  "order.additionalInfo": "Informasi Tambahan",
  "order.additionalInfo.helper": "Catatan opsional tentang pemesanan ini",
  "order.clinicalInfo": "Informasi Klinis",
  "order.continue": "Lanjut",
  "order.current.time": "Waktu sekarang (hh:mm)",
  "order.dashboard.empty": "Pemesanan tidak ditemukan",
  "order.dashboard.title": "Dasbor Pemesanan",
  "order.department.label": "ruang/departemen/unit:",
  "order.diagnosis.helper": "Diagnosis sementara — menjadi pedoman dalam pemilihan tes. Tidak terekam sebagai diagnosis yang telah dikonfirmasi.",
  "order.diagnosis.placeholder": "Masukkan diagnosis atau catatan klinis",
  "order.entry.setup": "Pengaturan Entri Permintaan Batch",
  "order.external": "Eksternal",
  "order.facility": "Lembaga",
  "order.filter.priority": "Filter berdasarkan Prioritas",
  "order.filter.status": "Filter berdasarkan Status",
  "order.fixIssue": "Perbaiki Masalah",
  "order.form.label": "Formulir:",
  "order.form.select": "Pilih Formulir",
  "order.generate.barcode": "Buat Kode QR dan Simpan",
  "order.generate.barcode.history": "Nomor Registrasi yang digunakan sebelumnya",
  "order.if.other.label": "Lainnya, jelaskan:",
  "order.invalid.requester.name.label": "nama pemohon tidak valid",
  "order.invalid.site.name": "Nama tempat tidak valid",
  "order.labNumber": "Nomor Registrasi",
  "order.labNumber.generate": "Membuat Nomor Registrasi",
  "order.labNumber.helper": "Pengidentifikasi unik untuk pemesanan ini",
  "order.attachment.action.delete": "Hapus lampiran",
  "order.attachment.action.download": "Unduh lampiran",
  "order.attachment.action.view": "Lihat lampiran",
  "order.attachment.column.actions": "Aksi",
  "order.attachment.column.fileName": "Nama File",
  "order.attachment.column.fileSize": "Ukuran",
  "order.attachment.column.fileType": "Jenis",
  "order.attachment.column.uploadedAt": "Waktu diunggah",
  "order.attachment.delete.confirm.body": "Apakah Anda yakin mau menghapus \"{fileName}\"? Ini tidak dapat dibatalkan.",
  "order.attachment.delete.confirm.title": "Hapus lampiran",
  "order.attachment.delete.failed": "Tidak dapat menghapus lampiran. Silahkan coba lagi.",
  "order.attachment.dropzone": "Tarik dan lepaskan file disini atau klik untuk mencari",
  "order.attachment.empty": "Belum ada lampiran",
  "order.attachment.error.maxFiles": "Anda dapat melampirkan maks {maxFiles} file.",
  "order.attachment.error.size": "Setiap file tidak lebih dari {maxSize}.",
  "order.attachment.error.type": "Jenis file yang didukung: {types}",
  "order.attachment.heading": "Lampiran",
  "order.attachment.hint": "Opsional. Sampai dengan {maxFiles} file, masing-masing 10MB. Mendukung: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "Satu atau lebih lampiran tidak dapat diunggah.",
  "order.labNumber.placeholder": "Masukkan atau buat nomor registrasi",
  "order.label.add": "Tambah Permintaan",
  "order.label.modify": "Modifikasi Permintaan",
  "order.legend.EDTATube": "Tabung EDTA",
  "order.legend.commonFields": "Field Umum",
  "order.legend.configureBarcode": "Konfigurasi Entri Kode QR",
  "order.legend.dryBloodSpot": "Tetes Darah Kering",
  "order.legend.dryTube": "Tabung kering",
  "order.legend.facility": "Lembaga",
  "order.legend.onDemand": "Sesuai permintaan",
  "order.legend.optionalFields": "Field opsional",
  "order.legend.patient": "Informasi Pasien",
  "order.legend.preDemand": "Pra-cetak",
  "order.legend.sample": "Sampel",
  "order.legend.selectMethod": "Pilih Metode",
  "order.legend.siteName": "Nama Tempat",
  "order.legend.specimen.collected": "Spesimen diambil",
  "order.legend.tests": "Pemeriksaan",
  "order.legend.viralLoadTest": "Pemeriksaan Viral Load",
  "order.lastUpdated": "Pembaruan Terakhir",
  "order.load.error": "Gagal memuat pemesanan",
  "order.location": "Lokasi",
  "order.new": "Pemesanan Baru",
  "order.payment.status.label": "Status pembayaran pasien:",
  "order.paymentStatus": "Status Pembayaran",
  "order.previousLabNumber": "Nomor Registrasi sebelumnya",
  "order.previousLabNumber.placeholder": "Masukkan nomor registrasi sebelumnya jika ada",
  "order.printLabels": "Cetak Label",
  "order.printLabels.info": "Cetak Kode QR untuk pemesanan ini",
  "order.priority": "Prioritas",
  "order.progress": "Kemajuan",
  "order.provisionalDiagnosis": "Diagnosis Sementara",
  "order.received.time": "Waktu datang (hh:mm)",
  "order.reception.time": "Waktu diterima (hh:mm)",
  "order.remember.site.and.requester.label": "Ingat tempat dan pemohon",
  "order.readonly.message": "Pemesanan ini dalam mode read-only",
  "order.requester": "Pemohon",
  "order.requester.email.label": "Email Pemohon:",
  "order.requester.fax.label": "Nomor Faks Pemohon:",
  "order.requester.firstName.label": "NamaDepan Pemohon:",
  "order.requester.lastName.label": "NamaBelakang Pemohon:",
  "order.requester.phone.label": "Nomor telepon Pemohon:",
  "order.requester.provisionalDiagnosis.label": "Diagnosis Klinis Sementara:",
  "order.result.reporting.heading": "PELAPORAN HASIL",
  "order.sampleCategory": "Kategori Sampel",
  "order.sampleCategory.helper": "Pilih kategori sampel untuk pengambilan",
  "order.sampling.performed.label": "Pengambilan sampel yang dilakukan untuk analisis:",
  "order.search.requester.label": "Cari Pemohon",
  "order.saveStatus.error": "Penyimpanan gagal",
  "order.saveStatus.saved": "Disimpan",
  "order.saveStatus.saving": "Menyimpan...",
  "order.saveStatus.unsaved": "Perubahan tidak tersimpan",
  "order.save.blocked": "Pemesanan tersebut tidak disimpan",
  "order.save.notPersisted": "The server accepted the order but stored no samples for it. Check the order before continuing.",
  "order.save.incomplete": "Mohon tambah pasien (atau tempat pengambilan sampel) dan setidaknya satu jenis sampel sebelum menyimpan.",
  "order.save.incomplete.fields": "Add {fields} before saving.",
  "order.save.incomplete.and": "and",
  "order.save.requirement.labNumber": "a lab number",
  "order.save.requirement.patient": "a patient",
  "order.save.requirement.samplingSite": "a sampling site",
  "order.save.requirement.collectionSite": "a collection site",
  "order.save.requirement.sampleType": "at least one sample type",
  "order.save.requirement.site": "a requesting site",
  "order.requestDate": "Tanggal Permintaan",
  "order.nextVisitDate": "Tanggal Kunjungan Berikutnya",
  "order.sampleHandling": "Sample Handling",
  "sampleAcceptance.qa.button.continueWithTesting": "Continue with testing",
  "sampleAcceptance.qa.continueWithTesting.reason": "Why is this sample being tested despite the failed check?",
  "sampleAcceptance.qa.continueWithTesting.record": "Record and continue",
  "order.eqaSample": "External quality assessment (EQA) sample",
  "order.noPatient": "This order has no patient",
  "order.noPatient.reason": "Reason for ordering without a patient",
  "order.noPatient.reason.eqa": "External quality assessment sample",
  "order.noPatient.warning.title": "Results will not be evaluated against a reference range",
  "order.noPatient.warning.subtitle": "Without a patient there is no age or sex to select a reference range from, so results on this order will not be flagged normal or abnormal.",
  "order.noPatient.butPatientChosen": "A patient is attached to this order, so the no-patient decision will not be recorded.",
  "order.eqa.program": "EQA Programme",
  "order.eqa.providerSampleId": "ID Sampel Penyelenggara",
  "order.eqa.deadline": "Tenggat Penyerahan",
  "order.eqa.priority": "Prioritas PME",
  "order.rememberSiteAndRequester": "Remember this site and requester for my next order",
  "order.testLocationCode": "Sampling Performed At",
  "order.testLocationCode.other": "Lainnya",
  "order.testLocationCode.otherLabel": "If other, specify",
  "provider.fax.invalid": "Enter a valid fax number, digits and + ( ) - only.",
  "provider.email.invalid": "Enter a valid email address, for example lab@example.org.",
  "order.save.requirement.provider": "a requesting provider",
  "order.save.requirement.testsPerSample": "at least one test or panel on every sample",
  "order.saved.draft": "Draf disimpan",
  "order.saved.title": "Pemesanan \"{labNumber}\" telah disimpan",
  "order.saved.next": "Berikutnya: {step}",
  "order.search.placeholder": "Cari pemesanan...",
  "order.search.site.name": "Cari Nama Tempat",
  "order.send.toAnalyzer": "Kirim ke alat",
  "order.send.modal.title": "Kirim pemesanan ke alat",
  "order.send.modal.confirm": "Kirim",
  "order.send.modal.cancel": "Batal",
  "order.send.modal.analyzerLabel": "Alat yang Dituju",
  "order.send.modal.accession": "Nomor registrasi pemesanan: {accession}",
  "order.send.modal.noAnalyzers": "Tidak ada alat yang dikonfigurasi untuk pengiriman dari SIL.",
  "order.send.success": "Pemesanan dikirim",
  "order.send.error": "Gagal mengirim pemesanan",
  "order.send.unknownError": "Kesalahan bridge tidak diketahui",
  "order.send.missingAccession": "Pemesanan tidak memiliki nomor registrasi yang terkait hasil",
  "order.site.name": "Nama tempat:",
  "order.step.collect": "Pengambilan",
  "order.step.complete": "Selesai",
  "order.step.enter": "Masukkan Pemesanan",
  "order.step.label": "Label & Simpan",
  "order.step.patient.info": "Informasi Pasien",
  "order.step.program.selection": "Pilihan Program",
  "order.step.qa": "Tinjauan QA",
  "order.start.new": "Mulai Pemesanan Baru",
  "order.submit.labNumber": "Kirim dengan Nomor Registrasi",
  "order.submit.success": "Pemesanan berhasil dikirim",
  "order.submitted.success.msg": "Pemesanan berhasil dikirim",
  "order.summary.accessionNumber": "Nomor Registrasi",
  "order.summary.collectionDate": "Tanggal Pengambilan",
  "order.summary.patientName": "Nama Pasien",
  "order.summary.sampleType": "Jenis Sampel",
  "order.summary.title": "Ringkasan Pemesanan",
  "order.test.request.heading": "Permintaan Pemeriksaan",
  "order.title": "PERMINTAAN",
  "ordertests.title": "Permintaan Pemeriksaan",
  "organization.add.placeholder": "Nilai alfanumerik",
  "organization.add.placeholder.active": "Ya atau Tidak",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Organisasi Induk",
  "organization.add.title": "Tambah Organisasi",
  "organization.city": "Kota",
  "organization.clia.number": "Nomor CLIA",
  "organization.edit.title": "Edit Organisasi",
  "organization.internetaddress": "Website",
  "organization.isActive": "Status Aktif",
  "organization.main.title": "Pengelolaan Organisasi",
  "organization.next": "Halaman Berikutnya",
  "organization.organizationName": "Nama Organisasi",
  "organization.parent": "Induk Organisasi",
  "organization.previous": "Halaman sebelumnya",
  "organization.search.byorgname": "Cari berdasarkan Nama Organisasi",
  "organization.search.parent.name": "Nama Organisasi Induk",
  "organization.search.placeHolder": "Cari berdasarkan Nama Organisasi...",
  "organization.select": "Pilih",
  "organization.short.CI": "Prefiks Organisasi",
  "organization.streetAddress": "Nama Jalan",
  "organization.type.CI": "Jenis Kegiatan",
  "organization.type.CI.description": "Jenis Kegiatan: Deskripsi",
  "organization.type.CI.name": "Jenis Kegiatan: Nama",
  "organization.type.CI.select": "Jenis Kegiatan: Pilih",
  "otherMalignant.placeholder": "Keganasan lainnya",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Kembali",
  "pagination.backward": "Halaman Sebelumnya",
  "pagination.forward": "Halaman Berikutnya",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} dari {total} barang",
  "pagination.items-on-page": "{count} {count, plural, one {item} other {items}} on this page",
  "pagination.items-per-page": "Item per halaman",
  "pagination.itemsPerPage": "Item per halaman:",
  "pagination.nextPage": "Halaman berikutnya",
  "pagination.page": "Halaman {page}",
  "pagination.page-number": "Nomor Halaman",
  "pagination.page-range": "dari {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Halaman sebelumnya",
  "panel.existing": "Panel yang ada",
  "panel.existing.inactive": "Panel Inaktif (tugaskan pemeriksaan untuk mengaktifkan)",
  "panel.new": "Panel Baru",
  "panel.panelName": "Nama Panel",
  "pathology.label.addblock": "Tambah Blok",
  "pathology.label.addslide": "Tambah Slide",
  "pathology.label.block": "Blok",
  "pathology.label.block.add.number": "Jumlah Blok untuk ditambah",
  "pathology.label.block.number": "Nomor Blok",
  "pathology.label.blocks": "Blok",
  "pathology.label.casesInProgress": "Kasus dalam Pengerjaan",
  "pathology.label.complete": "Selesai",
  "pathology.label.conclusion": "Kesimpulan",
  "pathology.label.dashboard": "Dasbor Patologi",
  "pathology.label.grossexam": "Pemeriksaan Umum",
  "pathology.label.location": "Lokasi",
  "pathology.label.microexam": "Pemeriksaan Mikroskopis",
  "pathology.label.printlabel": "Cetak Label",
  "pathology.label.refer": "Rujuk ke Imunohistokimia",
  "pathology.label.release": "Siap untuk dirilis",
  "pathology.label.report": "Laporan Patologi",
  "pathology.label.request": "Permintaan",
  "pathology.label.requests": "Permintaan Patologi Tambahan",
  "pathology.label.review": "Menunggu Tinjauan Patologi",
  "pathology.label.slide": "Slide",
  "pathology.label.slide.add.number": "Jumlah Slide untuk ditambah",
  "pathology.label.slide.number": "Nomor Slide",
  "pathology.label.slides": "Slide",
  "pathology.label.stage": "Tahapan",
  "pathology.label.techniques": "Teknik yang digunakan",
  "pathology.label.textconclusion": "Teks kesimpulan",
  "pathology.label.title": "Patologi",
  "pathology.label.view": "Lihat File",
  "pathology.stage.accessioned": "Accessioned",
  "pathology.stage.completed": "Selesai",
  "pathology.stage.coverslipping": "Coverslipping & QC",
  "pathology.stage.decalcification": "Decalcification",
  "pathology.stage.embedding": "Embedding",
  "pathology.stage.grossing": "Grossing",
  "pathology.stage.microtomy": "Microtomy",
  "pathology.stage.processing": "Pemrosesan",
  "pathology.stage.readyPathologist": "Ready for Pathologist",
  "pathology.stage.staining": "Staining",
  "pathology.stage.underReview": "Under Pathologist Review",
  "patient.address.camp": "Kelompok/Komunitas",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "Kabupaten",
  "patient.address.healthregion": "Kecamatan",
  "patient.address.province": "Propinsi",
  "patient.address.street": "Jalan",
  "patient.address.town": "Kota",
  "patient.age.days": "Hari",
  "patient.age.months": "Bulan",
  "patient.age.years": "Umur/Tahun",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nama Sumber Data",
  "patient.dob": "Tanggal Lahir",
  "patient.eduction": "Pendidikan",
  "patient.emergency.additional.camp": "Masukkan Kelompok/Komunitas",
  "patient.emergency.additional.district": "Masukkan Kabupaten",
  "patient.emergency.additional.education": "Masukkan Pendidikan",
  "patient.emergency.additional.maritalstatus": "Masukkan Status Pernikahan",
  "patient.emergency.additional.nationnality": "Masukkan Kewarganegaraan",
  "patient.emergency.additional.othernationality": "Masukkan Kewarganegaraan Lain",
  "patient.emergency.additional.region": "Masukkan Daerah",
  "patient.emergency.additional.street": "Masukkan Nama Jalan",
  "patient.emergency.additional.town": "Masukkan Kota",
  "patient.emergency.email": "Masukkan Email Kontak Darurat",
  "patient.emergency.firstname": "Masukkan Nama Depan Kontak Darurat",
  "patient.emergency.lastname": "Masukkan Nama Belakang Kontak Darurat",
  "patient.emergency.phone": "Masukkan Nomor Telepon Kontak Darurat",
  "patient.externalId": "Identitas eksternal",
  "patient.female": "Perempuan",
  "patient.first.name": "Nama Depan",
  "patient.gender": "Jenis Kelamin",
  "patient.gps.latitude": "Garis Lintang GPS",
  "patient.gps.latitude.placeholder": "mis., -18.879190 (rentang -90 sampai 90)",
  "patient.gps.longitude": "Garis bujur GPS",
  "patient.gps.longitude.placeholder": "mis., 47.507905 (rentang -180 sampai 180)",
  "patient.id": "Identitas Pasien",
  "patient.information.age": "Masukkan Umur",
  "patient.information.days": "Masukkan Hari",
  "patient.information.email": "Masukkan Email Pasien",
  "patient.information.firstname": "Masukkan Nama Depan Pasien",
  "patient.information.healthid": "Masukkan Pengidentifikasi Kesehatan Unik",
  "patient.information.lastname": "Masukkan Nama Belakang Pasien",
  "patient.information.months": "Masukkan Bulan",
  "patient.information.nationalid": "Masukkan NIK",
  "patient.information.primaryphone": "Masukkan Nomor Utama Pasien",
  "patient.label": "Pasien",
  "patient.label.additionalInfo": "Informasi Tambahan",
  "patient.label.age": "Umur",
  "patient.label.customNotes": "Catatan Kostum",
  "patient.label.diseaseProgramme": "Program Penyakit Target",
  "patient.label.occupation": "Pekerjaan",
  "patient.label.contactphone": "Nomor Telepon Kontak:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Informasi Pasien",
  "patient.label.modify": "Tambah atau Modifikasi Pasien",
  "patient.label.name": "Nama",
  "patient.label.nopatientid": "Informasi Pasien Tidak Tersedia",
  "patient.label.primaryphone": "Nomor Telepon Utama:{PHONE_FORMAT}",
  "patient.label.sex": "Jenis Kelamin",
  "patient.last.name": "Nama Belakang",
  "phone.format.international.label": "Internasional",
  "phone.format.local.label": "Lokal",
  "patient.male": "Laki-Laki",
  "patient.maritalstatus": "Status Pernikahan",
  "patient.merge.activeOrders": "Permintaan Aktif",
  "patient.merge.address": "Alamat",
  "patient.merge.addressesDiffer": "Alamat berbeda: {primary} vs {secondary}",
  "patient.merge.auditEntries": "Audit Entri (menyimpan data pasien asli)",
  "patient.merge.back": "Kembali",
  "patient.merge.cancelButton": "Batal",
  "patient.merge.clinicalSummary": "Ringkasan Klinis",
  "patient.merge.confirmButton": "Konfrimasi Penggabungan",
  "patient.merge.confirmCheckbox": "Saya memahami bahwa aksi ini tidak dapat dibatalkan dan telah memverifikasi bahwa pasien yang benar sedang digabungkan.",
  "patient.merge.confirmMerge": "Konfirmasi Penggabungan Pasien",
  "patient.merge.conflictNote": "(Demografi pasien primer akan digunakan)",
  "patient.merge.conflictingInfo": "Konflik Informasi terdeteksi",
  "patient.merge.contactInfo": "Informasi Kontak",
  "patient.merge.county": "Provinsi",
  "patient.merge.dataToConsolidate": "Data yang akan Dikonsolidasi",
  "patient.merge.demographics": "Demografi",
  "patient.merge.dob": "Tanggal lahir",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email berbeda: {primary} vs {secondary}",
  "patient.merge.error.alreadyMerged": "Pasien sudah tergabung",
  "patient.merge.error.executionFailed": "Eksekusi penggabungan gagal",
  "patient.merge.error.noPermission": "Hanya Administrator Global yang dapat melakukan penggabungan pasien",
  "patient.merge.error.patientNotFound": "Pasien tidak ditemukan",
  "patient.merge.error.samePatient": "Tidak dapat menggabung pasien yang sama",
  "patient.merge.error.selectBoth": "Pilih kedua pasien untuk melanjutkan",
  "patient.merge.error.selectPrimary": "Pilih pasien yang akan menjadi rekaman primer",
  "patient.merge.error.validationFailed": "Validasi penggabungan gagal",
  "patient.merge.externalIds": "Identitas Eksternal",
  "patient.merge.gender": "Jenis Kelamin",
  "patient.merge.identifiers": "Pengidentifikasi",
  "patient.merge.identifiersToPreserve": "Pengidentifikasi yang Perlu Disimpan (semua pasien)",
  "patient.merge.mergeSummary": "Ringkasan Penggabungan",
  "patient.merge.mergingFrom": "Penggabungan Dari",
  "patient.merge.mergingLabel": "Menggabungkan",
  "patient.merge.name": "Nama",
  "patient.merge.nationalId": "NIK",
  "patient.merge.nationalIds": "NIK",
  "patient.merge.nextStep": "Langkah Berikutnya",
  "patient.merge.noIdentifiers": "Pengidentifikasi tidak ditemukan",
  "patient.merge.noPatientSelected": "Tidak ada Pasien yang dipilih",
  "patient.merge.notRecorded": "Tidak terekam",
  "patient.merge.orders": "Permintaan",
  "patient.merge.ordersCount": "{count} ({active} aktif)",
  "patient.merge.patientId": "Nomor Identitas Pasien",
  "patient.merge.patientIds": "Nomor Identitas Pasien",
  "patient.merge.patientResults": "Hasil Pasien",
  "patient.merge.phone": "Telepon",
  "patient.merge.phonesDiffer": "Nomor Telepon berbeda: {primary} vs {secondary}",
  "patient.merge.postalCode": "Kode Pos",
  "patient.merge.primaryLabel": "Primer",
  "patient.merge.primaryPatient": "Pasien Primer",
  "patient.merge.reason": "Alasan penggabungan (wajib)",
  "patient.merge.reasonPlaceholder": "Masukan alasan penggabungan rekaman pasien",
  "patient.merge.recordsReassigned": "{count} rekaman yang ditugaskan",
  "patient.merge.samples": "Sampel",
  "patient.merge.searchDifferent": "Cari pasien yang berbeda",
  "patient.merge.selectFirstPatient": "Pilih Pasien Pertama",
  "patient.merge.selectPrimaryDescription": "Pasien yang mana akan menjadi rekaman primer?",
  "patient.merge.selectPrimaryRecord": "Pilih Rekaman Pasien Primer",
  "patient.merge.selectSecondPatient": "Pilih Pasien Kedua",
  "patient.merge.step.compare": "Pilih Primer",
  "patient.merge.step.confirm": "Konfirmasi Penggabungan",
  "patient.merge.step.select": "Pilih Pasien",
  "patient.merge.streetAddress": "Nama Jalan",
  "patient.merge.success": "Penggabungan pasien sukses",
  "patient.merge.successMessage": "Pasien {mergedId} telah digabungkan dengan pasien {primaryId}. Audit ID: {auditId}",
  "patient.merge.testResults": "Hasil Pemeriksaan",
  "patient.merge.title": "Gabung Rekaman Pasien",
  "patient.merge.totalContacts": "Kontak",
  "patient.merge.totalRelations": "Hubungan",
  "patient.merge.totalResults": "Hasil Total",
  "patient.merge.totalSamples": "Sampel",
  "patient.merge.town": "Kabupaten/Kota",
  "patient.merge.tryDifferentSearch": "Atur kriteria pencarian atau gunakan pengidentifikasi pasien yang lain.",
  "patient.merge.warning.dataLink": "Semua data berikutnya akan terkait dengan pasien primer. Pasien yang tidak dipilih akan ditandai sebagai penggabungan dan inaktif.",
  "patient.merge.warning.irreversible": "Aksi ini TIDAK BISA dibatalkan. Semua data akan dikonsolidasi permanen.",
  "patient.merge.warning.samePatient": "Pasien yang sama telah dipilih",
  "patient.merge.warning.samePatientDescription": "Anda telah memilih pasien yang sama. Silahkan pilih dua pasien yang berbeda untuk digabunngkan.",
  "patient.natioanalid": "NIK",
  "patient.nationalid": "NIK",
  "patient.nationality": "Kewarganegaraan",
  "patient.nationality.other": "Tuliskan Kewarganegaraan lainnya",
  "patient.photo.active.camera": "Klik untuk mengaktifkan kamera",
  "patient.photo.add": "Tambah Foto",
  "patient.photo.browse": "Klik untuk mencari file",
  "patient.photo.camera.permission.denied": "Izin akses kamera ditolak. Silakan periksa pengaturan browser Anda.",
  "patient.photo.cancel": "Batal",
  "patient.photo.capture": "Ambil Foto",
  "patient.photo.captured": "Foto yang diambil:",
  "patient.photo.change": "Ganti Gambar",
  "patient.photo.confirm": "Konfirmasi",
  "patient.photo.dragndrop": "Seret dan lepas gambar di sini",
  "patient.photo.error.fileTooLarge": "Gambar terlalu besar. Ukuran maksimum 2 MB.",
  "patient.photo.formats": "Format: JPG, PNG (maks 1MB)",
  "patient.photo.import": "Impor",
  "patient.photo.label": "Foto Pasien",
  "patient.photo.modal.heading": "Pilih Foto Pasien",
  "patient.photo.modal.options": "Opsi Pilihan Gambar",
  "patient.photo.preview": "Pratinjau:",
  "patient.photo.preview.alt": "Pratinjau Foto Pasien",
  "patient.photo.preview.captured.alt": "Foto pasien yang diambil",
  "patient.photo.retake": "Pengambilan ulang",
  "patient.photo.start.camera": "Buka Kamera",
  "patient.photo.take": "Ambil Foto",
  "patient.photo.view": "Lihat Foto",
  "patient.idDoc.title": "Dokumen Identitas",
  "patient.idDoc.addDocument": "Tambah Dokumen",
  "patient.idDoc.selectImage": "Pilih Gambar",
  "patient.idDoc.documentType": "Jenis Dokumen",
  "patient.idDoc.description": "Deskripsi",
  "patient.idDoc.description.placeholder": "Masukkan deskripsi dokumen",
  "patient.idDoc.category.nationalId": "NIK",
  "patient.idDoc.category.insuranceCard": "Kartu Asuransi",
  "patient.idDoc.category.other": "Lainnya",
  "patient.idDoc.view": "Lihat",
  "patient.idDoc.edit": "Sunting",
  "patient.idDoc.delete": "Hapus",
  "patient.idDoc.remove": "Hapus",
  "patient.idDoc.pending": "Tidak tersimpan",
  "patient.idDoc.empty": "Tidak ada dokumen identitas diunggah",
  "patient.idDoc.viewDocument": "Lihat Dokumen",
  "patient.idDoc.editDocument": "Edit Dokumen",
  "patient.idDoc.confirmDelete": "Hapus Dokumen",
  "patient.idDoc.deleteWarning": "Apakah Anda yakin akan menghapus dokumen ini? Aksi ini tidak dapat dibatalkan.",
  "patient.idDoc.upload": "Unggah",
  "patient.idDoc.dragndrop": "Seret dan lepas gambar di sini",
  "patient.idDoc.browse": "atau klik untuk mencari file",
  "patient.idDoc.formats": "Format: JPEG, PNG, PDF (maks 10MB)",
  "patient.idDoc.useCamera": "Buka Kamera",
  "patient.idDoc.pdfSelected": "Dokumen PDF dipilih",
  "patient.idDoc.error.invalidFormat": "Format file invalid. Format yang didukung: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File terlalu besar. Ukuran maksimum 10MB.",
  "patient.prev.lab.no": "Nomor Registrasi sebelumnya",
  "patient.report.associated.name": "Laporan Pasien Lainnya",
  "patient.report.collection.name": "Kumpulan Laporan Pasien ARV",
  "patient.search.nopatient": "Pasien yang dicari tidak ditemukan",
  "patient.st.number": "Nomor ST",
  "patient.subject.number": "Nomor Pengidentifikasi Kesehatan Unik",
  "patient.yrs": "tahun",
  "patientcontact.person.email": "Email Kontak",
  "patientcontact.person.firstname": "Nama Depan Kontak",
  "patientcontact.person.lastname": "Nama Belakang Kontak",
  "placeholder.accession.number": "Masukkan Nomor Registrasi",
  "print.barcode": "Cetak Kode QR",
  "process.testAdd.pressNext.ageRangeSelectiong": "Tekan tombol Berikutnya. Pemilihan Rentang Usia tidak diperlukan!",
  "process.testAdd.pressNext.selectGroupDictionary": "Tekan tombol Berikutnya. Langkah Memilih Grup Daftar Kamus tidak diperlukan!",
  "program.name.label": "Nama Program",
  "project.ARVFollowupStudy.name": "Tindak lanjut ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV Awal",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Tidak ditentukan",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Pemeriksaan Terkini",
  "project.SequencingStudy.name": "Sekuensing",
  "project.SpecialRequestStudy.name": "Permintaan Khusus",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Tambah Proyek",
  "project.add.title": "Tambah Proyek",
  "project.browse.title": "Proyek",
  "project.completedDate": "Tanggal Selesai",
  "project.desc.short": "Deksripsi Proyek",
  "project.description": "Deskripsi Proyek",
  "project.edit.subtitle": "Edit Proyek",
  "project.edit.title": "Edit Proyek",
  "project.external.reference": "Rujukan Eksternal",
  "provider.browse.title": "Pengelolaan Penyelenggara",
  "provider.email": "Email",
  "provider.fax": "No. Telp",
  "provider.isActive": "Adalah Aktif",
  "provider.modal.add.heading": "Tambah Penyelenggara",
  "provider.modal.update.heading": "Perbarui Penyelenggara",
  "provider.providerFirstName": "Nama Depan Penyelenggara",
  "provider.providerLastName": "Nama Belakang Penyelenggara",
  "provider.search": "Cari Penyelenggara",
  "provider.search.placeholder": "Cari Nama Penyelenggara...",
  "provider.select": "Pilih Penyelenggara",
  "provider.telephone": "Nomor Telepon",
  "qa.checklist.incomplete": "Daftar centang QA tidak lengkap",
  "qa.checklist.instructions": "Selesaikan semua centang yang diperlukan sebelum mengirim",
  "qa.checklist.samplingSiteCorrect": "Informasi tempat pengambilan sampel sudah benar",
  "qa.checklist.title": "Daftar centang QA",
  "qa.summary.noSamples": "Tidak ada sampel untuk ditinjau",
  "qa.summary.noTests": "Tidak ada pengujian yang dipilih",
  "qa.summary.order": "Rincian Pemesanan",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Informasi Pasien",
  "qa.summary.poolOf": "Kumpulan foto {count} {animal}",
  "qa.summary.samples": "Ringkasan Sampel",
  "qa.summary.samplingSite": "Tempat Pengambilan Sampel",
  "qa.summary.siteCode": "Kode Tempat",
  "qa.summary.siteName": "Nama Tempat",
  "qc.comments.add": "Tambah Komentar",
  "qc.comments.empty": "Belum ada komentar",
  "qc.comments.placeholder": "Masukkan komentar QC...",
  "qc.comments.title": "Komentar QC",
  "qc.expectedValue": "Nilai yang Diharapkan",
  "qc.frequency.compliance": "Metrik Kepatuhan",
  "qc.frequency.config": "Konfigurasi Frekuensi QC",
  "qc.frequency.daily": "Startup Harian",
  "qc.frequency.everyHours": "Setiap N Jam",
  "qc.frequency.everySamples": "Setiap N Sampel",
  "qc.frequency.manual": "Hanya Trigger Manual",
  "qc.frequency.notConfigured": "Tidak dikonfigurasi",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "SImpan Konfigurasi",
  "qc.frequency.type": "Jenis Frekuensi",
  "qc.frequency.value": "Nilai Frekuensi",
  "qc.leveyJennings.mean": "Rata-rata",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "Tidak ada QC data tersedia",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Bagan Control Charts Levey-Jennings",
  "qc.notes": "Catatan QC",
  "qc.notes.placeholder": "Masukkan catatan dan pengamatan QC",
  "qc.parentSample": "Sampel Induk",
  "qc.signature.comment": "Komentar (opsional)",
  "qc.signature.comment.placeholder": "Tambah komentar...",
  "qc.signature.ipAddress": "Alamat IP",
  "qc.signature.noSignatures": "Belum ada tanda tangan",
  "qc.signature.sign": "Tanda tangan Laporan",
  "qc.signature.signedAt": "Waktu Tanda Tangan",
  "qc.signature.success": "Laporan berhasil ditandatangani",
  "qc.signature.title": "Tanda Tangan Elektronik",
  "qc.signature.userId": "ID Pengguna",
  "qc.status": "Status QC",
  "qc.status.failed": "Gagal",
  "qc.status.notRequired": "Tidak Wajib",
  "qc.status.passed": "Lolos",
  "qc.status.pending": "QC tertunda",
  "qc.status.select": "Pilih Status QC",
  "qc.status.update.button": "Perbarui Status QC",
  "qc.status.update.success": "Status QC berhasil diperbarui",
  "qc.status.update.title": "Perbarui Status QC",
  "qc.status.warning.message": "Lot ini tidak dapat digunakan bila ditandai \"Gagal\", sampai status QC diperbarui.",
  "qc.status.warning.title": "Peringatan Kegagalan QC",
  "qc.westgard.noViolations": "Tidak ada pelanggaran terdeteksi",
  "qc.westgard.rule.disabled": "Dinonaktifkan",
  "qc.westgard.rule.enabled": "Diaktifkan",
  "qc.westgard.rules": "Westgard Rule",
  "qc.westgard.rules.description": "Konfigurasi evaluasi QC Westgard multi-rule",
  "qc.westgard.violations": "Pelanggaran",
  "quantity": "Kuantitas",
  "quantity.balanced": "Kuantitas Seimbang",
  "quantity.not.balanced": "Kuantitas tidak seimbang",
  "quick.entry.accession.number": "Nomor Registrasi",
  "referTest.referralLabel": "Rujuk Pemeriksaan ke lab rujukan",
  "referral.button.labSearch": "Cari Rujukan dengan Nomor Registrasi",
  "referral.button.patientSearch": "Cari Pasien",
  "referral.button.unitTestSearch": "Cari Rujukan Berdasarkan Instalasi Lab & Pemeriksaan",
  "referral.date.end": "Tanggal Selesai (dd/mm/yyyy)",
  "referral.date.start": "Tanggal Dimulai (dd/mm/yyyy)",
  "referral.emptyState": "Tidak ditemukan rujukan yang sesuai dengan filter yang dipilih.",
  "referral.error": "Tidak ada Rujukan yang cocok dengan kriteria",
  "referral.input": "Pindai atau Masukkan Manual",
  "referral.label.institute": "Lembaga",
  "referral.label.reason": "Alasan Merujuk",
  "referral.label.referredOutTests": "Pemeriksaan yang dirujuk ke luar",
  "referral.label.sentdate": "Tanggal Dikirim",
  "referral.label.testmethod": "Metode",
  "referral.label.testtoperform": "Pemeriksaan yang Dilakukan",
  "referral.main.button": "Cari Rujukan berdasarkan Pasien",
  "referral.matching.search": "Pencarian Kecocokan Pemeriksaan Rujukan",
  "referral.out.head": "Rujukan",
  "referral.out.note": "Catatan: Jika pencarian dilakukan berdasarkan tanggal hasil, maka hanya pemeriksaan yang ada hasilnya yang akan muncul.",
  "referral.out.request": "Hasil berdasarkan Tanggal / Pemeriksaan / Jenis Tanggal Instalasi Lab:",
  "referral.print.selected.patient.reports": "Cetak Laporan Pasien yang Dipilih",
  "referral.print.selected.patient.reports.selectall.button": "Pilih Semua",
  "referral.print.selected.patient.reports.selectnone.button": "Kosongkan Pilihan",
  "referral.result.labNumber": "Hasil berdasarkan Nomor Registrasi",
  "referral.result.referenceRange": "Rentang referensi",
  "referral.search": "Cari",
  "referral.search.column.analysisId": "ID Analisis",
  "referral.search.column.referenceLab": "Lab Rujukan",
  "referral.search.column.resultDate": "Tanggal Hasil",
  "referral.search.column.sentDate": "Tanggal Dikirim",
  "referral.test": "Pemeriksaan",
  "referral.testresult.pastnote": "Catatan Sebelumnya",
  "referral.units": "Unit",
  "referrer.label": "Perujuk",
  "reflexTests": "Pemeriksaan Refleks",
  "reject.action.button": "Penolakan",
  "reject.order.sample.notification": "Anda menolak sampel. Sampel ini akan ditolak dan tidak akan muncul dalam rencana kerja setelah disimpan, tidak ada hasil yang dapat dimasukkan untuk pemesanan ini.",
  "remaining.quantity": "Kuantitas sisa:",
  "remove.aliquot": "Hapus Alikuot",
  "report.enter.labNumber.headline": "Buat laporan atau semua laporan dalam rentang tertentu berdasarkan Nomor Permintaan / Nomor Registrasi",
  "report.enter.patient.headline": "Buat Semua Laporan untuk Klien tertentu",
  "report.enter.patient.headline.description": "Cari pasien melalui nomor registrasi sebelumnya, ID Pasien (yang dapat berupa nomor ID Kesehatan Unik atau NIK) atau bidang lainnya.",
  "report.enter.site.headline": "Buat Laporan berdasarkan Tempat",
  "report.labe.byLabNumber": "Laporan berdasarkan Nomor Registrasi",
  "report.labe.byPatient": "Laporan berdasarkan Pasien",
  "report.labe.date": "Laporan berdasarkan Tanggal",
  "report.labe.site": "Laporan berdasarkan Tempat",
  "report.label.site.dateType": "Jenis Tanggal",
  "report.label.site.onlyResults": "Hanya Laporan yang ada hasil",
  "report.patient.site.description": "Buat laporan berdasarkan tanggal hasil atau tanggal permintaan. Tanggal hasil hanya akan menampilkan laporan dengan hasil. Jika Anda hanya memilih laporan dengan hasil, maka semua laporan untuk pemeriksaan yang dalam pengerjaan tidak akan dibuat.",
  "report.select.site": "Pilih Tempat",
  "report.select.studttype": "Pilih Jenis Kajian",
  "reporting.label.testName": "Nama Pemeriksaan yang dilaporkan",
  "reports.auditTrail": "Jejak Audit",
  "reports.systemAuditTrail": "Jejak Audit Sistem",
  "reports.button": "Membuat Laporan",
  "reports.dateRange": "Rentang Tanggal",
  "reports.endDate": "Tanggal Selesai",
  "reports.error.dateRangeRequired": "Rentang tanggal wajib untuk jenis laporan ini",
  "reports.error.generationFailed": "Gagal membuat laporan. Silahkan coba lagi.",
  "reports.error.invalidDate": "Invalid date",
  "reports.error.invalidDateRange": "Tanggal selesai harus setelah tanggal mulai",
  "reports.error.unknownExportFormat": "Unknown export format",
  "reports.error.unknownReportType": "Unknown report type",
  "reports.export": "Ekspor",
  "reports.export.byDate": "Ekspor berdasarkan Tanggal",
  "reports.export.byDate_routine": "Laporan CSV Rutin",
  "reports.export.general": "Ekspor umum",
  "reports.export.specific": "Ekspor Data Viral Load",
  "reports.export.valid": "Validasi",
  "reports.export.whonet": "Laporan WHONET",
  "reports.followupRequired.byLocation": "Diperlukan Tindak Lanjut",
  "reports.format": "Format Ekspor",
  "reports.format.select": "Pilih format",
  "reports.generate.title": "Membuat Laporan Inventaris",
  "reports.generating": "Membuat...",
  "reports.generation.success": "Laporan berhasil dibuat dan diunduh",
  "reports.groupByLocation": "Kelompokkan berdasarkan lokasi penyimpanan",
  "reports.groupByType": "Kelompokkan berdasarkan jenis barang",
  "reports.grouping": "Opsi Pengelompokan",
  "reports.help.description": "Laporan ini untuk menganalisis data inventaris Anda:",
  "reports.help.tip1": "Rentang tanggal untuk analisis kecenderungan",
  "reports.help.tip2": "Kelompokkan berdasarkan jenis atau lokasi agar lebih mudah dipahami",
  "reports.help.tip3": "Ekspor ke Excel untuk analisis lebih lanjut",
  "reports.help.title": "Tips Pelaporan",
  "reports.includeExpired": "Sertakan lot kedaluwarsa",
  "reports.includeInactive": "Sertakan barang inaktif",
  "reports.info.message": "Pilih jenis dan pilihan laporan di bawah. Pembuatan laporan memerlukan waktu.",
  "reports.info.title": "Pembuatan Laporan",
  "reports.label.cistudyexport": "Laporan Umum",
  "reports.label.indicator": "Indikator",
  "reports.label.indicator.performance": "Kinerja Bagian",
  "reports.label.referred.out": "Laporan Pemeriksaan yang dirujuk ke luar",
  "reports.label.trends": "Tren",
  "reports.menu.covid": "Laporan Covid",
  "reports.nonConformity.byDate.report": "Berdasarkan Tanggal",
  "reports.nonConformity.byLabno.report": "Berdasarkan No Lab",
  "reports.nonConformity.bySectionReason.report": "Berdasarkan Unit dan Alasan",
  "reports.nonConformity.bySectionReason.title": "Laporan Ketidaksesuaian berdasarkan Unit dan Alasan",
  "reports.nonConformity.menu": "Laporan Ketidaksesuaian",
  "reports.nonConformity.notification.report": "Notifikasi Ketidaksesuaian",
  "reports.nonConformity.notification.report.instructions": "Jika layanan dipilih, maka semua notifikasi ketidaksesuaian yang belum dicetak akan dicetak. Jika tidak ada layanan yang tercantum, maka semua pemberitahuan telah dicetak. Dengan memasukkan nomor registrasi, maka Anda akan mencetak notifikasi meskipun sebelumnya telah dicetak. Layanan ini tidak harus dipilih.",
  "reports.options": "Opsi Filter",
  "reports.patient.ARV.version1": "ARV-Versi",
  "reports.patient.ARV.version1 ": "ARV-Versi 1",
  "reports.patient.ARVFollowup.version1": "ARV Tindak Lanjut Versi 1",
  "reports.patient.ARVFollowup.version2": "ARV Tindak Lanjut Versi 2",
  "reports.patient.ARVInitial.version1": "ARV Awal Versi 1",
  "reports.patient.ARVInitial.version2": "ARV Awal Versi 2",
  "reports.patient.Indeterminate.location": "Indeterminate berdasarkan Layanan",
  "reports.patient.Indeterminate.version1": "Indeterminate Versi 1",
  "reports.patient.Indeterminate.version2": "Indeterminate Versi 2",
  "reports.startDate": "Tanggal Mulai",
  "reports.type": "Jenis Laporan",
  "reports.type.expirationForecast": "Prakiraan Kedaluwarsa",
  "reports.type.expirationForecast.description": "Barang yang akan kedaluwarsa dalam rentang waktu tersebut",
  "reports.type.lotTraceability": "Ketertelusuran Lot",
  "reports.type.lotTraceability.description": "Ketertelusuran lengkap pergerakan dan penggunaan lot.",
  "reports.type.lowStock": "Peringatan Stok Sedikit",
  "reports.type.lowStock.description": "Barang yang di bawah level stok minimum",
  "reports.type.select": "Pilih jenis laporan",
  "reports.type.stockLevels": "Laporan Level Stok",
  "reports.type.stockLevels.description": "Level stok saat ini untuk semua barang inventaris",
  "reports.type.transactionHistory": "Riwayat Transaksi",
  "reports.type.transactionHistory.description": "Semua transaksi dalam kurun tanggal",
  "reports.type.usageTrends": "Kecenderungan Penggunaan",
  "reports.type.usageTrends.description": "Pola penggunaan dan kecenderungan konsumsi seiring waktu",
  "request.samesite.order": "Masukan permintaan dari tempat yang sama",
  "requester.label": "Pemohon",
  "required.invalidtext": "FIeld ini wajib",
  "result.acceptasis.warning": "Dengan mencentang kotak ini berarti Anda menerima hasilnya tanpa syarat. \nHal ini dapat berarti:\n1. Pemeriksaan sudah diulang dan hasilnya sama.\n2. Tidak ada hasil, tapi tidak ingin membatalkan pemeriksaan.\n3. Ada perubahan hasil, dan ingin memberi opsi agar petugas dapat mencantumkan catatan perubahan untuk petugas di tahap validasi.\nAlasan mengapa aksi ini dilakukan harus dicantumkan.\n",
  "result.acceptasis.trigger": "Terima",
  "result.acceptasis.reason.label": "Alasan untuk penerimaan tanpa syarat",
  "result.acceptasis.reason.placeholder": "Wajib — mis. diuji ulang dua kali dengan hasil yang sama, atau tidak ada hasil tersedia",
  "result.acceptasis.confirm": "Konfirmasi penerimaan",
  "result.acceptasis.cancel": "Batal",
  "result.acceptasis.committed": "Diterima",
  "result.acceptasis.undo": "Batal",
  "result.entry.error.accessionRequired": "Silahkan masukkan nomor registrasi",
  "result.entry.error.title": "Kesalahan",
  "result.entry.info.title": "Informasi",
  "result.entry.label": "Entri Hasil",
  "result.entry.noResults": "Tidak ada sampel ditemukan untuk nomor registrasi {accessionNumber}",
  "result.entry.noTestsFound": "Tidak ada pemeriksaan dengan hasil tertunda ditemukan untuk nomor registrasi {accessionNumber}",
  "result.entry.results.accessionNumber": "Nomor Registrasi",
  "result.entry.results.sampleCount": "Sampel",
  "result.entry.results.testCount": "Pemeriksaan",
  "result.entry.results.title": "Hasil Pemeriksaan Tertunda",
  "result.entry.saveSuccess": "Hasil disimpan untuk {testName}",
  "result.entry.search.accessionLabel": "Nomor Registrasi",
  "result.entry.search.accessionPlaceholder": "Masukkan nomor registrasi...",
  "result.entry.search.button": "Cari",
  "result.entry.search.searching": "Mencari...",
  "result.entry.search.title": "Cari berdasarkan Nomor Registrasi",
  "result.entry.success.title": "Berhasil",
  "result.entry.table.action": "Aksi",
  "result.entry.table.header.sampleId": "Nomor Identitas Sampel",
  "result.entry.table.header.sampleType": "Jenis Sampel",
  "result.entry.table.header.testCount": "Pemeriksaan",
  "result.entry.table.noSamples": "Tidak ditemukan sampel dengan pemeriksaan",
  "result.entry.table.noTests": "Tidak ada pemeriksaan untuk sampel ini",
  "result.entry.table.result": "Hasil",
  "result.entry.table.resultPlaceholder": "Masukkan hasil",
  "result.entry.table.save": "Simpan",
  "result.entry.table.saving": "Menyimpan...",
  "result.entry.table.status": "Status",
  "result.entry.table.testName": "Nama Pemeriksaan",
  "result.entry.table.testsTitle": "Pemeriksaan ({count})",
  "result.entry.title": "Entri Hasil",
  "result.noTestsFound": "Tidak ditemukan pemeriksaan yang tepat.",
  "result.nonconforming.item": "Sampel atau permintaan tidak sesuai ATAU telah ditolak",
  "result.outOfValidRange.msg": "Nilai yang Anda masukkan (kolom merah) berada di luar rentang nilai yang diizinkan. Silakan periksa nilainya.",
  "result.notNumeric.msg": "{test}: \"{value}\" is not a number. Enter a plain decimal or scientific notation such as 1.5e5 or 1.5 x 10^5, then save again.",
  "result.reject.warning": "Penolakan hasil bersifat permanen. \nHasil tidak akan tersedia lagi.",
  "result.report.queue.size": "Jumlah Antrian :",
  "result.search.noresult": "Hasil tidak ditemukan",
  "resultreporting.browse.title": "Konfigurasi Pelaporan Hasil",
  "resultreporting.config.url": "URL situs untuk mengirim hasil. Contohnya http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Rujuk pemeriksaan ke lab rujukan",
  "routine.reports": "Laporan Rutin",
  "rulebuilder.error.invalidNumeric": "Nomor Numerik Tidak Valid",
  "rulebuilder.error.invalidTest": "Pemeriksaan Tidak Valid",
  "rulebuilder.label.add.externaltrigger": "Masukkan pesan eksternal `dipicu oleh`",
  "rulebuilder.label.add.internaltrigger": "Masukkan pesan internal `dipicu oleh` message",
  "rulebuilder.label.addAction": "Tambah Aksi",
  "rulebuilder.label.addCondition": "Tambah Kondisi",
  "rulebuilder.label.addExternalNote": "Tambah Catatan Eksternal",
  "rulebuilder.label.addInternalNote": "Tambah Catatan Internal",
  "rulebuilder.label.addPopup": "Tambah Pop Up",
  "rulebuilder.label.addRule": "Tambah Aturan",
  "rulebuilder.label.addRuleConditions": "Tambah Kondisi Aturan Refleks",
  "rulebuilder.label.confirmDelete": "Apakah Anda ingin menonaktifkan Aturan ini?",
  "rulebuilder.label.dictValue": "Nilai Kamus",
  "rulebuilder.label.noSuggestions": "Tidak ada saran tersedia",
  "rulebuilder.label.numericValue": "Nilai Numerik",
  "rulebuilder.label.numericValue2": "Nilai Numerik 2",
  "rulebuilder.label.overallOptions": "Semua Opsi",
  "rulebuilder.label.perfomActions": "Lakukan aksi berikut",
  "rulebuilder.label.relation": "Hubungan",
  "rulebuilder.label.removeAction": "Hapus Aksi",
  "rulebuilder.label.removeCondition": "Hapus Kondisi",
  "rulebuilder.label.removeRule": "Nonaktifkan Aturan",
  "rulebuilder.label.rule": "Aturan",
  "rulebuilder.label.ruleDetails": "Lihat Aturan",
  "rulebuilder.label.ruleName": "Nama Aturan",
  "rulebuilder.label.searchTest": "Cari Pemeriksaan",
  "rulebuilder.label.selectSample": "Pilih Sampel",
  "rulebuilder.label.textValue": "Nilai teks",
  "rulebuilder.label.toggleRule": "Alihkan Aturan",
  "sample.accession.number": "Aksesi Sampel",
  "sample.add.action": "Tambah Sampel",
  "sample.collection.date": "Tanggal Pengambilan",
  "sample.collection.method": "Metode Pengambilan",
  "sample.collection.method.placeholder": "mis., venipuncture, capillary, tubing",
  "sample.collection.time": "Waktu Pengambilan",
  "sample.currentDate": "Tanggal Saat Ini",
  "sample.requiredBy": "Wajib",
  "sample.specimen.origin": "Asal Spesimen (lab perujuk)",
  "sample.specimen.origin.placeholder": "Nama laboratorium perujuk",
  "sample.temperature": "Suhu Sampel",
  "sample.temperature.placeholder": "mis., suhu ruang, dibekukan, didinginkan",
  "sample.entry.available.tests": "Pemeriksaan Tersedia",
  "sample.entry.nextVisit.date": "Tanggal kunjungan berikutnya",
  "sample.entry.panels": "Panel",
  "sample.entry.project.patient.and.testName": "Nama/Kode pasien {br} Nama Pemeriksaan",
  "sample.entry.project.testName": "Nama Pemeriksaan",
  "sample.entry.search.barcode": "Cetak Kode QR untuk Permintaan yang Ada",
  "sample.id": "Nomor Identitas Sampel",
  "sample.item.info": "Informasi Sampel",
  "sample.items.for.accession": "Item Sampel untuk nomor registrasi:",
  "sample.label.accessionNumber": "Nomor Registrasi",
  "sample.label.collectionDate": "Tanggal Pengambilan",
  "sample.label.dept": "Ruang/Departmen/Unit",
  "sample.label.facility": "Lembaga Perujuk",
  "sample.label.labnumber": "Nomor Registrasi",
  "sample.label.labnumber.generate": "Buat",
  "sample.label.labnumber.new": "Nomor Registrasi Baru",
  "sample.labnumber.reassign.button": "Mengubah Nomor Registrasi",
  "sample.labnumber.reassign.confirm": "Menugaskan Kembali",
  "sample.labnumber.reassign.current": "Nomor Registrasi Saat Ini",
  "sample.labnumber.reassign.heading": "Mengubah Nomor Registrasi",
  "sample.labnumber.reassign.pending": "Spesimen ini akan dialihkan ke {number} saat Anda menyimpannya.",
  "sample.labnumber.reassign.pending.title": "Penetapan ulang nomor registrasi laboratorium tertunda",
  "sample.labnumber.reassign.undo": "Batal",
  "sample.labnumber.reassign.warning": "Penugasan ulang akan mengubah Nomor Registrasi spesimen ini secara permanen. Label, laporan, dan referensi yang ada yang mengacu pada nomor saat ini tidak akan lagi sesuai dengan nomor tersebut. Lakukan hal ini hanya untuk memperbaiki spesimen yang salah diberi label.",
  "sample.label.noorder": "Permintaan Tidak Ada",
  "sample.label.orderdate": "Tanggal Permintaan",
  "sample.label.orderpanel": "Panel Permintaan",
  "sample.label.requester": "Pemohon",
  "sample.label.search.Order": "Cari Permintaan",
  "sample.label.search.labnumber": "Cari berdasarkan Nomor Registrasi",
  "sample.label.search.patient": "Cari berdasarkan Pasien",
  "sample.label.typeOfSample": "Jenis Sampel",
  "sample.label.types": "Jenis Sampel",
  "sample.management.action.clearSelection": "Hapus Pilihan",
  "sample.management.action.createAliquot": "Buat Alikuot",
  "sample.management.action.selectAllAliquots": "Pilih Semua Alikuot",
  "sample.management.action.selectAllParents": "Pilih Semua Induk",
  "sample.management.addTests.button": "Tambah Pemeriksaan",
  "sample.management.addTests.error.addFailed": "Gagal menambah pemeriksaan. Silahkan coba lagi.",
  "sample.management.addTests.error.loadSampleTypes": "Error memuat jenis sampel",
  "sample.management.addTests.error.loadTests": "Error memuat pemeriksaan yang tersedia",
  "sample.management.addTests.error.noEligibleSamples": "Tidak dapat menambah pemeriksaan; semua sampel yang dipilih akan dipindahkan seluruhnya",
  "sample.management.addTests.error.noTests": "Silahkan pilih setidaknya satu pemeriksaan",
  "sample.management.addTests.modal.add": "Tambah Pemeriksaan",
  "sample.management.addTests.modal.addCount": "Menambah {count} Pemeriksaan",
  "sample.management.addTests.modal.adding": "Menambahkan...",
  "sample.management.addTests.modal.aliquotsIncluded": "alikuot dimasukkan",
  "sample.management.addTests.modal.bulkAliquotNote": "Pemeriksaan akan ditambahkan pada sampel yang dipilih termasuk alikuot.",
  "sample.management.addTests.modal.cancel": "Batal",
  "sample.management.addTests.modal.noEligibleSamples": "Tidak Ada Sampel yang Memenuhi Syarat",
  "sample.management.addTests.modal.noTestsAvailable": "Tidak ada pemeriksaan tersedia untuk jenis sampel ini.",
  "sample.management.addTests.modal.noTestsSelected": "Tidak ada pemeriksaan yang dipilih",
  "sample.management.addTests.modal.panels": "Panel",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Cari pemeriksaan...",
  "sample.management.addTests.modal.selectSampleType": "Jenis Sampel",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Silahkan pilih jenis sampel untuk mulai menampilkan panel dan pemeriksaan yang tersedia.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Pilih jenis sampel...",
  "sample.management.addTests.modal.selectTests": "Pilih Pemeriksaan",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Cari dan pilih pemeriksaan...",
  "sample.management.addTests.modal.selectedTests": "Pemeriksaan yang Dipilih",
  "sample.management.addTests.modal.subtitle": "Tambah pemeriksaan ke {count} sampel terpilih",
  "sample.management.addTests.modal.tests": "Pemeriksaan",
  "sample.management.addTests.modal.title": "Tambahkan Pemeriksaan ke Sampel",
  "sample.management.addTests.resultItem": "{sampleId}: {added} ditambahkan",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} ditambah, {skipped} dilewatkan",
  "sample.management.addTests.success": "{count} pemeriksaan telah berhasil ditambah",
  "sample.management.addTests.successDetailed": "{count} pemeriksaan ditambah ke sampel {samples}: {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} pemeriksaan ditambah ke sampel {samples}, {skipped} dilewatkan: {details}",
  "sample.management.addTests.successWithSkipped": "{added} pemeriksaan ditambah, {skipped} pemeriksaan dilewatkan (sudah dipesan)",
  "sample.management.addTests.title": "Tambah Pemeriksaan",
  "sample.management.addTests.warning.dispensedSamples": "{count} sampel yang tidak ada volume tersisa akan dilewatkan. Pemeriksaan akan ditambahkan pada {eligible} sampel yang memenuhi syarat.",
  "sample.management.addTests.warning.dispensedSamples.title": "Tidak termasuk sampel yang dipindahkan",
  "sample.management.aliquot.error.createFailed": "Gagal membuat alikuot. Silahkan coba lagi.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Jumlah alikuot harus antara 1 dan 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Kuantitas yang diminta ({requested}) melebihi yang tersisa ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Kuantitas per alikuot ({quantityPerAliquot}) akan kurang dari minimum (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Kuantitas harus lebih dari 0",
  "sample.management.aliquot.error.quantityRequired": "Kuantitas harus ada",
  "sample.management.aliquot.error.title": "Kesalahan",
  "sample.management.aliquot.modal.cancel": "Batal",
  "sample.management.aliquot.modal.create": "Buat Alikuot",
  "sample.management.aliquot.modal.createMultiple": "Buat {count} Alikuot",
  "sample.management.aliquot.modal.creating": "Membuat...",
  "sample.management.aliquot.modal.notesLabel": "Catatan (Opsional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Tambah catatan mengenai alikuot ini...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Masukkan jumlah alikuot bervolume sama yang akan dibuat (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Jumlah Alikuot",
  "sample.management.aliquot.modal.parentInfo": "Informasi Sampel Induk",
  "sample.management.aliquot.modal.preview": "Pratinjau",
  "sample.management.aliquot.modal.previewText": "Membuat {count} alikuot dengan kuantitas masing-masing {quantityEach} {unit}",
  "sample.management.aliquot.modal.quantityHelper": "Masukkan kuantitas untuk dipindahkan dalam {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Kuantitas yang akan Dipindahkan",
  "sample.management.aliquot.modal.quantityPlaceholder": "Masukkan kuantitas",
  "sample.management.aliquot.modal.subtitle": "Membuat alikuot dari sampel {externalId}",
  "sample.management.aliquot.modal.title": "Buat Alikuot",
  "sample.management.aliquot.modal.totalQuantityHelper": "Masukkan kuantitas total untuk dibagi ke alikuot dalam {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Total Kuantitas yang akan Dipindahkan",
  "sample.management.aliquot.success": "Alikuot {externalId} berhasil dibuat. Silahkan lakukan pencarian kembali untuk melihat pembaruan hasil.",
  "sample.management.aliquot.successMultiple": "{count} alikuot berhasil dibuat ({externalIds}). Silahkan lakukan pencarian kembali untuk melihat pembaruan hasil.",
  "sample.management.breadcrumb.title": "Pengelolaan Sampel",
  "sample.management.cancelTest.error": "Gagal membatalkan pemeriksaan. Silahkan coba lagi.",
  "sample.management.cancelTest.success": "Pemeriksaan \"{testName}\" berhasil dibatalkan",
  "sample.management.description": "Pencarian dan pengelolaan item sampel, membuat alikuot, dan menambah pemeriksaan",
  "sample.management.error.title": "Kesalahan",
  "sample.management.hierarchy.aliquotOf": "Alikuot dari {parent}",
  "sample.management.hierarchy.aliquots": "alikuot",
  "sample.management.noResults.subtitle": "Tidak ada sampel ditemukan untuk nomor registrasi ini: {accessionNumber}",
  "sample.management.noResults.title": "Hasil tidak ditemukan",
  "sample.management.results.accessionNumber": "Nomor Registrasi",
  "sample.management.results.aliquots": "alikuot",
  "sample.management.results.aliquotsSelected": "alikuot",
  "sample.management.results.item": "Barang",
  "sample.management.results.items": "item",
  "sample.management.results.selected": "Dipilih",
  "sample.management.results.title": "Item Sampel",
  "sample.management.results.totalCount": "Total Sampel",
  "sample.management.search.error.general": "Error memuat hasil sampel. Silahkan coba lagi.",
  "sample.management.search.label": "Cari Sampel",
  "sample.management.search.loading": "Mencari...",
  "sample.management.search.placeholder": "Masukkan nomor registrasi untuk mencari...",
  "sample.management.search.title": "Cari Sampel",
  "sample.management.status.allVolumeDispensed": "Semua volume dipindahkan",
  "sample.management.status.available": "Tersedia",
  "sample.management.status.consumed": "Habis",
  "sample.management.status.inUse": "Sedang Digunakan",
  "sample.management.status.unknown": "Tidak diketahui",
  "sample.management.success.title": "Berhasil",
  "sample.management.table.cancelTest": "Batalkan Pemeriksaan",
  "sample.management.table.cancelling": "Membatalkan...",
  "sample.management.table.header.externalId": "Nomor Identitas Sampel",
  "sample.management.table.header.hierarchy": "Hirarki",
  "sample.management.table.header.originalQuantity": "Kuantitas Awal",
  "sample.management.table.header.quantity": "Kuantitas Awal",
  "sample.management.table.header.remainingQuantity": "Kuantitas Sisa",
  "sample.management.table.header.sampleType": "Jenis Sampel",
  "sample.management.table.header.status": "Status",
  "sample.management.table.header.tests": "Pemeriksaan",
  "sample.management.table.noResults": "Tidak ada item sampel untuk ditampilkan. Gunakan pencarian di atas untuk menemukan sampel.",
  "sample.management.table.noTests": "Tidak ada pemeriksaan yang dipesan untuk sampel ini",
  "sample.management.table.orderedDate": "Dipesan",
  "sample.management.table.orderedTests": "Pemeriksaan yang Dipesan ({count})",
  "sample.management.title": "Pengelolaan Sampel",
  "sample.panel.label.text": "Cari Panel yang Tersedia",
  "sample.panel.placeholder": "Pilih Panel yang Tersedia",
  "sample.panel.search.error.msg": "Tidak ada panel yang cocok",
  "sample.quantity.label": "Kuantitas",
  "sample.receivedDate": "Tanggal Diterima",
  "sample.reject.label": "Tolak Sampel",
  "sample.remove.action": "Hapus Sampel",
  "sample.requestDate": "Tanggal Permintaan",
  "sample.search.nosample": "Tidak ada sampel ditemukan untuk nomor registrasi ini",
  "sample.search.panel.legend.text": "Cari dari panel yang tersedia",
  "sample.search.scanner.instructions": "Pindai atau Masukkan Manual. Untuk laporan tunggal, kosongkan kotak di kanan",
  "sample.search.scanner.instructions.highaccession": "Untuk laporan tunggal, kosongkan kotak di kanan",
  "sample.search.scanner.instructions2": "Pindai atau Masukkan Manual",
  "sample.search.title": "Cari Sampel",
  "sample.select.type": "Pilih jenis sampel",
  "sample.type": "Jenis Sampel",
  "sample.type.and.test.sort.order": "Jenis sampel dan urutan penyortiran pemeriksaan",
  "sample.type.helper": "Pilih jenis spesimen — panel dan tes yang tersedia akan diperbarui setelah pemilihan.",
  "sample.uom.label": "Satuan Pengukuran Sampel",
  "sample.voided.title": "Sampel dibatalkan",
  "sampleManagement.actions": "Aksi",
  "sampleManagement.addTests.button": "Tambah Pemeriksaan",
  "sampleManagement.addTests.cancel": "Batal",
  "sampleManagement.addTests.duplicate": "Pemeriksaan sudah dipesan untuk {sampleId}",
  "sampleManagement.addTests.error": "Error menambah pemeriksaan",
  "sampleManagement.addTests.incompatible": "Pemeriksaan tidak kompatibel dengan jenis sampel ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Pilih Sampel untuk menambah Pemeriksaan",
  "sampleManagement.addTests.selectTests": "Pilih Sampel untuk ditambah",
  "sampleManagement.addTests.skipped": "{count} duplikat dilewati",
  "sampleManagement.addTests.submit": "Tambah Pemeriksaan",
  "sampleManagement.addTests.success": "{count} pemeriksaan berhasil ditambah",
  "sampleManagement.addTests.title": "Tambahkan Pemeriksaan ke Sampel",
  "sampleManagement.aliquot.button": "Buat Alikuot",
  "sampleManagement.aliquot.cancel": "Batal",
  "sampleManagement.aliquot.error": "Error saat membuat alikuot",
  "sampleManagement.aliquot.error.concurrentModification": "Pengguna lain memodifikasi sampel ini. Refresh dan coba lagi.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Tidak dapat membuat alikuot: yang diminta {requested} melebihi yang sisa {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Semua volume dipindahkan: tidak ada kuantitas sisa yang tersedia untuk pengalikuotan",
  "sampleManagement.aliquot.notes": "Catatan (opsional)",
  "sampleManagement.aliquot.notesPlaceholder": "Tambahkan catatan untuk alikuot ini...",
  "sampleManagement.aliquot.parentExternalId": "Identitas Eksternal Induk",
  "sampleManagement.aliquot.parentLabel": "Sampel Induk",
  "sampleManagement.aliquot.quantityPlaceholder": "Masukkan kuantitas...",
  "sampleManagement.aliquot.quantityToTransfer": "Kuantitas yang akan Dipindahkan",
  "sampleManagement.aliquot.remainingQuantity": "Kuantitas Sisa",
  "sampleManagement.aliquot.submit": "Buat Alikuot",
  "sampleManagement.aliquot.success": "Alikuot {externalId} berhasil dibuat",
  "sampleManagement.aliquot.title": "Buat Alikuot",
  "sampleManagement.aliquot.unit": "Unit",
  "sampleManagement.aliquot.validation.exceeds": "Kuantitas melebihi kuantitas sisa",
  "sampleManagement.aliquot.validation.min": "Kuantitas harus setidaknya 0.001",
  "sampleManagement.aliquot.validation.required": "Kuantitas untuk dipindahkan harus ada",
  "sampleManagement.clearSelection": "Hapus pilihan",
  "sampleManagement.hierarchy.children": "Alikuot:",
  "sampleManagement.hierarchy.collapse": "Susutkan hirarki",
  "sampleManagement.hierarchy.expand": "Kembangkan hirarki",
  "sampleManagement.hierarchy.level": "Tingkatan {level}",
  "sampleManagement.hierarchy.parent": "Induk:",
  "sampleManagement.notification.refreshResults": "Hasil sudah direfresh",
  "sampleManagement.results.children": "Alikuot",
  "sampleManagement.results.collectionDate": "Tanggal Pengambilan",
  "sampleManagement.results.count": "{count} sampel ditemukan",
  "sampleManagement.results.externalId": "Identitas Eksternal",
  "sampleManagement.results.originalQuantity": "Kuantitas Awal",
  "sampleManagement.results.parent": "Induk",
  "sampleManagement.results.remainingQuantity": "Kuantitas Sisa",
  "sampleManagement.results.sampleType": "Jenis Sampel",
  "sampleManagement.results.status": "Status",
  "sampleManagement.results.tests": "Pemeriksaan",
  "sampleManagement.results.title": "Hasil Pencarian",
  "sampleManagement.search.button": "Cari",
  "sampleManagement.search.error": "Error saat mencari sampel",
  "sampleManagement.search.label": "Cari berdasarkan Nomor Registrasi",
  "sampleManagement.search.loading": "Mencari...",
  "sampleManagement.search.noResults": "Tidak ada sampel ditemukan untuk nomor registrasi ini",
  "sampleManagement.search.placeholder": "Masukkan Nomor Registrasi...",
  "sampleManagement.selectSamples": "Pilih Sampel",
  "sampleManagement.selectedCount": "{count} terpilih",
  "sampleManagement.test.name": "Nama Pemeriksaan",
  "sampleManagement.test.orderedDate": "Tanggal Permintaan",
  "sampleManagement.test.status": "Status",
  "sampleManagement.test.status.CANCELLED": "Dibatalkan",
  "sampleManagement.test.status.COMPLETED": "Selesai",
  "sampleManagement.test.status.IN_PROGRESS": "Dalam Pengerjaan",
  "sampleManagement.test.status.ORDERED": "Pemesanan",
  "sampleManagement.title": "Pengelolaan Sampel",
  "sampleManagement.validation.accessionNumberRequired": "Nomor Registrasi wajib ada",
  "sampleManagement.validation.parentSampleRequired": "Item sampel induk harus ada",
  "sampleManagement.validation.samplesRequired": "Setidaknya satu sampel harus dipilih",
  "sampleManagement.validation.testsRequired": "Setidaknya satu pemeriksaan harus dipilih",
  "sampleType.existing": "Jenis sampel yang ada",
  "sampleType.existing.inactive": "Jenis Sampel Inaktif. Tugaskan pemeriksaan untuk mengaktivasi.",
  "sampleType.new": "Jenis Sampel Baru",
  "sampleType.typeName": "Nama Jenis Sampel",
  "save.aliquot.changes": "Simpan Perubahan Alikuot",
  "save.config.success.msg": "Konfigurasi Berhasil Diperbarui",
  "save.order.success.msg": "Entri Permintaan Sampel berhasil disimpan",
  "save.success": "Penyimpanan berhasil",
  "saving": "Menyimpan...",
  "search.by.dictionary.entry": "Cari berdasarkan Entri Kamus",
  "search.label": "Cari",
  "search.label.accession": "Masukkan Nomor Registrasi",
  "search.label.analysis": "Pilih Status Analisis",
  "search.label.collectiondate": "Masukkan Tanggal Pengambilan",
  "search.label.fromaccession": "Dari Nomor Registrasi",
  "search.label.loadnext": "Masukkan 99 Rekaman Berikutnya, dimulai dari Nomor Registrasi",
  "search.label.receiveddate": "Masukkan Tanggal Diterima",
  "search.label.sample": "Pilih Status Sampel",
  "search.label.test": "Pilih Nama Pemeriksaan",
  "search.label.testdate": "Masukkan Tanggal Pemeriksaan",
  "search.label.testunit": "Pilih Instalasi Lab",
  "search.label.toaccession": "Ke Nomor Registrasi",
  "search.patient.label": "Cari Pasien",
  "search.placeholder": "Mencari...",
  "searchTests.label": "Cari Pemeriksaan yang Tersedia",
  "searchTests.legend": "Cari seluruh pemeriksaan yang tersedia",
  "searchindexmanagement.description": "Indeks pencarian diperbarui secara otomatis saat data ditambahkan atau dimodifikasi. Jika Anda ingin memperbarui indeks pencarian secara manual, klik tombol Mulai Pengindeksan Ulang. Proses ini akan membutuhkan waktu.",
  "searchindexmanagement.label": "Cari Pengelolaan Indeks",
  "searchindexmanagement.reindex": "Mulai Pengindeksan",
  "searchindexmanagement.reindex.error": "Pengindeksan Ulang gagal",
  "searchindexmanagement.reindex.success": "Pengindeksan Ulang berhasil",
  "select.aliquot": "Cari Alikuot",
  "select.datarange.label": "Rentang tanggal adalah saat perujukan dilakukan",
  "select.dateRange": "Pilih Rentang Tanggal untuk Ringkasan Laporan Pemeriksaan",
  "select.default.option.label": "Pilih satu opsi",
  "select.end.date.referredTests": "Tanggal Selesai (dd/mm/yyyy)",
  "select.labUnits": "Pilih unit laboratorium yang ingin Anda buat pemeriksaannya, Anda dapat memilih sebanyak yang dinginkan.",
  "select.label.analyser": "Pilih Alat",
  "select.priority.tests": "Pilih prioritas pemeriksaan yang ingin ditampilkan",
  "select.program": "Program",
  "select.referral.centre": "Pusat Rujukan atau Laboratorium",
  "select.referral.centre.is.required": "Pusat rujukan atau laboratorium adalah wajib",
  "select.start.date.referredTests": "Tanggal Dimulai (dd/mm/yyy)",
  "select.timeFrame": "Pilih waktu yang diinginkan untuk membuat laporan",
  "select.timeFrame.Note": "CATATAN: semua tanggal dan waktu didasarkan pada waktu penerimaan. Contoh: pemeriksaan yang diterima pada 31 Januari pukul 23:59 dan hasilnya keluar pada 1 Februari pukul 09:30 akan tercatat di luar jam kerja normal pada bulan Januari.",
  "select.year.report": "Pilih tahun yang diinginkan untuk membuat laporan",
  "selectListRenameEntry.selectList": "Pilih Daftar Ganti Nama Entri",
  "selectListRenameEntry.selectListEdit": "Pilih Edit Daftar Ganti Nama Entri",
  "selectReportValues.title": "Pilih Nilai Laporan",
  "selectResult.title": "Pilih Hasil",
  "serial.config.active.label": "Aktif",
  "serial.config.baudRate.label": "Kecepatan Baud",
  "serial.config.connect.button": "Hubungkan",
  "serial.config.connect.error": "Error saat menghubungkan serial port",
  "serial.config.connect.success": "Serial port berhasil terhubung",
  "serial.config.create.title": "Buat Konfigurasi Serial Port",
  "serial.config.dataBits.label": "Bit Data",
  "serial.config.disconnect.button": "Koneksi Putus",
  "serial.config.disconnect.error": "Error saat diskoneksi serial port",
  "serial.config.disconnect.success": "Diskoneksi serial port berhasil",
  "serial.config.edit.title": "Edit Konfigurasi Serial Port",
  "serial.config.flowControl.label": "Kendali Alur",
  "serial.config.flowControl.none": "Tidak ada",
  "serial.config.form.legend": "Pengaturan Serial Port",
  "serial.config.parity.even": "Genap",
  "serial.config.parity.label": "Paritas",
  "serial.config.parity.mark": "Tanda",
  "serial.config.parity.none": "Tidak ada",
  "serial.config.parity.odd": "Ganjil",
  "serial.config.parity.space": "Ruang",
  "serial.config.portName.label": "Nama Portal",
  "serial.config.save.error": "Gagal menyimpan konfigurasi serial port",
  "serial.config.save.success": "Konfigurasi serial port berhasil disimpan",
  "serial.config.status.label": "Status Koneksi",
  "serial.config.stopBits.label": "Bit Penghenti",
  "serial.config.validation.analyzerId.required": "Identitas alat wajib ada",
  "serial.config.validation.baudRate.invalid": "Baud rate harus di antara 9600 dan 115200",
  "serial.config.validation.dataBits.invalid": "Bit data harus 7 atau 8",
  "serial.config.validation.portName.required": "Nama portal wajib ada",
  "server.error.msg": "Error pada server, silahkan kontak administrator",
  "common.retry": "Ulang",
  "show.aliquoting": "Tampilkan Pengalikuotan",
  "showing": "Menampilkan",
  "breadcrumb.label.addOrder": "Tambah Pemesanan",
  "sidenav.label.admin": "Admin",
  "sidenav.label.admin.backToMainMenu": "Kembali ke menu utama",
  "sidenav.label.admin.barcodeconfiguration": "Konfigurasi Kode QR",
  "sidenav.label.admin.labelPresets": "Pengaturan Label",
  "sidenav.label.admin.commonproperties": "Properti Aplikasi",
  "sidenav.label.admin.eqaProgram": "Pengelolaan Program PME",
  "sidenav.label.admin.formEntry.menustatementconfig": "Konfigurasi MenuStatement",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Konfigurasi Ketidaksesuaian",
  "sidenav.label.admin.formEntry.patientconfig": "Konfigurasi Entri Pasien",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Konfigurasi Laporan Cetak",
  "sidenav.label.admin.formEntry.resultConfig": "Konfigurasi Entri Hasil",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Konfigurasi Entri Permintaan",
  "sidenav.label.admin.formEntry.siteBranding": "Branding Situs",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Pengaturan Informasi Aplikasi",
  "sidenav.label.admin.formEntry.validationconfig": "Konfigurasi Validasi",
  "sidenav.label.admin.formEntry.Workplanconfig": "Konfigurasi Rencana Kerja",
  "sidenav.label.admin.labNumber": "Pengelolaan Nomor Registrasi",
  "sidenav.label.admin.localization": "Lokalisasi",
  "sidenav.label.admin.menu": "Konfigurasi Menu",
  "sidenav.label.admin.menu.billing": "Konfigurasi Menu Pembayaran",
  "sidenav.label.admin.menu.global": "Konfigurasi Menu Global",
  "sidenav.label.admin.menu.nonconform": "Konfigurasi Menu Ketidaksesuaian",
  "sidenav.label.admin.menu.patient": "Konfigurasi Menu Pasien",
  "sidenav.label.admin.menu.study": "Konfigurasi Menu Kajian",
  "sidenav.label.admin.organizationmgt": "Pengelolaan Organisasi",
  "sidenav.label.admin.testmgt": "Konfigurasi Pemeriksaan Refleks",
  "sidenav.label.admin.testmgt.calculated": "Pengelolaan Pemeriksaan dengan Nilai Terkalkulasi",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Editor Katalog Pemeriksaan",
  "sidenav.label.admin.testCatalog": "Pengelolaan Katalog Pemeriksaan",
  "sidenav.label.admin.testCatalog.backToList": "← Semua Pemeriksaan",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Pilih pemeriksaan untuk pengeditan bagian",
  "sidenav.label.admin.testCatalog.editing": "Edit: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Mengedit pemeriksaan",
  "label.testCatalog.editor": "Editor Katalog Pemeriksaan",
  "label.testCatalog.editor.empty": "Tidak ada pengujian yang dipilih",
  "label.testCatalog.editor.empty.helper": "Buka pemeriksaan dari Katalog Pemeriksaan untuk mengedit",
  "label.testCatalog.editor.loadError": "Gagal memuat pemeriksaan ini. Silahkan coba lagi.",
  "label.testCatalog.editor.saveAsNew": "Simpan sebagai pemeriksaan baru...",
  "label.testCatalog.editor.save.pending": "Penyimpanan tersedia setelah editor bagian tersebut dibuat",
  "label.testCatalog.editor.clone.pending": "Simpan sebagai pemeriksaan baru tersedia setelah editor bagian tersebut dibuat",
  "label.testCatalog.section.pending": "Editor pada bagian ini sudah dikirim ke tahap pengembangan berikutnya.",
  "label.testCatalog.section.basic-info": "Informasi Dasar",
  "label.testCatalog.section.sample-results": "Sampel & Hasil",
  "label.testCatalog.section.methods": "Metode",
  "label.testCatalog.section.ranges": "Rentang",
  "label.testCatalog.section.qc-targets": "QC Targets",
  "label.testCatalog.section.storage": "Penyimpanan Sampel",
  "label.testCatalog.section.panels": "Panel",
  "label.testCatalog.entity.panels": "Panel",
  "note.panel.domainUpgrade": "Panel-panel kini memiliki Domain; panel-panel yang ada ditetapkan ke kategori Klinis.",
  "note.panel.domainLaterPhase": "Domain Lingkungan dan Vektor diaktifkan pada tahap selanjutnya.",
  "label.panel.list.description": "Kumpulan pemeriksaan yang diurutkan; jenis sampel berasal dari pemeriksaan-pemeriksaan yang menjadi anggotanya",
  "label.panel.list.empty": "Tidak ada panel yang sesuai dengan filter saat ini.",
  "label.panel.search": "Cari berdasarkan nama atau LOINC",
  "button.panel.add": "Tambah Panel",
  "label.panel.col.name": "Nama Panel",
  "label.panel.col.tests": "Pemeriksaan",
  "label.panel.col.domain": "Domain",
  "label.panel.list.mixedDomain": "Mixed domain",
  "label.panel.list.mixedDomain.detail": "Sample types outside this panel's domain: {sampleTypes}",
  "label.panel.col.sampleTypes": "Jenis Sampel (turunan)",
  "label.panel.col.status": "Status",
  "label.panel.backToList": "Kembali ke daftar",
  "title.panel.new": "Panel Baru",
  "label.panel.name": "Nama Panel",
  "placeholder.panel.name": "misalnya: Pemeriksaan Anemia",
  "label.panel.domain": "Domain",
  "helper.panel.domainGuard": "Hanya pengujian domain {domain}yang dapat ditambahkan ke panel ini.",
  "helper.panel.loincIsIdentifier": "LOINC panel tersebut berfungsi sebagai pengidentifikasinya.",
  "note.panel.sampleTypesDerived": "Jenis sampel ditentukan berdasarkan pemeriksaan-pemeriksaan yang terdapat dalam panel ini.",
  "label.panel.description": "Deskripsi",
  "label.panel.active": "Aktif",
  "helper.panel.needsTest": "Tambahkan setidaknya satu pemeriksaan sebelum panel ini dapat diaktifkan.",
  "error.panel.save": "Panel tersebut tidak dapat disimpan. Periksa bidang-bidangnya dan coba lagi.",
  "error.panel.nameRequired": "Nama Panel wajib diisi.",
  "error.panel.nameTooLong": "A panel name has at most 20 characters.",
  "error.panel.descriptionTooLong": "A description has at most 60 characters.",
  "error.panel.nameDuplicate": "Another panel already uses this name. Enter a different name.",
  "error.panel.domainConflict": "This panel cannot be filed under {domain}: {count, plural, one {# of its tests belongs} other {# of its tests belong}} to another domain ({tests}).",
  "helper.panel.domainConflict.remedy": "Change the domain of those tests in the Test Catalog, or remove them from this panel, then save again.",
  "error.panel.tests.domainConflict": "Not saved: {tests} {count, plural, one {is} other {are}} not in this panel's domain ({domain}). Only {domain}-domain tests can be added.",
  "error.testCatalog.panels.domainConflict": "This test cannot join {panelName}: the panel is filed under {panelDomain} and the test under {testDomain}.",
  "success.panel.created": "Panel created. It stays inactive until at least one test is assigned to it.",
  "error.panel.create.invalid": "The panel could not be created. Fill in every required field, including a LOINC code.",
  "label.panel.section.basic-info": "Informasi Dasar",
  "label.panel.section.tests": "Pemeriksaan",
  "label.panel.section.terminology": "Terminologi",
  "label.panel.section.localization": "Lokalisasi",
  "label.panel.localization.intro": "Edit terjemahan per bahasa untuk nama panel ini. Bidang yang belum diterjemahkan akan ditampilkan dalam bahasa Inggris. Kelola semua terjemahan dari halaman admin Pengelolaan Terjemahan.",
  "label.panel.localization.empty": "Panel ini tidak memiliki kolom nama yang dapat diterjemahkan.",
  "label.panel.localization.loadError": "Tidak dapat memuat terjemahan untuk panel ini.",
  "label.panel.localization.field.name": "Nama Panel",
  "sidenav.label.admin.panel.editing": "Panel penyuntingan: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Klik sebuah panel untuk mengedit bagian-bagiannya",
  "sidenav.label.admin.panel.addingNew": "Menambahkan Panel Baru",
  "label.panel.testsCount": "pengujian",
  "label.panel.addTest": "Tambahkan pemeriksaan",
  "label.panel.tests.filterBySampleType": "Filter berdasarkan Jenis Sampel",
  "label.panel.tests.filterBySampleType.all": "Semua Jenis Sampel",
  "placeholder.panel.addTest": "Cari berdasarkan nama atau kode…",
  "helper.panel.membershipSync": "Penulisan anggota menjaga agar daftar panel entri pesanan tetap sinkron.",
  "label.panel.col.order": "Pemesanan",
  "label.panel.col.testName": "Nama Pemeriksaan",
  "label.panel.col.code": "Kode",
  "label.panel.moveUp": "Geser ke atas",
  "label.panel.moveDown": "Geser ke bawah",
  "empty.panel.tests": "Tidak ada pemeriksaan — gunakan kolom pencarian di atas untuk menambahkan yang pertama.",
  "helper.panel.loincRouting": "Kode ini juga berfungsi sebagai kunci perutean aktif — pesanan elektronik FHIR mencocokkan panel berdasarkan kode ini saat penerimaan. Kode LOINC utama tetap tercantum pada panel untuk tampilan daftar dan entri pesanan.",
  "label.panel.terminology.primary": "Primer",
  "label.panel.terminology.empty": "Belum ada pemetaan terminologi. Pemetaan LOINC adalah pengidentifikasi panel tersebut.",
  "label.panel.terminology.saved": "Pemetaan terminologi telah disimpan.",
  "label.panel.terminology.saveInvalid": "Beberapa pemetaan tidak valid. Periksa sumber, kode, dan Duplikasi.",
  "label.panel.terminology.saveError": "Tidak dapat menyimpan pemetaan terminologi.",
  "note.panel.positionShared": "Kolom ini menyimpan nilai panel_item.sort_order — kolom yang sama yang diedit di bagian \"Panels\" pada sisi pengujian.",
  "label.testCatalog.section.labels": "Label",
  "label.testCatalog.section.terminology": "Terminologi",
  "label.testCatalog.labels.col.preset": "Pengaturan",
  "label.testCatalog.labels.col.defaultQty": "Kuantitas Default",
  "label.testCatalog.labels.col.maxQty": "Kuantitas Maks",
  "label.testCatalog.labels.col.allowOverride": "Izinkan Override",
  "label.testCatalog.labels.col.actions": "Aksi",
  "label.testCatalog.labels.addLabelType": "Tambah Jenis Label",
  "label.testCatalog.labels.addLabelType.placeholder": "Pilih Pengaturan Label",
  "label.testCatalog.labels.empty": "Tidak ada jenis label yang dikonfigurasi. Tambah pengaturan label untuk secara otomatis diterapkan saat pemeriksaan ini dipesan.",
  "label.testCatalog.labels.loadError": "Gagal memuat konfigurasi label untuk pemeriksaan ini.",
  "label.testCatalog.labels.saved": "Konfigurasi label disimpan",
  "label.testCatalog.labels.saveError": "Gagal menyimpan konfigurasi label.",
  "label.testCatalog.labels.unsaved": "Anda memiliki perubahan label yang tidak tersimpan. Klik Simpan untuk menerapkannya.",
  "label.testCatalog.labels.maxLtDefault": "Kuantitas Maks harus lebih dari atau sama dengan Kuantitas Default.",
  "label.testCatalog.labels.allowOverride.label": "Izinkan override saat entri pemesanan",
  "label.testCatalog.labels.generationSettings": "Pengaturan Pembuatan Label",
  "label.testCatalog.labels.remove.action": "Hapus",
  "label.testCatalog.labels.remove.title": "Hapus Jenis Label",
  "label.testCatalog.labels.remove.confirm": "Hapus",
  "label.testCatalog.labels.remove.body": "Hapus {name} dari konigurasi label pemeriksaan ini?",
  "label.testCatalog.section.reagents": "Reagen",
  "label.testCatalog.section.analyzers": "Alat",
  "label.testCatalog.section.alerts": "Peringatan",
  "label.testCatalog.section.accreditation": "Accreditation",
  "label.testCatalog.accreditation.add": "Add accreditation",
  "label.testCatalog.accreditation.added": "Accreditation added",
  "label.testCatalog.accreditation.removed": "Accreditation removed",
  "label.testCatalog.accreditation.empty": "This test is not accredited by any body.",
  "label.testCatalog.accreditation.selectBody": "Choose an accrediting body",
  "label.testCatalog.accreditation.remove": "Remove accreditation",
  "label.testCatalog.accreditation.remove.body": "Remove this test from {body}? Its logo will stop appearing on reports that contain only this test.",
  "label.testCatalog.accreditation.manageLink": "Manage accrediting bodies and expiry dates",
  "label.testCatalog.accreditation.loadError": "Accreditation could not be loaded.",
  "label.testCatalog.accreditation.saveError": "The accreditation could not be added.",
  "label.testCatalog.accreditation.deleteError": "The accreditation could not be removed.",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Lokalisasi",
  "label.testCatalog.section.display-order": "Urutan tampilan",
  "label.sampleType.section.basic-info": "Informasi Dasar",
  "label.sampleType.section.associated-tests": "Pemeriksaan Terkait",
  "label.sampleType.section.terminology": "Terminologi",
  "label.sampleType.section.localization": "Lokalisasi",
  "label.sampleType.localization.intro": "Edit terjemahan per bahasa untuk nama jenis sampel ini. Kolom yang belum diterjemahkan akan menggunakan Bahasa Inggris sebagai bahasa default. Kelola semua terjemahan dari halaman admin Manajemen Terjemahan.",
  "label.sampleType.localization.empty": "Jenis sampel ini tidak memiliki bidang nama yang dapat dilokalkan.",
  "label.sampleType.localization.loadError": "Tidak dapat memuat terjemahan untuk jenis sampel ini.",
  "label.sampleType.localization.field.name": "Nama Jenis Sampel",
  "label.sampleType.terminology.intro": "Petakan jenis sampel ini ke kode terminologi standar demi interoperabilitas.",
  "label.sampleType.terminology.empty": "Tidak ada pemetaan terminologi.",
  "label.sampleType.terminology.saved": "Pemetaan terminologi telah disimpan.",
  "label.sampleType.terminology.saveError": "Tidak dapat menyimpan pemetaan terminologi.",
  "label.sampleType.terminology.saveInvalid": "Beberapa pemetaan tidak valid. Periksa sumber, kode, dan Duplikasi.",
  "label.sampleType.terminology.addHint": "Simpan dulu jenis sampel ini, lalu tambahkan pemetaan terminologi.",
  "label.sampleType.localization.addHint": "Simpan dulu Jenis Sampel ini, lalu edit terjemahannya.",
  "label.sampleType.name": "Nama",
  "label.sampleType.section.display-order": "Urutan tampilan",
  "label.sampleType.section.disposal": "Musnahkan",
  "label.sampleType.displayOrder": "Posisi di menu Jenis Sampel",
  "label.sampleType.displayOrder.intro": "Tempatkan jenis sampel ini dalam menu Jenis Sampel pada bagian entri pesanan. Ketikkan urutan atau gunakan tombol panah, lalu simpan — setiap jenis sampel akan diberi nomor ulang.",
  "label.sampleType.displayOrder.current": "Jenis sampel ini",
  "label.sampleType.displayOrder.loading": "Memuat jenis sampel...",
  "label.sampleType.displayOrder.saved": "Urutan tampilan telah diperbarui.",
  "label.sampleType.displayOrder.saveError": "Tidak dapat memperbarui urutan tampilan.",
  "label.sampleType.displayOrder.addHint": "Simpan dulu jenis sampel ini, lalu atur posisinya di menu.",
  "label.sampleType.disposalInstructions": "Petunjuk pembuangan",
  "label.sampleType.disposal.intro": "Panduan referensi dalam bentuk teks bebas mengenai pembuangan jenis spesimen ini. Petunjuk penanganan yang resmi dan terstruktur tercantum pada bagian Penyimpanan setiap tes serta alur kerja pembuangan spesimen.",
  "label.sampleType.disposal.placeholder": "misalnya, disterilkan dengan autoklaf sebelum dimusnahkan sebagai limbah berbahaya biologis",
  "label.sampleType.disposal.loading": "Sedang memuat petunjuk pembuangan...",
  "label.sampleType.disposal.saved": "Petunjuk pembuangan telah disimpan.",
  "label.sampleType.disposal.saveError": "Tidak dapat menyimpan petunjuk pembuangan.",
  "label.sampleType.disposal.addHint": "Simpan dulu jenis sampel ini, lalu tambahkan petunjuk pembuangan.",
  "label.sampleType.tests.manageIntro": "Tes yang terkait dengan jenis sampel ini. Telusuri katalog untuk menambahkan tautan lain, atau menghapus tautan yang sudah ada. Tautan yang sama juga dapat dikelola dari Informasi Dasar tes di Katalog Tes.",
  "label.sampleType.tests.search": "Pemeriksaan pencarian",
  "label.sampleType.tests.searchPlaceholder": "Cari berdasarkan nama pemeriksaan...",
  "label.sampleType.tests.filterBySampleType": "Filter berdasarkan Jenis Sampel",
  "label.sampleType.tests.filterBySampleType.all": "Apa saja jenis sampel",
  "label.sampleType.tests.pick": "Pemeriksaan untuk menambahkan",
  "label.sampleType.tests.pickPlaceholder": "Pilih pemeriksaan...",
  "label.sampleType.tests.add": "Tambah Pemeriksaan",
  "label.sampleType.tests.addError": "Tidak dapat menghubungkan pemeriksaan tersebut dengan jenis sampel ini.",
  "label.sampleType.tests.remove": "Hapus pemeriksaan",
  "label.sampleType.tests.removeError": "Tidak dapat memutuskan tautan pemeriksaan tersebut.",
  "label.sampleType.tests.loading": "Memuat pemeriksaan yang terkait...",
  "label.sampleType.tests.none": "Tidak ada pemeriksaan yang terkait dengan jenis sampel ini.",
  "message.sampleType.add.success": "Sample type saved successfully.",
  "message.sampleType.edit.success": "Jenis sampel berhasil diperbarui.",
  "error.sampleType.create.invalidName": "This name contains characters that are not allowed, such as HTML tags. Remove them and try again.",
  "error.sampleType.create.invalid": "The sample type was not created. Check the fields and try again.",
  "error.sampleType.create.duplicateName": "A sample type with this name already exists.",
  "error.sampleType.update.description.409": "Another sample type in this domain already has this description.",
  "error.sampleType.update.abbreviation.409": "Another sample type in this domain already uses this abbreviation.",
  "error.sampleType.update.abbreviation.400": "The abbreviation has at most 10 characters.",
  "error.sampleType.update.whonetCode.400": "The WHONET code has at most 5 characters.",
  "label.sampleType.loading": "Memuat Jenis Sampel...",
  "stock.status.pendingQc": "QC tertunda",
  "stock.status.qcFailed": "Failed QC",
  "stock.status.quarantined": "Quarantined",
  "label.sampleType.whonetCode": "Kode spesimen WHONET",
  "helper.sampleType.whonetCode": "Kode yang ditulis pada bidang SPECIMEN_TYPE di WHONET (maksimal 5 karakter).",
  "label.sampleType.whonetReturn": "Kembali ke pratinjau WHONET",
  "warning.sampleType.deactivateInUse": "{count} Tes aktif menggunakan jenis ini; tes tersebut tidak dapat dipesan selama statusnya inaktif.",
  "note.sampleType.associatedTests.viewOnly": "Hanya untuk dilihat — spesimen suatu tes merupakan bagian dari identitasnya. Untuk menjalankan tes pada jenis sampel ini, buat varian spesimen di Katalog Pemeriksaan.",
  "sidenav.label.admin.sampleType.backToList": "← Semua Jenis Sampel",
  "sidenav.label.admin.sampleType.editing": "Edit: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Mengedit Jenis Sampel",
  "sidenav.label.admin.sampleType.sectionsHelper": "Klik Jenis Sampel untuk mengedit bagian-bagiannya",
  "sidenav.label.admin.sampleType.addingNew": "Menambahkan Jenis Sampel Baru",
  "label.testCatalog.localization.locale": "Lokal",
  "label.testCatalog.localization.intro": "Edit terjemahan untuk nama pemeriksaan dan pelaporan. Bidang yang tidak diterjemahkan akan dikembalikan ke Bahasa Inggris. Kelola terjemahan dari laman admin Pengelolaan Terjemahan.",
  "label.testCatalog.localization.unsaved": "Anda memiliki perubahan terjemahan yang tidak tersimpan. Klik Simpan untuk menerapkannya.",
  "label.testCatalog.localization.loadError": "Gagal memuat terjemahan untuk pemeriksaan ini.",
  "label.testCatalog.localization.empty": "Pemeriksaan ini tidak memiliki bidang nama lokal.",
  "label.testCatalog.localization.saved": "Terjemahan disimpan",
  "label.testCatalog.localization.saveError": "Tidak dapat menyimpan terjemahan.",
  "label.testCatalog.localization.field.name": "Nama Pemeriksaan",
  "label.testCatalog.localization.field.reportingName": "Nama Pelaporan",
  "label.testCatalog.localization.fallback.en": "Bahasa Alternatif (en)",
  "label.testCatalog.localization.fallback.tooltip": "Menampilkan nilai dalam Bahasa Inggris karena tidak ada terjemahan yang dikonfigurasi untuk {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Gagal memuat refleks dan kalkukasi terkait pemeriksaan ini.",
  "label.testCatalog.reflexCalc.reflex.heading": "Pemeriksaan Refleks",
  "label.testCatalog.reflexCalc.reflex.helper": "Aturan yang mengurutkan pemeriksaan secara otomatis berdasarkan hasil. Kelola ini di Daftar Master → Aturan Refleks.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Nama Aturan",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Kondisi Trigger",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Pemeriksaan Refleks Dipesan",
  "label.testCatalog.reflexCalc.reflex.empty": "Tidak ada aturan refleks yang dikonfigurasi. Aturan refleks dikelola di Daftar Master → Aturan Refleks.",
  "label.testCatalog.reflexCalc.reflex.manage": "Kelola Aturan Refleks",
  "label.testCatalog.reflexCalc.calc.heading": "Hasil Terkalkulasi",
  "label.testCatalog.reflexCalc.calc.helper": "Formula yang menggunakan hasil pemeriksaan ini atau yang menghasilkan pemeriksaan ini sebagai output. Kelola di Daftar Master → Hasil Terkalkukasi.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "Pemeriksaan ini mengumpan ke",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "Pemeriksaan ini dikalkulasi oleh",
  "label.testCatalog.reflexCalc.calc.col.name": "Nama Formula",
  "label.testCatalog.reflexCalc.calc.col.formula": "Rumus",
  "label.testCatalog.reflexCalc.calc.col.output": "Output Pemeriksaan",
  "label.testCatalog.reflexCalc.calc.empty": "Tidak ada",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "Pemeriksaan ini tidak menjadi bagian dari hasil perhitungan apa pun. Perhitungan dikelola di Daftar Utama → Nilai yang Dihitung.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "Pemeriksaan ini tidak dihitung dari pemeriksaan lainnya. Penghitungan dikelola di Daftar Utama → Nilai Terkalkulasi.",
  "label.testCatalog.reflexCalc.calc.manage": "Kelola Hasil Terkalkulasi",
  "label.testCatalog.alerts.addRule": "Tambah Aturan",
  "label.testCatalog.alerts.empty": "Tidak ada konfigurasi aturan peringatan. Tambah aturan untuk menotifikasi penerima jika hasil cocok dengan kondisi.",
  "label.testCatalog.alerts.loadError": "Gagal memuat aturan peringatan untuk pemeriksaan ini.",
  "label.testCatalog.alerts.saved": "Aturan peringatan berhasil disimpan",
  "label.testCatalog.alerts.saveError": "Gagal menyimpan aturan peringatan.",
  "label.testCatalog.alerts.deleted": "Aturan peringatan dihapus",
  "label.testCatalog.alerts.deleteError": "Gagal menghapus aturan peringatan.",
  "label.testCatalog.alerts.nameRequired": "Wajib ada nama aturan.",
  "label.testCatalog.alerts.valueRequired": "Nilai spesifik diperlukan untuk trigger Nilai Spesifik.",
  "label.testCatalog.alerts.col.name": "Nama",
  "label.testCatalog.alerts.col.trigger": "Pemicu",
  "label.testCatalog.alerts.col.channels": "Channel",
  "label.testCatalog.alerts.col.ack": "Wajib Konfirmasi",
  "label.testCatalog.alerts.col.enabled": "Diaktifkan",
  "label.testCatalog.alerts.col.actions": "Aksi",
  "label.testCatalog.alerts.trigger.ALL": "Semua Hasil",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Tidak normal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Kritis",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Nilai Spesifik",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Pelanggaran Kepatuhan",
  "label.testCatalog.alerts.edit.action": "Sunting",
  "label.testCatalog.alerts.delete.action": "Hapus",
  "label.testCatalog.alerts.delete.title": "Hapus Aturan Peringatan",
  "label.testCatalog.alerts.delete.confirm": "Hapus",
  "label.testCatalog.alerts.delete.body": "Hapus aturan peringatan {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Tambah Aturan Peringatan",
  "label.testCatalog.alerts.modal.editTitle": "Edit Aturan Peringatan",
  "label.testCatalog.alerts.field.name": "Nama Aturan",
  "label.testCatalog.alerts.field.trigger": "Peringatan jika hasil adalah:",
  "label.testCatalog.alerts.field.specificValue": "Nilai spesifik",
  "label.testCatalog.alerts.field.channels": "Channel notifikasi",
  "label.testCatalog.alerts.field.recipients": "Penerima",
  "label.testCatalog.alerts.field.ackRequired": "Wajib ada konfirmasi",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Email",
  "label.testCatalog.alerts.recipient.physician": "Dokter Pemesan",
  "label.testCatalog.alerts.recipient.patient": "Pasien",
  "label.testCatalog.alerts.recipient.facility": "Lembaga Perujuk",
  "label.testCatalog.alerts.recipient.customPhone": "Telepon kostum",
  "label.testCatalog.alerts.recipient.customEmail": "Email kostum",
  "label.testCatalog.alerts.recipient.roleId": "Notifikasi pengguna dengan peran",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Pilih peran",
  "label.testCatalog.reagents.col.name": "Nama Reagen",
  "label.testCatalog.reagents.col.usage": "Jenis Penggunaan",
  "label.testCatalog.reagents.col.qty": "Kuantitas per Pemeriksaan",
  "label.testCatalog.reagents.col.stock": "Level Stok",
  "label.testCatalog.reagents.col.actions": "Aksi",
  "label.testCatalog.reagents.empty": "Tidak ada reagen terkait. Tautkan reagen dari inventaris untuk melacak konsumsi per pemeriksaan.",
  "label.testCatalog.reagents.loadError": "Gagal memuat reagen untuk pemeriksaan ini.",
  "label.testCatalog.reagents.linkButton": "Tautkan Reagen",
  "label.testCatalog.reagents.linkError": "Gagal menautkan satu atau lebih reagen. Silahkan coba lagi.",
  "label.testCatalog.reagents.modal.title": "Tautkan Reagen",
  "label.testCatalog.reagents.modal.linkSelected": "Tautkan Yang Dipilih",
  "label.testCatalog.reagents.modal.select.label": "Reagen",
  "label.testCatalog.reagents.modal.select.placeholder": "Pilih reagen untuk ditautkan",
  "label.testCatalog.reagents.modal.allLinked": "Semua reagen yang tersedia sudah ditautkan ke pemeriksaan ini.",
  "label.testCatalog.reagents.unitPlaceholder": "Unit",
  "label.testCatalog.reagents.updated": "Reagen diperbarui",
  "label.testCatalog.reagents.saveError": "Gagal menyimpan perubahan.",
  "label.testCatalog.reagents.unsaved": "Anda memiliki perubahan reagen yang tidak tersimpan. Klik Simpan untuk menerapkannya.",
  "label.testCatalog.reagents.retry": "Ulang",
  "label.testCatalog.reagents.unlink.action": "Putuskan Tautan",
  "label.testCatalog.reagents.unlink.title": "Putuskan Tautan Reagen",
  "label.testCatalog.reagents.unlink.confirm": "Putuskan Tautan",
  "label.testCatalog.reagents.unlink.body": "Putuskan tautan {name} untuk pemeriksaan ini? Hasil yang sudah tertaut dengan reagen ini tidak terpengaruh.",
  "label.testCatalog.reagents.unlinked": "Reagen tidak tertaut",
  "label.testCatalog.reagents.unlinkError": "Gagal memutuskan tautan reagen. Silahkan coba lagi.",
  "label.testCatalog.basicInfo.name": "Nama",
  "label.testCatalog.basicInfo.name.helper": "Nama tampilan adalah terjemahan — edit di bagian Lokalisasi.",
  "label.testCatalog.basicInfo.reportingName": "Nama pelaporan",
  "label.testCatalog.basicInfo.labUnit": "Instalasi Lab",
  "label.testCatalog.basicInfo.createInactiveHint": "Pemeriksaan yang dibuat Inaktif. Lakukan konfigurasi, kemudian aktifkan agar dapat dipesan.",
  "sidenav.label.environmental.compliance.tooltip": "Dasbor Kepatuhan Lingkungan",
  "site.search.helper": "Ketik minimal 2 karakter untuk melakukan pencarian otomatis. Wajib untuk mengarahkan hasil kembali ke situs yang meminta.",
  "storage.skipped.title": "Penyimpanan dilewati untuk sampel {count}",
  "test.qc.blankThreshold": "Ambang Batas Kosong",
  "test.qc.recoveryWindowPct": "Jendela Pemulihan (%)",
  "test.qc.rpdThreshold": "Ambang Batas RPD (%)",
  "test.qc.thresholds.description": "Nilai ambang batas opsional untuk evaluasi QC lingkungan/vektor. Biarkan kosong jika tidak berlaku.",
  "test.qc.thresholds.heading": "Ambang Batas Penerimaan QC",
  "title.testCatalog.createTest": "Buat pemeriksaan baru",
  "label.testCatalog.testName": "Nama pemeriksaan",
  "label.testCatalog.testCode": "Kode pemeriksaan",
  "label.testCatalog.domain": "Domain",
  "label.testCatalog.specimenType": "Jenis sampel",
  "label.testCatalog.basicInfo.sampleTypes": "Jenis sampel",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Pilih semua spesimen yang akan diuji dalam tes ini. Konfigurasi tersebut berlaku untuk semua spesimen tersebut.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Pilih setidaknya satu jenis sampel.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "Jenis Sampel ini tidak sesuai dengan domain tes.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Spesimen",
  "label.testCatalog.override.shared": "Semua spesimen (yang dibagikan)",
  "notice.testCatalog.intake.awaitingSpecimen": "Menunggu sampel — pemeriksaan ini dilakukan pada beberapa sampel; selesaikan saat pengambilan sampel.",
  "tag.testCatalog.finding.noSampleTypeLink": "Tidak ada tautan jenis sampel",
  "error.testCatalog.codeExists": "Pemeriksaan dengan kode ini sudah ada.",
  "error.testCatalog.description.inUse": "Pemeriksaan lain sudah menggunakan deskripsi ini. Deskripsi harus unik — ubah deskripsinya, lalu simpan kembali.",
  "notification.testCatalog.testCreated": "Pemeriksaan '{name}' dibuat. Lengkapi konfigurasi pada bagian sebelah kiri.",
  "label.testCatalog.basicInfo.code": "Kode",
  "label.testCatalog.basicInfo.description": "Deskripsi",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Klinis",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Lingkungan",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vektor",
  "label.testCatalog.basicInfo.domainModal.title": "Ganti domain pemeriksaan?",
  "label.testCatalog.basicInfo.domainModal.body": "Ganti domain pemeriksaan ini menjadi {domain}? Ini akan mempengaruhi pengkategorian pemeriksaan di katalog.",
  "label.testCatalog.basicInfo.amr": "Pemeriksaan surveilans AMR",
  "label.testCatalog.basicInfo.cultureWorkflowType": "Alur Kerja budaya",
  "label.testCatalog.basicInfo.cultureWorkflowType.none": "Bukan alur kerja budaya",
  "label.testCatalog.basicInfo.cultureWorkflowType.BACTERIOLOGY": "Bakteriologi",
  "label.testCatalog.basicInfo.cultureWorkflowType.MYCOBACTERIOLOGY_TB": "Mikobakteriologi/TB",
  "label.testCatalog.basicInfo.cultureWorkflowType.MYCOLOGY": "Mikologi",
  "label.testCatalog.basicInfo.active": "Aktif",
  "label.testCatalog.basicInfo.status": "Status",
  "label.testCatalog.basicInfo.orderable": "Dapat dipesan",
  "label.testCatalog.basicInfo.saved": "Informasi dasar disimpan.",
  "label.testCatalog.sampleResults.saved": "Sampel & hasil disimpan.",
  "label.testCatalog.sampleResults.empty": "Tidak ada komponen hasi. Tambahkan komponen hasil untuk mendefinisikan bagaimana hasil pemeriksaan diambil.",
  "label.testCatalog.sampleResults.newComponent": "(komponen baru)",
  "label.testCatalog.sampleResults.code": "Kode komponen",
  "label.testCatalog.sampleResults.isPrimary": "Komponen primer",
  "label.testCatalog.sampleResults.showOnReport": "Tampilkan di laporan pasien",
  "label.testCatalog.sampleResults.label": "Label komponen",
  "label.testCatalog.sampleResults.resultType": "Jenis hasil",
  "label.testCatalog.sampleResults.resultType.N": "Numerik",
  "label.testCatalog.sampleResults.resultType.none": "Tidak ada jenis hasil yang dipilih",
  "label.testCatalog.sampleResults.preview.noType": "Pilih jenis hasil di atas untuk melihat bagaimana teknisi akan memasukkan hasil ini.",
  "label.testCatalog.sampleResults.resultType.D": "Daftar pilihan tunggal (kamus)",
  "label.testCatalog.sampleResults.resultType.R": "Teks bebas",
  "label.testCatalog.sampleResults.resultType.M": "Daftar pilihan ganda",
  "label.testCatalog.sampleResults.resultType.C": "Pilihan ganda bertingkat",
  "label.testCatalog.sampleResults.resultType.T": "Titer",
  "label.testCatalog.sampleResults.resultType.A": "Alpha (teks yang telah melalui proses Divalidasi)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Umum",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Jenis lanjutan / jenis lama",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Jenis lanjutan / jenis lama",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Sembunyikan advanced / legacy types",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "Angka terukur dengan satuan (mis. 12.3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "Satu nilai di pilih dari fixed set (mis. Terdeteksi / Tidak terdeteksi).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "Komentar atau deksripsi yang diketik.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "Satu atau lebih nilai dari daftar; tidak ada nilai rujukan tunggal.<br>",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Opsi grup; pilih multiple grup.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "Rasio dilusi, misalnya, 1:10 atau 1:20 (umum di serologi).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Teks alfanumerik yang valid (kode atau nilai dengan kode singkat).",
  "label.testCatalog.sampleResults.preview": "Pratinjau entri hasil",
  "label.testCatalog.sampleResults.previewHelper": "Yang terlihat saat petugas lab mengisi hasil.",
  "label.testCatalog.sampleResults.purpose": "Menjelaskan apa yang direkam oleh petugas lab untuk pemeriksaan ini dan bagaimana hasil diinterpretasikan.",
  "label.testCatalog.sampleResults.labelRequired": "Setiap komponen hasil memerlukan label sebelum dapat disimpan.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Pilih jenis hasil untuk \"{component}\" sebelum menyimpan.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Umumnya pemeriksaan merekam satu hasil. Tambah komponen jika pemeriksaan menghasilkan beberapa nilai (mis. diferensial).",
  "label.testCatalog.sampleResults.displayOrder": "Urutan tampilan",
  "label.testCatalog.sampleResults.uom": "Satuan pengukuran",
  "label.testCatalog.sampleResults.uom.none": "(tidak ada)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Tambah satuan baru…",
  "label.testCatalog.sampleResults.uom.newName": "Nama di Tampilan",
  "label.testCatalog.sampleResults.uom.newCode": "Kode",
  "label.testCatalog.sampleResults.uom.newUcum": "Kode UCUM",
  "label.testCatalog.sampleResults.uom.newDescription": "Deskripsi",
  "label.testCatalog.sampleResults.uom.saveNew": "Buat satuan",
  "label.testCatalog.sampleResults.significantDigits": "Digit signifikan",
  "label.testCatalog.sampleResults.significantDigits.helper": "Jumlah digit yang akan dipertahankan setelah koma desimal saat hasil numerik dimasukkan. Biarkan kosong jika tidak ingin dilakukan pembulatan.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Limit of detection (optional)",
  "admin.testCatalog.sampleResults.loq.helper": "Limit of quantification (optional)",
  "error.testCatalog.sampleResults.lodGtLoq": "LOD cannot be greater than LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Detection limits must be zero or more.",
  "admin.testCatalog.qcTargets.section.label": "QC Targets",
  "admin.testCatalog.qcTargets.intro": "The control targets Results Entry judges each QC run against. Enter them once here so technicians only enter the measured value.",
  "admin.testCatalog.qcTargets.column.level": "Control level",
  "admin.testCatalog.qcTargets.column.expected": "Expected value",
  "admin.testCatalog.qcTargets.column.uncertainty": "Uncertainty (±)",
  "admin.testCatalog.qcTargets.column.unit": "Unit",
  "admin.testCatalog.qcTargets.column.overrides": "Lot overrides",
  "admin.testCatalog.qcTargets.column.status": "Status",
  "admin.testCatalog.qcTargets.column.actions": "Aksi",
  "admin.testCatalog.qcTargets.level.low": "Rendah",
  "admin.testCatalog.qcTargets.level.normal": "Normal",
  "admin.testCatalog.qcTargets.level.high": "Tinggi",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Expected outcome",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Choose the expected outcome",
  "admin.testCatalog.qcTargets.addTarget": "Add target",
  "admin.testCatalog.qcTargets.addOverride": "Add lot override",
  "admin.testCatalog.qcTargets.lot.label": "Control lot",
  "admin.testCatalog.qcTargets.lot.placeholder": "Search control lots…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "No lots found — manage lots in QC Lot Management",
  "admin.testCatalog.qcTargets.overrides.none": "No lot overrides",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, one {# lot override} other {# lot overrides}}",
  "admin.testCatalog.qcTargets.empty.level": "No target configured — techs enter values at capture",
  "admin.testCatalog.qcTargets.helper.precedence": "At results entry, the control form prefills from the lot override if one exists, otherwise the level default.",
  "admin.testCatalog.qcTargets.showDeactivated": "Tampilkan sudah inaktif",
  "admin.testCatalog.qcTargets.deactivate": "Nonaktifkan",
  "admin.testCatalog.qcTargets.reactivate": "Aktifkan Ulang",
  "admin.testCatalog.qcTargets.edit": "Edit target",
  "admin.testCatalog.qcTargets.done": "Selesai",
  "admin.testCatalog.qcTargets.saved": "QC targets saved.",
  "admin.testCatalog.qcTargets.loadError": "The QC targets could not be loaded.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "Ketidakpastian harus berupa bilangan non-negatif.",
  "error.testCatalog.qcTargets.required": "Every active target needs an expected value and an uncertainty, or an expected outcome.",
  "label.testCatalog.sampleResults.defaultResult": "Hasil default",
  "label.testCatalog.sampleResults.allowMultiple": "Izinkan pembacaan multiple",
  "label.testCatalog.sampleResults.options": "Opsi select-list",
  "label.testCatalog.sampleResults.options.empty": "Belum ada opsi yang ditentukan. Tambah setidaknya satu opsi agar hasil ini dapat dimasukkan.",
  "label.testCatalog.sampleResults.option.value": "Nilai",
  "label.testCatalog.sampleResults.option.sortOrder": "Sortir Pemesanan",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Pilihan ditampilkan kepada petugas dalam urutan naik — angka yang lebih kecil muncul terlebih dahulu.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.addOption": "Tambah opsi",
  "label.testCatalog.sampleResults.addCustomOption": "Tambah opsi khusus",
  "label.testCatalog.sampleResults.searchDictionary": "Cari nilai kamus...",
  "label.testCatalog.sampleResults.removeOption": "Hapus opsi",
  "label.testCatalog.sampleResults.interpretations": "Interpretasi",
  "label.testCatalog.sampleResults.interpretations.empty": "Tidak ada interpretasi yang ditentukan. Tambah satu interpretasi untuk melampirkan panduan atau penanda keparahan pada suatu hasil.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Nilai cocok",
  "label.testCatalog.sampleResults.interp.selectValue": "Pilih nilai...",
  "label.testCatalog.sampleResults.interp.numericHint": "mis. >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretasi",
  "label.testCatalog.sampleResults.interp.severity": "Keparahan",
  "label.testCatalog.sampleResults.addInterpretation": "Tambah interpretasi",
  "label.testCatalog.sampleResults.removeInterpretation": "Hapus interpretasi",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Tidak normal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Kritis",
  "label.testCatalog.sampleResults.actions": "Aksi",
  "label.testCatalog.sampleResults.addComponent": "Tambah komponen",
  "label.testCatalog.sampleResults.removeComponent": "Hapus komponen",
  "label.testCatalog.sampleResults.moveUp": "Pindahkan komponen ke atas",
  "label.testCatalog.sampleResults.moveDown": "Pindahkan komponen ke bawah",
  "label.testCatalog.sampleResults.copyFrom": "Salin konfigurasi dari pemeriksaan",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Pilih pemeriksaan",
  "label.testCatalog.sampleResults.copyFromButton": "Salin dari pemeriksaan",
  "label.testCatalog.sampleResults.copyConfirm.title": "Replace this test's result configuration?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Every result component, select-list option and interpretation of this test will be replaced with those of {source}. Nothing changes until you click Save. Once saved, the replacement cannot be undone.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Replace configuration",
  "label.testCatalog.sampleResults.copyStaged": "Configuration copied from {source}, not saved yet",
  "label.testCatalog.sampleResults.copyStaged.helper": "Click Save to replace this test's configuration with it, or discard it to keep the current one.",
  "label.testCatalog.sampleResults.copyDiscard": "Discard copied configuration",
  "label.testCatalog.sampleResults.copyEmpty": "{source} has no result configuration to copy.",
  "label.testCatalog.sampleResults.copyLoadError": "The configuration of {source} could not be loaded.",
  "label.testCatalog.sampleResults.copied": "Konfigurasi disalin.",
  "label.testCatalog.ranges.activated": "Pemeriksaan diaktifkan.",
  "label.testCatalog.ranges.ackModal.title": "Aktifkan dengan coverage gap?",
  "label.testCatalog.ranges.ackModal.confirm": "Ketahui dan aktifkan",
  "label.testCatalog.ranges.ackModal.warning": "Pemeriksaan ini memiliki rentang referensi dengan coverage gap.",
  "label.testCatalog.ranges.ackModal.body": "Rentang usia berikut ini tidak memiliki rentang referensi — hasil pada rentang tersebut tidak dapat ditandai berdasarkan rentang tersebut. Klik \"Ketahui\" untuk tetap mengaktifkannya.",
  "label.testCatalog.ranges.male": "Laki-Laki",
  "label.testCatalog.ranges.female": "Perempuan",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "hari",
  "label.testCatalog.ranges.months": "bulan",
  "label.testCatalog.ranges.years": "tahun",
  "label.testCatalog.ranges.noUpperLimit": "tidak ada batas atas",
  "label.testCatalog.ranges.noLowerLimit": "tidak ada batas bawah",
  "label.testCatalog.ranges.both": "Keduanya",
  "label.testCatalog.ranges.add": "Tambahkan rentang",
  "label.testCatalog.ranges.empty": "Tidak ada rentang referensi yang ditetapkan.",
  "label.testCatalog.ranges.saved": "Rentang referensi telah disimpan.",
  "label.testCatalog.ranges.loadError": "Tidak dapat memuat rentang referensi.",
  "label.testCatalog.ranges.col.component": "Komponen",
  "label.testCatalog.ranges.allComponents": "Semua komponen",
  "label.testCatalog.ranges.col.sex": "Jenis Kelamin",
  "label.testCatalog.ranges.col.age": "Rentang Umur",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Kritis",
  "label.testCatalog.ranges.col.valid": "Validasi",
  "label.testCatalog.ranges.col.actions": "Aksi",
  "label.testCatalog.ranges.anyAge": "Umur apa saja",
  "label.testCatalog.ranges.coverage.title": "Validasi cakupan",
  "label.testCatalog.ranges.coverage.gapsHeading": "Jendela umur yang belum teridentifikasi:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Tersedia secara lengkap",
  "label.testCatalog.ranges.coverage.status.GAP": "Ada celah-celah",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Terdapat bagian yang tumpang tindih",
  "label.testCatalog.ranges.coverage.status.EMPTY": "Tidak ada rentang",
  "label.testCatalog.ranges.modal.titleAdd": "Tambah rentang referensi",
  "label.testCatalog.ranges.modal.titleEdit": "Edit rentang referensi",
  "label.testCatalog.ranges.modal.sex": "Terapkan untuk",
  "label.testCatalog.ranges.modal.component": "Komponen hasil",
  "label.testCatalog.ranges.modal.component.all": "Semua komponen",
  "label.testCatalog.ranges.modal.ageUnit": "Satuan umur",
  "label.testCatalog.ranges.modal.minAge": "Dari umur",
  "label.testCatalog.ranges.modal.maxAge": "Hingga umur (kosong = tidak ada batas atas)",
  "label.testCatalog.ranges.modal.lowNormal": "Rendah normal",
  "label.testCatalog.ranges.modal.highNormal": "Tinggi normal",
  "label.testCatalog.ranges.modal.lowCritical": "Rendah kritis",
  "label.testCatalog.ranges.modal.highCritical": "Tingkat kritis tinggi",
  "label.testCatalog.ranges.modal.lowValid": "Nilai rendah yang sah",
  "label.testCatalog.ranges.modal.highValid": "Tinggi yang valid",
  "label.testCatalog.ranges.modal.ageError": "“Umur” harus lebih besar dari “Dari umur”.",
  "label.testCatalog.ranges.modal.boundsError": "Batas-batas harus disusun secara bertingkat ke luar: batas rendah valid ≤ batas rendah kritis ≤ batas rendah normal ≤ batas tinggi normal ≤ batas tinggi kritis ≤ batas tinggi valid.",
  "label.testCatalog.storage.saved": "Penyimpanan sampel telah disimpan.",
  "label.testCatalog.storage.loadError": "Tidak dapat memuat pengaturan Penyimpanan Sampel.",
  "label.testCatalog.storage.history.view": "Lihat riwayat perubahan",
  "label.testCatalog.storage.history.title": "Penyimpanan Sampel — Riwayat Perubahan",
  "label.testCatalog.storage.history.loadError": "Tidak dapat memuat riwayat perubahan.",
  "label.testCatalog.storage.history.empty": "Tidak ada perubahan yang tercatat.",
  "label.testCatalog.storage.history.filter": "Saring berdasarkan bidang",
  "label.testCatalog.storage.history.col.changedAt": "Diubah pada",
  "label.testCatalog.storage.history.col.changedBy": "Diubah oleh",
  "label.testCatalog.storage.history.col.field": "Bidang",
  "label.testCatalog.storage.history.col.old": "Nilai Lama",
  "label.testCatalog.storage.history.col.new": "Nilai Baru",
  "label.testCatalog.storage.storageHeading": "Penyimpanan",
  "label.testCatalog.storage.disposalHeading": "Musnahkan",
  "label.testCatalog.storage.handlingHeading": "Penanganan khusus",
  "label.testCatalog.storage.condition": "Kondisi penyimpanan",
  "label.testCatalog.storage.conditionCustom": "Kondisi khusus",
  "label.testCatalog.storage.duration": "Durasi penyimpanan maksimum",
  "label.testCatalog.storage.durationUnit": "Satuan durasi",
  "label.testCatalog.storage.stabilityNotes": "Catatan Stabilitas",
  "label.testCatalog.storage.protectFromLight": "Lindungi dari cahaya",
  "label.testCatalog.storage.doNotFreeze": "Jangan dibekukan",
  "label.testCatalog.storage.doNotRefrigerate": "Jangan disimpan di lemari es",
  "label.testCatalog.storage.disposalMethod": "Metode pembuangan",
  "label.testCatalog.storage.disposalTimeframe": "Jangka waktu musnahkan",
  "label.testCatalog.storage.disposalUnit": "Satuan rentang waktu",
  "label.testCatalog.storage.specialInstructions": "Petunjuk khusus",
  "label.testCatalog.storage.overrideRestricted": "Membatasi penggantian durasi penyimpanan",
  "label.testCatalog.storage.none": "— tidak ada —",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient (Suhu Ruangan)",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Suhu ruangan yang dikendalikan (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Ruangan pendingin (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Ruangan pendingin (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Didinginkan (2–8 °C)",
  "label.testCatalog.storage.condition.FROZEN": "Beku (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Dibekukan dalam suhu sangat rendah (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Lemari pembeku bersuhu sangat rendah (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Inkubator hangat (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Pembakaran",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoklaf",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Desinfeksi kimiawi",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Limbah berbahaya biologis",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Wadah limbah tajam",
  "label.testCatalog.storage.disposal.SEWER": "Pembuangan limbah saluran pembuangan / saluran air",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Kembalikan kepada pengirim",
  "label.testCatalog.storage.disposal.ARCHIVE": "Arsip jangka panjang",
  "label.testCatalog.storage.disposal.STANDARD": "Sampah umum",
  "label.testCatalog.storage.unit.hours": "jam",
  "label.testCatalog.storage.unit.days": "hari",
  "label.testCatalog.storage.unit.weeks": "mingguan",
  "label.testCatalog.storage.unit.months": "bulan",
  "label.testCatalog.analyzers.infoCard": "Alat analisis dihubungkan ke pemeriksaan ini pada layar Konfigurasi alat analisis. Daftar ini bersifat hanya baca.",
  "label.testCatalog.analyzers.empty": "Tidak ada alat analisis yang dipetakan ke pemeriksaan ini.",
  "label.testCatalog.analyzers.loadError": "Tidak dapat memuat alat analisis untuk pemeriksaan ini.",
  "label.testCatalog.analyzers.col.analyzer": "Alat",
  "label.testCatalog.analyzers.col.testName": "Nama Pemeriksaan Alat",
  "label.testCatalog.displayOrder.pickSampleType": "Jenis sampel",
  "label.testCatalog.displayOrder.intro": "Atur ulang urutan penampilan tes dalam suatu jenis sampel. Urutan tersebut akan disimpan secara otomatis.",
  "label.testCatalog.displayOrder.empty": "Tidak ada pemeriksaan yang ditugaskan ke jenis sampel ini.",
  "label.testCatalog.displayOrder.loadError": "Tidak dapat memuat urutan tampilan.",
  "label.testCatalog.displayOrder.saved": "Urutan tampilan disimpan.",
  "label.testCatalog.displayOrder.moveUp": "Geser ke atas",
  "label.testCatalog.displayOrder.moveDown": "Geser ke bawah",
  "label.testCatalog.displayOrder.col.position": "Posisi",
  "label.testCatalog.displayOrder.col.test": "Pemeriksaan",
  "label.testCatalog.displayOrder.dragHandle": "Seret untuk mengatur ulang urutannya",
  "label.testCatalog.terminology.intro": "Sesuaikan pemeriksaan ini dengan kode terminologi standar demi interoperabilitas.",
  "vector.collectedVolume.helper": "Jumlah organisme di kolam ini, misalnya, jumlah nyamuk.",
  "vector.complete.animal": "Hewan",
  "vector.complete.cancel": "Batal",
  "vector.complete.details.collectionDate": "Tanggal Pengambilan",
  "vector.complete.details.collectionSite": "Tempat Pengambilan",
  "vector.complete.details.collector": "Pengambil sampel",
  "vector.complete.details.lifecycleStage": "Tahapan Siklus Hidup",
  "vector.complete.details.tests": "Pemeriksaan",
  "vector.complete.details.title": "Rincian Pemesanan",
  "vector.complete.details.trapType": "Jenis Perangkap",
  "vector.complete.labNumber": "Nomor Registrasi",
  "vector.complete.newOrder": "Pemesanan Vektor Baru",
  "vector.complete.quantity": "Kuantitas",
  "vector.complete.quantity.value": "{count} Organisme",
  "vector.complete.status": "Status",
  "vector.complete.status.processing": "Pemrosesan",
  "vector.lifecycleStage.helper": "Tahapan perkembangan organisme yang diambil.",
  "vector.order.collectionContext.helper": "Opsional — mencatat kondisi ekologis pada saat pengambilan (bionomik).",
  "vector.order.collectionDate.heading": "Tanggal Pengambilan",
  "vector.order.collectionDate.helper": "Tanggal pengambilan sampel secara langsung dari lapangan. Berlaku untuk setiap sampel dalam pesanan ini.",
  "vector.order.site.add.new": "+ Tambahkan tempat baru \"{name}\"",
  "vector.order.site.add.new.restricted": "Fitur penambahan tempat pengambilan sampel baru telah dinonaktifkan oleh administrator Anda.",
  "vector.order.site.new.helper": "Akan dibuat sebagai tempat pengambilan sampel baru saat pesanan ini disimpan.",
  "vector.order.site.new.tag": "Baru",
  "vector.order.site.no.match": "Tidak ditemukan situs yang sesuai.",
  "vector.pool.noTests": "Tidak ada pemeriksaan yang tercatat",
  "vector.pool.summary": "Kumpulan foto {count} {animal}",
  "vector.trapCount.helper": "Jumlah perangkap yang dipasang — digunakan bersama dengan jumlah malam untuk menghitung kepadatan per malam per perangkap.",
  "vector.trapNights.helper": "Jumlah malam perangkap tersebut sudah aktif. Biarkan kosong jika upaya tersebut tidak terekam.",
  "vector.trapType.helper": "Metode atau perangkat pengambilan sampel yang digunakan — pilih jenis sampel terlebih dahulu.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} ditugaskan · {pools} pools",
  "vectorDec.button.back": "Kembali",
  "vectorDec.button.discard": "Buang",
  "vectorDec.button.previewGrouping": "Pratinjau Pengelompokan",
  "vectorDec.button.savePools": "Simpan Kolam",
  "vectorDec.button.splitIndividuals": "Dipisahkan ke masing-masing individu →",
  "vectorDec.button.splitIndividuals.tooltip": "Pengaturan cepat: satu spesimen per Pool",
  "vectorDec.button.view": "Lihat",
  "vectorDec.col.children": "Spesimen Anak-Anak",
  "vectorDec.col.positiveTest": "Hasil Pemeriksaan Positif",
  "vectorDec.col.results": "Hasil",
  "vectorDec.col.status": "Status",
  "vectorDec.empty": "Tidak ada tugas dekonvolusi.",
  "vectorDec.error.initiateFailed": "Tidak dapat memulai proses dekonvolusi.",
  "vectorDec.error.loadWorklist": "Tidak dapat memuat daftar pekerjaan dekonvolusi.",
  "vectorDec.error.minPoolCount": "Jumlah pool harus minimal 2.",
  "vectorDec.error.noAssignedSpecimens": "Seret setidaknya satu spesimen ke dalam kolam sebelum menyimpannya.",
  "vectorDec.error.noParent": "Tidak ada SampleItem induk yang tersedia untuk dipisahkan.",
  "vectorDec.error.poolFloorByType": "Lot memiliki jenis sampel \"{types}\" ({names}) — wajib memiliki setidaknya {types} pool untuk distribusi acak.",
  "vectorDec.error.unassignedSpecimens": "{count} Spesimen-spesimen tersebut masih tidak ditugaskan. Menugaskan semua spesimen sebelum menyimpan.",
  "vectorDec.field.howManyPools": "Ada berapa kolam renang?",
  "vectorDec.field.notes": "Catatan",
  "vectorDec.field.organismsPerPool": "Jumlah organisme per kolam",
  "vectorDec.field.poolCount": "Jumlah pool",
  "vectorDec.field.strategy": "Metode penugasan",
  "vectorDec.filter.all": "Semua",
  "vectorDec.filter.status": "Filter berdasarkan Status",
  "vectorDec.heading.preview": "Usulan Pengelompokan Kolam",
  "vectorDec.heading.split": "Dipisahkan ke dalam sub-kelompok",
  "vectorDec.heading.worklist": "Dekonvolusi Kolam Renang",
  "vectorDec.individualMode.badge": "Mode individu",
  "vectorDec.locationOverride.help": "Ganti tempat pengambilan sampel yang diwarisi untuk masing-masing sub-kelompok. Gunakan opsi ini jika satu lot sampel diambil dari beberapa lokasi.",
  "vectorDec.locationOverride.inherit": "Mewarisi dari lot (default)",
  "vectorDec.locationOverride.notes": "Catatan alikuot",
  "vectorDec.locationOverride.site": "Tempat Pengambilan",
  "vectorDec.locationOverride.title": "Per lokasi pengambilan sub-kolam (opsional)",
  "vectorDec.message.success": "{count} sub-pool telah dibuat ({labRange}), {orders} pesanan uji telah dimasukkan ke antrian. Status → Proses dekonvolusi sedang dalam pengerjaan.",
  "vectorDec.message.successIndividual": "{count} aliquot individu telah dibuat ({labRange}), {orders} pemesanan tes telah dimasukkan ke antrian. Status → Dekonvolusi Dalam Pengerjaan. Konfirmasi Sporozoit VR-07 akan dijalankan pada hasil positif yang telah dikonfirmasi.",
  "vectorDec.parent.label": "Induk",
  "vectorDec.parent.quantity": "Kuantitas: {qty}",
  "vectorDec.preview.body": "{count} kelompok menggunakan {strategy}. Seret spesimen antar kelompok untuk menyesuaikan sebelum menyimpan.",
  "vectorDec.preview.empty": "Tidak ada spesimen",
  "vectorDec.preview.organisms": "Organisme",
  "vectorDec.preview.poolN": "Kolam Renang {n}",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} other {# specimens}}",
  "vectorDec.preview.title": "Pengelompokan yang diusulkan",
  "vectorDec.preview.unassigned": "{count, plural, =0 {All specimens assigned} one {# unassigned} other {# unassigned}}",
  "vectorDec.preview.unassignedHint": "{count} Tidak ditugaskan — yang ini tetap berada di kumpulan aslinya.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Aturan refleks akan aktif saat melakukan penyelamatan",
  "vectorDec.reflexPreview.parentTests": "Perintah pengujian induk ({test}) — dijalankan ulang pada setiap anak",
  "vectorDec.reflexPreview.screeningPanel": "panel penyaringan",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Tips: Pisahkan menjadi spesimen-spesimen terpisah agar juga dapat memicu {rules} — aturan ini hanya diterapkan pada kelompok yang berisi satu organisme saja.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} specimens → ~{perPool} per pool{remainder, plural, =0 {} other {, remainder +1 to first {remainder}}}",
  "vectorDec.status.complete": "Dekontaminasi Selesai",
  "vectorDec.status.confirmed": "Telah dilakukan konfirmasi",
  "vectorDec.status.inProgress": "Dalam Pengerjaan",
  "vectorDec.status.pending": "Diperlukan Ulasan",
  "vectorDec.strategy.manual": "Menugaskan secara manual — seret dan lepas spesimen ke dalam kelompok",
  "vectorDec.strategy.manual.hint": "Seret dan lepas spesimen ke dalam kolam sendiri",
  "vectorDec.strategy.manual.title": "Menugaskan secara manual",
  "vectorDec.strategy.random": "Menugaskan secara acak — sebarkan spesimen secara merata ke dalam kelompok-kelompok",
  "vectorDec.strategy.random.hint": "Sebarkan spesimen secara merata ke dalam kelompok-kelompok",
  "vectorDec.strategy.random.title": "Menugaskan secara acak",
  "vectorDec.strategy.species": "Sub-kelompok otomatis berdasarkan spesies — mengelompokkan spesimen yang serupa",
  "vectorDec.strategy.species.hint": "Digrupkan spesimen berdasar spesies — spesimen wajib mencantumkan identitas spesies",
  "vectorDec.strategy.species.title": "Pengelompokan otomatis oleh spesies",
  "vectorDec.totalOrganisms": "Jumlah organisme",
  "vectorDec.warning.exceedsParent.body": "{total} Organisme yang diminta di seluruh kumpulan anak, tetapi kumpulan induk memiliki nilai {parent}. Sistem tetap akan membuat kumpulan anak bernil{total}.",
  "vectorDec.warning.exceedsParent.title": "Kuantitasnya melebihi kuantitas induknya",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} other {# specimens selected}}",
  "vectorId.bloodMeal.add": "Tambah Panel ke Pemesanan",
  "vectorId.bloodMeal.added": "Panel Identifikasi Tepung Darah ditambahkan ke pesanan pengujian spesimen.",
  "vectorId.bloodMeal.addedSub": "Sumber: manual (saran yang diterima dari teknisi laboratorium). Sesuai BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Panel uji tepung darah sudah terpasang (pemeriksaan {skipped}).",
  "vectorId.bloodMeal.body": "Pesanlah Panel Identifikasi Makanan Darah Nyamuk untuk mengidentifikasi spesies inang yang menjadi sumber makanan spesimen ini.",
  "vectorId.bloodMeal.bulkAdd": "Tambah Panel ke Semua ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Panel analisis tepung darah yang diproses untuk spesimen yang berasal dari spesies {count}.",
  "vectorId.bloodMeal.bulkBody": "Tambah Panel Identifikasi Makanan Darah Nyamuk ke setiap spesimen yang dipilih agar laboratorium dapat mengidentifikasi inang vertebrata mana yang menjadi sumber makanan nyamuk tersebut.",
  "vectorId.bloodMeal.bulkSummary": "Panel tepung darah: {added} telah ditambahkan, {skipped} sudah tercantum, {rejected} ditolak.",
  "vectorId.bloodMeal.bulkTitle": "Perempuan yang telah menghisap darah terdeteksi (spesimen {count})",
  "vectorId.bloodMeal.dismiss": "Tutup",
  "vectorId.bloodMeal.error.add": "Tidak dapat menambahkan Panel Identifikasi Makanan Darah Nyamuk.",
  "vectorId.bloodMeal.error.dismiss": "Tidak dapat merekam pemecatan tersebut.",
  "vectorId.bloodMeal.title": "Terdeteksi perempuan yang baru saja menghisap darah",
  "vectorId.bulk.applyToCount": "Terapkan pada spesimen yang ber{count}",
  "vectorId.bulk.heading": "Terapkan Identitas Spesies Secara Massal",
  "vectorId.bulk.notice.body": "Bidang detail molekuler (gen target, uji, Nomor Registrasi) tidak disalin secara massal — catatlah informasi tersebut untuk setiap spesimen.",
  "vectorId.bulk.notice.title": "Bidang yang spesifik untuk spesimen tidak disalin",
  "vectorId.button.bulkApply": "🔖 Terapkan Massal ({count})",
  "vectorId.button.cancel": "Batal",
  "vectorId.button.close": "▲ Tutup",
  "vectorId.button.confirm": "Konfirmasi",
  "vectorId.button.confirmAll": "✓ Konfirmasi untuk semua vektor",
  "vectorId.button.confirmResult": "✓ Konfirmasi: {test}",
  "vectorId.button.hideResults": "Sembunyikan hasil",
  "vectorId.button.identify": "▼ Identifikasi",
  "vectorId.button.reviewResults": "Hasil tinjauan ({n})",
  "vectorId.button.save": "Simpan Identitas",
  "vectorId.button.splitPool": "↗ Pisahkan",
  "vectorId.col.collectionDate": "Tanggal Pengambilan",
  "vectorId.col.decon": "Dekontaminasi",
  "vectorId.col.decon.help": "Status dekonvolusi — apakah hasil pool telah dimasukkan dan sub-pool sedang menunggu tinjauan.",
  "vectorId.col.idStatus": "Status Identitas",
  "vectorId.col.lotId": "Identitas Lot",
  "vectorId.col.organismGroup": "Kelompok",
  "vectorId.col.progress": "Kemajuan",
  "vectorId.col.site": "Tempat Pengambilan Sampel",
  "vectorId.completion.body": "{positive} dari sub-kelompok \"{total}\" telah dikonfirmasi ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} Vektor yang telah dilakukan konfirmasi",
  "vectorId.completion.body.partial": "Telah dilakukan konfirmasi untuk semua vektor dalam kelompok ini:",
  "vectorId.completion.heading": "Dekonvolusi Selesai",
  "vectorId.completion.heading.confirmed": "Hasil Telah Dikonfirmasi",
  "vectorId.completion.heading.partial": "Hasil Telah Terkonfirmasi Sebagian",
  "vectorId.completion.tag": "Dekontaminasi Selesai",
  "vectorId.completion.tag.confirmed": "Telah dilakukan konfirmasi",
  "vectorId.completion.tag.partial": "Terbukti Sebagian",
  "vectorId.confidence.confirmed": "Telah dilakukan konfirmasi",
  "vectorId.confidence.presumptive": "Dugaan",
  "vectorId.distribution.confirmed": "{count} Telah dikonfirmasi",
  "vectorId.distribution.heading": "Distribusi Spesies",
  "vectorId.distribution.notIdentified": "{count} Tidak Teridentifikasi",
  "vectorId.distribution.notYet": "Belum teridentifikasi",
  "vectorId.distribution.presumptive": "{count} Dugaan",
  "vectorId.empty": "Tidak ada lot dalam antrian ini.",
  "vectorId.error.accessionFormat": "Format nomor registrasi GenBank: 1–2 huruf yang diikuti oleh 5–8 angka (misalnya MW123456).",
  "vectorId.error.confidenceRequired": "Rasa percaya diri wajib.",
  "vectorId.error.loadSpecimens": "Tidak dapat memuat spesimen untuk lot ini.",
  "vectorId.error.loadWorklist": "Tidak dapat memuat daftar pekerjaan.",
  "vectorId.error.methodRequired": "Metode identifikasi wajib.",
  "vectorId.error.notesTooLong": "Catatan harus terdiri dari maksimal 500 karakter.",
  "vectorId.error.requiredFields": "Spesies, metode, dan tingkat kepercayaan wajib dicantumkan.",
  "vectorId.error.saveFailed": "Tidak dapat menyimpan data identifikasi.",
  "vectorId.error.speciesRequired": "Spesies wajib diisi.",
  "vectorId.filter.complete": "Selesai",
  "vectorId.filter.complete.sub": "Semua spesimen telah diidentifikasi.",
  "vectorId.filter.decon": "Dekonvolusi",
  "vectorId.filter.decon.sub": "Hasil pool sudah dimasukkan, sedang menunggu keputusan petugas untuk membaginya atau melakukan konfirmasi.",
  "vectorId.filter.label": "Status",
  "vectorId.filter.notstarted": "Belum dimulai",
  "vectorId.filter.notstarted.sub": "Diterima, 0 spesimen telah diidentifikasi.",
  "vectorId.filter.partialid": "Identitas Sebagian",
  "vectorId.filter.partialid.sub": "Proses identifikasi sedang dalam pengerjaan.",
  "vectorId.filter.pending": "Tertunda",
  "vectorId.filter.pending.sub": "Semua lot yang belum selesai, termasuk kelompok yang hasilnya masih menunggu tinjauan petugas.",
  "vectorId.form.assayName": "Nama Uji",
  "vectorId.form.assayName.placeholder": "PCR multipel",
  "vectorId.form.confidence": "Keyakinan",
  "vectorId.form.genbankAccession": "Nomor Registrasi GenBank",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Tahapan Siklus Hidup",
  "vectorId.form.linkedResult": "Tautan ke Hasil Analisis Patogen",
  "vectorId.form.linkedResultPlaceholder": "Pilih hasil pada bidang tanah ini…",
  "vectorId.form.method": "Metode",
  "vectorId.form.molecularDetails": "🔬 Rincian Molekuler",
  "vectorId.form.notes": "Catatan",
  "vectorId.form.physState": "Status Fisiologis",
  "vectorId.form.select": "Pilih…",
  "vectorId.form.species": "Spesies",
  "vectorId.form.speciesPlaceholder": "Cari genus atau spesies…",
  "vectorId.form.targetGene": "Gen Target",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, rDNA 28S",
  "vectorId.heading.worklist": "Daftar Pekerjaan Identifikasi Vektor",
  "vectorId.loading": "Sedang dimuat…",
  "vectorId.message.bulkSuccess": "Identifikasi yang diterapkan pada spesimen {count}.",
  "vectorId.message.saveSuccess": "Identifikasi telah disimpan.",
  "vectorId.method.both": "Morfologi + Molekuler",
  "vectorId.method.molecular": "Molekuler",
  "vectorId.method.morphological": "Morfologis",
  "vectorId.notif.confirmAll.error": "Hasil tidak dapat dikonfirmasi. Silakan coba lagi.",
  "vectorId.notif.confirmAll.success": "Hasil telah dikonfirmasi untuk semua vektor dalam kelompok ini.",
  "vectorId.notif.deconNeeded.body": "Hasil telah dimasukkan untuk kelompok ini. Pisahkan menjadi kelompok-kelompok kecil untuk pengujian lebih lanjut, atau pastikan bahwa hasil tersebut berlaku untuk semua vektor.",
  "vectorId.notif.deconNeeded.bodyWithTest": "Salah satu pemeriksaan telah menghasilkan hasil. Pisahkan menjadi sub-kelompok untuk pengujian lebih lanjut, atau pastikan bahwa hasil tersebut berlaku untuk semua vektor.",
  "vectorId.notif.deconNeeded.title": "Hasil Pertandingan Menunggu Tinjauan",
  "vectorId.physState.blood_fed": "Telah menghisap darah",
  "vectorId.physState.gravid": "Hamil",
  "vectorId.physState.half_gravid": "Setengah hamil",
  "vectorId.physState.unfed": "Belum diberi makan",
  "vectorId.physState.unknown": "Tidak diketahui / belum dievaluasi",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Cari banyak…",
  "vectorId.specimen.col.confidence": "Keyakinan",
  "vectorId.specimen.col.idStatus": "Status Identitas",
  "vectorId.specimen.col.label": "Spesimen",
  "vectorId.specimen.col.labNo": "Nomor Registrasi",
  "vectorId.specimen.col.poolOrSpecimen": "Kumpulan / Spesimen",
  "vectorId.specimen.col.species": "Spesies",
  "vectorId.specimen.confirmed": "Telah dilakukan konfirmasi",
  "vectorId.specimen.count": "Spesimen",
  "vectorId.specimen.empty": "Tidak ada spesimen untuk lot ini.",
  "vectorId.specimen.label": "Spesimen No.{n}",
  "vectorId.specimen.notIdentified": "Tidak Teridentifikasi",
  "vectorId.specimen.presumptive": "Dugaan",
  "vectorId.status.complete": "Selesai",
  "vectorId.status.inProgress": "Dalam Pengerjaan",
  "vectorId.status.notStarted": "Belum dimulai",
  "vectorId.tag.deconComplete": "Selesai",
  "vectorId.tag.deconInProgress": "Proses dekon sedang dalam pengerjaan",
  "vectorId.tag.deconNeeded": "⚠ Hasil Peninjauan",
  "vectorId.tag.subPoolPending": "{count} sub-pool yang berisi hasil",
  "vectorId.tree.organisms": "{count, plural, one {# organism} other {# organisms}}",
  "vectorReport.density.bySite": "Kepadatan oleh lokasi dan periode",
  "vectorReport.density.effortNotRecorded": "Upaya tidak terekam",
  "vectorReport.density.period": "Periode",
  "vectorReport.density.perTrapNight": "Kepadatan (per malam per perangkap)",
  "vectorReport.density.pools": "Kolam renang",
  "vectorReport.density.site": "Situs",
  "vectorReport.density.specimens": "Spesimen",
  "vectorReport.density.title": "Jumlah spesimen menurut lokasi",
  "vectorReport.density.trapNights": "Malam-malam pesta",
  "vectorReport.description": "Indeks pemantauan yang dihitung dari data pengumpulan vektor, identifikasi spesies, dan hasil pemeriksaan patogen yang tercatat",
  "vectorReport.empty": "Tidak ada data untuk ruang lingkup yang dipilih.",
  "vectorReport.exportPdf": "Ekspor PDF",
  "vectorReport.fieldMap.description": "Atur ulang urutan, sembunyikan, beri label baru, atau beri tag portal pada metrik yang ditampilkan di Manual Entry Helper.",
  "vectorReport.fieldMap.hidden": "Tersembunyi",
  "vectorReport.fieldMap.label": "Label",
  "vectorReport.fieldMap.metric": "Metrik",
  "vectorReport.fieldMap.order": "Pemesanan",
  "vectorReport.fieldMap.portalTag": "Tag portal",
  "vectorReport.fieldMap.title": "Peta Bidang Entri Manual",
  "vectorReport.fieldMap.visibility": "Visibilitas",
  "vectorReport.fieldMap.visible": "Terlihat",
  "vectorReport.fieldMap.visibleLabel": "Tampak di Asisten Entri Manual",
  "vectorReport.filter.allSites": "Semua Tempat",
  "vectorReport.filter.apply": "Terapkan",
  "vectorReport.filter.dateRange": "Rentang Tanggal",
  "vectorReport.filter.from": "Dari",
  "vectorReport.filter.site": "Tempat Pengambilan Sampel",
  "vectorReport.filter.to": "Kepada",
  "vectorReport.freshness": "Kebaruan data",
  "vectorReport.freshness.as": "Data per {time}",
  "vectorReport.freshness.unknown": "Tidak diketahui",
  "vectorReport.generated": "Dibuat:",
  "vectorReport.home": "Beranda",
  "vectorReport.loadError": "Gagal memuat indikator pengawasan. Silakan coba lagi.",
  "vectorReport.manualEntry.confirmBody": "Apakah perlu rekam ringkasan audit angka-angka minggu ini ({periodStart} – {periodEnd})? Pengiriman ulang data minggu tersebut akan dicatat sebagai entri terpisah.",
  "vectorReport.manualEntry.confirmSubmit": "Konfirmasi",
  "vectorReport.manualEntry.copied": "Telah disalin ke papan klip",
  "vectorReport.manualEntry.copy": "Salin nilai",
  "vectorReport.manualEntry.empty": "Tidak ada metrik yang dikonfigurasi untuk periode ini",
  "vectorReport.manualEntry.loading": "Sedang memuat data mingguan...",
  "vectorReport.manualEntry.lowConfidence": "Tingkat kepercayaan menurun (dekonvolusi kumpulan di bawah 95%)",
  "vectorReport.manualEntry.markSubmitted": "Tanda minggu telah dikirim",
  "vectorReport.manualEntry.submitError": "Tidak dapat menyimpan pengiriman",
  "vectorReport.manualEntry.submitted": "Minggu telah ditandai sebagai telah dikirimkan",
  "vectorReport.manualEntry.title": "Alat Bantu Pengisian Manual",
  "vectorReport.manualEntry.week": "Minggu pelaporan",
  "vectorReport.mir.classic": "MIR (klasik)",
  "vectorReport.mir.observed": "Tingkat infeksi (yang teramati)",
  "vectorReport.mir.pathogen": "Patogen",
  "vectorReport.mir.positivePools": "Kelompok positif",
  "vectorReport.mir.resolution": "Penyelesaian yang positif",
  "vectorReport.mir.species": "Spesies",
  "vectorReport.mir.sporozoite": "Tingkat sporozoit",
  "vectorReport.mir.sporozoiteNote": "Tingkat kepercayaan akan menurun jika resolusi dekonvolusi kolam berada di bawah 95%.",
  "vectorReport.mir.title": "Tingkat Infeksi Minimum oleh Spesies",
  "vectorReport.mir.totalSpecimens": "Total Spesimen",
  "vectorReport.mir.withheld": "Ditahan",
  "vectorReport.positivity.notConfigured": "Klasifikasi hasil positif tidak dikonfigurasi untuk penerapan ini, sehingga angka tingkat infeksi, hasil positif, dan sporozoit tidak tersedia. Konfigurasikan tingkat signifikansi hasil di Katalog Pemeriksaan untuk mengaktifkannya.",
  "vectorReport.positivity.pathogen": "Patogen",
  "vectorReport.positivity.pct": "Sikap positif",
  "vectorReport.positivity.poolsPositive": "Kolam renang yang positif",
  "vectorReport.positivity.poolsTested": "Kolam yang telah dilakukan pemeriksaannya",
  "vectorReport.positivity.title": "Hasil positif patogen",
  "vectorReport.positivity.unrecognized": "Beberapa hasil memiliki nilai signifikansi yang tidak termasuk dalam klasifikasi yang diakui (POSITIF, NEGATIF, atau TIDAK JELAS) dan tidak dimasukkan dalam perhitungan hasil positif. Periksa Katalog Pemeriksaan agar hasil-hasil ini dapat dihitung.",
  "vectorReport.prompt": "Pilih rentang tanggal dan lokasi, lalu pilih \"Terapkan\" untuk melihat indeks pemantauan.",
  "vectorReport.qc.detail": "{passed} dari analisis {total} yang lolos",
  "vectorReport.qc.passed": "Analisis telah lolos",
  "vectorReport.qc.passRate": "Tingkat kelulusan",
  "vectorReport.qc.title": "Tingkat kelulusan QC",
  "vectorReport.qc.total": "Jumlah analisis",
  "vectorReport.species.genus": "Genus",
  "vectorReport.species.pct": "Bagikan",
  "vectorReport.species.species": "Spesies",
  "vectorReport.species.specimens": "Spesimen",
  "vectorReport.species.title": "Distribusi spesies",
  "vectorReport.sporozoite.title": "Tingkat sporozoit (Anopheles)",
  "vectorReport.title": "Surveilans Vektor",
  "vfs.abj": "ABJ (Tingkat Bebas Larva)",
  "vfs.abj.target.below": "✗ ABJ di bawah target 95% Kementerian Kesehatan",
  "vfs.abj.target.met": "✓ ABJ memenuhi target 95% yang ditetapkan oleh Kemenkes",
  "vfs.bi": "Indeks Breteau (per 100 rumah)",
  "vfs.ci": "Indeks Wadah (CI)",
  "vfs.containersExamined": "Wadah yang diperiksa",
  "vfs.containersPositive": "Wadah positif",
  "vfs.err.containersExceeded": "Jumlah wadah yang diperiksa tidak boleh melebihi batas yang ditentukan.",
  "vfs.err.examinedMin": "Harus ≥ 1 saat memasukkan data larva.",
  "vfs.err.housesExceeded": "Jumlah rumah yang diperiksa tidak boleh melebihi batas tersebut.",
  "vfs.err.negative": "Tidak boleh negatif.",
  "vfs.err.populationMin": "Harus ≥ 1 saat memasukkan data kepompong.",
  "vfs.hi": "Indeks Rumah (HI)",
  "vfs.housesExamined": "Rumah-rumah yang diperiksa",
  "vfs.housesPositive": "Rumah-rumah yang positif",
  "vfs.indices.title": "Indeks yang dihitung (pratinjau)",
  "vfs.larval.title": "Survei Larva — Mode C",
  "vfs.populationAtRisk": "Kelompok berisiko",
  "vfs.ppi": "Pupa per Orang (PPI)",
  "vfs.pupaeCount": "Jumlah kepompong",
  "vfs.pupal.title": "Survei Kepompong — Mode D",
  "vfs.surveyMethod": "Metode survei",
  "vfs.surveyMethod.placeholder": "Pilih satu opsi",
  "warning.testCatalog.noLoinc": "Tes ini tidak memiliki kode LOINC. Hasil dari Alat dan pesanan elektronik tidak dapat diimpor ke tes ini.",
  "warning.testCatalog.duplicateLoinc": "LOINC ({code}) juga digunakan oleh {testName}. Hasil yang masuk untuk kode ini hanya diarahkan ke satu tes (yang pertama kali cocok) — hasil mungkin dikirim ke tes yang salah.",
  "label.testCatalog.terminology.col.source": "Sumber",
  "label.testCatalog.terminology.col.code": "Kode",
  "label.testCatalog.terminology.col.displayName": "Nama di Tampilan",
  "label.testCatalog.terminology.displayName.placeholder": "misalnya, Glukosa [Massa/volume] dalam Serum atau Plasma",
  "label.testCatalog.terminology.col.relationship": "Hubungan",
  "label.testCatalog.terminology.col.appliesTo": "Terapkan untuk",
  "label.testCatalog.terminology.appliesTo.test": "Seluruh pemeriksaan",
  "label.testCatalog.terminology.col.actions": "Aksi",
  "label.testCatalog.terminology.source": "Sumber terminologi",
  "label.testCatalog.terminology.code": "Kode",
  "label.testCatalog.terminology.relationship": "Hubungan",
  "label.testCatalog.terminology.addMapping": "Tambah Pemetaan",
  "label.testCatalog.terminology.remove": "Hapus pemetaan",
  "label.testCatalog.terminology.empty": "Tidak ada pemetaan terminologi.",
  "label.testCatalog.terminology.loadError": "Tidak dapat memuat pemetaan terminologi.",
  "label.testCatalog.terminology.saved": "Pemetaan terminologi telah disimpan.",
  "error.testCatalog.terminology.duplicate": "Kode \"{source}\" ini duplikat dari {code} — pemetaan ini sudah ada untuk pemeriksaan ini.",
  "error.testCatalog.terminology.invalid": "Pemetaan tidak dapat disimpan — periksa apakah ada kode yang duplikat, sumber yang tidak diketahui, atau hubungan yang tidak valid.",
  "label.testCatalog.terminology.rel.none": "— tidak ada —",
  "label.testCatalog.terminology.rel.SAME_AS": "Sama seperti",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Lebih luas daripada",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Lebih sempit daripada",
  "label.testCatalog.panels.intro": "Kelola panel mana saja yang mencakup pemeriksaan ini, serta posisinya di dalam masing-masing panel tersebut.",
  "label.testCatalog.panels.addToPanel": "Tambah ke panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Posisi",
  "label.testCatalog.panels.col.actions": "Aksi",
  "label.testCatalog.panels.position": "Posisi",
  "label.testCatalog.panels.remove": "Hapus dari panel",
  "label.testCatalog.panels.remove.confirm.heading": "Hapus pemeriksaan dari panel?",
  "label.testCatalog.panels.remove.confirm.body": "Pemeriksaan ini akan dihapus dari {panel}. Pemeriksaan ini tetap ada di Katalog dan panel-panel lain. Anda dapat menambahkannya kembali nanti.",
  "label.testCatalog.panels.moveUp": "Bergeraklah lebih awal",
  "label.testCatalog.panels.moveDown": "Tunda dulu",
  "label.testCatalog.panels.viewOrder": "Lihat urutan pengujian panel ini",
  "label.testCatalog.panels.orderContext": "Pemeriksaan dalam panel ini (berurutan):",
  "label.testCatalog.panels.empty": "Tes ini belum termasuk dalam panel apa pun.",
  "label.testCatalog.panels.loadError": "Tidak dapat memuat keanggotaan panel.",
  "label.testCatalog.panels.saved": "Keanggotaan panel telah disimpan.",
  "label.testCatalog.panels.createPanel": "Buat panel baru",
  "label.testCatalog.panels.createPanelHint": "Masukkan nama untuk membuat panel dan tambahkan tes ini ke dalamnya. Jenis sampel, urutan modul, dan pengaturan lainnya akan dikonfigurasi nanti di Editor Panel.",
  "notification.testCatalog.panels.created": "Panel '{name}' telah dibuat dan pemeriksaan ini telah ditambahkan. Lakukan Konfigurasi lebih lanjut di Panel Editor.",
  "label.search": "Cari",
  "label.testCatalog.list": "Katalog Pemeriksaan",
  "label.testCatalog.list.search": "Cari berdasarkan nama pemeriksaan",
  "label.testCatalog.list.col.status": "Status",
  "label.testCatalog.list.filter.allDomains": "Semua domain",
  "label.testCatalog.list.filter.allStatus": "Semua status",
  "label.testCatalog.list.filter.inactive": "Inaktif",
  "label.testCatalog.list.coverageIncomplete": "Cakupan belum lengkap",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Apa saja",
  "label.testCatalog.list.filter.amrOnly": "Hanya AMR",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Jenis Sampel",
  "label.testCatalog.list.filter.allSampleTypes": "Semua Jenis Sampel",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "Tidak ada LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Hanya pemeriksaan yang mengalami masalah",
  "label.testCatalog.list.health.banner": "{count} Pemeriksaan tersebut mengalami masalah konfigurasi (kesalahan {errors} · peringatan {warnings})",
  "label.testCatalog.list.health.show": "Tampilkan",
  "label.testCatalog.activation.incomplete.heading": "Pemeriksaan tersebut belum dapat diaktifkan",
  "label.testCatalog.activation.incomplete.body": "Selesaikan hal-hal berikut ini sebelum pemeriksaan ini dapat diaktifkan:",
  "label.testCatalog.list.col.sampleType": "Jenis Sampel",
  "button.testCatalog.newTest": "Pemeriksaan baru",
  "button.testCatalog.editRelated": "Edit pemeriksaan terkait secara bersamaan",
  "button.testCatalog.editRelatedFromEditor": "Edit pemeriksaan yang terkait…",
  "label.testCatalog.editor.noRelated": "Tidak ada pemeriksaan terkait yang memiliki nama yang sama dengan pemeriksaan ini.",
  "label.testCatalog.editor.createSaveFirst.title": "Simpan dulu hasil pemeriksaannya",
  "label.testCatalog.editor.createSaveFirst": "Selesaii Informasi Dasar dan simpan. Bagian ini akan tersedia setelah pemeriksaan dibuat.",
  "label.testCatalog.editingNTests": "Mengedit pemeriksaan `{count}`",
  "label.testCatalog.perTestIdentity": "Identitas & LOINC (per pemeriksaan)",
  "state.testCatalog.differsAcrossTests": "Berbeda-beda antar pemeriksaan",
  "button.testCatalog.setAllTo": "Atur semuanya ke nilai-nilai ini",
  "label.testCatalog.group.rangesSaved": "Rentang referensi telah disimpan ke pemeriksaan-{count}.",
  "label.testCatalog.group.storageIntro": "Edit pengaturan penyimpanan & penanganan sekali saja; penghematan yang dilakukan akan diterapkan ke setiap Pemeriksaan yang dipilih.",
  "button.testCatalog.removeFromSet": "Hapus dari himpunan ini",
  "label.testCatalog.group.rangesIntro": "Edit rentang referensi sekali saja; setelah disimpan, pengaturan tersebut akan diterapkan ke semua pemeriksaan yang dipilih. Identitas dan LOINC tetap berlaku per pemeriksaan.",
  "label.testCatalog.group.rangesDiffer": "Rentang arus pada pemeriksaan yang dipilih tidak sama. Jika Anda menyimpan pengaturan ini, semua pemeriksaan akan disetel ke nilai-nilai di bawah ini.",
  "label.testCatalog.ranges.table.sex": "Terapkan untuk",
  "label.testCatalog.ranges.table.age": "Rentang Umur",
  "label.testCatalog.ranges.table.normal": "Normal (rendah / tinggi)",
  "label.testCatalog.list.filters": "Filter",
  "label.testCatalog.list.filters.count": "Filter ({count})",
  "label.testCatalog.list.error": "Katalog Pemeriksaan tidak dapat dimuat. Sesuaikan filter atau muat ulang untuk mencoba lagi.",
  "label.testCatalog.list.empty": "Tidak ada pemeriksaan yang sesuai dengan filter saat ini.",
  "sidenav.label.admin.testmgt.ManageMethod": "Pengelolaan Metode",
  "sidenav.label.admin.testmgt.reflex": "Pengelolaan Pemeriksaan Refleks",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Lihat Katalog Pemeriksaan",
  "sidenav.label.admin.usermgt": "Pengelolaan Pengguna",
  "sideNav.label.arvfollowup1": "ARV Tindak Lanjut Versi 1",
  "sideNav.label.arvfollowup2": "ARV TIndak Lanjut Versi 2",
  "sideNav.label.arvreports1": "ARV Awal Versi 1",
  "sideNav.label.arvreports2": "ARV Awal Versi 2",
  "sideNav.label.arvversion1": "ARV-Versi 1",
  "sideNav.label.associatedpatientreport": "Laporan Pasien Terkait",
  "sideNav.label.audittrail": "Jejak Audit",
  "sidenav.label.barcode": "kode QR",
  "sidenav.label.batchorder": "Entri Pemesanan Batch",
  "sideNav.label.bypaneltype": "Berdasarkan Jenis Panel",
  "sideNav.label.bytesttype": "Berdasarkan Jenis Pemeriksaan",
  "sideNav.label.byunit": "Berdasarkan Unit",
  "sideNav.label.collectedarvpatientreports": "Kumpulan Laporan Pasien ARV",
  "sidenav.label.cytology": "Sitologi",
  "sidenav.label.cytology.dashboard": "Dasbor",
  "sideNav.label.delayedvalidation": "Validasi Tertunda",
  "sidenav.label.editorder": "Edit Pemesanan",
  "sideNav.label.eidreports1": "EID Versi 1",
  "sideNav.label.eidreports2": "EID Versi 2",
  "sideNav.label.exportcsvfile": "Ekspor file CSV rutin",
  "sideNav.label.followuprequired": "Diperlukan Tindak Lanjut",
  "sideNav.label.generalreport": "Laporan Umum",
  "sideNav.label.hivtestsummary": "Ringkasan Pemeriksaan HIV",
  "sidenav.label.immunochem": "Imunohistokimia",
  "sidenav.label.immunochem.dashboard": "Dasbor",
  "sidenav.label.incomingorder": "Permintaan elektronik",
  "sideNav.label.intermediatebyservice": "Internediate berdasarkan Layanan",
  "sideNav.label.intermediatereport1": "Intermediate Versi 1",
  "sideNav.label.intermediatereport2": "Internediate Versi 2",
  "sidenav.label.inventory": "Inventaris",
  "sidenav.label.inventory.management": "Pengelolaan inventaris",
  "sidenav.label.inventory.management.tooltip": "Kelola barang inventaris, lot dan jumlah stok",
  "sidenav.label.inventory.tooltip": "Pengelolaan inventaris untuk reagen, kit dan pasokan",
  "sideNav.label.laporanHasil": "Laporan Kepatuhan",
  "sideNav.label.noncomformitynotification": "Notifikasi Ketidaksesuaian",
  "sideNav.label.noncomformityreportsbydate": "Berdasarkan Tanggal",
  "sideNav.label.noncomformityreportsbylabno": "Berdasarkan No Lab",
  "sideNav.label.noncomformityreportsbyunit": "Berdasarkan Unit dan Alasan",
  "sidenav.label.notebook": "Buku Catatan",
  "sidenav.label.add.order": "Tambah Pemesanan",
  "sidenav.label.clinical.order": "Tambah Pemesanan Klinis",
  "sidenav.label.environmental.compliance": "Dasbor Kepatuhan",
  "sidenav.label.environmental.order": "Tambah Pemesanan Lingkungan",
  "sidenav.label.vector.order": "Tambah Pemesanan Vektor",
  "sidenav.label.order": "Pemesanan",
  "sidenav.label.order.collect": "Ambil Sampel",
  "sidenav.label.order.dashboard": "Dasbor",
  "sidenav.label.order.enter": "Masukkan Pemesanan",
  "sidenav.label.order.label": "Label & Simpan",
  "sidenav.label.order.qa": "Tinjauan QA",
  "sidenav.label.pathology": "Patologi",
  "sidenav.label.pathology.dashboard": "Dasbor",
  "sideNav.label.referredtestreport": "Laporan Pemeriksaan yang dirujuk ke luar",
  "sideNav.label.rejectionreport": "Laporan Penolakan",
  "sidenav.label.reports": "Laporan",
  "sidenav.label.reports.routine": "Rutin",
  "sidenav.label.reports.study": "Kajian",
  "sidenav.label.results": "Hasil",
  "sidenav.label.results.byrange": "Berdasarkan Rentang Nomor Registrasi",
  "sidenav.label.results.order": "Berdasarkan Permintaan",
  "sidenav.label.results.patient": "Berdasarkan Pasien",
  "sidenav.label.results.testdate": "Berdasarkan Tanggal Pemeriksaan",
  "sidenav.label.results.unit": "Berdasarkan Unit",
  "sideNav.label.sectionperformance": "Kinerja Bagian",
  "sideNav.label.specialrequest": "Permintaan Khusus",
  "sidenav.label.statisticsreport": "Laporan Statistik",
  "sidenav.label.statusreport": "Laporan Status Pasien",
  "sidenav.label.storage.coldstorage": "Pemantauan Penyimpanan Dingin",
  "sidenav.label.storage.coldstorage.tooltip": "Memantau suhu dan kelembaban freezer dan kulkas",
  "sidenav.label.storage.management": "Pengelolaan Penyimpanan",
  "sidenav.label.storage.management.tooltip": "Pengelolaan lokasi penyimpanan dan perangkat",
  "sidenav.label.testsummary": "Ringkasan Semua Pemeriksaan",
  "sidenav.label.validation": "Validasi",
  "sidenav.label.validation.order": "Cari Berdasarkan Permintaan",
  "sidenav.label.validation.routine": "Rutin",
  "sidenav.label.validation.study": "Kajian",
  "sidenav.label.validation.testdate": "Cari Berdasarkan Tanggal Pemeriksaan",
  "sideNav.label.viralloaddataexport": "Ekspor Data Viral Load",
  "sideNav.label.vlversionnational": "Versi VL Nasional",
  "sidenav.label.workplan": "Rencana Kerja",
  "sidenav.label.workplan.panel": "Berdasarkan Jenis Panel",
  "sidenav.label.workplan.priority": "Berdasarkan Prioritas",
  "sidenav.label.workplan.test": "Berdasarkan Jenis Pemeriksaan",
  "sidenav.label.workplan.unit": "Berdasarkan Unit",
  "sideNav.title.activityreport": "Laporan Kegiatan",
  "sidenav.title.aggregatereport": "Laporan Agregat",
  "sideNav.title.arvreports": "Laporan ARV",
  "sideNav.title.associatedpatientreport": "Laporan Terkait Pasien",
  "sideNav.title.audittrail": "Jejak Audit",
  "sideNav.title.collectedarvpatientreports": "Kumpulan Laporan pasien ARV",
  "sideNav.title.delayedvalidation": "Validasi Tertunda",
  "sideNav.title.eidreports": "Laporan EID",
  "sideNav.title.environmentalReports": "Laporan Lingkungan",
  "sideNav.title.exportbydate": "Ekspor berdasarkan Tanggal",
  "sideNav.title.exportcsvfile": "Ekspor CSV file Rutin",
  "sideNav.title.indicator": "Indikator",
  "sideNav.title.intermediatereport": "Laporan Intermediate",
  "sideNav.title.noncomformityreports": "Laporan Ketidaksesuaian",
  "sideNav.title.referredtestreport": "Laporan Pemeriksaan yang dirujuk ke luar",
  "sideNav.title.rejectionreport": "Laporan Penolakan",
  "sideNav.title.specialrequest": "Permintaan Khusus",
  "sideNav.title.tatreport": "Waktu Penyelesaian",
  "sideNav.title.vectorIdentification": "Identifikasi Vektor",
  "sideNav.title.vlreport": "Laporan VL",
  "sideNav.label.audittrail.orderEvents": "Event Pemesanan",
  "sideNav.label.audittrail.systemEvents": "Event Sistem",
  "sidenav.label.addorder": "Tambah Permintaan",
  "sidenav.label.admin.sampleTypeManagement": "Editor Jenis Sampel",
  "sideNav.label.qa": "Quality Assurance",
  "sideNav.label.qa.overview": "QA Overview",
  "sideNav.label.qa.qc": "Statistical QC",
  "sideNav.label.qa.qc.dashboard": "Dasbor QC",
  "sideNav.label.qa.qc.alerts": "Peringatan QC",
  "sideNav.label.qa.qc.controlLots": "QC Lot Management",
  "sideNav.label.qa.qc.ruleConfig": "Konfigurasi Aturan",
  "sideNav.label.qa.qc.reagentQc": "Reagent QC",
  "sideNav.label.qa.qc.manualQc": "Analyzer Manual QC",
  "sideNav.label.qa.qi": "Quality Indicators",
  "sideNav.label.qa.qi.dashboard": "QI Dashboard",
  "sideNav.label.qa.qi.config": "QI Configuration",
  "qa.qiConfig.subtitle": "Set per-indicator target and action thresholds, enable or disable indicators, and override thresholds for specific test sections.",
  "qa.qiConfig.column.overrides": "Overrides",
  "qa.qiConfig.field.enabled": "Track this indicator",
  "qa.qiConfig.field.target": "Target",
  "qa.qiConfig.field.action": "Action threshold",
  "qa.qiConfig.field.category": "Test section",
  "qa.qiConfig.editor.title": "Edit {indicator}",
  "qa.qiConfig.editor.defaults": "Default thresholds",
  "qa.qiConfig.editor.overrides": "Per-section overrides",
  "qa.qiConfig.editor.usesDefault": "Test sections without an override use the indicator default.",
  "qa.qiConfig.editor.noOverrides": "No overrides — every test section uses the default.",
  "qa.qiConfig.editor.addOverride": "Add section override",
  "qa.qiConfig.editor.autoNce": "When the month-to-date value breaches the action threshold, a non-conforming event is created automatically (one per indicator per month).",
  "qa.qiConfig.indicator.tat": "Average Turnaround Time",
  "qa.qiConfig.indicator.rejection": "Rejection Rate",
  "qa.qiConfig.indicator.amendment": "Amendment Rate",
  "qa.qiConfig.indicator.nce": "NCE Pulse",
  "qa.qiConfig.indicator.callback": "Critical Callback Compliance",
  "qa.qiConfig.validation.required": "Both target and action thresholds are required.",
  "qa.qiConfig.validation.range": "Thresholds must be between 0 and 100.",
  "qa.qiConfig.validation.direction": "Target and action threshold are in the wrong order for this indicator.",
  "qa.qiConfig.validation.category": "Choose a test section for each override.",
  "qa.qiConfig.validation.duplicateCategory": "A test section can only be overridden once.",
  "qa.qiConfig.confirmDisableTitle": "Disable this indicator?",
  "qa.qiConfig.confirmDisableBody": "This will hide the dashboard tile, suppress new alerts, and stop auto-generated NCEs for this indicator. Historical data is preserved. Continue?",
  "qa.qiConfig.saveFailed": "Could not save QI configuration.",
  "sideNav.label.qa.qms": "QMS & Improvement",
  "sideNav.label.qa.qms.esigLog": "Electronic Signature Log",
  "sideNav.label.qa.qms.capaRegister": "CAPA Register",
  "sideNav.label.qa.qms.accreditation": "Accreditation",
  "qa.qms.capaRegister.subtitle": "Every corrective and preventive action across all non-conforming events, with due dates and status.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Due This Week",
  "qa.qms.capaRegister.tile.completed": "Completed (90d)",
  "qa.qms.capaRegister.filter.assignee": "Assignee",
  "qa.qms.capaRegister.filter.from": "Due Date (From)",
  "qa.qms.capaRegister.filter.to": "Due Date (To)",
  "qa.qms.capaRegister.column.correctiveAction": "Corrective / Preventive Action",
  "qa.qms.capaRegister.column.assignee": "Person Responsible",
  "qa.qms.capaRegister.status.open": "Buka",
  "qa.qms.capaRegister.status.overdue": "Lewat tenggat",
  "qa.qms.capaRegister.status.completed": "Selesai",
  "qa.qms.capaRegister.error": "The CAPA register could not be loaded.",
  "qa.qms.accreditation.title": "Test Accreditation",
  "qa.qms.accreditation.subtitle": "Accrediting bodies and per-test enrollment. Drives the accreditation logos on patient reports and the inspector-readiness answer.",
  "qa.qms.accreditation.error": "Accreditation data could not be loaded.",
  "qa.qms.accreditation.actionError": "The change could not be saved.",
  "qa.qms.accreditation.tile.total": "Bodies",
  "qa.qms.accreditation.inForce": "In force: {names}",
  "qa.qms.accreditation.bodies.title": "Accrediting Bodies",
  "qa.qms.accreditation.bodies.add": "Add body",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Expires",
  "qa.qms.accreditation.status.ACTIVE": "Aktif",
  "qa.qms.accreditation.status.EXPIRING": "Expiring soon",
  "qa.qms.accreditation.status.EXPIRED": "Kedaluwarsa",
  "qa.qms.accreditation.status.INACTIVE": "Inaktif",
  "qa.qms.accreditation.body.modal.addTitle": "Add Accrediting Body",
  "qa.qms.accreditation.body.modal.editTitle": "Edit Accrediting Body",
  "qa.qms.accreditation.body.edit": "Edit body",
  "qa.qms.accreditation.body.delete": "Delete body",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 characters: capitals, digits and hyphens. Cannot be changed later.",
  "qa.qms.accreditation.body.field.expiresOn": "Accreditation expires",
  "qa.qms.accreditation.body.field.visibilityMode": "Show the logo on a report when",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Any accredited test is on the report",
  "qa.qms.accreditation.visibility.PERCENTAGE": "A percentage of the report's tests are accredited",
  "qa.qms.accreditation.body.field.thresholdPct": "Threshold (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG or JPEG, at least 64×64 pixels, up to 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Remove logo",
  "qa.qms.accreditation.body.required": "Code, name and expiry date are required.",
  "qa.qms.accreditation.body.saveError": "The accrediting body could not be saved.",
  "qa.qms.accreditation.body.logoError": "The logo could not be uploaded. Use a PNG or JPEG of at least 64×64 pixels and no more than 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Delete Accrediting Body",
  "qa.qms.accreditation.body.delete.body": "Delete {name}? This cannot be undone.",
  "qa.qms.accreditation.body.delete.blocked": "Cannot delete — {count} test accreditations reference this body. Remove them first.",
  "qa.qms.accreditation.enrollments.title": "Enrolled Tests",
  "qa.qms.accreditation.enrollments.add": "Enroll tests",
  "qa.qms.accreditation.enrollment.column.body": "Accrediting Body",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Effective From",
  "qa.qms.accreditation.enrollment.column.expires": "Body Expires",
  "qa.qms.accreditation.enrollment.remove": "Remove enrollment",
  "qa.qms.accreditation.eqa.title": "EQA Coverage of Accredited Scope",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 asks whether every test you claim as accredited takes part in external quality assessment. This compares accredited scope against active EQA enrollments.",
  "qa.qms.accreditation.eqa.column.scope": "Tests in Scope",
  "qa.qms.accreditation.eqa.column.covered": "Covered by EQA",
  "qa.qms.accreditation.eqa.column.gaps": "Gaps",
  "qa.qms.accreditation.eqa.noGaps": "Full coverage",
  "qa.qms.accreditation.eqa.gapsMore": "{names} and {count} more",
  "qa.qms.accreditation.eqa.error": "EQA coverage could not be loaded.",
  "qa.qms.accreditation.filter.body": "Accrediting body",
  "qa.qms.accreditation.filter.test": "Test: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Enroll Tests",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Effective from (optional)",
  "qa.qms.accreditation.enroll.required": "Select an accrediting body and at least one test.",
  "qa.qms.accreditation.enroll.failed": "The enrollment was rejected.",
  "qa.qms.accreditation.enrollment.delete.title": "Remove Enrollment",
  "qa.qms.accreditation.enrollment.delete.body": "Remove {test} from {body}?",
  "qa.qms.esigLog.subtitle": "Every electronic signature recorded in the system — who signed what, when, and why.",
  "qa.qms.esigLog.column.signer": "Signer",
  "qa.qms.esigLog.column.subject": "Subjek",
  "qa.qms.esigLog.filter.subjectType": "Subject Type",
  "qa.qms.esigLog.filter.apply": "Apply Filters",
  "qa.qms.esigLog.export.confirm.title": "Export without filters?",
  "qa.qms.esigLog.export.confirm.body": "No filters are applied, so this exports every signature in the selected date range (up to 10,000 rows).",
  "qa.qms.esigLog.meaning.AUTHORED": "Dibuat oleh",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Validated & Released",
  "qa.qms.esigLog.meaning.REJECTED": "Ditolak",
  "qa.qms.esigLog.error": "Unable to load the signature log. Please try again.",
  "qa.qi.dashboard.subtitle": "Five quality indicators including the optional Critical Callback Compliance opt-in.",
  "qa.qi.dashboard.window.label": "Reporting window",
  "qa.qi.dashboard.window.7d": "Rolling 7 days",
  "qa.qi.dashboard.window.30d": "Rolling 30 days",
  "qa.qi.dashboard.window.90d": "Rolling 90 days",
  "qa.qi.dashboard.window.ytd": "Year to date",
  "qa.qi.dashboard.lastRecomputed": "Last recomputed: {time}",
  "qa.qi.dashboard.viewDetail": "View detail",
  "qa.qi.dashboard.tileInfo": "What does this tile measure?",
  "qa.qi.disabled.toast.title": "Indicator disabled",
  "qa.qi.disabled.toast.message": "This quality indicator is disabled in QI Configuration; its detail page is unavailable.",
  "qa.qi.dashboard.tile.tat.label": "Average TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "Average turnaround time from sample receipt to result validation, across all completed test orders in the reporting window.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.tat.secondary": "Across {count, plural, one {# lab unit} other {# lab units}} · Slowest: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "No completed test orders in this window.",
  "qa.qi.dashboard.tile.tat.error": "Turnaround data is unavailable.",
  "qa.qi.dashboard.tile.rejection.label": "Rejection Rate",
  "qa.qi.dashboard.tile.amendment.label": "Amendment Rate",
  "qa.qi.dashboard.tile.ncePulse.label": "NCE Pulse",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Critical non-conforming events not yet acknowledged, as of now. A current count, not a trend.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "critical pending",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.qi.dashboard.tile.ncePulse.error": "NCE data is unavailable.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Results corrected after their patient report went out, as a share of results released in the reporting window.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} amended of {released} released",
  "qa.qi.dashboard.tile.amendment.empty": "No results released in this window.",
  "qa.qi.dashboard.tile.amendment.error": "Amendment data is unavailable.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Tests rejected at results entry or validation, as a share of tests started in the reporting window.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} rejected of {total} started",
  "qa.qi.dashboard.tile.rejection.empty": "No tests started in this window.",
  "qa.qi.dashboard.tile.rejection.error": "Rejection data is unavailable.",
  "qa.qi.dashboard.tile.thresholds": "Target {target} · action {action}",
  "qa.qi.amendment.title": "Amendment Rate — Detail",
  "qa.qi.amendment.subtitle": "Results corrected after their patient report went out.",
  "qa.qi.amendment.column.amendedAt": "Amended at",
  "qa.qi.amendment.column.priorValue": "Prior value",
  "qa.qi.amendment.column.currentValue": "Current value",
  "qa.qi.amendment.column.amendedBy": "Amended by",
  "qa.qi.amendment.column.releasedAt": "Released at",
  "qa.qi.amendment.column.timeToAmend": "Time to amend",
  "qa.qi.amendment.rate.label": "Amendment rate",
  "qa.qi.amendment.trend.empty": "No trend data in this window.",
  "qa.qi.amendment.breakdown.title": "By test",
  "qa.qi.amendment.breakdown.column.rate": "Rate",
  "qa.qi.rejection.title": "Rejection Rate — Detail",
  "qa.qi.rejection.subtitle": "Tests rejected at results entry, with the recorded rejection reason.",
  "qa.qi.rejection.column.rejectedAt": "Rejected at",
  "qa.qi.rejection.column.rejectedBy": "Rejected by",
  "qa.qi.rejection.heatmap.title": "Heatmap: ordering location × test section",
  "qa.qi.rejection.heatmap.section": "Test section",
  "qa.qi.rejection.heatmap.unknown": "Unknown location",
  "qa.qi.rejection.heatmap.unknownSection": "Unknown section",
  "qa.qi.rejection.heatmap.legend": "Cells colored by rate against the lab's thresholds: green ≤ {target}%, amber in between, red ≥ {action}%. Hover a cell for rejected / started counts.",
  "qa.qi.rejection.rate.label": "Rejection rate",
  "qa.qi.rejection.reasons.title": "By reason (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% of rejections",
  "qa.qi.rejection.reasons.column.cumulative": "Cumulative %",
  "qa.qi.rejection.reasons.donut.label": "Rejections",
  "qa.qi.rejection.reasons.insight": "Top {count} of {total} reasons account for {percent}% of rejections — addressing {reason} first has the biggest impact.",
  "qa.qi.rejection.breakdown.other": "Other ({count} tests)",
  "qa.qi.rejection.list.title": "Individual rejections",
  "qa.qi.amendment.list.title": "Individual amendments",
  "qa.qi.callback.button": "Log callback",
  "qa.qi.callback.banner.title": "Critical results need a clinician callback",
  "qa.qi.callback.banner.subtitle": "{count, plural, one {# saved critical result on this page has no callback logged — read-back required (TJC NPSG.02.03.01).} other {# saved critical results on this page have no callback logged — read-back required (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Log critical callback",
  "qa.qi.callback.field.recipientName": "Person notified",
  "qa.qi.callback.field.recipientName.placeholder": "Name of clinician or ward contacted",
  "qa.qi.callback.field.status": "Callback outcome",
  "qa.qi.callback.status.CONFIRMED": "Confirmed with read-back",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Reached, no read-back",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Unable to reach",
  "qa.qi.callback.save.success": "Callback logged",
  "qa.qi.callback.save.fail": "Failed to log callback",
  "qa.qi.callback.title": "Critical Callback Compliance — Detail",
  "qa.qi.callback.subtitle": "Released critical results and whether each was phoned to a clinician with read-back inside the callback target window.",
  "qa.qi.callback.distribution.title": "Time-to-acknowledge distribution",
  "qa.qi.callback.distribution.0-5": "0–5 min",
  "qa.qi.callback.distribution.5-15": "5–15 min",
  "qa.qi.callback.distribution.15-30": "15–30 min",
  "qa.qi.callback.distribution.30-60": "30–60 min",
  "qa.qi.callback.distribution.over60": "60+ min",
  "qa.qi.callback.distribution.noAck": "No ack",
  "qa.qi.callback.failures.title": "Failures ({count}) by reason",
  "qa.qi.callback.failures.overTarget": "Over target",
  "qa.qi.callback.failures.unableToReach": "Unable to reach",
  "qa.qi.callback.failures.noReadback": "No read-back recorded",
  "qa.qi.callback.failures.noCallback": "No callback recorded",
  "qa.qi.callback.list.title": "Critical results in window",
  "qa.qi.callback.rate.label": "Callback compliance (read-back within {minutes} min)",
  "qa.qi.callback.status.notLogged": "Not logged",
  "qa.qi.callback.column.status": "Callback status",
  "qa.qi.callback.column.timeToCallback": "Time to callback",
  "qa.qi.callback.column.loggedBy": "Logged by",
  "qa.qi.dashboard.tile.callback.label": "Critical Callback Compliance",
  "qa.qi.dashboard.tile.callback.tooltip": "Released critical results with a confirmed read-back callback within the lab's callback target window. Opt-in — enable in QI Configuration. Compliance is recomputed from current critical ranges.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} of {critical} critical results acknowledged within target",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.callback.empty": "No critical results in this window.",
  "qa.qi.dashboard.tile.callback.error": "Callback data is unavailable.",
  "qa.qi.dashboard.tile.callback.disabled": "Not enabled — turn on in QI Configuration.",
  "qa.empty.callback.title": "No critical results in this window",
  "qa.empty.callback.subhead": "Released critical results appear here with their callback documentation status.",
  "qa.overview.rejection.caption": "rejected at results entry (30d)",
  "qa.overview.rejection.ofStarted": "{rejected} of {total} started",
  "qa.overview.callback.caption": "critical read-back compliance (30d)",
  "qa.overview.callback.ofCritical": "{confirmed} of {critical} confirmed",
  "qa.overview.callback.none": "no critical results in window",
  "qa.overview.week.confirmedCount": "{count} confirmed",
  "qa.overview.amendment.caption": "amended after report (30d)",
  "qa.overview.amendment.ofReleased": "{amended} of {released} released",
  "qa.future.subtitle": "Future feature — design exists; build not yet scheduled.",
  "qa.future.questionLabel": "The question this feature answers",
  "qa.future.whyLabel": "Why it matters",
  "qa.future.readDesignDoc": "Read design doc on GitHub",
  "qa.future.reagentQc.question": "Has this reagent lot been verified before we use it on patients?",
  "qa.future.reagentQc.summary": "Per-lot QC frequency tracking. Before a new reagent lot is used clinically, the system requires documented verification samples comparing the new lot against the old lot or a peer-comparison reference.",
  "qa.future.reagentQc.why": "Without lot verification, a bad reagent lot can ruin a week of patient results before anyone notices. Most labs do this informally today; shipping it as a system feature catches the cases where the informal process fails.",
  "qa.future.manualQc.question": "Did the technician run a daily control on this instrument today, and did it pass?",
  "qa.future.manualQc.summary": "Daily PASS/FAIL log per instrument. Different instruments have different daily checks; the system holds them all to one shape: a daily PASS/FAIL log with a signer, a timestamp, and a block on instrument use if FAIL.",
  "qa.future.manualQc.why": "The first thing an inspector asks when they walk into a lab is 'show me your daily QC log for this instrument.' A signed log per instrument per day, every day. Forgetting it is what fails inspections.",
  "qa.overview.subtitle": "Daily snapshot for the QA Officer",
  "qa.overview.comingSoon": "Coming soon",
  "qa.overview.section.attention": "Attention Required",
  "qa.overview.section.thisWeek": "This Week",
  "qa.overview.section.pillars": "Pillar Status",
  "qa.overview.section.activity": "Recent Activity",
  "qa.overview.section.inspector": "Inspector readiness — five ISO 15189 quality questions",
  "qa.overview.attention.criticalNce": "Critical NCEs pending acknowledgment",
  "qa.overview.attention.criticalResults": "Critical results in last 24 hours",
  "qa.overview.attention.overdueCapas": "Overdue CAPAs",
  "qa.overview.attention.qcViolations": "QC violations in last 24 hours",
  "qa.overview.attention.effectivenessReview": "CAPA effectiveness reviews due",
  "qa.overview.attention.eqaDue": "EQA submissions due in next 14 days",
  "qa.overview.attention.nceSla": "NCEs nearing acknowledgment SLA",
  "qa.overview.tile.criticalCallback": "Critical Callback",
  "qa.overview.week.newNces": "New NCEs",
  "qa.overview.week.ncesResolved": "NCEs resolved",
  "qa.overview.week.capasCompleted": "CAPAs completed",
  "qa.overview.week.qcViolations": "QC violations",
  "qa.overview.week.criticalResults": "Critical results",
  "qa.overview.week.eqaSubmissions": "EQA submissions",
  "qa.overview.week.auditEntries": "Audit log entries",
  "qa.overview.week.signatureEvents": "Signature events",
  "qa.overview.inspector.q1": "Are runs in control?",
  "qa.overview.inspector.q2": "How did EQA perform last cycle?",
  "qa.overview.inspector.q3": "Are QIs on target?",
  "qa.overview.inspector.q4": "Open critical NCEs?",
  "qa.overview.inspector.q5": "Accreditation status?",
  "qa.overview.inspector.q1.answer": "{inControl} of {total} instruments in control (30d)",
  "qa.overview.inspector.q3.answer": "Avg TAT {tat} vs prior 30d",
  "qa.overview.inspector.q4.answer": "{count} critical NCEs pending acknowledgment",
  "qa.overview.inspector.q5.answer": "{active} of {total} in force, {expiring} expiring, {expired} expired",
  "qa.overview.inspector.q5.noData": "No accrediting bodies configured",
  "qa.overview.week.severityBreakdown": "{critical} critical · {major} major · {minor} minor",
  "qa.overview.week.overdueCount": "{count} overdue",
  "qa.overview.week.currentlyOpen": "currently open",
  "qa.overview.pillar.qc.text": "{inControl} of {total} instruments in control",
  "qa.overview.pillar.qc.noData": "No QC data yet",
  "qa.overview.pillar.qi.text": "Avg TAT {tat}",
  "qa.overview.pillar.qi.noData": "No TAT data yet",
  "qa.overview.pillar.qi.disabled": "Not currently tracked",
  "qa.overview.pillar.qms.text": "{critical} critical pending · {capa} in corrective action",
  "qa.overview.activity.viewAudit": "View full audit trail",
  "qa.overview.activity.empty": "No activity in the last 24 hours",
  "qa.empty.activity.subhead": "Attested actions across all pillars appear here as they happen.",
  "qa.empty.attention.title": "Nothing needs attention right now",
  "qa.empty.attention.subhead": "Critical NCEs, overdue CAPAs, and QC violations surface here when they occur.",
  "qa.empty.amendment.title": "No amendments in this window",
  "qa.empty.amendment.subhead": "Amendments appear here when a released result is corrected.",
  "qa.empty.rejection.title": "No rejections in this window",
  "qa.empty.rejection.subhead": "Rejections appear here when a test is rejected at results entry or validation.",
  "qa.empty.capaRegister.title": "No CAPAs match these filters",
  "qa.empty.capaRegister.subhead": "Corrective and preventive actions appear here as they are recorded against non-conforming events.",
  "qa.empty.accreditation.bodies.title": "No accrediting bodies yet",
  "qa.empty.accreditation.bodies.subhead": "Add the bodies that accredit this laboratory to start tracking per-test accreditation.",
  "qa.empty.accreditation.enrollments.title": "No enrollments match these filters",
  "qa.empty.accreditation.enrollments.subhead": "Enroll tests under an accrediting body to show its logo on patient reports.",
  "qa.empty.accreditation.eqa.title": "Nothing to compare yet",
  "qa.empty.accreditation.eqa.subhead": "Once tests are enrolled under an accrediting body, their EQA coverage is compared here.",
  "qa.empty.esigLog.title": "No signatures in this window",
  "qa.empty.esigLog.subhead": "Signatures appear here as results are authored and validated. Try a wider date range or fewer filters.",
  "qa.empty.tat.title": "No results in this window",
  "qa.empty.tat.subhead": "Turnaround times appear here as test orders are completed and validated. Try a different date range.",
  "qa.empty.sparse.labUnits": "{count, plural, one {# lab unit} other {# lab units}} this period",
  "qa.overview.activity.yesterday": "Yesterday {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "authored results for",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "validated & released",
  "qa.overview.activity.meaning.REJECTED": "rejected",
  "qa.overview.activity.qc": "QC alert: {rule} ({severity}) on {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} reported {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} acknowledged {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} assigned {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} added a note to {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} updated the status of {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} updated corrective action on {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} resolved {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} updated {nce}",
  "sidenav.title.statusreport": "Laporan Status Pasien",
  "systemAudit.filter.startDate": "Tanggal Mulai",
  "systemAudit.filter.endDate": "Tanggal Selesai",
  "systemAudit.filter.entityType": "Jenis Entitas",
  "systemAudit.filter.action": "Aksi",
  "systemAudit.filter.search": "Cari",
  "systemAudit.filter.export": "Ekspor CSV",
  "systemAudit.table.heading.time": "Waktu",
  "systemAudit.table.heading.entityType": "Jenis Entitas",
  "systemAudit.table.heading.entityId": "ID Entitas",
  "systemAudit.table.heading.action": "Aksi",
  "systemAudit.table.heading.user": "Pengguna",
  "systemAudit.table.heading.changes": "Perubahan",
  "systemAudit.noResults": "Tidak ada event sistem ditemukan untuk filter ini.",
  "systemAudit.filter.all": "Semua",
  "systemAudit.filter.user": "Pengguna",
  "systemAudit.filter.searchText": "Cari",
  "systemAudit.filter.searchText.placeholder": "Cari berdasarkan ID entitas...",
  "systemAudit.filter.exportPdf": "Ekspor PDF",
  "systemAudit.filter.selectedPatient": "Pasien yang Dipilih",
  "systemAudit.filter.selectedPatient.none": "Tidak ada",
  "systemAudit.filter.selectPatient": "Pilih Pasien",
  "systemAudit.filter.selectAnotherPatient": "Pilih Pasien Lain",
  "systemAudit.action.insert": "Masukkan",
  "systemAudit.action.update": "Perbarui",
  "systemAudit.action.delete": "Hapus",
  "site.branding.cancel": "Batalkan",
  "site.branding.color.format.error": "Format warna tidak valid. Mohon gunakan warna CSS valid (misalnya, #0f62fe)",
  "site.branding.color.hex.label": "Kode Warna Hex",
  "site.branding.colorPicker.helperText": "Masukkan warna CSS (misalnya, #0f62fe, biru, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe atau biru",
  "site.branding.confirm.remove": "Hapus Logo",
  "site.branding.confirm.remove.message": "Apakah Anda ingin menghapus logo ini dan mengembalikan ke logo OpenELIS default?",
  "site.branding.current.logo": "Logo saat ini",
  "site.branding.description": "Kostumisasi branding visual organisasi, seperti logo dan warna",
  "site.branding.error.remove": "Gagal menghapus file logo.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Ikon yang tampil di browser tab dan bookmark",
  "site.branding.file.format.error": "Format file tidak didukung. Mohon gunakan PNG, SVG, atau JPG/JPEG",
  "site.branding.file.pending": "File dipilih - klik Simpan Perubahan untuk mengunggah",
  "site.branding.file.size.error": "Ukuran file melebihi batas 2MB",
  "site.branding.formats": "Format: PNG, SVG, JPG (maks 2MB)",
  "site.branding.header.color": "Warna header",
  "site.branding.header.color.description": "Warna latar belakang untuk header bar aplikasi",
  "site.branding.header.logo": "Logo Header",
  "site.branding.header.logo.description": "Logo header di kiri-atas",
  "site.branding.login.logo": "Logo Halaman Login",
  "site.branding.login.logo.description": "Logo yang tampil di halaman login",
  "site.branding.login.using.header.logo": "Menggunakan logo header untuk halaman login",
  "site.branding.logo.upload.success": "Logo berhasil diunggah",
  "site.branding.no.logo": "Tidak ada logo kostum (default)",
  "site.branding.preview": "Pratinjau",
  "site.branding.primary.color": "Warna primer",
  "site.branding.primary.color.description": "Warna untuk tombol primer, item menu aktif, dan tautan",
  "site.branding.remove.favicon": "Hapus Favicon",
  "site.branding.remove.header.logo": "Hapus Logo Header",
  "site.branding.remove.login.logo": "Hapus Logo Login",
  "site.branding.remove.logo": "Hapus Logo",
  "site.branding.reset.confirmation": "Apakah anda ingin mengatur ulang semua branding ke default OpenELIS? Aksi ini akan menghapus semua kostumisasi logo dan warna.",
  "site.branding.reset.error": "Gagal mengatur ulang branding ke default.",
  "site.branding.reset.success": "Atur ulang branding ke default berhasil dilakukan.",
  "site.branding.reset.to.defaults": "Atur Ulang ke Branding Awal (Default)",
  "site.branding.save": "Simpan Perubahan",
  "site.branding.save.error": "Gagal menyimpan konfigurasi branding",
  "site.branding.save.success": "Konfigurasi branding berhasil disimpan",
  "site.branding.secondary.color": "Warna Sekunder",
  "site.branding.secondary.color.description": "Warna untuk tombol sekunder, batas, dan status yang inaktif",
  "site.branding.section.colors": "Warna",
  "site.branding.section.logos": "Logo",
  "site.branding.title": "Branding Situs",
  "site.branding.unsaved.changes": "Anda memiliki perubahan yang belum disimpan. Apakah Anda ingin menyimpan, menghapus, atau membatalkan?",
  "site.branding.unsaved.changes.warning": "Perubahan belum disimpan. Klik Simpan untuk menerapkan perubahan.",
  "site.branding.upload.favicon": "Unggah Favicon",
  "site.branding.upload.header.logo": "Unggah Logo Header",
  "site.branding.upload.login.logo": "Unggah Logo Login",
  "site.branding.upload.logo": "Unggah Logo",
  "site.branding.use.header.logo.for.login": "Gunakan logo yang sama sebagai header",
  "siteInfo.description.default.barcode": "Tentukan jumlah default label kode QR yang harus dicetak pada setiap pemesanan dan spesimen.",
  "siteInfo.description.dimensions": "Tentukan dimensi yang harus dipatuhi saaat mencetak label kode QR.",
  "siteInfo.description.elements": "Centang kotak di samping, untuk elemen opsional yang harus muncul pada pemesanan dan label kode QR sampel.",
  "siteInfo.description.max.barcode": "Tentukan jumlah maksimum label kode QR yang dapat dicetak untuk setiap pemesanan atau spesimen. Setelah jumlah maksimum tercapai, pengguna tidak akan dapat mencetak label tambahan.",
  "siteInfo.elements.mandatory": "Elemen Wajib",
  "siteInfo.elements.optional": "Elemen Opsional",
  "siteInfo.section.altAccession": "Kode QR Nomor Registrasi Pracetak",
  "siteInfo.section.elements": "Elemen Label Kode QR",
  "siteInfo.section.number": "Label Nomor Kode QR ",
  "siteInfo.section.size": "Dimensi Label Kode QR",
  "siteInfo.title.default.barcode": "Label Kode QR Default",
  "siteInfo.title.default.barcode.block": "Blok",
  "siteInfo.title.default.barcode.height": "Tinggi",
  "siteInfo.title.default.barcode.order": "Pemesanan",
  "siteInfo.title.default.barcode.order.none": "Tidak ada",
  "siteInfo.title.default.barcode.slide": "Slide",
  "siteInfo.title.default.barcode.specimen": "Spesimen",
  "siteInfo.title.default.barcode.freezer": "Lemari Pembeku",
  "siteInfo.title.default.barcode.width": "Lebar",
  "siteInfo.title.max.barcode": "Label Kode QR Maksimum",
  "started.date": "Tanggal Mulai",
  "status": "Status",
  "status.in.progress": "Dalam Pengerjaan",
  "status.unknown": "Tidak diketahui",
  "stillThere.message": "Sesi pengguna akan habis. Klik dimana saja untuk tetap login.",
  "stillThere.title": "Masih di tempat?",
  "stock.available": "Tersedia",
  "stock.level": "Level Stok",
  "stock.status": "Status Stok",
  "stock.status.expired": "Kedaluwarsa",
  "stock.status.expiring": "Segera Kedaluwarsa",
  "stock.status.expiringIn": "Expiring ({days}d)",
  "stock.status.inStock": "Stok Ada",
  "stock.status.lowStock": "Stok Sedikit",
  "stock.status.outOfStock": "Stok Habis",
  "storage.active": "Aktif",
  "storage.add.device": "Tambah Perangkat",
  "storage.add.location": "Lokasi",
  "storage.add.location.option": "Tambah Lokasi...",
  "storage.add.new.device": "Tambah perangkat baru",
  "storage.add.rack": "Tambah Laci",
  "storage.add.box": "Tambah Boks",
  "storage.add.room": "Tambah Ruangan",
  "storage.add.shelf": "Tambah Rak",
  "storage.allAssigned.title": "Semua Sample Ditugaskan",
  "storage.assign.button": "Tempatkan di Lokasi",
  "storage.assign.title": "Tugaskan Lokasi Penyimpanan",
  "storage.assigned": "Ditugaskan",
  "storage.assigned.by": "Ditempatkan Oleh",
  "storage.assigned.date": "Tanggal Penempatan",
  "storage.barcode.scan.placeholder": "Pindai Kode QR atau masukkan manual",
  "storage.bulk.move.auto.assigned": "Posisi ditetapkan otomatis (dapat diedit)",
  "storage.bulk.move.preview": "Pratinjau Pemindahan Jumlah Besar",
  "storage.cannotDelete.hasAssignments": "Tidak dapat menghapus {entityType} '{name}': yang mengandung {count} sampel yang ditempatkan",
  "storage.cannotDelete.hasChildren": "Tidak dapat menghapus {entityType} '{name}': yang mengandung {count} {childType}",
  "storage.capacity.calculated": "Dihitung",
  "storage.capacity.manual": "Batas Manual",
  "storage.capacity.undetermined.tooltip": "Kapasitas tidak dapat dihitung: beberapa lokasi turunan tidak memiliki kapasitas yang ditentukan",
  "storage.capacity.warning": "{location} is {percentage}% penuh. Pertimbangkan penyimpanan alternatif.",
  "storage.code.change.acknowledge": "Saya mengerti dan akan melanjutkan pengubahan kode",
  "storage.code.change.warning": "Peringatan",
  "storage.code.change.warning.message": "Mengubah kode akan membatalkan validasi label yang sudah dicetak untuk lokasi ini.",
  "storage.confirm.add.device": "Apakah Anda mau membuat perangkat baru '{name}'?",
  "storage.conditionNotes": "Catatan Kondisi",
  "storage.conditionNotes.placeholder": "Masukkan catatan tentang kondisi penyimpanan...",
  "storage.confirm.delete": "Konfirmasi Penghapusan",
  "storage.create.room.error": "Gagal membuat ruangan: {error}",
  "storage.create.room.success": "Ruangan \"{name}\" berhasil dibuat",
  "storage.current.location": "Lokasi Saat Ini",
  "storage.currentLocation": "Lokasi Saat Ini",
  "storage.delete.admin.only": "Hanya Administrator Global yang dapat menghapus lokasi",
  "storage.delete.are.you.sure": "Apakah Anda mau menghapus",
  "storage.delete.cannot.be.undone": "Aksi ini tidak dapat dibatalkan",
  "storage.delete.cascade.confirm": "Konfirmasi Penghapusan Bertingkat",
  "storage.delete.cascade.confirmation.checkbox": "Saya mengkonfirmasi akan menghapus lokasi dan turunannya. Semua sampel akan tidak ditempatkan lagi. Aksi ini tidak dapat dibatalkan.",
  "storage.delete.cascade.summary": "Ini akan menghapus {childCount} {childType} dan sampel yang belum ditempatkan {sampleCount}. Apakah Anda ingin lanjut?",
  "storage.delete.cascade.warning": "Peringatan Penghapusan Bertingkat",
  "storage.delete.checking": "Memeriksa batasan...",
  "storage.delete.confirmation.checkbox": "Saya mengkonfirmasi akan menghapus lokasi ini. Aksi ini tidak dapat dibatalkan.",
  "storage.delete.constraints.title": "Tidak Dapat Menghapus",
  "storage.delete.device": "Hapus Perangkat",
  "storage.delete.error": "Gagal menghapus lokasi",
  "storage.delete.location": "Hapus Lokasi",
  "storage.delete.rack": "Hapus Laci",
  "storage.delete.room": "Hapus Ruangan",
  "storage.delete.shelf": "Hapus Rak",
  "storage.device.code": "Kode",
  "storage.device.communicationProtocol": "Protokol Komunikasi",
  "storage.device.communicationProtocol.helper": "Protokol yang digunakan untuk komunikasi perangkat (misalnya, BACnet)",
  "storage.device.ipAddress": "Alamat IP",
  "storage.device.ipAddress.helper": "Alamat IPv4 atau IPv6 untuk alat terkoneksi ke jaringan",
  "storage.device.label": "Perangkat",
  "storage.device.name": "Nama",
  "storage.device.placeholder": "Pilih atau ketik untuk menambah perangkat...",
  "storage.device.port": "Portal",
  "storage.device.port.helper": "Nomor Portal (1-65535) untuk komunikasi",
  "storage.device.room": "Ruangan",
  "storage.device.type": "Jenis",
  "storage.edit.device": "Edit Perangkat",
  "storage.edit.error.loadLocation": "Gagal memuat lokasi",
  "storage.edit.error.saveFailed": "Penyimpanan gagal",
  "storage.edit.error.saveHttp": "Penyimpanan gagal (HTTP {status})",
  "storage.edit.rack": "Edit Laci",
  "storage.edit.room": "Edit Ruangan",
  "storage.edit.shelf": "Edit Rak",
  "storage.edit.selectParent": "Pilih {parent}",
  "storage.editbox.error.loadBox": "Gagal memuat boks",
  "storage.editbox.selectRack": "Pilih Laci",
  "storage.box.capacity": "Kapasitas",
  "storage.box.gridSize": "Grid size",
  "storage.box.rows": "Baris",
  "storage.box.columns": "Kolom",
  "storage.box.preset": "Pengaturan awal dimensi",
  "storage.box.preset.select": "Pilih dimensi",
  "storage.error.location.inactive": "Tidak dapat menempatkan di lokasi yang inaktif",
  "storage.error.name.duplicate": "{entityType} dengan nama ini sudah ada di lokasi induk yang dipilih",
  "storage.error.position.occupied": "Posisi sudah diisi",
  "storage.expanded.capacityLimit": "Batas Kapasitas",
  "storage.expanded.createdBy": "Dibuat Oleh",
  "storage.expanded.createdDate": "Tanggal Dibuat",
  "storage.expanded.description": "Deskripsi",
  "storage.expanded.lastModifiedBy": "Dimodifikasi Terakhir Oleh",
  "storage.expanded.lastModifiedDate": "Tanggal Modifikasi Terakhir",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Petunjuk Skema Posisi",
  "storage.expanded.temperatureSetting": "Pengaturan Suhu",
  "storage.filter.by.locations": "Filter berdasarkan lokasi",
  "storage.filter.by.locations.placeholder": "Filter berdasarkan lokasi...",
  "storage.filter.device": "Filter berdasarkan Perangkat",
  "storage.filter.room": "Filter berdasarkan Ruangan",
  "storage.filter.status": "Filter berdasarkan Status",
  "storage.hierarchical.path": "Jalur Lokasi",
  "storage.inline.add.device": "Tambah Perangkat Baru",
  "storage.inline.add.rack": "Tambah Laci Baru",
  "storage.inline.add.room": "Tambah Ruangan Baru",
  "storage.inline.add.shelf": "Tambah Rak Baru",
  "storage.location": "Lokasi",
  "storage.location.active": "Aktif",
  "storage.location.add.button": "Tambah Lokasi",
  "storage.location.add.title": "Tambah Lokasi Penyimpanan",
  "storage.location.current": "Lokasi Penyimpanan",
  "storage.location.code": "Kode Lokasi",
  "storage.location.code.helper": "Maksimum 10 karakter, alfanumerik dengan hyphen/underscore",
  "storage.location.description": "Deskripsi",
  "storage.location.label": "Lokasi Penyimpanan",
  "storage.location.name": "Nama Lokasi",
  "storage.location.skipped": "Penyimpanan Dilewati",
  "storage.location.tempMax": "Suhu Maksimum",
  "storage.location.tempMin": "Suhu Minimum",
  "storage.location.type": "Jenis Lokasi",
  "storage.location.unassigned": "Tidak ditugaskan",
  "storage.location.notAssigned": "Not assigned",
  "storage.location.move": "Move storage location",
  "storage.location.assign": "Assign storage location",
  "storage.manageLocation.error.saveFailed": "Penyimpanan gagal",
  "storage.manageLocation.error.selectTarget": "Pilih perangkat, rak, laci, atau boks sebelum menyimpan",
  "storage.nav.box": "Box",
  "storage.nav.device": "Perangkat",
  "storage.nav.room": "Ruangan",
  "storage.nav.shelf": "Rak",
  "storage.picker.currentLocation": "Lokasi saat ini",
  "storage.picker.heading.assignLocation": "Tugaskan Lokasi Penyimpanan",
  "storage.picker.heading.move": "Move Item",
  "storage.picker.newLocation": "Lokasi baru",
  "storage.picker.notes": "Catatan",
  "storage.picker.orBrowse": "Or pick level by level",
  "storage.picker.position.optional": "Posisi (opsional)",
  "storage.picker.select": "Pilih {level}",
  "storage.picker.selectDeviceType": "Select device type",
  "storage.picker.addNewLevel": "Tambah baru {level}",
  "storage.picker.inlineCreate.heading": "Buat baru {level}",
  "storage.picker.inlineCreate.error.title": "Tidak dapat membuat lokasi",
  "storage.picker.inlineCreate.error": "Gagal membuat lokasi",
  "storage.picker.occupant.identifier": "Pengidentifikasi",
  "storage.picker.occupant.heading": "Barang",
  "storage.picker.occupant.status": "Status",
  "storage.picker.occupant.type": "Jenis",
  "storage.picker.storageLocation": "Lokasi Penyimpanan",
  "storage.metrics.active": "Aktif",
  "storage.metrics.disposed": "Dimusnahkan",
  "storage.metrics.total.samples": "Total Item Sampel",
  "storage.mode.autocomplete": "Pencarian Ketik",
  "storage.mode.barcode": "Pindai Kode QR",
  "storage.mode.cascading": "Dropdown bertingkat",
  "storage.move.button": "Pindahkan Sampel",
  "storage.move.reason.label": "Alasan Pemindahan",
  "storage.nav.boxes": "Boks",
  "storage.nav.boxes.tooltip": "Kelola boks penyimpanan",
  "storage.nav.dashboard": "Dasbor penyimpanan",
  "storage.nav.devices": "Perangkat",
  "storage.nav.devices.tooltip": "Kelola perangkat penyimpanan",
  "storage.nav.locations": "Lokasi",
  "storage.nav.locations.tooltip": "Kelola lokasi penyimpanan",
  "storage.nav.racks": "Laci",
  "storage.nav.racks.tooltip": "Kelola laci penyimpanan",
  "storage.nav.rooms": "Ruangan",
  "storage.nav.rooms.tooltip": "Kelola ruangan penyimpanan",
  "storage.nav.sample.items": "Item Sampel",
  "storage.nav.sample.items.tooltip": "Lihat dan kelola sampel tersimpan",
  "storage.nav.samples": "Item Sampel",
  "storage.nav.samples.tooltip": "Lihat dan kelola sampel tersimpan",
  "storage.nav.shelves": "Rak",
  "storage.nav.shelves.tooltip": "Kelola rak penyimpanan",
  "storage.no.data": "Tidak ada data",
  "storage.occupancy": "Tingkat Keterisian",
  "storage.position.label": "Posisi",
  "storage.rack.device": "Perangkat",
  "storage.rack.dimensions": "Dimensi",
  "storage.rack.label": "Laci",
  "storage.rack.placeholder": "Pilih atau ketik untuk menambah laci...",
  "storage.rack.room": "Ruangan",
  "storage.rack.shelf": "Rak",
  "storage.room.code": "Kode",
  "storage.room.devices": "Perangkat",
  "storage.room.label": "Ruangan",
  "storage.room.name": "Nama",
  "storage.room.placeholder": "Pilih atau ketik untuk menambah ruangan...",
  "storage.room.samples": "Sampel",
  "storage.sampleitem.id": "ID Item Sampel",
  "storage.search.boxes.placeholder": "Search boxes by label or code...",
  "storage.search.devices.placeholder": "Cari berdasarkan nama atau kode perangkat...",
  "storage.search.location.minLength": "Keep typing, at least 2 characters",
  "storage.search.location.searching": "Mencari...",
  "storage.search.location.error": "Could not search locations. Please try again.",
  "storage.search.location.noResults": "No storage locations match \"{query}\"",
  "storage.search.placeholder": "Cari berdasarkan ID sampel atau lokasi...",
  "storage.search.racks.placeholder": "Cari berdasarkan label laci...",
  "storage.search.rooms.placeholder": "Cari berdasarkan nama atau kode ruangan...",
  "storage.search.lots.placeholder": "Search by lot number, barcode, item or location...",
  "storage.search.samples.placeholder": "Cari berdasarkan ID sampel atau lokasi...",
  "storage.search.shelves.placeholder": "Cari berdasarkan label rak...",
  "storage.select.location": "Pilih Lokasi",
  "storage.selectSample": "Pilih Sampel",
  "storage.shelf.device": "Perangkat",
  "storage.shelf.label": "Rak",
  "storage.shelf.placeholder": "Pilih atau ketik untuk menambah rak...",
  "storage.shelf.room": "Ruangan",
  "storage.status": "Status",
  "storage.status.disposed": "Dimusnahkan",
  "storage.success.assigned": "Penempatan sampel di lokasi penyimpanan berhasil",
  "storage.success.moved": "Pemindahan sampel ke lokasi baru berhasil",
  "storage.tab.ariaLabel": "Storage management tabs",
  "storage.tab.dashboard": "Dasbor",
  "storage.tab.inventoryLots": "Inventory Lots",
  "storage.tab.samples": "Item Sampel",
  "storage.target.location": "Lokasi Target",
  "storage.unassigned.title": "Sampel tidak ditugaskan",
  "storage.skipAssignment": "Tidak diperlukan penyimpanan - sampel akan segera diproses",
  "success.add.edited.msg": "Berhasil Ditambah/Diedit",
  "success.delete.msg": "Berhasil DIhapus",
  "success.import.patient": "Pasien Berhasil Diimpor",
  "success.report.status": "Pembuatan Laporan Berhasil",
  "success.save.msg": "Penyimpanan berhasil",
  "success.save.patient": "Penyimpanan Pasien Berhasil",
  "systemuser.firstName": "Nama Depan Pengguna Sistem",
  "systemuser.isActive": "Adalah Aktif",
  "systemuser.lastName": "Nama Akhir Pengguna Sistem",
  "systemuser.loginName": "Nama Login Pengguna Sistem",
  "systemuser.role": "Peran",
  "systemuserrole.apply": "Terapkan",
  "systemuserrole.allLabUnits.confirm.body": "Switching this row to All Lab Units removes these lab unit permissions. The All Lab Units row starts with no permissions ticked.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "no permissions ticked",
  "systemuserrole.allLabUnits.confirm.primary": "Replace permissions",
  "systemuserrole.allLabUnits.confirm.title": "Replace lab unit permissions?",
  "systemuserrole.allLabUnits.exclusive.error": "All Lab Units cannot be combined with individual lab units. Nothing was saved.",
  "systemuserrole.allLabUnits.exclusive.info": "All Lab Units cannot be combined with individual lab units: selecting it replaces every lab-unit-specific permission.",
  "systemuserrole.copypermissions": "Salin Izin dari Pengguna",
  "systemuserrole.copypermissions.placeholder": "Menyalin Izin Pengguna",
  "systemuserrole.instruction.1": "Terdapat dua jenis Peran. Peran Global untuk keseluruhan aplikasi dan Peran Unit Laboratorium untuk semua Unit Laboratorium atau Unit Laboratorium tertentu.",
  "systemuserrole.instruction.2": "Peran Global yang tersedia adalah: Administrator Global (Akses ke semua Fungsi Admin), Jejak Audit (Akses ke semua Jejak Audit), Administrator Akun Pengguna (memiliki akses ke semua fitur administrasi akun pengguna, tetapi tidak ke fungsi admin lainnya).",
  "systemuserrole.instruction.3": "Peran Unit Laboratorium adalah: Penerimaan (Akses ke Tab Pemesanan, Pasien, dan Ketidaksesuaian), Hasil (Akses ke Tab Rencana Kerja, Ketidaksesuaian, dan Hasil), Validasi (Akses ke Tab Validasi dan Ketidaksesuaian), Laporan (Akses ke Tab Laporan kecuali ekspor CSV hanya tersedia untuk Administrator Global).",
  "systemuserrole.instruction.4": "Untuk menetapkan Peran Unit Lab, pilih semua unit lab atau unit lab tertentu dari menu dropdown dan pilih peran apa yang ingin ditetapkan.",
  "systemuserrole.instruction.5": "Anda dapat menggunakan Fitur Salin Izin untuk menyalin izin pengguna yang sudah ada. Pastikan Anda telah mengisi semua informasi di atas dan masukkan nama pengguna yang izinnya ingin Anda salin ke dalam kotak, lalu klik terapkan.",
  "systemuserrole.newpermissions": "Tambah Izin Baru",
  "systemuserrole.rmpermissions": "Hapus Izin",
  "systemuserrole.roles.global": "Peran Global",
  "systemuserrole.roles.labunit": "Peran Unit Lab",
  "test.add.copy.name": "Salin dari Nama Pemeriksaan",
  "test.antimicrobialResistance": "Resistensi Antimikroba",
  "test.description.active": "Jika pemeriksaan sedang aktif, maka dapat dipesan melalui formulir pemesanan atau sebagai bagian algoritma pemeriksaan. Jika pemeriksaan tidak aktif, maka tidak dapat dipesan atau dijadikan bagian algoritma pemeriksaan.",
  "test.description.name": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis.",
  "test.description.orderable": "Jika pemeriksaan aktif dan dapat dipesan, maka pemeriksaan dapat dipesan melalui formulir pemesanan. Jika pemeriksaan aktif tetapi tidak dapat dipesan, maka pemeriksaan hanya akan dilakukan sebagai refleks dari pemeriksaan lain.",
  "test.description.panel": "Jika pemeriksaan ini merupakan bagian dari panel pemeriksaan, maka panel tersebut dapat ditambahkan di sini. Kemungkinan pemeriksaan ada di lebih dari satu panel.",
  "test.description.reportName": "Nama pemeriksaan akan muncul di dalam sistem, baik versi bahasa Inggris maupun Prancis. Jika Nama dan nama pelapor sama, klik tombol untuk menyalin nama",
  "test.description.testSection": "Bagian tempat pemeriksaan dilakukan",
  "test.description.uom": "Satuan pengukuran pemeriksaan. Biasanya berlaku hanya untuk jenis hasil numerik atau alfanumerik.",
  "test.field.active": "Aktif",
  "test.field.orderable": "Dapat dipesan",
  "test.inLabOnly": "Hanya Di Lab",
  "test.modify.en": "id",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Pilih Pemeriksaan yang akan Dimodifikasi!",
  "test.modify.header.test": "Pemeriksaan",
  "test.name": "Nama Pemeriksaan",
  "test.notifyResults": "Kirim Notifikasi ke Pasien dengan Hasil",
  "test.section": "Bagian Pemeriksaan",
  "test.section.label": "Bagian Pemeriksaan",
  "test.show.guide": "Tampilkan Panduan",
  "testcalculation.label.calculation": "Penghitungan",
  "testcalculation.label.finalresult": "Hasil Akhir",
  "testcalculation.label.insertOperation": "Masukan Operasi",
  "testcalculation.label.integer": "Bilangan Bulat",
  "testcalculation.label.mathFucntion": "Fungsi Matematika",
  "testcalculation.label.name": "Nama Penghitungan",
  "testcalculation.label.patientAttribute": "Atribut Pasien",
  "testcalculation.label.searchNumericTest": "Cari Pemeriksaan Numerik",
  "testcalculation.label.selectDictionaryValue": "Pilih Nilai Kamus",
  "testcalculation.label.testResult": "Hasil Pemeriksaan",
  "testcalculation.label.textValue": "Nilai teks",
  "testCatalog.header.ageRange": "Rentang Umur",
  "testCatalog.header.criticalRange": "Rentang Kritis",
  "testCatalog.header.field": "Bidang",
  "testCatalog.header.gender": "Jenis Kelamin",
  "testCatalog.header.normalRange": "Rentang Normal",
  "testCatalog.header.reportingRange": "Rentang Pelaporan",
  "testCatalog.header.validRange": "Rentang Valid",
  "testCatalog.header.value": "Nilai",
  "admin.testCatalog.methods.title": "Metode",
  "admin.testCatalog.methods.column.name": "Nama Metode",
  "admin.testCatalog.methods.column.code": "Kode",
  "admin.testCatalog.methods.column.default": "Standar",
  "admin.testCatalog.methods.column.effectiveDate": "Tanggal Efektif",
  "admin.testCatalog.methods.column.actions": "Aksi",
  "admin.testCatalog.methods.action.edit": "Sunting",
  "admin.testCatalog.methods.action.remove": "Hapus",
  "admin.testCatalog.methods.btn.linkMethod": "+ Metode Tautan",
  "admin.testCatalog.methods.btn.createMethod": "+ Buat Metode Baru",
  "admin.testCatalog.methods.btn.copyFromTest": "Salin dari Pemeriksaan",
  "admin.testCatalog.methods.modal.link.title": "Metode Tautan",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Pilih metode untuk menautkan",
  "admin.testCatalog.methods.modal.link.noAvailable": "Semua metode yang aktif sudah terhubung",
  "admin.testCatalog.methods.inline.nameEnglish": "Nama Metode (Bahasa Inggris)",
  "admin.testCatalog.methods.inline.nameFrench": "Nama Metode (Perancis)",
  "admin.testCatalog.methods.inline.code": "Kode pendek",
  "admin.testCatalog.methods.inline.codeHint": "3–10 karakter alfanumerik huruf besar, tanpa ruang",
  "admin.testCatalog.methods.inline.createAndLink": "Buat & Tautkan",
  "admin.testCatalog.methods.copyFromTest.label": "Salin metode dari pemeriksaan",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Pilih pemeriksaan",
  "admin.testCatalog.methods.effectiveDate.label": "Tanggal Efektif",
  "admin.testCatalog.methods.default.label": "Tetapkan sebagai default",
  "admin.testCatalog.methods.error.duplicateLink": "Metode ini sudah dihubungkan dengan pemeriksaan tersebut",
  "admin.testCatalog.methods.error.codeFormat": "Kode harus terdiri dari 3–10 karakter alfanumerik huruf besar tanpa ruang",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Tanggal Efektif wajib diisi",
  "admin.testCatalog.methods.error.duplicateCode": "A method with this code already exists. Enter a different code.",
  "admin.testCatalog.methods.error.invalidRequest": "The request was refused. Check the fields and try again.",
  "admin.testCatalog.methods.error.server": "The server could not complete the request. Try again.",
  "admin.testCatalog.methods.linked": "Method linked.",
  "admin.testCatalog.methods.created": "Method created and linked.",
  "admin.testCatalog.methods.copied": "From {source}: {count, plural, one {# method} other {# methods}} copied.",
  "admin.testCatalog.methods.copyNothing": "No methods copied: {source} has no methods that are not already linked to this test.",
  "admin.testCatalog.methods.empty": "Tidak ada metode yang ditautkan. Gunakan '+ Tautkan Metode' atau '+ Buat Metode Baru' untuk menambahkannya.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Nama pemeriksaan",
  "testnotification.instructionis.variables.body.0": "[testResult] : Hasil pemeriksaan",
  "testnotification.instructionis.variables.body.1": "[patientFirstName] : Nama depan pasien ",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial] : Inisial nama belakang pasien",
  "testnotification.instructionis.variables.header": "Daftar variabel:",
  "testnotification.instructions.body": "Saat notifikasi dibuat, sistem akan memeriksa dahulu apakah template pesan telah ditentukan untuk penerima/tipe pesan tersebut.",
  "testnotification.instructions.body.0": "Jika tidak ada, maka akan menggunakan pesan default pemeriksaan.",
  "testnotification.instructions.body.1": "Jika tidak ada, maka akan menggunakan pesan default sistem.",
  "testnotification.instructions.body.2": "Variabel akan digantikan oleh nilai yang sesuai di dalam isi pesan dan subjek.",
  "testnotification.instructions.body.3": "Variabel harus selalu menyertakan tanda kurung siku dan tidak boleh mengandung spasi.",
  "testnotification.instructions.header": "Petunjuk:",
  "testnotification.messagetemplate": "Pesan",
  "testnotification.options": "Pesan Pribadi",
  "testnotification.patient.email": "Email Pasien",
  "testnotification.patient.sms": "SMS Pasien",
  "testnotification.patiententry.header": "Pelaporan Hasil",
  "testnotification.patiententry.info": "Jika sistem tidak dapat terhubung ke penerima, maka hasilnya akan dimasukkan ke dalam antrian. Antrian yang banyak dan menumpuk adalah tanda bahwa perlu dilakukan pemecahan masalah, misalnya menghubungi pihak penerima.",
  "testnotification.provider.email": "Email Penyelenggara",
  "testnotification.provider.sms": "SMS Penyelenggara",
  "testnotification.subjecttemplate": "Subjek",
  "testnotification.systemdefault.template": "Pesan Default Sistem",
  "testnotification.testdefault.editIcon": "Edit Notifikasi Pemeriksaan",
  "testnotification.testdefault.template": "Pesan Default untuk Pemeriksaan",
  "testnotificationconfig.browse.title": "Konfigurasi Notifikasi Pemeriksaan",
  "tests.not.assigned": "Pemeriksaan tidak ditugaskan",
  "testsection.testSectionName": "Nama Bagian Pemeriksaan",
  "testUnit.existing": "Instalasi Lab Yang Ada",
  "testUnit.existing.inactive": "Instalasi Lab Inaktif. Tugaskan pemeriksaan untuk mengaktivasi.",
  "testUnit.new": "Pemeriksaan Unit Baru",
  "text.length.max": "Panjang teks tidak lebih dari 200",
  "title.notestfoundmatching": "Tidak ditemukan kecocokan pemeriksaan",
  "to.title": "Kepada",
  "tooltip.banner.menu.generic.sample.results": "Masukan hasil pemeriksaan untuk sampel generik",
  "tooltip.banner.menu.workplan.batch": "Batch Workplan",
  "total.quantity": "Kuantitas Total",
  "transaction.date": "Tanggal",
  "transaction.quantity": "Kuantitas",
  "transaction.type": "Jenis",
  "transaction.user": "Pengguna",
  "true.label": "Benar",
  "unifiedSystemUser.add.user": "Tambah Pengguna",
  "unifiedSystemUser.browser.button.add": "Tambah Pengguna Baru",
  "unifiedSystemUser.browser.search": "Cari Berdasarkan Nama Pengguna",
  "unifiedSystemUser.browser.search.placeholder": "Cari Berdasarkan Nama Pengguna...",
  "unifiedSystemUser.browser.title": "Pengelolaan Pengguna",
  "unifiedSystemUser.edit.user": "Modifikasi Pengguna",
  "unifiedSystemUser.select": "Pilih",
  "unknown.section": "Bagian Tidak Diketahui",
  "unknown.test": "Pemeriksaan Tidak Diketahui",
  "uom.browse.title": "Satuan Pengukuran",
  "uom.create.heading.confirmation": "Konfirmasi",
  "uom.existing": "Satuan Pengukuran Saat Ini",
  "uom.existing.inactive": "Satuan Pengukuran Inaktif. Tugaskan pemeriksaan pada Satuan Pengukuran untuk mengaktivasi.",
  "uom.new": "Buat Satuan Pengukuran baru",
  "uom.new.added": "Satuan Pengukuran Baru akan ditambahkan",
  "uom.notification.duplicate": "Satuan Pengukuran sudah ada",
  "uom.notification.save": "Satuan Pengukuran Baru akan disimpan.",
  "uom.uomName": "Nama Satuan Pengukuran",
  "training.installation.message": "Instalasi Pelatihan",
  "translation.edit.title": "Edit Terjemahan",
  "translation.export": "Ekspor CSV",
  "translation.export.success": "Terjemahan berhasil diekspor",
  "translation.fallback": "Alternatif (English)",
  "translation.management.description": "Lihat dan edit terjemahan untuk metadata.",
  "translation.management.title": "Pengelolaan Terjemahan",
  "translation.missing": "Hilang",
  "translation.search": "Cari terjemahan...",
  "translation.selectLocale": "Pilih Bahasa",
  "translation.showMissing": "Tampilkan Hanya yang Hilang ",
  "translation.stats.title": "Kemajuan Penterjemahan",
  "translation.stats.total": "Total entri: {count}",
  "translation.update.error": "Gagal memperbarui terjemahan",
  "translation.update.success": "Terjemahan berhasil diperbarui",
  "translation.value": "Terjemahan",
  "usage.analysisId": "Nomor Identitas Analisis",
  "usage.date": "Tanggal Digunakan",
  "usage.error.quantityPositive": "Kuantitas harus lebih dari 0",
  "usage.fefo.note": "The quantity is deducted from this item's earliest-expiring QC-passed lot (FEFO), which may not be the lot you opened this from.",
  "usage.item": "Barang",
  "usage.notes": "Catatan",
  "usage.notes.placeholder": "Tambah catatan untuk penggunaan ini",
  "usage.quantityUsed": "Kuantitas yang Digunakan",
  "usage.quantityUsed.helper": "Masukkan nomor unit yang habis",
  "usage.record.button": "Merekam Penggunaan",
  "usage.record.error": "Error recording usage",
  "usage.record.success": "Penggunaan berhasil terekam",
  "usage.record.title": "Merekam Penggunaan Inventaris",
  "usage.testResultId": "Nomor Identitas Hasil Pemeriksaan (Opsional)",
  "usage.testResultId.placeholder": "Terkati ke hasil pemeriksaan untuk penelusuran",
  "user.select.instruction": "Pilih Pengguna yang ingin Dimodifikasi atau Dinonaktifkan. Anda dapat mengatur Filter, Mencari pengguna, atau Menambahkan Pengguna dengan kendali di bagian atas.",
  "validation.accept.all": "Simpan Semua Hasil",
  "validation.accept.normal": "Simpan Semua Normal",
  "validation.field.required": "Bidang ini diperlukan",
  "validation.ignore.all": "Abaikan Semua Hasil",
  "validation.label.nonconform": "= Sampel atau Pemesanan yang tidak sesuai atau Pemeriksaan telah ditolak",
  "validation.legend.qcHold": "= A quality control covering this result failed; the non-conformity is still open",
  "validation.qcHold.tooltip": "A control run for this test in this lab unit failed. Review the non-conformity before releasing this result.",
  "validation.password.match": "Kata kunci harus sama",
  "validation.password.minLength": "Kata Kunci harus lebih dari 7 karakter",
  "validation.password.notSameAsOld": "Kata kunci baru tidak boleh sama dengan kata kunci lama",
  "validation.password.specialChar": "Kata kunci harus mengandung setidaknya satu karakter khusus (*$#!) dan satu huruf besar",
  "validation.no.records.display": "Tidak ada rekaman untuk ditampilkan",
  "validation.reject.all": "Ulang Semua Pemeriksaan",
  "validation.save.error": "Validasi Hasil berhasil",
  "validation.save.success": "Validasi Hasil berhasil",
  "validation.search.noresult": "Hasil tidak ditemukan untuk divalidasi",
  "validation.search.noresult.analyser": "Hasil tidak ditemukan dari :",
  "vl.arvRegimen": "Regimen ARV",
  "vl.durationOnARV": "Durasi pemberian ARV (bulan)",
  "vl.durationOnARV.placeholder": "Masukkan bulan berjalan pengobatan",
  "vl.indication": "Indikasi untuk pemeriksaan VL",
  "vl.lastVLDate": "Tanggal Hasil VL Terakhir",
  "vl.lastVLResult": "Hasil VL Terakhir (copies/mL)",
  "vl.lastVLResult.placeholder": "mis., 150",
  "vl.pregnancyStatus": "Status Kehamilan / Menyusui",
  "workplan.batch.action.activate": "Aktifkan",
  "workplan.batch.action.archive": "Arsip",
  "workplan.batch.action.complete": "Selesai",
  "workplan.batch.batches": "Batches",
  "workplan.batch.batches.empty": "No batches found",
  "workplan.batch.column.actions": "Aksi",
  "workplan.batch.column.count": "Pemeriksaan",
  "workplan.batch.column.created": "Dibuat",
  "workplan.batch.column.method": "Metode",
  "workplan.batch.column.name": "Batch",
  "workplan.batch.column.sampleType": "Jenis sampel",
  "workplan.batch.column.status": "Status",
  "workplan.batch.column.test": "Pemeriksaan",
  "workplan.batch.column.unit": "Unit",
  "workplan.batch.create": "Create batch ({count})",
  "workplan.batch.create.error": "Batch could not be created",
  "workplan.batch.create.success": "Batch created",
  "workplan.batch.pending.empty": "No pending tests found",
  "workplan.batch.pendingTests": "Pending Tests",
  "workplan.batch.refresh": "Segarkan",
  "workplan.batch.selectPage": "Select page",
  "workplan.batch.selectTest": "Pilih {accessionNumber}",
  "workplan.batch.status.ACTIVE": "Aktif",
  "workplan.batch.status.ARCHIVED": "Diarsipkan",
  "workplan.batch.status.COMPLETED": "Selesai",
  "workplan.batch.status.DRAFT": "Draf",
  "workplan.batch.status.error": "Batch status could not be updated",
  "workplan.batch.status.success": "Batch status updated",
  "workplan.batch.tabs": "Batch workplan tabs",
  "workplan.batch.title": "Batch Workplan",
  "workplan.page.title": "Rencana Kerja {0}",
  "workplan.panel.selection.error.msg": "Ini pesan error tidak valid.",
  "workplan.panel.title": "Rencana Kerja Berdasarkan Panel",
  "workplan.panel.types": "Jenis Panel",
  "workplan.print": "Cetak Rencana Kerja",
  "workplan.priority.list": "Prioritas",
  "workplan.priority.title": "Rencana Kerja Berdasarkan Prioritas",
  "workplan.run": "Ambil Rencana Kerja",
  "workplan.test.title": "Rencana Kerja Berdasarkan Pemeriksaan",
  "workplan.test.types": "Jenis Pemeriksaan",
  "workplan.title": "Rencana Kerja",
  "workplan.unit.title": "Rencana Kerja Berdasarkan Unit",
  "workplan.unit.types": "Jenis Unit",
  "yes.option": "Ya",
  "shipment.module.title": "Pengelolaan Pengiriman",
  "shipment.breadcrumb": "Pengiriman Sampel",
  "shipment.nav.dashboard": "Dasbor",
  "shipment.nav.createBox": "Buat Boks",
  "shipment.nav.receiveBox": "Terima Boks",
  "shipment.dashboard.title": "Dasbor Pengiriman",
  "shipment.dashboard.description": "Kelola boks pengiriman dan lacak sampel yang dirujuk",
  "shipment.dashboard.tabs.shipments": "Pengiriman",
  "shipment.dashboard.tabs.unassigned": "Pemeriksaan Tidak Ditugaskan",
  "shipment.tab.boxes": "Boks Pengiriman",
  "shipment.tab.unassignedSamples": "Sampel Tidak Ditugaskan",
  "shipment.label.boxId": "ID Boks",
  "shipment.label.createdDate": "Tanggal Dibuat",
  "shipment.label.daysUnassigned": "Hari Tidak Ditugaskan",
  "shipment.label.destination": "Tujuan",
  "shipment.label.priority": "Prioritas",
  "shipment.label.referralTest": "Pemeriksaan Rujukan",
  "shipment.label.sampleCount": "Jumlah Sample",
  "shipment.label.state": "Status",
  "shipment.label.tests": "Pemeriksaan",
  "shipment.filter.state": "Filter berdasarkan Status",
  "shipment.filter.facility": "Filter berdasarkan Lembaga",
  "shipment.action.addSelected": "Tambah yang dipilih",
  "shipment.action.addToBox": "Tambah ke Boks",
  "shipment.action.cancelReferral": "Batalkan Rujukan",
  "shipment.action.confirmRejection": "Konfirmasi Penolakan",
  "shipment.action.createBox": "Buat Boks Baru",
  "shipment.action.markAsLost": "Tandai sebagai Hilang",
  "shipment.action.printManifest": "Cetak Manifest",
  "shipment.action.rejectSample": "Tolak Sampel",
  "shipment.action.saveAndMarkReady": "Simpan & Tandai Siap Dikirim",
  "shipment.action.saveBox": "Simpan Boks",
  "shipment.action.saveDraft": "Simpan sebagai Draf",
  "shipment.action.scanSample": "Pindai Sampel",
  "shipment.box.addSample": "Tambah Sampel",
  "shipment.box.addSampleDescription": "Pilih sampel untuk ditambah ke boks pengiriman ini",
  "shipment.box.addSamples": "Tambah Sampel",
  "shipment.box.details": "Detail Boks",
  "shipment.box.autoGenerate": "Membuat secara otomatis",
  "shipment.box.capacity": "Kapasitas",
  "shipment.box.capacityValue": "{capacity} sampel",
  "shipment.box.create": "Buat Boks",
  "shipment.box.createDescription": "Buat boks pengiriman baru untuk sampel yang dirujuk",
  "shipment.box.created": "Tanggal Dibuat:",
  "shipment.box.createdBy": "Dibuat Oleh:",
  "shipment.box.createdDate": "Tanggal Dibuat",
  "shipment.box.destination": "Tujuan",
  "shipment.box.downloadLabel": "Unduh Label",
  "shipment.box.downloadManifest": "Unduh Manifest",
  "shipment.box.generateLabel": "Buat Label",
  "shipment.box.generateManifest": "Buat Manifest",
  "shipment.box.id": "ID Boks:",
  "shipment.box.labelDownloaded": "Label berhasil diunduh",
  "shipment.box.labelPrefix": "Prefiks Label",
  "shipment.box.labelPrefixHelper": "Dikonfigurasi oleh administrator di Pengaturan Situs",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest berhasil diunduh",
  "shipment.box.noSamples": "Boks ini belum memiliki sampel",
  "shipment.box.noUnassignedSamples": "Tidak ada sampel yang ditugaskan untuk lembaga ini",
  "shipment.box.notes": "Catatan",
  "shipment.box.notesPlaceholder": "Masukkan instruksi atau catatan penanganan khusus...",
  "shipment.box.number": "Nomor Boks",
  "shipment.box.readyConfirmation": "Apakah Anda yakin ingin menandai boks ini sebagai siap dikirim?",
  "shipment.box.readySampleCount": "Boks ini memiliki {count} sampel",
  "shipment.box.readyToSend": "Tandai Siap Dikirim",
  "shipment.box.reconcile": "Rekonsiliasi",
  "shipment.box.removeSample": "Hapus Sampel",
  "shipment.box.removeSampleConfirmation": "Apakah Anda yakin ingin menghapus sampel ini dari boks?",
  "shipment.box.resendManifest": "Kirim Ulang Manifest",
  "shipment.box.sampleCount": "Jumlah Sampel",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} sisa)",
  "shipment.box.samplesAdded": "Sampel Ditambah",
  "shipment.box.samplesSelected": "{count} sampel dipilih",
  "shipment.box.scanExisting": "Pindai yang ada",
  "shipment.box.scanExistingId": "Pindai atau masukkan ID Boks yang ada",
  "shipment.box.scanExistingIdPlaceholder": "Pindai kode QR atau ketik ID boks",
  "shipment.box.sendBox": "Kirim Boks",
  "shipment.box.sendConfirmation": "Apakah Anda yakin akan mengirim boks ini?",
  "shipment.box.sendSampleCount": "Boks ini memiliki {count} sampel yang akan ditandai sebagai terkirim",
  "shipment.box.state": "Status",
  "shipment.box.summary": "Ringkasan",
  "shipment.box.temperature": "Persyaratan Suhu",
  "shipment.box.title": "Boks {boxId}",
  "shipment.box.useExistingId": "Mode ID Boks",
  "shipment.dashboard.boxNotFound": "Tidak ada boks ditemukan dengan ID \"{boxId}\". Coba dengan memfilter daftar.",
  "shipment.dashboard.scanBoxPlaceholder": "Cari atau pindai ID Boks (tekan Enter untuk navigasi)",
  "shipment.error.addSample": "Gagal menambah sampel ke boks",
  "shipment.error.assignToBox": "Gagal menugaskan sampel ke boks",
  "shipment.error.boxFull": "Boks penuh. Tidak dapat menambah sampel.",
  "shipment.error.boxNotEmpty": "Boks harus memiliki setidaknya satu sampel",
  "shipment.error.boxNotFound": "Boks tidak ditemukan",
  "shipment.error.cancelReferral": "Gagal membatalkan rujukan",
  "shipment.error.confirmReception": "Gagal mengkonfirmasi penerimaan",
  "shipment.error.createBox": "Gagal membuat boks pengiriman",
  "shipment.error.exceedsCapacity": "Tidak dapat menambah {requested} sampel. Hanya {available} slot yang tersedia.",
  "shipment.error.fetchBox": "Gagal menarik informasi boks",
  "shipment.error.fetchBoxes": "Gagal menarik boks yang tersedia",
  "shipment.error.generateLabel": "Error membuat label pengiriman",
  "shipment.error.generateManifest": "Error membuat manifest",
  "shipment.error.invalidState": "Status boks invalid untuk operasional ini",
  "shipment.error.markAsLost": "Gagal menandai sampel sebagai hilang",
  "shipment.error.markReady": "Gagal menandai boks sebagai siap dikirim",
  "shipment.error.noDestinationFacility": "Tidak ada lembaga tujuan dicantumkan untuk sampel ini",
  "shipment.error.noReferralId": "Tidak ada ID rujukan tersedia untuk sampel ini",
  "shipment.error.noSampleSelected": "Mohon pilih setidaknya satu sampel",
  "shipment.error.partialReception": "Beberapa sampel statusnya gagal diperbarui. Mohon coba lagi.",
  "shipment.error.partialSampleAdd": "Only {added} of {total} samples were added to the box. It was left as a draft so you can add the rest.",
  "shipment.error.reasonRequired": "Masukkan alasan",
  "shipment.error.reconcile": "Error rekonsiliasi boks",
  "shipment.error.removeSample": "Gagal menghapus sampel dari boks",
  "shipment.error.sampleAlreadyAssigned": "Sampel ini siap ditugaskan ke boks",
  "shipment.error.sampleAlreadyInBox": "Sampel sudah di dalam boks",
  "shipment.error.sampleNotFound": "Sampel tidak ditemukan",
  "shipment.error.saveFailed": "Gagal menyimpan",
  "shipment.error.searchFailed": "Gagal mencari sampel. Mohon coba lagi.",
  "shipment.error.selectBox": "Mohon pilih boks",
  "shipment.error.sendBox": "Gagal mengirim boks",
  "shipment.filter.clear": "Hapus Filter",
  "shipment.filter.dateFrom": "Dari Tanggal",
  "shipment.filter.dateTo": "Sampai Tanggal",
  "shipment.filter.referenceLab": "Lab Rujukan",
  "shipment.label.addedDate": "Tanggal Ditambah",
  "shipment.label.position": "Posisi",
  "shipment.label.samples": "Sampel",
  "shipment.label.shippingLabel": "LABEL PENGIRIMAN",
  "shipment.manifest.generated": "Dibuat:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Penarikan manifest tidak tersedia lagi (sudah melebihi batas 7-hari sejak dikirim)",
  "shipment.manifest.regenerationExpired": "Pembuatan ulang manifest tidak tersedia lagi (sudah melebihi batas 24-jam sejak dikirim)",
  "shipment.manifest.serviceLocation": "Lokasi Layanan:",
  "shipment.manifest.specimenBarcodes": "Kode QR Spesimen",
  "shipment.manifest.title": "Manifest Pengiriman",
  "shipment.manifest.totalSamples": "Total Sampel",
  "shipment.modal.addToBox.existingBox": "Tambah ke boks yang ada",
  "shipment.modal.addToBox.mode": "Pilih opsi",
  "shipment.modal.addToBox.newBox": "Buat boks baru",
  "shipment.modal.addToBox.newBoxInfo.message": "Anda akan diarahkan ke pembuatan boks baru untuk sampel ini",
  "shipment.modal.addToBox.newBoxInfo.title": "Buat Boks Baru",
  "shipment.modal.addToBox.noDraftBoxes.message": "Tidak ada draf boks untuk tujuan ini. Boks baru akan dibuat.",
  "shipment.modal.addToBox.noDraftBoxes.title": "Tidak Ada Draf Boks Tersedia",
  "shipment.modal.addToBox.selectBox": "Pilih Boks",
  "shipment.modal.addToBox.title": "Tambah Sampel ke Boks",
  "shipment.modal.cancelReferral.reason": "Alasan Pembatalan",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Mohon jelaskan mengapa perujukan ini dibatalkan...",
  "shipment.modal.cancelReferral.title": "Batalkan Rujukan",
  "shipment.modal.cancelReferral.warning.message": "Aksi ini akan membatalkan rujukan secara permanen dan tidak bisa dibatalkan.",
  "shipment.modal.cancelReferral.warning.title": "Peringatan",
  "shipment.modal.createBox.cancel": "Batal",
  "shipment.modal.createBox.submit": "Buat",
  "shipment.modal.createBox.title": "Buat Boks Baru",
  "shipment.modal.markAsLost.reason": "Alasan menandai sebagai hilang",
  "shipment.modal.markAsLost.reasonPlaceholder": "Jelaskan mengapa sampel ini ditandai sebagai hilang...",
  "shipment.modal.markAsLost.title": "Tandai Sampel sebagai Hilang",
  "shipment.modal.markAsLost.warning.message": "Aksi ini akan menandai sampel sebagai hilang secara permanen dan tidak bisa dibatalkan.",
  "shipment.modal.markAsLost.warning.title": "Peringatan",
  "shipment.modal.rejectSample": "Tolak Sampel",
  "shipment.modal.rejectSampleMessage": "Apakah Anda yakin ingin menolak sampel {accession}?",
  "shipment.nav.referenceLabResults": "Hasil Laboratorium Rujukan",
  "shipment.nav.reports": "Laporan",
  "shipment.nav.settings": "Pengaturan",
  "shipment.notification.boxCreated": "Boks berhasil dibuat",
  "shipment.notification.boxReadyToSend": "Boks ditandai sebagai Siap Dikirim",
  "shipment.notification.boxReconciled": "Boks berhasil direkonsiliasi",
  "shipment.notification.boxSent": "Boks berhasil dikirim",
  "shipment.notification.error": "Terjadi error: {message}",
  "shipment.notification.partialSamplesAdded": "Hanya {added} dari {total} sampel ditambahkan. Boks sudah mencapai kapasitasnya ({notAdded} tidak ditambahkan).",
  "shipment.notification.receptionComplete": "Paket berhasil diterima",
  "shipment.notification.referralCancelled": "Perujukan berhasil dibatalkan",
  "shipment.notification.sampleAdded": "Sampel {accessionNumber} ditambah dengan {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sampel berhasil ditugaskan ke boks",
  "shipment.notification.sampleMarkedAsLost": "Sampel ditandai sebagai hilang",
  "shipment.notification.sampleRejected": "Sampel {accession} ditolak: {reason}",
  "shipment.notification.sampleRemoved": "Sampel dihapus dari boks",
  "shipment.notification.samplesAdded": "{count, plural, other {# sampel ditambah ke boks}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sampel dihapus karena pengurangan kapasitas.",
  "shipment.reception.acceptSample": "Terima Sampel",
  "shipment.reception.applyToAll": "Terapkan status ke semua...",
  "shipment.reception.awaitingAcceptance": "Menunggu persetujuan",
  "shipment.reception.confirmMessage": "Konfirmasi penerimaan untuk {count} sampel?",
  "shipment.reception.confirmReception": "Konfirmasi Penerimaan",
  "shipment.reception.damaged": "Rusak",
  "shipment.reception.description": "Pindai kode QR boks untuk menerima dan memverifikasi sampel",
  "shipment.reception.enterBoxId": "SIlahkan masukan ID boks",
  "shipment.reception.generalNotes": "Catatan Umum",
  "shipment.reception.generalNotesPlaceholder": "Masukkan catatan umum penerimaan ",
  "shipment.reception.importError": "Error mengimpor pengiriman dari remote server",
  "shipment.reception.importFromFhir": "Impor dari FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.incomingBoxes": "Pengiriman yang Akan Diterima",
  "shipment.reception.leaked": "Bocor",
  "shipment.reception.markAllMissing": "Tandai Semua Hilang",
  "shipment.reception.markAllReceived": "Tandai Semua Diterima",
  "shipment.reception.missing": "Hilang",
  "shipment.reception.noIncomingBoxes": "Tidak ada pengiriman yang masuk. Klik 'Impor dari FHIR' untuk memeriksa apakah ada pengiriman baru.",
  "shipment.reception.notes": "Catatan",
  "shipment.reception.notesPlaceholder": "Masukkan catatan bila diperlukan",
  "shipment.reception.notesRequired": "Catatan wajib ada untuk sampel yang diterima tidak dalam kondisi baik",
  "shipment.reception.notesRequiredPlaceholder": "Wajib: jelaskan masalah",
  "shipment.reception.openBox": "Buka",
  "shipment.reception.originFacility": "Dari",
  "shipment.reception.pending": "Tertunda",
  "shipment.reception.pendingAcceptance": "Spesimen yang Sedang Menunggu Persetujuan",
  "shipment.reception.received": "Diterima",
  "shipment.reception.referralOrder": "Pemesanan Rujukan",
  "shipment.reception.rejected": "Ditolak",
  "shipment.reception.sampleCountSummary": "{accepted} diterima / diharapkan {expected}",
  "shipment.reception.sampleNotFound": "Sampel {accessionNumber} tidak ditemukan di boks ini",
  "shipment.reception.sampleScanned": "Sampel {accessionNumber} diperiksa saat diterima",
  "shipment.reception.sampleVerification": "Verifikasi Sampel",
  "shipment.reception.scanBox": "ID Boks / Kode QR",
  "shipment.reception.scanBoxPlaceholder": "Pindai atau masukkan kode QR boks",
  "shipment.reception.scanButton": "Pindai Boks",
  "shipment.reception.scanSample": "Pindai Sampel ID",
  "shipment.reception.scanSampleButton": "Sampel Check In",
  "shipment.reception.scanSamplePlaceholder": "Pindai atau ketik nomor registrasi sampel",
  "shipment.reception.shipped": "Sudah dikirim",
  "shipment.reception.specimen": "Spesimen",
  "shipment.reception.status": "Status Penerimaan",
  "shipment.reception.title": "Terima Paket",
  "shipment.reception.unresolved": "Tidak ada pemesanan yang cocok",
  "shipment.rejection.damaged": "Rusak",
  "shipment.rejection.expired": "Kedaluwarsa",
  "shipment.rejection.insufficientVolume": "Volume tidak cukup",
  "shipment.rejection.other": "Lainnya",
  "shipment.rejection.reason": "Alasan Penolakan",
  "shipment.rejection.wrongType": "Jenis Sampel Salah",
  "shipment.report.contents": "Isi",
  "shipment.report.description": "Buat dan ekspor laporan pengiriman berdasarkan boks, tanggal, tujuan, atau lab rujukan",
  "shipment.report.export.excel": "Ekspor Excel",
  "shipment.report.export.pdf": "Ekspor PDF",
  "shipment.report.generate": "Buat Laporan",
  "shipment.report.noResults": "Tidak ada rekaman pengiriman ditemukan dengan filter ini.",
  "shipment.report.receivedDate": "Tanggal Diterima",
  "shipment.report.receivedStatus": "Status Penerimaan",
  "shipment.report.receiver": "Penerima",
  "shipment.report.receivingUser": "Pengguna Yang Menerima",
  "shipment.report.sender": "Pengirim",
  "shipment.report.sentDate": "Tanggal Dikirim",
  "shipment.report.title": "Laporan Pengiriman",
  "shipment.report.totalBoxes": "Total Boks",
  "shipment.report.totalSamples": "Total Sampel",
  "shipment.sample.accessionNumber": "Nomor Registrasi",
  "shipment.sample.multipleMatches": "Ada beberapa sampel yang cocok — pilih mana yang akan ditambahkan",
  "shipment.sample.remove": "Hapus",
  "shipment.sample.search": "Cari sampel berdasarkan nomor registrasi",
  "shipment.sample.searchPlaceholder": "Pindai atau masukkan nomor registrasi",
  "shipment.sample.status": "Status",
  "shipment.sample.type": "Jenis Sampel",
  "shipment.settings.administration": "Administrasi",
  "shipment.settings.boxLabelSection": "Konfigurasi Label Boks",
  "shipment.settings.description": "Konfigurasi pengaturan modul pengiriman",
  "shipment.settings.fhirConfig": "Opsi Pemetaan FHIR",
  "shipment.settings.fhirConfigDesc": "Konfigurasi pemetaan SupplyDelivery dan jenis wadah spesimen untuk interoperabilitas FHIR",
  "shipment.settings.fhirConfigNote": "Pemetaan FHIR dikonfigurasi melalui properti aplikasi. Kontak admin sistem untuk melakukan perubahan.",
  "shipment.settings.fhirConfigSaveError": "Gagal menyimpan konfigurasi pemetaan FHIR",
  "shipment.settings.fhirConfigSaved": "Konfigurasi pemetaan FHIR disimpan",
  "shipment.settings.fhirContainerType": "Jenis Wadah Spesimen (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Nama di Tampilan",
  "shipment.settings.fhirNonConformity": "Kode Ketidaksesuaian (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Kode SNOMED CT",
  "shipment.settings.manageFacilities": "Kelola Registri Lembaga",
  "shipment.settings.manageFacilitiesDesc": "Tambah, edit, atau hapus tujuan laboratorium rujukan",
  "shipment.settings.manageUsers": "Kelola Pengguna",
  "shipment.settings.manageUsersDesc": "Konfigurasi akun dan peran pengguna untuk modul pengiriman",
  "shipment.settings.prefixHelperText": "Prefiks yang digunakan saat membuat ID boks baru (mis. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOKS",
  "shipment.settings.prefixPreview": "Pratinjau: {preview}",
  "shipment.settings.prefixRequired": "Prefiks label boks wajib ada",
  "shipment.settings.prefixSaveError": "Error saat menyimpan prefiks label boks",
  "shipment.settings.prefixSaved": "Prefiks label boks berhasil disimpan",
  "shipment.settings.siteOrgDescription": "Pilih organisasi yang mewakili laboratorium ini. Hanya pengiriman dengan tujuan laboratorium ini yang akan diimpor ke server FHIR remote.",
  "shipment.settings.siteOrgLabel": "Laboratorium Ini",
  "shipment.settings.siteOrgSaveError": "Error menyimpan pengaturan tempat",
  "workflow.clinical": "Klinis",
  "workflow.environmental": "Lingkungan / Lainnya",
  "provider.name": "Nama Penyelenggara",
  "provider.name.placeholder": "Masukkan nama penyelenggara",
  "provider.phone": "Telepon Penyelenggara",
  "provider.search.helper": "Masukkan nama atau nomor telepon penyelenggara dan tekan Cari.",
  "site.search": "Cari Tempat",
  "site.name": "Nama Tempat",
  "site.name.placeholder": "Masukkan nama tempat",
  "site.location": "Lokasi",
  "site.type": "Jenis",
  "site.department": "Departemen / Ruang / Unit",
  "site.department.selectFirst": "Pilih lembaga terlebih dahulu..",
  "site.department.choose": "Pilih departemen...",
  "site.department.none": "Tidak ada subunit tersedia",
  "sample.filterByLabUnit": "Filter berdasarkan Instalasi Lab",
  "sample.allLabUnits": "Semua Instalasi Lab",
  "sample.orderPanels": "Panel Pemesanan",
  "sample.orderTests": "Pemesanan Pemeriksaan",
  "sample.referToReferenceLab": "Rujuk pemeriksaan ke lab rujukan",
  "sample.optional.info": "Pemilihan sampel dan pemeriksaan opsional pada tahap ini. Jenis pemeriksaan dan sampel dapat dispesifikasi nanti saat pengambilan.",
  "panel.search.placeholder": "Pilih Panel yang Tersedia",
  "test.search.placeholder": "Pilih Pemeriksaan yang tersedia",
  "test.timeHolding": "Waktu Penahanan Maksimum sesuai SOP (menit)",
  "select.regimen": "Pilih Regimen...",
  "select": "Pilih...",
  "generating": "Membuat...",
  "label.order": "Label Pemesanan",
  "label.sample": "Label Sampel",
  "label.slide": "Label Slide",
  "label.block": "Label Blok",
  "label.freezer": "Label Freezer",
  "environmental.coming.soon": "Alur Kerja Lingkungan",
  "environmental.location.info": "Bidang hirarki lokasi (Kabupaten/Kecamatan/Kelurahan-Desa) dan tangkapan GPS akan tersedia disini.",
  "env.collectionConditions.title": "Kondisi Pengambilan Default",
  "env.collectionConditions.subtitle": "Default di aplikasikan ke semua sampel di batch ini",
  "env.collectionMethod": "Metode Pengambilan",
  "env.waterTemp": "Suhu Air (°C)",
  "env.ambientTemp": "Suhu Lingkungan (°C)",
  "env.weather": "Cuaca",
  "env.preservationMethod": "Metode Pengawetan",
  "env.preservationMethod.placeholder": "mis., asidifikasi HNO3, pendinginan 4°C",
  "env.fieldNotes": "Catatan Lapangan",
  "env.fieldNotes.placeholder": "Masukkan pengamatan lapangan...",
  "env.sample.manifest.title": "Manifes Pra-Pengambilan Sampel",
  "env.sample.manifest.subtitle": "satu baris = satu sampel fisik",
  "env.sample.container": "Wadah",
  "env.sample.gpsLat": "Lintang GPS",
  "env.sample.gpsLat.placeholder": "mis. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "mis. 106.8456",
  "env.sample.locationDetails": "Rincian Lokasi",
  "env.sample.locationDetails.placeholder": "mis., Keran, Sungai...",
  "env.sample.collected": "Diambil",
  "env.sample.duplicate": "Duplikasi sampel",
  "env.sample.addRow": "+ Tambah baris sampel",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} di batch ini",
  "env.sample.testsAndPanels": "Pengujian & Panel",
  "env.sample.tests.required": "wajib",
  "env.complianceStandards.title": "Baku Mutu Tersedia",
  "env.complianceStandards.subtitle": "Pilih standar peraturan untuk pemesanan ini",
  "env.complianceStandards.label": "Baku Mutu",
  "env.complianceStandards.placeholder": "Pilih standar...",
  "env.complianceStandards.empty": "Tidak ada konfigurasi baku mutu aktif. Tambah baku mutu di Administrasi → Baku Mutu.",
  "order.dashboard.samplingSite": "Tempat Pengambilan Sampel",
  "order.search.placeholder.env": "Cari berdasarkan nama tempat atau nomor lab...",
  "order.filter.dateFrom": "Dari",
  "order.filter.dateTo": "Kepada",
  "program.placeholder": "Ketik untuk memfilter atau memilih dari daftar",
  "program.helper": "Ketik untuk memfilter atau memilih dari daftar. Memilih program akan menampilkan bidang Informasi Pesanan Tambahan khusus program tersebut di bawah ini.",
  "patient.externalSearch": "Pencarian Eksternal",
  "patient.results": "Hasil Pasien",
  "patient.id.helper": "Masukkan nomor subyek, NIK, atau nomor ST.",
  "patient.id.placeholder": "Masukkan Identitas Pasien",
  "patient.lastName.placeholder": "Masukkan Nama Belakang Pasien",
  "patient.firstName.placeholder": "Masukkan Nama Depan Pasien",
  "patient.natId": "Nomor Pengidentifikasi Kesehatan Unik",
  "patient.dataSource": "Sumber Data",
  "patient.noResults": "0-0 dari 0 item",
  "patient.new.info": "Masukkan informasi pasien di bawah ini. Pasien akan dibuat saat pemesanan disimpan.",
  "pagination.showing": "Menunjukkan {start}-{end} dari {total} pemeriksaan",
  "results.found.for": "hasil ditemukan untuk \"{term}\"",
  "selected": "Dipilih",
  "shipment.settings.siteOrgSaved": "Pengorganisasian situs disimpan (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Organisasi Situs (FHIR)",
  "shipment.settings.title": "Pengaturan Pengiriman",
  "shipment.state.cancelled": "Dibatalkan",
  "shipment.state.draft": "Draf",
  "shipment.state.inTransit": "Dalam Transit",
  "shipment.state.lostInTransit": "Hilang Dalam Transit",
  "shipment.state.partiallyReceived": "Parsial DIterima",
  "shipment.state.readyToSend": "Siap Dikirim",
  "shipment.state.received": "Diterima",
  "shipment.state.reconciled": "Direkonsiliasi",
  "shipment.state.sent": "Terkirim",
  "shipment.stats.delivered": "Sudah Diantar",
  "shipment.stats.inTransit": "Dalam Transit",
  "shipment.stats.reconciled": "Direkonsiliasi",
  "shipment.stats.totalSamples": "Total Sampel",
  "shipment.temperature.ambient": "Ambient (Suhu Ruangan)",
  "shipment.temperature.deepFrozen": "Beku Sangat Dalam (-80°C)",
  "shipment.temperature.dryIce": "Es Kering",
  "shipment.temperature.frozen": "Beku (-20°C)",
  "shipment.temperature.refrigerated": "Didinginkan (2–8 °C)",
  "shipment.validation.addSample": "Tambah setidaknya satu sampel",
  "shipment.validation.selectDestination": "Pilih lembaga tujuan",
  "qc.dashboard.title": "Dasbor Kendali Mutu",
  "qc.dashboard.lastUpdate": "Pembaruan Terakhir",
  "qc.dashboard.complianceStatus": "Status Kepatuhan",
  "qc.dashboard.compliant": "Sesuai Kepatuhan",
  "qc.dashboard.warning": "Peringatan",
  "qc.dashboard.nonCompliant": "Tidak Sesuai Kepatuhan",
  "qc.dashboard.violationsCount": "{count} pelanggaran",
  "qc.dashboard.lastResult": "Hasil Terakhir",
  "qc.dashboard.noInstruments": "Tidak ada alat dikonfigurasi",
  "qc.dashboard.subtitle": "Monitor status dan peringatan QC alat",
  "qc.dashboard.loading": "Memuat data dasbor...",
  "qc.dashboard.refresh": "Segarkan",
  "qc.dashboard.lastUpdated": "Pembaruan Terakhir",
  "qc.dashboard.export.title": "Export QC Data",
  "qc.dashboard.export.selectInstrument": "Select an instrument",
  "qc.dashboard.export.dateError": "End date must be on or after the start date.",
  "qc.dashboard.error.title": "Kesalahan",
  "qc.dashboard.error.loadFailed": "Gagal memuat data dasbor. Silahkan coba lagi.",
  "qc.dashboard.tab.instruments": "Alat",
  "qc.dashboard.tab.alerts": "Peringatan",
  "qc.dashboard.summary.inControl": "Alat Dalam Kendali",
  "qc.dashboard.summary.warningStatus": "Status Peringatan",
  "qc.dashboard.summary.outOfControl": "Diluar Kendali",
  "qc.dashboard.summary.passRate": "QC Pass Rate Secara Umum",
  "qc.dashboard.summary.ofTotal": "{percentage}% total alat",
  "qc.dashboard.instruments.title": "Status Kendali Mutu Alat",
  "qc.dashboard.instruments.subtitle": "Monitor status kepatuhan dan kinerja QC di semua alat laboratorium",
  "qc.dashboard.instruments.search": "Cari alat...",
  "qc.dashboard.instruments.col.id": "ID Alat",
  "qc.dashboard.instruments.col.name": "Nama Alat",
  "qc.dashboard.instruments.col.type": "Tipe",
  "qc.dashboard.instruments.col.location": "Lokasi",
  "qc.dashboard.instruments.col.status": "Status",
  "qc.dashboard.instruments.col.analytes": "Analit",
  "qc.dashboard.instruments.col.violations": "Pelanggaran Terkini",
  "qc.dashboard.instruments.col.lastUpdate": "Pembaruan Terakhir",
  "qc.dashboard.instruments.col.actions": "Aksi",
  "qc.dashboard.instruments.view": "Lihat",
  "qc.dashboard.instruments.status.green": "Dalam Kendali",
  "qc.dashboard.instruments.status.yellow": "Peringatan",
  "qc.dashboard.instruments.status.red": "Diluar Kendali",
  "qc.dashboard.instruments.status.notConfigured": "Tidak dikonfigurasi",
  "qc.dashboard.instruments.status.unknown": "Tidak diketahui",
  "qc.dashboard.instruments.noViolations": "Tidak ada pelanggaran",
  "qc.dashboard.instruments.empty": "Tidak ada alat ditemukan",
  "qc.dashboard.alerts.title": "Pelanggaran & Peringatan QC",
  "qc.dashboard.alerts.subtitle": "Menunjukkan pelanggaran dari {period} terakhir",
  "qc.dashboard.alerts.timePeriod": "Periode Waktu",
  "qc.dashboard.alerts.timePeriod.24h": "24 jam terakhir",
  "qc.dashboard.alerts.timePeriod.72h": "72 jam terakhir",
  "qc.dashboard.alerts.timePeriod.7d": "7 hari terakhir",
  "qc.dashboard.alerts.timePeriod.30d": "30 hari terakhir",
  "qc.dashboard.alerts.timePeriod.all": "Semua Waktu",
  "qc.dashboard.alerts.active": "Pelanggaran QC Aktif",
  "qc.dashboard.alerts.active.count": "{count} pelanggaran tidak diketahui yang memerlukan perhatian",
  "qc.dashboard.alerts.active.empty": "Tidak ada pelanggaran aktif",
  "qc.dashboard.alerts.acknowledge": "Mengetahui",
  "qc.dashboard.alerts.acknowledged": "Pelanggaran yang Diketahui",
  "qc.dashboard.alerts.acknowledged.count": "{count} pelanggaran telah diketahui",
  "qc.dashboard.alerts.acknowledged.empty": "Tidak ada pelanggaran yang diketahui",
  "qc.dashboard.alerts.col.severity": "Keparahan",
  "qc.dashboard.alerts.col.time": "Waktu",
  "qc.dashboard.alerts.col.instrument": "Alat",
  "qc.dashboard.alerts.col.analyte": "Analit",
  "qc.dashboard.alerts.col.rule": "Aturan",
  "qc.dashboard.alerts.col.acknowledgedBy": "DIketahui Oleh",
  "qc.dashboard.alerts.col.acknowledgedDate": "Tanggal Diketahui",
  "qc.dashboard.banner.title": "{count} active QC violation(s) require attention",
  "qc.dashboard.banner.viewAll": "View all alerts",
  "qc.violations.error.acknowledgeFailed": "Failed to acknowledge violation",
  "qc.chart.axis.date": "Tanggal/Waktu",
  "qc.chart.axis.run": "Run",
  "qc.chart.axis.value": "Simpangan Baku (σ)",
  "qc.instrument.notFound": "Instrument not found",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Sigma performance",
  "qc.chart.sigma.notCalculable": "Not calculable — TEa not configured",
  "qc.chart.sigma.bias": "Bias not applied (no peer data)",
  "qc.chart.sigma.WORLD_CLASS": "World-class",
  "qc.chart.sigma.ACCEPTABLE": "Dapat diterima",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Poor",
  "qc.chart.title": "Quality Control Chart",
  "qc.chart.loading": "Loading control chart…",
  "qc.chart.error.title": "Unable to load control chart",
  "qc.chart.tabs.label": "Control chart levels",
  "qc.chart.filter.allLevels": "All levels",
  "qc.chart.filter.selectLot": "Select lot",
  "qc.chart.action.zoomIn": "Zoom in",
  "qc.chart.action.zoomOut": "Zoom out",
  "qc.chart.action.zoomReset": "Reset zoom",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Pelanggaran",
  "qc.chart.mean": "Rata-rata",
  "qc.chart.noData": "Tidak ada data QC tersedia",
  "qc.chart.tooltip.date": "Tanggal",
  "qc.chart.tooltip.value": "Nilai",
  "qc.chart.tooltip.violations": "Pelanggaran",
  "qc.chart.tooltip.zScore": "Skor Z",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Bagan Levey-Jennings",
  "qc.charts.dateRange": "Rentang Tanggal",
  "qc.charts.controlLevel": "Level Kontrol",
  "qc.charts.export": "Ekspor grafik",
  "qc.charts.noData": "Tidak ada data QC tersedia",
  "qc.violations.title": "Pelanggaran QC",
  "qc.violations.severity": "Keparahan",
  "qc.violations.rule": "Aturan",
  "qc.violations.date": "Tanggal",
  "qc.violations.status": "Status",
  "qc.violations.unresolved": "Belum diatasi",
  "qc.violations.resolved": "Sudah diatasi",
  "qc.violations.acknowledged": "Sudah diketahui",
  "qc.correctiveActions.title": "Tindakan Perbaikan",
  "qc.correctiveActions.create": "Buat Tindakan Perbaikan",
  "qc.correctiveActions.type": "Jenis Tindakan",
  "qc.correctiveActions.description": "Deskripsi",
  "qc.correctiveActions.assignedTo": "Ditugaskan Ke",
  "qc.correctiveActions.status": "Status",
  "qc.correctiveActions.pending": "Tertunda",
  "qc.correctiveActions.inProgress": "Dalam Pengerjaan",
  "qc.correctiveActions.completed": "Selesai",
  "qc.correctiveActions.resolutionNotes": "Catatan Pemecahan Masalah",
  "qc.alerts.title": "Peringatan QC",
  "qc.alerts.markAsRead": "Tandai sebagai Sudah Dibaca",
  "qc.alerts.viewDetails": "Lihat Rincian",
  "qc.rules.title": "Konfigurasi Aturan Westgard",
  "qc.rules.enable": "Aktifkan",
  "qc.rules.disable": "Nonaktifkan",
  "qc.rules.preset": "Pengaturan Ulang Konfigurasi ",
  "qc.rules.basic": "Dasar",
  "qc.rules.standard": "Standar",
  "qc.rules.comprehensive": "Komprehensif",
  "qc.rules.1₂ₛ.description": "Satu kontrol melebihi ±2SD",
  "qc.rules.1₃ₛ.description": "Satu kontrol melebihi ±3SD",
  "qc.rules.2₂ₛ.description": "Dua kontrol berurutan melebihi ±2SD ke arah yang sama",
  "qc.rules.R₄ₛ.description": "Rentang antara dua kontrol melebihi 4SD",
  "qc.rules.4₁ₛ.description": "Empat kontrol berurutan melebihi ±1SD ke arah yang sama",
  "qc.rules.10ₓ.description": "Sepuluh kontrol berurutan berada di sisi mean yang sama",
  "qc.rules.3₁ₛ.description": "Tiga kontrol berurutan melebihi ±1SD ke arah yang sama",
  "qc.rules.7ₜ.description": "Tujuh kontrol berurutan cenderung ke arah yang sama",
  "qc.ruleConfig.title": "Konfigurasi Aturan",
  "qc.ruleConfig.subtitle": "Konfigurasi Westgard rule per kombinasi alat dan pemeriksaan",
  "qc.ruleConfig.field.analyzer": "Alat",
  "qc.ruleConfig.field.selectAnalyzer": "Pilih alat",
  "qc.ruleConfig.field.test": "Pemeriksaan",
  "qc.ruleConfig.field.selectTest": "Pilih pemeriksaan",
  "qc.ruleConfig.field.severity": "Keparahan",
  "qc.ruleConfig.severity.warning": "Peringatan",
  "qc.ruleConfig.severity.rejection": "Penolakan",
  "qc.ruleConfig.category.rejection": "Aturan Penolakan",
  "qc.ruleConfig.category.warning": "Aturan Peringatan",
  "qc.ruleConfig.action.reset": "Atur Ulang ke Default",
  "qc.ruleConfig.loading": "Memuat konfigurasi aturan...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Pilih alat dan pemeriksaan untuk mengkonfigurasi Westgard rules.",
  "qc.ruleConfig.error.title": "Kesalahan",
  "qc.ruleConfig.error.selectAnalyzerTest": "Silahkan pilih alat maupun pemeriksaan.",
  "qc.ruleConfig.error.saveFailed": "Gagal menyimpan konfigurasi aturan",
  "qc.ruleConfig.success.title": "Berhasil",
  "qc.ruleConfig.success.saved": "Konfigurasi aturan berhasil disimpan.",
  "qc.ruleConfig.table.title": "Set Aturan yang Dikonfigurasi",
  "qc.ruleConfig.table.empty": "Konfigurasi aturan tidak ditemukan",
  "qc.ruleConfig.field.enabledRules": "Aktifkan Aturan",
  "qc.ruleConfig.unconfigured.title": "Pemetaan Kontrol yang Tidak Dikonfigurasi",
  "qc.ruleConfig.unconfigured.subtitle": "Lot kontrol tanpa konfigurasi aturan Westgard",
  "qc.ruleConfig.unconfigured.configure": "Konfigurasi",
  "qc.ruleConfig.unconfigured.activeLots": "Lot Aktif",
  "qc.ruleConfig.modal.title.edit": "Edit Konfigurasi Aturan",
  "qc.ruleConfig.modal.title.create": "Membuat Konfigurasi Aturan",
  "button.saving": "Menyimpan...",
  "qc.controlLots.title": "Lot Kontrol",
  "qc.controlLots.create": "Buat Lot Kontrol",
  "qc.controlLots.productName": "Nama Produk",
  "qc.controlLots.lotNumber": "Nomor Lot",
  "qc.controlLots.level": "Level Kontrol",
  "qc.controlLots.statisticsMethod": "Metode Kalkulasi Statistik",
  "qc.controlLots.initialRuns": "Putaran Awal",
  "qc.controlLots.rolling": "Jendela Bergerak",
  "qc.controlLots.manufacturerFixed": "Perbaikan Pabrik",
  "qc.controlLots.activationDate": "Tanggal Aktivasi",
  "qc.controlLots.expirationDate": "Tanggal Kedaluwarsa",
  "qc.controlLots.status.active": "Aktif",
  "qc.controlLots.status.establishment": "Percobaan",
  "qc.controlLots.status.expired": "Kedaluwarsa",
  "qc.controlLots.subtitle": "Kelola lot kontrol QC untuk evaluasi Westgard rule",
  "qc.controlLots.empty": "Tidak ada lot kontrol ditemukan",
  "qc.controlLot.filter.allStatuses": "Semua Status",
  "qc.controlLot.status.establishment": "Percobaan",
  "qc.controlLot.status.active": "Aktif",
  "qc.controlLot.status.expired": "Kedaluwarsa",
  "qc.controlLot.field.lotNumber": "Nomor Lot",
  "qc.controlLot.field.lotNumberPlaceholder": "Masukkan nomor lot",
  "qc.controlLot.field.material": "Bahan Kontrol",
  "qc.controlLot.field.materialPlaceholder": "Masukkan nama bahan",
  "qc.controlLot.field.manufacturer": "Produsen",
  "qc.controlLot.field.level": "Level Kontrol",
  "qc.controlLot.field.selectLevel": "Pilih level",
  "qc.controlLot.field.expiration": "Tanggal Kedaluwarsa",
  "qc.controlLot.field.analyzer": "Alat",
  "qc.controlLot.field.selectAnalyzer": "Pilih Alat",
  "qc.controlLot.field.analyzerHelper": "Optional. Choose \"Bench / no analyzer\" for a manual method run at the bench without an instrument.",
  "qc.controlLot.analyzer.bench": "Bench / no analyzer (manual method)",
  "qc.controlLot.field.test": "Pemeriksaan",
  "qc.controlLot.field.selectTest": "Pilih Pemeriksaan",
  "qc.controlLot.field.isActive": "Status",
  "qc.controlLot.field.inactive": "Inaktif",
  "qc.controlLot.field.active": "Aktif",
  "qc.controlLot.field.status": "Status",
  "qc.controlLot.loading": "Memuat...",
  "qc.controlLot.error.title": "Kesalahan",
  "qc.controlLot.error.saveFailed": "Gagal menyimpan lot kontrol",
  "qc.controlLot.error.statsRequired": "Manufacturer-fixed lots need a mean and standard deviation. Click \"Configure\" to enter them before saving.",
  "qc.controlLot.error.benchNeedsFixedStats": "A bench lot has no analyzer accumulating runs, so it must use manufacturer-fixed statistics. Click \"Configure\" to enter a mean and standard deviation, or select an analyzer for this lot.",
  "qc.controlLot.new.title": "Lot Kontrol Baru",
  "qc.controlLot.viewChart": "View chart",
  "qc.controlLot.new.subtitle": "Buat lot kontrol QC baru",
  "qc.controlLot.edit.title": "Edit Lot Kontrol",
  "qc.controlLot.edit.subtitle": "Perbarui konfigurasi lot kontrol",
  "qc.controlLot.validation.lotNumberRequired": "Nomor lot wajib ada",
  "qc.controlLot.validation.materialRequired": "Bahan wajib ada",
  "qc.controlLot.validation.levelRequired": "Level kontrol wajib ada",
  "qc.controlLot.validation.expirationRequired": "Tanggal kedaluwarsa wajib ada",
  "qc.controlLot.validation.analyzerRequired": "Alat wajib ada",
  "qc.controlLot.validation.testRequired": "Pemeriksaan wajib ada",
  "qc.controlLot.level.low": "Rendah",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "Tinggi",
  "qc.controlLot.statistics.title": "Konfigurasi Statistik",
  "qc.controlLot.statistics.configure": "Konfigurasi",
  "qc.controlLot.statistics.method": "Metode Kalkulasi",
  "qc.controlLot.statistics.mean": "Rata-rata",
  "qc.controlLot.statistics.sd": "Simpangan Baku",
  "qc.controlLot.statistics.config.title": "Konfigurasi Statistik",
  "qc.controlLot.statistics.config.label": "Konfigurasi metode statistik",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Perbaikan Produsen",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Gunakan nilai mean dan SD yang disediakan produsen",
  "qc.controlLot.statistics.method.rolling": "Jendela Bergerak",
  "qc.controlLot.statistics.method.rolling.description": "Hitung ulang dari hasil N terkini",
  "qc.controlLot.statistics.method.initial_runs": "Putaran Awal",
  "qc.controlLot.statistics.method.initial_runs.description": "Hitung sekali dari putaran N pertama",
  "qc.controlLot.statistics.manufacturerValues": "Nilai Produsen",
  "qc.controlLot.statistics.rollingConfig": "Konfigurasi Rolling",
  "qc.controlLot.statistics.windowSize": "Ukuran Jendela",
  "qc.controlLot.statistics.windowSize.helper": "Jumlah hasil terakhir untuk diikutkan ke kalkulasi",
  "qc.controlLot.statistics.initialRunsConfig": "Konfigurasi Run Awal",
  "qc.controlLot.statistics.initialRunsRequired": "Putaran yang Diperlukan",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Jumlah putaran uji coba sebelum penghitungan statistik dilakukan",
  "qc.instrumentDetail.analytesMonitored": "Analit yang Dimonitor",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, other {# pelanggaran}}",
  "qc.instrumentDetail.tab.activityTimeline": "Timeline Kegiatan",
  "qc.instrumentDetail.tab.controlChart": "Control Charts",
  "qc.instrumentDetail.timeline.empty": "Tidak ada peringatan atau tindakan korektif direkam pada periode waktu yang dipilih",
  "qc.instrumentDetail.timeline.violation": "Pelanggaran",
  "qc.instrumentDetail.timeline.correctiveAction": "Tindakan Perbaikan",
  "qc.instrumentDetail.timeline.loading": "Memuat timeline kegiatan...",
  "qc.instrumentDetail.chart.selectAnalyte": "Pilih Analit",
  "qc.instrumentDetail.chart.loading": "Memuat control chart...",
  "qc.instrumentDetail.chart.noData": "Tidak ada data QC tersedia untuk analit ini.",
  "qc.instrumentDetail.chart.activeRules": "Aturan QC Aktif",
  "qc.instrumentDetail.chart.noRules": "Tidak ada aturan aktif yang dikonfigurasi",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Rata-rata (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Simpangan Baku (s)",
  "qc.instrumentDetail.error.loadFailed": "Gagal memuat rincian alat",
  "qc.instrumentDetail.notConfigured.title": "QC operasional tidak dikonfigurasi",
  "qc.instrumentDetail.notConfigured.description": "Tidak ada sampel Lot Kontrol aktif atau hasil QC yang terhubung dengan alat analisis ini.",
  "question.text.required": "Teks pertanyaan wajib ada",
  "compliance.legend.limitTypes": "JENIS BATAS:",
  "compliance.limitType.borderlineShort": "Garis Ambang ⚑",
  "compliance.limitType.descriptiveShort": "Kualitatif",
  "compliance.limitType.MAXIMUM": "Batas Atas ≤",
  "compliance.limitType.MINIMUM": "Batas Bawah ≥",
  "compliance.limitType.RANGE": "Rentang Normal",
  "compliance.limitType.BORDERLINE": "Garis Ambang 🚩",
  "compliance.limitType.DESCRIPTIVE": "Kualitatif",
  "compliance.limitType.EXACT": "Pasti",
  "compliance.limitType.SELECT_MAP": "Pemetaan Nilai",
  "compliance.status.ACTIVE": "Aktif",
  "compliance.status.DRAFT": "Draf",
  "compliance.status.SUPERSEDED": "Digantikan",
  "compliance.status.ARCHIVED": "Diarsipkan",
  "compliance.standard.placeholder.name": "mis., PP No. 22/2021 — Kualitas Air",
  "compliance.standard.placeholder.issuingBody": "mis., Pemerintah RI",
  "compliance.standard.placeholder.regulationNumber": "mis., PP 22/2021",
  "compliance.standard.placeholder.version": "mis., 2021",
  "compliance.standard.placeholder.countryRegion": "mis., Indonesia",
  "compliance.standard.placeholder.description": "Opsional. Deskripsi lengkap ruang lingkup standar",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Bawah / Min",
  "compliance.threshold.placeholder.upper": "Atas / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Arsip",
  "compliance.standard.archiveHeading": "Arsipkan Baku Mutu",
  "compliance.standard.archivePrompt": "Apakah standar ini mau diarsipkan? Hasil yang sudah dievaluasi akan tetap ada untuk audit, tapi standar akan disembunyikan dari daftar aktif. Aksi ini dapat di batalkan dengan mengedit status standar kembali ke Aktif.",
  "compliance.standard.archived": "Baku Mutu Diarsipkan",
  "compliance.standard.archiveError": "Tidak dapat mengarsipkan baku mutu ini.",
  "button.complianceStandard.copy": "Salin Standar",
  "compliance.standard.copied": "Baku Mutu disalin sebagai Draf baru.",
  "compliance.standard.copyError": "Tidak dapat menyalin standar ini",
  "compliance.standard.viewLinkedTests": "Lihat Pengujian Terkait",
  "compliance.testEditor.groupBy": "Digrupkan berdasar",
  "compliance.testEditor.section.configuration": "Konfigurasi",
  "compliance.testEditor.section.organization": "Organisasi",
  "compliance.testEditor.section.resources": "Sumber daya",
  "compliance.testEditor.section.automation": "Otomatisasi",
  "compliance.testEditor.section.compliance": "Kepatuhan",
  "compliance.testEditor.tab.compliance": "Kepatuhan",
  "compliance.testEditor.tabPlaceholder": "Segera datang dengan Editor Pengujian — saat ini dapat dikelola di halaman Modifikasi Pengujian.",
  "compliance.parameterGroup.editBtn": "Sunting",
  "compliance.parameterGroup.moveUp": "Geser ke atas",
  "compliance.parameterGroup.moveDown": "Geser ke bawah",
  "compliance.parameterGroup.updateError": "Tidak dapat memperbarui grup parameter.",
  "compliance.testEditor.standardInactiveBanner": "Pengujian ini memiliki ambang batas terkait dengan {name} yang sekarang {status}. Hasil tidak lagi dievaluasi terhadap standar ini.",
  "compliance.standard.viewLinkedTests.heading": "Pengujian terkait — {name}",
  "compliance.standard.viewLinkedTests.empty": "Tidak ada pengujian yang terkait dengan standar ini.",
  "compliance.filter.status": "Status",
  "compliance.filter.region": "Daerah",
  "compliance.filter.allStatuses": "Semua Status",
  "compliance.filter.allRegions": "Semua Daerah",
  "compliance.filter.sampleType": "Jenis Sampel",
  "compliance.filter.allSampleTypes": "Semua Jenis Sampel",
  "compliance.sampleTypes.addLabel": "Tambah jenis sampel",
  "compliance.sampleTypes.noneConfigured": "Tidak ada konfigurasi",
  "compliance.sampleTypes.noneTitle": "Belum ada konfigurasi jenis sampel.",
  "compliance.sampleTypes.noneSubtitle": "Tambahkan satu jenis sampel sebelum mengaitkan pengujian.",
  "compliance.sampleTypes.counter": "{count, plural, other {# jenis sampel dikonfigurasi}}",
  "compliance.standard.default": "Standar",
  "compliance.standard.groups": "Grup",
  "compliance.standard.tests": "Pengujian",
  "compliance.standard.expiryDate": "Tanggal Kedaluwarsa",
  "compliance.parameterGroups.heading": "Grup Parameter & Pengujian Terkait",
  "compliance.parameterGroups.requireSampleTypes": "Konfigurasi bidang standar dan jenis sampel, kemudian kaitkan pengujian.",
  "compliance.button.save": "Simpan",
  "compliance.button.saving": "Menyimpan...",
  "compliance.parameterGroup.createError": "Tidak dapat menambah grup parameter.",
  "compliance.parameterGroup.deleteHeading": "Hapus Grup Parameter",
  "compliance.parameterGroup.deletePrompt": "Hapus grup parameter {name} dan semua ambang batas? Hal ini tidak dapat dibatalkan.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, other {# pengujian adalah}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Tidak dapat menyimpan baris ini.",
  "compliance.threshold.deleteError": "Tidak dapat menghapus baris ini.",
  "compliance.validation.required": "Bidang ini diperlukan.",
  "compliance.validation.expiryAfterEffective": "Tanggal kedaluwarsa harus pada atau setelah tanggal efektif.",
  "compliance.validation.missingUpper": "Batas atas wajib ada.",
  "compliance.validation.missingLower": "Batas bawah wajib ada.",
  "compliance.validation.missingBounds": "Baik batas bawah dan atas wajib ada.",
  "compliance.validation.lowerGtUpper": "Batas bawah harus kurang dari atau sama dengan batas atas",
  "compliance.validation.missingDescriptive": "Nilai kualitatif wajib ada.",
  "compliance.linkTest.selectNoOptions": "Pengujian ini select-list tapi tidak ada opsi yang dikonfigurasi di katalog uji. Tambah opsi hasil di kelola pengujian sebelum mengaitkan ke baku mutu.",
  "compliance.linkTest.resultTypeLegend": "Jenis hasil",
  "compliance.linkTest.resultType.numeric": "Numerik (gunakan nilai batas)",
  "compliance.linkTest.resultType.select": "Select list (petakan opsi ke status)",
  "compliance.linkTest.optionsHint": "Tambah opsi hasil untuk pengujian ini (mis., 'Absent', 'Present'). Anda dapat memetakannya di status kepatuhan baku mutu di tahap selanjutnya.",
  "compliance.linkTest.optionLabel": "Nilai opsi",
  "compliance.linkTest.optionPlaceholder": "mis., Absen",
  "compliance.linkTest.optionsRequired": "Masukkan setidaknya satu opsi di atas sebelum melakukan pemetaan status.",
  "compliance.admin.title": "Administrasi Baku Mutu",
  "compliance.admin.tile.explain": "Kelola baku mutu, grup parameter, dan ambang batas pengujian (mis., PP 22/2021, WHO Air Minum).",
  "compliance.tabs.standardsAdmin": "Daftar Baku Mutu",
  "compliance.tabs.testThresholds": "Tab Kepatuhan (Editor Pengujian)",
  "compliance.testEditor.back": "Kembali",
  "compliance.testEditor.editTest": "Edit Pengujian:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Jenis Sampel:",
  "compliance.testEditor.resultType": "Jenis Hasil:",
  "compliance.testEditor.saveTest": "Simpan Pengujian",
  "compliance.testEditor.saveDisabledHint": "Tab editor teks lainnya belum diintegrasikan dalam iterasi ini.",
  "compliance.testEditor.thresholdsHeading": "Ambang Batas Kepatuhan untuk",
  "compliance.testEditor.addThreshold": "Tambah Ambang Batas",
  "compliance.testEditor.addThresholdHeading": "Kaitkan {name} ke baku mutu",
  "compliance.testEditor.pickStandard": "Baku Mutu",
  "compliance.testEditor.pickStandardPlaceholder": "-- Pilih standar --",
  "compliance.testEditor.pickGroup": "Grup parameter",
  "compliance.testEditor.pickGroupPlaceholder": "-- Pilih grup parameter --",
  "compliance.testEditor.pickGroupHint": "Pilih standar dan grup parameter di atas untuk mengkonfigurasi ambang batas.",
  "compliance.testEditor.unlink": "Tidak kaitkan",
  "compliance.testEditor.unlinkHeading": "Tidak kaitkan ambang batas",
  "compliance.testEditor.unlinkPrompt": "Hapus ambang batas ini dari {test}? Ambang batas akan tetap ada di grup parameter standar; tapi akan dihapus dari pengujian yang terkait.",
  "compliance.testEditor.linkedBanner": "Pengujian ini terkait ke {count, plural, one {# compliance standard} other {# compliance standards}}. Ambang batas akan dievaluasi pada saat validasi.",
  "compliance.testEditor.expandRow": "Perluas baris",
  "compliance.testEditor.col.standard": "Standar",
  "compliance.testEditor.col.parameterGroup": "Grup Parameter",
  "compliance.testEditor.col.limitType": "Jenis Batas",
  "compliance.testEditor.col.thresholdRange": "Ambang batas / Rentang",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Efektif",
  "compliance.testEditor.col.status": "Status",
  "compliance.testThresholds.selectHint": "Pilih pemeriksaan untuk melihat ambang kepatuhan yang saling terkait dengan berbagai standar.",
  "compliance.testThresholds.overviewHeading": "Pengujian terkait ke baku mutu",
  "compliance.testThresholds.overviewCount": "{filtered} dari {total} pengujian {total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "Belum ada pengujian terkait ke baku mutu.",
  "compliance.testThresholds.overviewEmptyHint": "Ambang batas berbasis CSV pada tingkat grup parameter muncul di Tab 1 (Administrasi Baku Mutu), bukan di sini. Cari di atas untuk memilih pengujian dari katalog dan tautkan ke standar.",
  "compliance.testThresholds.noLinkedMatches": "Tidak ada pengujian terkait yang cocok dengan \"{q}\".",
  "compliance.testThresholds.addSection": "Tambahkan pengujian ke baku mutu",
  "compliance.testThresholds.col.test": "Pengujian",
  "compliance.testThresholds.col.code": "Kode",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Jenis Sampel",
  "compliance.testThresholds.col.thresholdCount": "# Ambang Batas",
  "compliance.testThresholds.col.standardCount": "# Standar",
  "compliance.testThresholds.openEditor": "Buka",
  "compliance.testThresholds.title": "Ambang Kepatuhan Pengujian",
  "compliance.testThresholds.tile.explain": "Lihat ambang batas kepatuhan terkait ke pengujian, berdasarkan grup standar dan parameter.",
  "compliance.testThresholds.searchLabel": "Cari pengujian",
  "compliance.testThresholds.searchPlaceholder": "Filter daftar pengujian...",
  "compliance.testThresholds.test": "Pengujian",
  "compliance.testThresholds.selectPlaceholder": "-- Pilih pengujian --",
  "compliance.testThresholds.empty": "Belum ada ambang batas kepatuhan terkait dengan pengujian ini. Kilk + Tambah Ambang Batas di atas untuk mengaitkan baku mutu dengan grup parameter.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Jenis Batas",
  "compliance.testThresholds.value": "Nilai",
  "compliance.testThresholds.note": "Catatan",
  "compliance.testThresholds.unknownStandard": "Standar tidak diketahui",
  "compliance.button.openAdmin": "Buka Admin Baku Mutu",
  "compliance.button.addStandard": "Tambah Standar",
  "compliance.button.saveStandard": "Simpan Standar",
  "compliance.button.linkTest": "Kaitkan Pemeriksaan ke Grup",
  "compliance.button.saveLimits": "Simpan Batas",
  "compliance.button.saveMapping": "Simpan Pemetaan",
  "compliance.search": "Cari standar",
  "compliance.search.placeholder": "Cari berdasarkan nama, badan yang menerbitkan, peraturan, negara...",
  "compliance.list.empty": "Belum ada baku mutu.",
  "compliance.standard.name": "Nama Standar",
  "compliance.standard.issuingBody": "Badan yang menerbitkan",
  "compliance.standard.regulationNumber": "Nomor Peraturan",
  "compliance.standard.version": "Versi",
  "compliance.standard.countryRegion": "Negara / Regional",
  "compliance.standard.status": "Status",
  "compliance.standard.effectiveDate": "Tanggal Efektif",
  "compliance.standard.description": "Deskripsi",
  "compliance.standard.addNew": "Tambah Baku Mutu Baru",
  "compliance.standard.edit": "Edit Baku Mutu",
  "compliance.standard.preSeeded": "Telah ditempatkan sebelumnya",
  "compliance.standard.saved": "Baku mutu disimpan.",
  "compliance.standard.saveError": "Tidak dapat menyimpan standar.",
  "compliance.standard.saveBeforeGroups": "Simpan standar sebelum menambahkan grup parameter.",
  "compliance.standard.deleted": "Baku mutu dihapus.",
  "compliance.standard.deleteError": "Tidak dapat menghapus standar (mungkin sedang diisi atau terkait dengan ambang batas).",
  "compliance.standard.deleteHeading": "Hapus Baku Mutu",
  "compliance.standard.deletePrompt": "Apakah Anda yakin mau menghapus standar ini? Standar yang tengah diisi atau terkait dengan ambang batas tidak dapat dihapus.",
  "compliance.sampleTypes.heading": "Jenis Sampel yang Dapat Diterapkan",
  "compliance.sampleTypes.explicitHint": "Sebutkan kategori jenis sampel yang dapat menerapkan standar. Pilihan ini menentukan filter pengujian saat mengatikan pengujian.",
  "compliance.sampleTypes.empty": "Belum ada jenis sample disebutkan.",
  "compliance.sampleTypes.selectPlaceholder": "Pilih jenis sampel...",
  "compliance.sampleTypes.addBtn": "Tambah Jenis Sampel",
  "compliance.sampleTypes.remove": "Hapus",
  "compliance.parameterGroups": "Grup Parameter",
  "compliance.parameterGroups.empty": "Belum ada grup parameter didefinisikan.",
  "compliance.parameterGroups.add": "Tambah Grup Parameter",
  "compliance.parameterGroup.name": "Nama grup",
  "compliance.parameterGroup.description": "Deskripsi",
  "compliance.parameterGroup.deleteBtn": "Hapus",
  "compliance.label.tests": "pengujian",
  "compliance.linkedTest.name": "Pengujian",
  "compliance.linkedTest.sampleTypes": "Jenis Sampel",
  "compliance.linkedTest.limits": "Konfigurasi Batas",
  "compliance.linkedTest.editLimits": "Edit batas",
  "compliance.linkedTest.unlink": "Hapus dari grup",
  "compliance.linkedTest.unlinkHeading": "Hapus Pengujian dari Grup",
  "compliance.linkedTest.unlinkConfirm": "Hapus",
  "compliance.linkedTest.unlinkPrompt": "Hapus pengujian dari grup? Semua definisi ambang batas untuk pengujian ini di grup ini akan dihapus.",
  "compliance.group.noTests": "Belum ada pengujian terkait dengan grup ini. Kaitkan pengujian untuk mendefinisikan ambang batas kepatuhan untuk evaluasi.",
  "compliance.linkTest.heading": "Kaitkan Pemeriksaan ke Grup",
  "compliance.linkTest.step1": "Tahap 1 — Filter berdasar Jenis Sampel",
  "compliance.linkTest.step2": "Tahap 2 — Cari & Pilih Pengujian",
  "compliance.linkTest.step3Numeric": "Tahap 3 — Konfigurasi Batas",
  "compliance.linkTest.step3Select": "Tahap 3 — Pemetaan Nilai Kepatuhan",
  "compliance.linkTest.filterByST": "Filter berdasarkan jenis sampel:",
  "compliance.linkTest.searchTest": "Cari katalog pengujian",
  "compliance.linkTest.searchPlaceholder": "Ketik untuk mencari berdasarkan nama atau kode...",
  "compliance.linkTest.noResults": "Tidak ada pengujian yang cocok.",
  "compliance.linkTest.selectListBadge": "Pilih Daftar",
  "compliance.linkTest.clearSelection": "Hapus pilihan",
  "compliance.multiLimit.editHeading": "Konfigurasi Batas",
  "compliance.multiLimit.hint": "Mungkinkan satu atau lebih jenis batas untuk pengujian ini. Setidaknya satu jenis batas harus ada.",
  "compliance.multiLimit.type": "Jenis Batas",
  "compliance.multiLimit.lower": "Bawah",
  "compliance.multiLimit.upper": "Atas",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Catatan / Saran",
  "compliance.multiLimit.descriptive.placeholder": "mis., Tidak berbau, Absen, Jernih",
  "compliance.multiLimit.note.placeholder": "Catatan Opsional",
  "compliance.limitType.high": "Batas Atas ≤",
  "compliance.limitType.high.hint": "Tidak sesuai kepatuhan bila hasil melebihi batas atas",
  "compliance.limitType.low": "Batas Bawah ≥",
  "compliance.limitType.low.hint": "Tidak sesuai kepatuhan bila hasil di bawah batas bawah",
  "compliance.limitType.range": "Rentang Normal",
  "compliance.limitType.range.hint": "Dalam rentang kepatuhan atas–bawah",
  "compliance.limitType.borderline": "Garis ambang (Saran)",
  "compliance.limitType.borderline.hint": "Zona Saran - akan mentriger flag untuk meninjau, tidak gagal",
  "compliance.limitType.descriptive": "Kualitatif / Deskriptif",
  "compliance.limitType.descriptive.hint": "Nilai teks dievaluasi oleh analis",
  "compliance.selectMap.editHeading": "Pemetaan Kepatuhan",
  "compliance.selectMap.hint": "Petakan semua opsi hasil terhadap status kepatuhan. Opsi diambil dari katalog pengujian.",
  "compliance.selectMap.option": "Opsi Hasil",
  "compliance.selectMap.status": "Status Kepatuhan",
  "compliance.selectMap.preview": "Pratinjau",
  "compliance.selectMap.badge": "Pemetaan Nilai",
  "compliance.selectMap.optionsLabel": "opsi dipetakan",
  "compliance.selectMap.statusForOption": "Status kepatuhan untuk {option}",
  "compliance.status.compliant": "Sesuai Kepatuhan",
  "compliance.status.borderline": "Garis ambang",
  "compliance.status.nonCompliant": "Tidak Sesuai Kepatuhan",
  "compliance.status.compliantWithIcon": "Sesuai Kepatuhan ✓",
  "compliance.status.borderlineWithIcon": "Garis Ambang ⚑",
  "compliance.status.nonCompliantWithIcon": "Tidak Sesuai Kepatuhan ✗",
  "compliance.linkedTest.noLimits": "Tidak ada konfigurasi batas",
  "compliance.threshold.savedThresholds": "Ambang batas kepatuhan terkait pada pengujian.",
  "compliance.threshold.savedValueMap": "Ambang batas pemetaan nilai berhasil disimpan.",
  "compliance.threshold.savedPartialError": "Ambang batas tidak dapat disimpan. Tinjau ulang baris yang ditandai.",
  "compliance.threshold.unlinked": "Ambang batas tidak terkait dari pengujian.",
  "compliance.threshold.unlinkError": "Tidak dapat membatalkan ambang terkait.",
  "notification.title.success": "Berhasil",
  "notification.title.error": "Kesalahan",
  "sidenav.label.admin.vectorSurveillance": "Surveilans Vektor",
  "vector.admin.title": "Pengaturan Surveilans Vektor",
  "vector.admin.groups": "Grup organisme",
  "vector.admin.group.code": "Kode",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Tag Warna",
  "vector.admin.group.description": "Deskripsi",
  "vector.admin.active": "Aktif",
  "vector.admin.system": "Sistem",
  "vector.admin.trapTypes": "Jenis Perangkap",
  "vector.admin.trapType.name": "Nama",
  "vector.admin.trapType.description": "Deskripsi",
  "vector.admin.species": "Spesies",
  "vector.admin.selectGroup": "Pilih grup di kiri untuk mengelola perangkap berdasar jenis dan spesies.",
  "vector.admin.newGroup": "Grup baru (tidak disimpan)",
  "vector.admin.newTrapType": "Jenis perangkap baru",
  "vector.admin.newSpecies": "Spesies baru",
  "vector.admin.saveGroup": "Simpan grup",
  "vector.admin.saveTrap": "Simpan perangkap",
  "vector.admin.saveSpecies": "Simpan spesies",
  "vector.admin.addGroup": "+ Tambah group",
  "vector.admin.addTrapType": "+ Tambah jenis perangkap",
  "vector.admin.addSpecies": "+ Tambah spesies",
  "vector.admin.locked": "dikunci",
  "vector.admin.systemGroup": "Grup diproteksi sistem",
  "vector.admin.systemGroup.desc": "Kode ini dikunci karena grup di gunakan pada laporan inti dan data. Anda tetap dapat mengedit label, warna, dan deskripsi.",
  "vector.admin.usedBy": "Digunakan oleh",
  "vector.admin.status": "Status",
  "vector.admin.status.active": "Aktif",
  "vector.admin.status.inactive": "Inaktif",
  "vector.admin.group": "Grup organisme",
  "vector.admin.trapType.group": "Grup organisme target",
  "vector.admin.trapType.groups": "Grup organisme",
  "vector.admin.trapType.sampleTypes": "Jenis sampel",
  "vector.admin.sampleType": "Jenis sampel",
  "vector.admin.search.groups": "Cari berdasarkan kode dan label...",
  "vector.admin.search.traps": "Cari nama perangkap atau deskripsi...",
  "vector.admin.search.species": "Cari genus atau spesies...",
  "vector.admin.samplingSites": "Tempat Pengambilan Sampel",
  "vector.admin.samplingSite.newSite": "Tempat baru",
  "vector.admin.samplingSite.allSites": "Semua Tempat",
  "vector.admin.samplingSite.code": "Kode",
  "vector.admin.samplingSite.name": "Nama Tempat",
  "vector.admin.samplingSite.type": "Jenis Tempat",
  "vector.admin.samplingSite.region": "Regional",
  "vector.admin.samplingSite.district": "Kabupaten / Kota",
  "vector.admin.samplingSite.contactName": "Kontak Person",
  "vector.admin.samplingSite.contactPhone": "Telepon Kontak",
  "vector.admin.samplingSite.gpsLatitude": "Garis Lintang GPS",
  "vector.admin.samplingSite.gpsLongitude": "Garis bujur GPS",
  "vector.admin.samplingSite.environmentalZone": "Zona Lingkungan",
  "vector.admin.samplingSite.address": "Alamat",
  "vector.admin.samplingSite.description": "Deskripsi",
  "vector.admin.samplingSite.source": "Sumber",
  "vector.admin.samplingSite.source.local": "LOKAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Pengambilan Terakhir",
  "vector.admin.samplingSite.search": "Cari berdasarkan kode, nama, regional...",
  "vector.admin.samplingSite.saveSite": "Simpan tempat",
  "vector.admin.samplingSites.registry": "Registri Tempat Pengambilan Sampel",
  "vector.admin.samplingSite.deactivate": "Nonaktifkan",
  "vector.admin.samplingSite.activate": "Aktifkan",
  "vector.admin.samplingSite.location": "Lokasi",
  "vector.admin.samplingSite.allTypes": "Semua Jenis",
  "vector.admin.samplingSite.subtype": "Subtipe",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. Sungai, Sumur, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "Kota",
  "vector.admin.samplingSite.addressLocation": "Lokasi Alamat",
  "vector.admin.samplingSite.addressSearch.placeholder": "Cari lokasi untuk auto-fill dropdown...",
  "vector.admin.samplingSite.gpsCoordinates": "Koordinat GPS",
  "vector.admin.samplingSite.lastModified": "Dimodifikasi Terakhir",
  "label.noResults": "Hasil tidak ditemukan",
  "vector.admin.addSite": "+ Tempat Baru",
  "vector.order.title": "Pemesanan Vektor Baru",
  "vector.order.subtitle": "Instalasi Lab: Lab Surveilans Vektor - Domain vektor aktif",
  "vector.order.samplingSite": "Tempat Pengambilan Sampel",
  "vector.order.site.code": "Kode Tempat",
  "vector.order.site.helper": "Hanya lokasi pemantauan aktif yang muncul dalam hasil. Koordinat GPS sudah terisi otomatis berdasarkan catatan lokasi.",
  "vector.order.site.name": "Nama Tempat",
  "vector.order.site.placeholder": "Cari berdasarkan nama tempat atau kode...",
  "vector.order.site.type": "Jenis Tempat",
  "vector.order.specimen": "Spesimen",
  "vector.order.organism": "Hewan / Organisme",
  "vector.order.organism.hint": "Nama umum — mis., Nyamuk, Caplak, Rodensia, Agas.",
  "vector.order.organism.placeholder": "Cari organisme atau spesies...",
  "vector.order.quantity": "Kuantitas",
  "vector.order.quantity.hint": "Jumlah organisme dalam pool ini.",
  "vector.order.requester.section": "Program yang Memohon / Memesan",
  "vector.order.requester": "Pemohon",
  "vector.order.requester.placeholder": "Cari organisasi berdasarkan nama atau kode...",
  "vector.order.panels": "Panel Pemesanan",
  "vector.order.panels.search": "Pilih panel tersedia",
  "vector.order.tests": "Pemesanan Pengujian",
  "vector.order.tests.search": "Pilih Pengujian yang tersedia",
  "vector.order.collectionContext": "Konteks Pengambilan (opsional — bionomics capture)",
  "vector.order.timeOfDay": "Waktu Hari Itu",
  "vector.order.timeOfDay.dawn": "Pagi",
  "vector.order.timeOfDay.day": "Siang",
  "vector.order.timeOfDay.dusk": "Sore",
  "vector.order.timeOfDay.night": "Malam",
  "vector.order.restingContext": "Konteks Resting",
  "vector.order.restingContext.outdoor": "Di luar ruangan (eksofilik)",
  "vector.order.restingContext.indoor": "Di dalam ruangan (endofilik)",
  "vector.order.restingContext.peridomestic": "Sekitar rumah",
  "vector.order.humanBitingCatch": "Penangkapan saat menggigit manusia (Human-Biting)",
  "vector.order.humanBitingCatch.hint": "spesimen ditemukan pada manusia",
  "vector.order.collectionNotes": "Catatan Pengambilan",
  "vector.order.collectionNotes.placeholder": "Cuaca, kondisi perangkap, anomali...",
  "vector.admin.group.code.placeholder": "mis., AGAS",
  "vector.admin.group.label.placeholder": "mis., Agas",
  "vector.species.genus.placeholder": "mis., Mansonia",
  "vector.species.species.placeholder": "mis., uniformis",
  "vector.species.subspecies.placeholder": "mis., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Spesies",
  "vector.species.subspecies": "Subspesies",
  "vector.species.pathogensOfInterest": "Patogen yang Menarik Perhatian",
  "vector.species.lifecycleStages": "Tahap Siklus Hidup",
  "vector.species.pathogenCategory": "Kategori Patogen",
  "vector.species.lifecycleCategory": "Kategori Siklus Hidup",
  "workflow.vector": "Surveilans Vektor",
  "vector.sampleType": "Jenis Sampel",
  "vector.organismGroup": "Grup organisme",
  "vector.species": "Spesies",
  "vector.animalOrganism": "Hewan/Organisme",
  "vector.animalOrganism.add": "Tambah Hewan/Organisme",
  "vector.animalOrganism.remove": "Hapus Hewan/Organisme",
  "vector.collectedVolume": "Kuantitas dalam Pool",
  "vector.lifecycleStage": "Tahapan Siklus Hidup",
  "vector.trapCount": "Perangkap Telah Dipasang",
  "vector.trapNights": "Malam-malam yang Dilewati",
  "vector.trapType": "Jenis Perangkap",
  "vector.poolingMethod": "Metode Pooling",
  "vector.poolCount": "Jumlah Pool",
  "vector.samplesPerPool": "Spesimen per Pool",
  "vector.totalSpecimens": "Total Spesimen",
  "vector.pathogensOfInterest": "Patogen yang Menarik Perhatian",
  "vector.homogeneous": "Homogen",
  "vector.random": "Acak",
  "vector.collectionSite": "Tempat Pengambilan",
  "vector.collectionSiteName": "Nama Tempat Pengambilan",
  "vector.gpsLatitude": "Garis Lintang GPS",
  "vector.gpsLongitude": "Garis bujur GPS",
  "patient.search.merged.tag": "Menggabungkan",
  "patient.merged.banner.title": "Rekaman pasien ini telah digabungkan",
  "patient.merged.banner.subtitle": "Rekaman aktif disimpan pada Pasien {target}.",
  "patient.merged.banner.subtitle.noTarget": "Rekaman ini telah digabungkan ke pasien lain.",
  "admin.testCatalog.tabs.ariaLabel": "Pemeriksaan detail tab",
  "admin.testCatalog.tabs.details": "Rincian",
  "admin.testCatalog.tabs.labels": "Label",
  "admin.testCatalog.labels.masterOverride.label": "Izinkan Override Pemesanan",
  "admin.testCatalog.labels.masterOverride.on": "Nyalakan",
  "admin.testCatalog.labels.masterOverride.off": "Matikan",
  "admin.testCatalog.labels.linkedPresets.title": "Pengaturan Label Tertaut",
  "admin.testCatalog.labels.linkedPresets.empty": "Tidak ada pengaturan label yang terhubung. Gunakan menu tarik-turun di bawah ini untuk menambahkan satu.",
  "admin.testCatalog.labels.col.presetName": "Nama Pengaturan",
  "admin.testCatalog.labels.col.defaultQty": "Kuantitas Default",
  "admin.testCatalog.labels.col.maxQty": "Kuantitas Maks",
  "admin.testCatalog.labels.col.allowOverride": "Izinkan Override",
  "admin.testCatalog.labels.col.actions": "Aksi",
  "admin.testCatalog.labels.action.remove": "Hapus tautan pengaturan",
  "admin.testCatalog.labels.addPreset.label": "Tambah Jenis Label",
  "admin.testCatalog.labels.addPreset.placeholder": "Pilih Pengaturan Label",
  "admin.testCatalog.labels.preview.title": "Pratinjau Entri Pesanan",
  "admin.testCatalog.labels.preview.col.locked": "Terkunci",
  "admin.testCatalog.labels.preview.locked": "Terkunci",
  "admin.testCatalog.labels.preview.unlocked": "Dapat diedit",
  "admin.testCatalog.labels.save.success": "Konfigurasi label disimpan.",
  "admin.testCatalog.labels.save.error": "Gagal menyimpan konfigurasi label.",
  "orderEntry.labels.orderTable.title": "Label pemesanan",
  "orderEntry.labels.sampleTable.title": "Label Sampel",
  "orderEntry.labels.col.row": "Baris",
  "orderEntry.labels.col.sample": "Sampel",
  "orderEntry.labels.col.quantity": "Kuantitas",
  "orderEntry.labels.orderRow.header": "Pemesanan",
  "orderEntry.labels.sampleRow.header": "Sampel {number}",
  "orderEntry.labels.input.sample": "Sampel {number} {column} jumlah",
  "orderEntry.labels.source.test": "Dari pemeriksaan",
  "orderEntry.labels.source.presetDefault": "Pengaturan bawaan",
  "orderEntry.labels.locked.tooltipFor": "{label} Telah terkunci oleh konfigurasi pemeriksaan dan tidak dapat diubah.",
  "orderEntry.labels.total": "Jumlah label: {total}",
  "orderEntry.labels.heading": "LABELS",
  "label.patientHistory.filterByCategory": "Saring berdasarkan kategori pemeriksaan",
  "label.patientHistory.testCategories": "Kategori pemeriksaan",
  "label.patientHistory.tree": "Pohon",
  "label.patientHistory.showTree": "Tampilkan pohon",
  "label.patientHistory.resetTree": "Atur Ulang pohon",
  "label.patientHistory.viewResults": "Lihat hasil lomba “{count}”",
  "label.patientHistory.emptyState": "Tidak ada \"{displayText}\" yang dapat ditampilkan untuk pasien ini",
  "label.patientHistory.record": "Rekam {displayText}",
  "label.patientHistory.dataLoadError": "Kesalahan Pemuatan Data",
  "label.patientHistory.errorCopy": "Maaf, terjadi masalah saat menampilkan informasi ini. Anda dapat mencoba memuat ulang halaman ini, atau menghubungi administrator situs dan menyebutkan kode kesalahan di atas.",
  "label.patientHistory.backToTimeline": "Kembali ke garis waktu",
  "label.patientHistory.returnToTimeline": "Kembali ke garis waktu",
  "label.patientHistory.timeOfTest": "Waktu Pemeriksaan",
  "label.patientHistory.observations": "pengamatan",
  "label.patientHistory.range.oneDay": "1 hari",
  "label.patientHistory.range.fiveDays": "5 hari",
  "label.patientHistory.range.oneMonth": "1 bulan",
  "label.patientHistory.range.sixMonths": "6 bulan",
  "label.patientHistory.range.oneYear": "1 tahun",
  "label.patientHistory.range.fiveYears": "5 tahun",
  "label.patientHistory.range.all": "Semua",
  "label.patientHistory.date": "Tanggal",
  "address.search.no.results": "Tidak ditemukan alamat untuk '{term}'",
  "address.search.placeholder": "Cari alamat (masukkan minimal 2 karakter)...",
  "address.search.results.count": "{count} Hasil yang ditemukan",
  "alert.error": "Kesalahan",
  "alert.warning": "Peringatan",
  "analyzer.errorDetails.noLogsAvailable": "Tidak ada log yang tersedia",
  "analyzer.fieldSelector.placeholder": "Cari dan pilih bidang...",
  "analyzer.fieldSelector.title": "Pilih Bidang OpenELIS",
  "analyzer.form.columnMappings": "Pemetaan Kolom (JSON)",
  "analyzer.form.columnMappings.helperText": "Memetakan nama kolom berkas ke nama bidang internal",
  "analyzer.form.delimiter": "Pemisah",
  "analyzer.form.fileFormat": "Format File",
  "analyzer.form.fileImport.title": "Pengaturan Impor File",
  "analyzer.form.filePattern": "Pola File",
  "analyzer.form.filePattern.helperText": "Pola Glob untuk mencocokkan file hasil",
  "analyzer.form.hasHeader": "File ini memiliki baris yang memiliki Header",
  "analyzer.form.importDirectory": "Direktori Impor",
  "analyzer.form.importDirectory.helperText": "Direktori tempat bridge memantau file hasil yang masuk",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Pemetaan kolom harus berupa JSON yang valid",
  "analyzer.form.validation.importDirectory.required": "Direktori impor wajib ada untuk penganalisis berbasis file",
  "analyzer.form.validation.port.invalid": "Nomor port harus berupa angka antara 1 dan 65535",
  "analyzer.qc.batch.failure.subtitle": "Proses pengendalian mutu pada batch ini menunjukkan adanya ketidaksesuaian. Silakan tinjau hasil pengendalian mutu di bawah ini sebelum menerima hasil pemeriksaan pasien.",
  "analyzer.qc.batch.failure.title": "Pengendalian QC Gagal",
  "analyzer.qc.controls.hidden": "QC yang tidak terlihat oleh pasien",
  "analyzer.qc.controls.section.title": "QC Controls ({count})",
  "audittrail.table.heading": "Informasi Pemesanan",
  "barcode.label.info.labnumber": "Nomor Registrasi",
  "button.close": "Tutup",
  "button.collapse": "Sembunyikan",
  "button.expand": "Perluas",
  "button.home": "Beranda",
  "button.new.search": "Cari Baru",
  "column.name.labNo": "Lab #",
  "env.collectionConditions.helper": "Cari lokasi pengambilan sampel yang sudah ada atau buat yang baru. Lokasi-lokasi tersebut dapat digunakan kembali di berbagai pemesanan — seperti halnya pasien dalam alur kerja klinis.",
  "env.collectionMethod.placeholder": "misalnya, sampel acak, sampel gabungan 24 jam",
  "env.conditions": "Kondisi Lingkungan",
  "env.conditions.placeholder": "misalnya, 20°C, cuaca cerah, musim kemarau",
  "env.regulatoryReference": "Referensi Peraturan",
  "env.regulatoryReference.placeholder": "mis., PP 22/2021 tentang Kualitas Air",
  "env.samplingSite.title": "Subjek — Tempat Pengambilan Sampel",
  "env.site.address": "Alamat",
  "env.site.addressSearch.placeholder": "Cari lokasi untuk mengisi otomatis daftar tarik-turun di bawah ini...",
  "env.site.code": "Kode Tempat",
  "env.site.code.placeholder": "Membuat secara otomatis (atau masukkan secara manual)",
  "env.site.contactPerson": "Kontak Person",
  "env.site.contactPerson.placeholder": "Nama pengelola situs atau kontak",
  "env.site.contactPhone": "Telepon Kontak",
  "env.site.description": "Deskripsi Situs",
  "env.site.description.placeholder": "misalnya, titik pemantauan hilir di dekat pintu air",
  "env.site.helperText": "Daftarkan tempat pengambilan sampel baru. Tempat tersebut akan disimpan di Registri Tempat Pengambilan Sampel dan dapat digunakan kembali untuk pemesanan di masa mendatang.",
  "env.site.name": "Nama Tempat",
  "env.site.name.placeholder": "misalnya, Sungai Ciliwung — Manggarai",
  "env.site.newTab": "Tempat Baru",
  "env.site.saveAndSelect": "Simpan & Pilih Tempat",
  "env.site.searchLabel": "Nama Tempat",
  "env.site.searchPlaceholder": "misalnya, Sungai Ciliwung – Manggarai",
  "env.site.searchTab": "Cari Situs Ini",
  "env.site.streetAddress": "Alamat",
  "env.site.streetAddress.placeholder": "Nama Jalan atau referensi lokasi",
  "env.site.subtype": "Subtipe",
  "env.site.subtype.placeholder": "misalnya, Sungai, Sumur, BG-Sentinel, Stasiun Tetap",
  "env.site.type": "Jenis Tempat",
  "env.site.type.select": "Pilih Jenis...",
  "env.site.zone": "Zona Lingkungan",
  "env.site.zone.select": "Pilih Zona...",
  "error.dateRange.start": "Silakan pilih tanggal mulai dan tanggal selesai.",
  "error.loading.metrics": "Terjadi kesalahan saat memuat metrik",
  "error.nonconform.report.data.found": "Tidak ada data ditemukan",
  "error.report.csv.dateType": "Silahkan pilih jenis tanggal.",
  "error.required.fields": "Silakan isi semua bidang yang wajib diisi",
  "error.save.sample": "Terjadi kesalahan saat menyimpan sampel",
  "error.validation.failed": "Validasi gagal",
  "error.value": "Silakan pilih sebuah nilai.",
  "esig.context.saveResults": "Simpan hasil pencarian \"{count}\" untuk Nomor Registrasi {accession}",
  "esig.context.saveResultsMulti": "Simpan hasil \"{count}\" dari berbagai nomor registrasi {accessionCount}",
  "esig.context.validateResults": "Validasi hasil {count} untuk nomor registrasi {accession}",
  "esig.context.validateResultsMulti": "Validasi hasil penelitian “{count}” pada berbagai nomor registrasi “{accessionCount}”",
  "fhir.questionnaire.title": "Informasi Tambahan",
  "genericSample.default.fields.title": "Informasi Sampel",
  "genericSample.import.success": "Impor Berhasil",
  "genericSample.notebook.label": "Pilih Notebook",
  "genericSample.order.newOrder": "Buat Contoh Lainnya",
  "genericSample.search.title": "Cari berdasarkan Nomor Registrasi",
  "http.success": "Berhasil!",
  "label.button.assign": "Menugaskan",
  "label.button.create": "Buat",
  "label.button.saving": "Menyimpan...",
  "label.button.view": "Lihat Laporan",
  "label.code": "Kode",
  "label.editing": "Penyuntingan",
  "label.label": "Label",
  "label.name": "Nama",
  "label.panel": "Panel",
  "label.tests": "pengujian",
  "loading.label": "Memuat...",
  "loading.metrics": "Memuat metrik...",
  "locale.save.error": "Gagal menyimpan bahasa",
  "logging.management.tail.clear": "Kosongkan",
  "logging.management.tail.disconnected": "Koneksi streaming putus. Matikan dan nyalakan kembali untuk menghubungkan kembali.",
  "logging.management.tail.label": "Log aplikasi secara langsung",
  "logging.management.tail.off": "Matikan",
  "logging.management.tail.on": "Nyalakan",
  "logging.management.tail.stream": "Siaran langsung",
  "nationalID.title": "NIK",
  "nce.button.linkSelected": "Tautan ke Sampel yang Dipilih",
  "nce.button.submit": "Kirimkan NCE",
  "nce.error.numberGeneration": "Gagal membuat nomor Kejadian Ketidaksesuaian. Silakan coba lagi.",
  "nce.field.dateOfEvent": "Tanggal Kejadian",
  "nce.field.description": "Deskripsi",
  "nce.field.nceNumber": "Nomor Kejadian Ketidaksesuaian",
  "nce.field.proposedAction.helper": "Terpisah dari tindakan CAPA yang ditugaskan selama alur kerja Tindakan Perbaikan",
  "nce.field.proposedAction.placeholder": "Langkah Berikutnya yang disarankan...",
  "nce.field.reporterName": "Nama Wartawan",
  "nce.field.reportingUnit": "Unit yang melapor",
  "nce.field.subcategory": "Subkategori",
  "nce.field.suspectedCauses.helper": "Hanya penilaian awal — penyebab utama yang sebenarnya ditentukan selama Investigasi",
  "nce.field.suspectedCauses.placeholder": "Wartawan",
  "nce.form.subtitle": "Dokumentasikan acara yang berkualitas dan cantumkan tautan ke sampel serta hasil yang terkait",
  "nce.form.title": "Lapor Kejadian Ketidaksesuaian",
  "nce.linkSamples.helper": "Cari pemesanan di atas untuk menghubungkan sampel ke NCE ini. Langkah ini bersifat opsional.",
  "nce.section.attachments": "Lampiran",
  "nce.section.classification": "Klasifikasi",
  "nce.section.details": "Rincian",
  "nce.section.linkSamples": "Tautan ke Sampel / Hasil (Opsional)",
  "nce.section.reporterContext": "Reporter & Konteks Acara",
  "nce.select.subcategory": "Pilih subkategori...",
  "nce.severity.critical.desc": "Resiko keselamatan pasien, pelanggaran peraturan",
  "nce.severity.major.desc": "Dampat signifikan pada mutu atau operasional",
  "nce.severity.minor.desc": "Dampak terbatas, mudah diperbaiki",
  "nonconform.corrective.requiredFields": "Isi semua kolom tindakan korektif (tindakan, Petugas yang bertanggungjawab, Tanggal selesai, dan setidaknya satu jenis tindakan), atau biarkan baris tersebut kosong seluruhnya.",
  "nonconform.view.requiredFields": "Komponen laboratorium, kategori Kejadian Ketidaksesuaian, jenis Kejadian Ketidaksesuaian, tingkat keparahan, konsekuensi, dan frekuensi kejadian semuanya wajib diisi.",
  "notebook.sample.create": "Buat",
  "notebook.sample.create.title": "Buat sampel baru",
  "notebook.sample.edit": "Sunting",
  "notebook.sample.edit.title": "Edit Sampel",
  "notebook.sample.import": "Impor",
  "notebook.sample.import.title": "Impor Sampel",
  "notebook.sample.order.info": "Sampel ini akan dikaitkan dengan notebook yang sedang aktif.",
  "notification.warning": "Peringatan",
  "order.entry.setup.batch": "Masukkan Pemesanan Batch",
  "order.legend.patient1": "Informasi Pasien",
  "pagination.next": "Halaman berikutnya",
  "pagination.previous": "Halaman sebelumnya",
  "patient.fetch.error": "Tidak dapat memuat data pasien. Identitas tersebut mungkin tidak valid atau server tidak dapat diakses.",
  "patient.firstName": "Nama Depan",
  "patient.lastName": "Nama Belakang",
  "print.barcode.all": "Cetak Semua Kode QR ({count})",
  "sample.item.id": "Nomor Identitas Sampel Barang",
  "sample.label": "Sampel",
  "sample.noPanels": "Tidak ada panel yang tersedia untuk jenis sampel ini",
  "sample.noTests": "Tidak ada pemeriksaan yang tersedia untuk jenis sampel ini",
  "sample.selectType.first": "Pilih jenis sampel di atas untuk melihat panel dan tes yang tersedia",
  "sample.testsCount": "{count} Pemeriksaan Tersedia",
  "sample.types": "Sampel",
  "save.error.msg": "Terjadi kesalahan saat menyimpan",
  "saving.label": "Menyimpan...",
  "select.label.analyzer": "Pilih Alat",
  "site.code": "Kode",
  "steps.complete": "langkah-langkah",
  "storage.audit.empty": "Tidak ada pergerakan yang tercatat untuk sampel ini.",
  "storage.audit.empty.title": "Tidak ada gerakan",
  "storage.audit.fetch.error": "Tidak dapat memuat jejak audit.",
  "storage.audit.fetch.error.title": "Kesalahan",
  "storage.audit.from": "Dari",
  "storage.audit.movedBy": "Dipindahkan Oleh",
  "storage.audit.movementDate": "Tanggal Perpindahan",
  "storage.audit.reason": "Alasan",
  "storage.audit.to": "Kepada",
  "storage.box.code.helper": "Maksimal 10 karakter",
  "storage.confirm.disposal": "Konfirmasi Musnahkan",
  "storage.dashboard.title": "Penyimpanan",
  "storage.disposal.method": "Metode Pembuangan",
  "storage.disposal.method.placeholder": "Pilih metode...",
  "storage.disposal.notes": "Catatan Tambahan (Opsional)",
  "storage.disposal.notes.placeholder": "Masukkan catatan tambahan apa saja...",
  "storage.disposal.reason": "Alasan Pemusnahan",
  "storage.disposal.reason.placeholder": "Pilih Alasan...",
  "storage.dispose.confirmation": "Saya menyatakan bahwa saya ingin membuang sampel ini secara permanen. Tindakan ini tidak dapat dibatalkan.",
  "storage.dispose.error": "Disposal failed",
  "storage.dispose.instructions.subtitle": "Harap pastikan prosedur pembuangan yang benar dipatuhi sesuai dengan Protokol Keselamatan Laboratorium.",
  "storage.dispose.instructions.title": "Petunjuk Pembuangan",
  "storage.dispose.location.note": "Sampel akan diambil dari lokasi ini saat pembuangan",
  "storage.dispose.sample": "Musnahkan Sampel",
  "storage.dispose.sample.subtitle": "Musnahkan sampel secara permanen {sampleId}",
  "storage.dispose.warning.subtitle": "Sampel tersebut akan ditandai sebagai telah dibuang dan dihapus dari tempat penyimpanan.",
  "storage.dispose.warning.title": "Aksi ini tidak dapat dibatalkan",
  "storage.edit.heading": "Edit {type}",
  "storage.edit.title": "Sunting",
  "storage.editbox.heading": "Kotak Edit",
  "storage.error": "Kesalahan",
  "storage.error.save": "Gagal menyimpan lokasi",
  "storage.filter.select.location": "Pilih Lokasi...",
  "storage.filter.selected": "Dipilih:",
  "storage.location.assigned.error": "Gagal menempatkan di lokasi",
  "storage.location.assigned.success": "Lokasi telah ditugaskan dengan sukses",
  "storage.location.created": "{level} created",
  "storage.location.deleted": "{level} deleted",
  "storage.location.no.results": "Tidak ditemukan lokasi",
  "storage.location.type.devices": "Perangkat",
  "storage.location.type.racks": "Laci",
  "storage.location.type.rooms": "Ruangan",
  "storage.location.type.shelves": "Rak",
  "storage.location.updated": "{level} updated",
  "storage.manage.location": "Kelola Lokasi",
  "storage.nav.rack": "Laci",
  "storage.sample.actions": "Sampel aksi",
  "storage.sampleitem.accession": "Aksesi Sampel",
  "storage.sampleitem.location": "Lokasi Penyimpanan",
  "storage.sampleitem.status": "Status",
  "storage.sampleitem.type": "Tipe",
  "storage.search.location.label": "Cari lokasi penyimpanan",
  "storage.search.location.placeholder": "Ketik jenis karakter 2+ untuk mencari…",
  "storage.skipRemaining": "Lewati penyimpanan untuk sampel tidak ditugaskan ({count}) — akan segera diproses",
  "storage.view.audit": "Lihat Audit",
  "storage.view.audit.subtitle": "Riwayat pergerakan untuk sampel {sampleId}",
  "storage.view.audit.title": "Jejak Audit Penyimpanan",
  "systemDefaultPayloadTemplate.messageTemplate": "Templat pesan",
  "systemDefaultPayloadTemplate.subjectTemplate": "Template Subjek",
  "tests.count": "{count, plural, one {test} other {tests}}",
  "validation.invalid.ip": "Format alamat IP tidak valid (IPv4 atau IPv6)",
  "validation.invalid.port": "Nomor port harus berkisar antara 1 dan 65535",
  "validation.required": "Bidang ini diperlukan",
  "common.accept": "Terima",
  "common.accessionNumber": "Nomor Registrasi",
  "common.action": "Aksi",
  "common.actions": "Aksi",
  "common.active": "Aktif",
  "common.addTests": "Tambah Pemeriksaan",
  "common.aliquots": "alikuot",
  "common.all": "Semua",
  "common.allStatuses": "Semua Status",
  "common.analyzer": "Alat",
  "common.analyzers": "Alat",
  "common.auditTrail": "Jejak Audit",
  "common.back": "Kembali",
  "common.boxId": "ID Boks",
  "common.byUnit": "Berdasarkan Unit",
  "common.cancel": "Batal",
  "common.category": "Kategori",
  "common.clinical": "Klinis",
  "common.code": "Kode",
  "common.collected": "Diambil",
  "common.collectionDate": "Tanggal Pengambilan",
  "common.complete": "Selesai",
  "common.completed": "Selesai",
  "common.confirm": "Konfirmasi",
  "common.correctiveActions": "Tindakan Perbaikan",
  "common.createAliquot": "Buat Alikuot",
  "common.critical": "Kritis",
  "common.dashboard": "Dasbor",
  "common.date": "Tanggal",
  "common.dateRange": "Rentang Tanggal",
  "common.deactivate": "Nonaktifkan",
  "common.delete": "Hapus",
  "common.description": "Deskripsi",
  "common.draft": "Draf",
  "common.edit": "Sunting",
  "common.editOrder": "Edit Sampel",
  "common.email": "Email",
  "common.enterResults": "Masukkan Hasil",
  "common.error": "Kesalahan",
  "common.expired": "Kedaluwarsa",
  "common.exportPdf": "Ekspor PDF",
  "common.failed": "Gagal",
  "common.filterByStatus": "Filter berdasarkan Status",
  "common.firstName": "Nama Depan",
  "common.from": "Dari",
  "common.generateReport": "Buat Laporan",
  "common.home": "Beranda",
  "common.inProgress": "Dalam Pengerjaan",
  "common.inactive": "Inaktif",
  "common.labNumber": "Nomor Registrasi",
  "common.lastName": "Nama Belakang",
  "common.loading": "Memuat...",
  "common.location": "Lokasi",
  "common.mean": "Rata-rata",
  "common.name": "Nama",
  "common.nationalId": "NIK",
  "common.new": "Baru",
  "common.none": "Tidak ada",
  "common.normal": "Normal",
  "common.normalRange": "Rentang Normal",
  "common.notes": "Catatan",
  "common.order": "Pemesanan",
  "common.overdue": "Lewat tenggat",
  "common.panels": "Panel",
  "common.participants": "Peserta",
  "common.patient": "Pasien",
  "common.pending": "Tertunda",
  "common.position": "Posisi",
  "common.printLabel": "Cetak Label",
  "common.priority": "Prioritas",
  "common.program": "Program",
  "common.programName": "Nama Program",
  "common.provider": "Penyelenggara",
  "common.quantity": "Kuantitas",
  "common.received": "Diterima",
  "common.referenceLab": "Lab Rujukan",
  "common.reject": "Tolak",
  "common.remove": "Hapus",
  "common.removeSelection": "Hapus {name}",
  "common.reports": "Laporan",
  "common.requester": "Pemohon",
  "common.result": "Hasil",
  "common.results": "Hasil",
  "common.room": "Ruangan",
  "common.routine": "Rutin",
  "common.sample": "Sampel",
  "common.sampleId": "Nomor Identitas Sampel",
  "common.sampleManagement": "Pengelolaan Sampel",
  "common.sampleType": "Jenis Sampel",
  "common.samples": "Sampel",
  "common.samplingSite": "Tempat Pengambilan Sampel",
  "common.save": "Simpan",
  "common.saveFailed": "Penyimpanan gagal",
  "common.saving": "Menyimpan...",
  "common.search": "Cari",
  "common.select": "Pilih",
  "common.severity": "Keparahan",
  "common.siteName": "Nama Tempat",
  "common.species": "Spesies",
  "common.standard": "Standar",
  "common.status": "Status",
  "common.storageLocation": "Lokasi Penyimpanan",
  "common.study": "Kajian",
  "common.test": "Pemeriksaan",
  "common.testName": "Nama Pemeriksaan",
  "common.tests": "Pemeriksaan",
  "common.type": "Tipe",
  "common.unit": "Unit",
  "common.user": "Pengguna",
  "common.value": "Nilai",
  "common.view": "Lihat",
  "common.warning": "Peringatan",
  "label.testCatalog.alerts.field.component": "Komponen hasil",
  "label.testCatalog.alerts.field.componentHelp": "Hasil mana yang dipantau oleh peringatan ini. Biarkan tidak diatur agar semua komponen pemeriksaan ini dipantau.",
  "label.testCatalog.alerts.field.sampleType": "Jenis sampel",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Spesimen mana yang dipantau oleh peringatan ini. Biarkan tidak diatur agar semua jenis sampel yang diuji dalam pemeriksaan ini dipantau.",
  "label.testCatalog.alerts.scope.anyComponent": "Komponen apa saja",
  "label.testCatalog.alerts.scope.anySampleType": "Apa saja jenis sampel",
  "label.testCatalog.alerts.col.scope": "Terapkan untuk",
  "label.testCatalog.alerts.scope.wholeTest": "Seluruh pemeriksaan",
  "microbiology.ast.breakpointStandard": "Standar titik henti",
  "microbiology.ast.hint": "Rekam pembacaan MIC atau zona, tinjau interpretasinya, dan dokumentasikan pengecualian secara langsung.",
  "microbiology.ast.noOverride": "Tidak ada penggantian",
  "microbiology.ast.reading": "Hasil pemeriksaan AST",
  "microbiology.case.isolates.hint": "Tambah dan identifikasi pertumbuhan yang signifikan secara klinis sebelum AST.",
  "microbiology.isolate.contaminant": "Kontaminasi",
  "microbiology.isolate.edit": "Edit isolat",
  "microbiology.isolate.identificationStatus": "Status identifikasi",
  "microbiology.isolate.normalFlora": "Flora normal",
  "microbiology.isolate.organism": "Organisme",
  "microbiology.isolate.organism.freeText": "Masukkan nama organisme sebagai teks bebas",
  "microbiology.isolate.significant": "Signifikan secara klinis",
  "microbiology.isolate.unknown": "Tidak diketahui",
  "microbiology.isolate.update": "Simpan data identifikasi",
  "microbiology.enum.AST_REVIEW_REQUIRED": "Peninjauan AST wajib",
  "microbiology.enum.AWAITING_RESULTS": "Menunggu Hasil",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Diperlukan Pemetaan Antibiotik yang wajib",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Diperlukan Penyelesaian Kasus yang Wajib",
  "microbiology.enum.AMENDED": "Telah diubah",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "Aksi Amandemen Gagal",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Perubahan Protokol Budaya",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "Amandemen Telah Dibuka",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "Riwayat Perubahan: Gagal Memuat",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Proses Amandemen Dalam Pengerjaan",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "Pelaksanaan AST Baru adalah wajib untuk Perubahan",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Amandemen Tidak Dibuka",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Alasan Perubahan Wajib",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "Amandemen Menyebabkan Rilis Akhir Menjadi Wajib",
  "microbiology.enum.ACKNOWLEDGED": "Sudah diketahui",
  "microbiology.enum.AMENDMENT_CANCELLED": "Amandemen Dibatalkan",
  "microbiology.enum.AMENDMENT_OPENED": "Pembahasan Perubahan Telah Dibuka",
  "microbiology.enum.AMENDMENT_RELEASED": "Amandemen Telah Dirilis",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "Sumber Perubahan AST Harus Dilaporkan",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Bendera Alat Sudah Diketahui",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "Pemeriksaan Kualitas (QC) Alat Analisis Gagal",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Hasil Analisis Diterima",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "Alasan Upaya AST Wajib Diisi",
  "microbiology.enum.AST_ENTRY": "Entri AST",
  "microbiology.enum.AST_IN_PROGRESS": "AST Dalam Pengerjaan",
  "microbiology.enum.AST_READY": "Siap untuk AST",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Diperlukan Pengulangan atau Pemeriksaan Ulang",
  "microbiology.enum.AST_REVIEW": "Ulasan AST",
  "microbiology.enum.AST_REVIEWED": "Telah Ditinjau oleh AST",
  "microbiology.enum.AST_READING_OVERRIDDEN": "Pembacaan AST Diganti",
  "microbiology.enum.AST_READING_RECORDED": "Pembacaan AST Direkam",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "AST yang Harus Dilaporkan Telah Dipilih",
  "microbiology.enum.AST_RUN_CREATED": "AST Run Dibuat",
  "microbiology.enum.AST_RUN_INVALIDATED": "AST Run Dibatalkan",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "Ketidaksesuaian Metode Pelaksanaan AST",
  "microbiology.enum.AST_QC_OVERRIDDEN": "AST QC Diabaikan",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "Pengaturan AST Tidak Tersedia",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "Diperlukan Peninjauan Pelaksanaan Sumber AST yang wajib",
  "microbiology.enum.ANALYZER": "Alat",
  "microbiology.enum.BROTH_MICRODILUTION": "Metode Mikrodilusi Kaldu",
  "microbiology.enum.CASE": "Kasus",
  "microbiology.enum.CASE_CREATED": "Kasus Dibuat",
  "microbiology.enum.CASE_REVIEW": "Tinjauan Kasus",
  "microbiology.enum.CANCELLED": "Dibatalkan",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Signifikan secara klinis",
  "microbiology.enum.CLOSED": "Ditutup",
  "microbiology.enum.CONFIRMED": "Telah dilakukan konfirmasi",
  "microbiology.enum.CONTAMINANT": "Kontaminasi",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Komunikasi Kritis Sudah Diketahui",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Komunikasi Kritis Ditutup",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Catatan Komunikasi Kritis Telah Dicatat",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Diperlukan Tindak Lanjut yang Sangat Kritis",
  "microbiology.enum.DISK_DIFFUSION": "Difusi Disk",
  "microbiology.enum.EMAIL": "Email",
  "microbiology.enum.EMERGENCY": "Keadaan Darurat",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Gagal",
  "microbiology.enum.FINAL": "Final",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Laporan Akhir Telah Diterbitkan",
  "microbiology.enum.GROWTH_DETECTED": "Terdeteksi Pertumbuhan",
  "microbiology.enum.HIGH": "Tinggi",
  "microbiology.enum.IDENTIFICATION": "Identifikasi",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "Inkubasi",
  "microbiology.enum.INPATIENT": "Pasien rawat inap",
  "microbiology.enum.IN_PROGRESS": "Dalam Pengerjaan",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "Secara Langsung",
  "microbiology.enum.INOCULATION_RECORDED": "Pemberian Vaksin Direkam",
  "microbiology.enum.ISOLATE": "Mengisolasi",
  "microbiology.enum.ISOLATE_CREATED": "Isolat Dibuat",
  "microbiology.enum.ISOLATE_ID": "Identitas Isolat",
  "microbiology.enum.ISOLATE_REQUIRED": "Isolasi wajib",
  "microbiology.enum.ISOLATE_UPDATED": "Isolat Terbarui",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Teknik MIC yang Tidak Ditentukan",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Teknik Zona yang Tidak Ditentukan",
  "microbiology.enum.MANUAL_NOTE": "Catatan Manual",
  "microbiology.enum.MANUAL_ENTRY": "Entri Manual",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "Audit Vaksinasi Tidak Dapat Dicatat",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "Protokol Audit Tidak Dapat Direkam",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Pilih Protokol Lain",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Menugaskan Alur Kerja Sebelum Memilih Protokol",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "Sumber subkultur harus berkaitan dengan kasus ini",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "Audit Alur Kerja Tidak Dapat Direkam",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Konfirmasi Pelestarian Karya yang Sudah Ada",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Klasifikasi Alur Kerja Wajib",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "Metode Budaya Tidak Sesuai dengan Alur Kerja",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Alur Kerja Tidak Didukung",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "Alur Kerja ini sebenarnya sudah ada",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Pilih Alur Kerja Lainnya",
  "microbiology.enum.NO_GROWTH_READY": "Tidak Siap untuk Pertumbuhan",
  "microbiology.enum.NORMAL_FLORA": "Flora normal",
  "microbiology.enum.NEEDS_WORKFLOW": "Perlu Alur Kerja",
  "microbiology.enum.NOT_READY": "Belum Siap",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Dilaporkan Tidak Sesuai",
  "microbiology.enum.NONE": "Tidak ada",
  "microbiology.enum.OPEN": "Buka",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Pemetaan Organisme Wajib",
  "microbiology.enum.ORGANISM": "Organisme",
  "microbiology.enum.ORIGINAL": "Asli",
  "microbiology.enum.OTHER": "Lainnya",
  "microbiology.enum.OUTPATIENT": "Rawat Jalan",
  "microbiology.enum.PENDING": "Tertunda",
  "microbiology.enum.PASSED": "Lolos",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Telepon",
  "microbiology.enum.POSITIVE_SIGNAL": "Sinyal Positif",
  "microbiology.enum.PRELIM_RELEASED": "Rilis Awal",
  "microbiology.enum.PRELIMINARY": "Awal",
  "microbiology.enum.PRELIMINARY_RELEASED": "Rilis Awal",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Laporan Awal Telah Dirilis",
  "microbiology.enum.QC_FAILED": "QC Gagal",
  "microbiology.enum.RECEIVED": "Diterima",
  "microbiology.enum.RELEASED": "Dirilis",
  "microbiology.enum.REPEAT": "Ulangi",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Diperlukan Pelaksanaan AST yang Wajib Dilaporkan",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Proses AST yang Harus Dilaporkan Harus Ditinjau",
  "microbiology.enum.RESULT": "Hasil",
  "microbiology.enum.RESULTS_IN": "Hasil Dalam",
  "microbiology.enum.RETEST": "Pemeriksaan Ulang",
  "microbiology.enum.REVIEW_READY": "Siap Ditinjau",
  "microbiology.enum.REVIEWED": "Telah Ditinjau",
  "microbiology.enum.INTERMEDIATE": "Menengah",
  "microbiology.enum.LOST_SPECIMEN": "Spesimen yang Hilang",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Spesimen yang Hilang - Kultur Positif",
  "microbiology.enum.NO_BREAKPOINT": "Tidak ada titik henti",
  "microbiology.enum.RESISTANT": "Tahan",
  "microbiology.enum.ROUTINE": "Rutin",
  "microbiology.enum.SAMPLE_ITEM": "Item Sampel",
  "microbiology.enum.SETUP": "Pengaturan",
  "microbiology.enum.SETUP_RECORDED": "Pengaturan Telah Direkam",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Spesimen Hilang",
  "microbiology.enum.STAGE_CHANGED": "Tahapan Telah Berubah",
  "microbiology.enum.SUBCULTURE_RECORDED": "Subkultur yang Direkam",
  "microbiology.enum.UNASSIGNED": "Tidak ditugaskan",
  "microbiology.enum.UNKNOWN_ERROR": "Kesalahan Tidak Diketahui",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Perubahan Alur Kerja",
  "microbiology.enum.ZONE": "Zona",
  "microbiology.enum.FINAL_RELEASED": "Versi Final Telah Dirilis",
  "microbiology.enum.SUSCEPTIBLE": "Rentan",
  "microbiology.enum.UNKNOWN": "Tidak diketahui",
  "rulebuilder.label.selectComponent": "Pilih Komponen",
  "testcalculation.label.selectComponent": "Pilih Komponen",
  "testcalculation.label.finalComponent": "Komponen Hasil",
  "qc.dashboard.tab.bench": "Bench QC",
  "qc.bench.source.all": "All bench sources",
  "qc.bench.source.manual": "Manual quantitative",
  "qc.bench.source.rdt": "Rapid test (RDT)",
  "qc.bench.column.runs": "Controls run",
  "qc.bench.column.lastRun": "Last run",
  "qc.bench.empty": "No manual or rapid-test controls were recorded in this period.",
  "microbiology.case.activityNote": "Catatan Kegiatan",
  "microbiology.case.accessionNumber": "Nomor Registrasi",
  "microbiology.case.actionError": "Aksi terkait budaya tidak dapat diselesaikan",
  "microbiology.case.action.markNoGrowth": "Tanda tidak siap untuk pertumbuhan",
  "microbiology.case.action.recordGrowth": "Terdeteksi pertumbuhan yang memecahkan rekor",
  "microbiology.case.action.rejectCase": "Tolak kasus",
  "microbiology.case.action.setIncubating": "Atur inkubasi",
  "microbiology.case.action.startInoculation": "Mulai proses inokulasi",
  "microbiology.case.createIsolate": "Buat isolat",
  "microbiology.case.cultureAction": "Aksi budaya",
  "microbiology.case.atmosphere": "Suasana",
  "microbiology.case.eyebrow": "Meja kerja untuk studi kasus mikrobiologi",
  "microbiology.case.sectionExpanded": "{section} diperluas",
  "microbiology.case.sectionStatus": "Status bagian",
  "microbiology.case.error": "Kesalahan dalam kasus mikrobiologi",
  "microbiology.case.isolateLabel": "Label isolat",
  "microbiology.case.isolates": "Isolat",
  "microbiology.case.isolates.empty": "Tidak ada isolat yang tercatat",
  "microbiology.case.loadError": "Tidak dapat memuat kasus mikrobiologi",
  "microbiology.case.lastActivityBy": "Aktivitas terakhir oleh",
  "microbiology.case.incubation": "Inkubasi",
  "microbiology.case.media": "Media atau botol",
  "microbiology.case.nextStage": "Tahapan berikutnya",
  "microbiology.case.patient": "Pasien",
  "microbiology.case.nonconformanceCount": "{count, plural, one {# NCE} other {# NCEs}}",
  "microbiology.case.relatedWorkflows": "Alur Kerja spesimen terkait",
  "microbiology.case.requestingLocation": "Meminta lokasi",
  "microbiology.case.preliminaryOrganism": "Organisme awal",
  "microbiology.case.recordActivity": "Rekam aktivitas",
  "microbiology.case.sampleItem": "Contoh barang sampel",
  "microbiology.case.setup": "Vaksinasi",
  "microbiology.case.setup.hint": "Rekam langkah pengaturan awal, media, atau inkubasi untuk kasus kultur ini.",
  "microbiology.case.significance": "Signifikansi",
  "microbiology.case.specimenType": "Jenis Spesimen",
  "microbiology.case.timeline": "Garis waktu kasus",
  "microbiology.case.timeline.addNote": "Tambah Catatan",
  "microbiology.case.timeline.auto": "Otomatis",
  "microbiology.case.timeline.culturePurposeChange": "{from} ke {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Perubahan pada tujuan budaya",
  "microbiology.case.timeline.empty": "Tidak ada aktivitas kasus yang tercatat",
  "microbiology.case.timeline.hint": "Data kasus yang tercatat ditampilkan secara kronologis.",
  "microbiology.case.timeline.manual": "Panduan",
  "microbiology.case.timeline.note": "Catatan atau pengamatan",
  "microbiology.case.timeline.noteExpanded": "Catatan dalam bentuk yang diperluas",
  "microbiology.case.timeline.performedBy": "Dibawakan oleh {actor}",
  "microbiology.case.timeline.saveNote": "Simpan catatan",
  "microbiology.case.timeline.showAll": "Tampilkan semua acara \"{count}\"",
  "microbiology.case.timeline.showRecent": "Tampilkan acara-acara terbaru dari \"{count}\"",
  "microbiology.case.events": "acara",
  "microbiology.case.finalLocked.message": "Fitur Isolate dan perubahan AST dinonaktifkan setelah rilis final.",
  "microbiology.case.finalLocked.title": "Kasus terakhir bersifat hanya baca",
  "microbiology.case.title": "Kasus mikrobiologi",
  "microbiology.case.workflow": "Alur Kerja",
  "microbiology.inoculation.addSubculture": "Tambah subkultur",
  "microbiology.inoculation.empty": "Tidak ada media yang direkam. Mulai proses inokulasi.",
  "microbiology.inoculation.hint": "Rekam setiap botol atau cawan dan simpan riwayat kulturnya.",
  "microbiology.inoculation.identifier": "Identitas botol atau piring",
  "microbiology.inoculation.identifierHint": "Pindai atau ketikkan pengidentifikasi tersebut.",
  "microbiology.inoculation.parent": "Media induk",
  "microbiology.inoculation.parentPlaceholder": "Pilih botol atau piring sumber",
  "microbiology.inoculation.primaryExpanded": "Formulir vaksinasi telah diperluas",
  "microbiology.inoculation.primary": "Primer",
  "microbiology.inoculation.recorded": "Media rekaman",
  "microbiology.inoculation.save": "Simpan media",
  "microbiology.inoculation.source": "Sumber",
  "microbiology.inoculation.start": "Mulai proses inokulasi",
  "microbiology.inoculation.subcultureExpanded": "Bentuk subkultur yang diperluas",
  "microbiology.inoculation.subculture": "Subbudaya",
  "microbiology.amendment.actionError": "Aksi perubahan tidak dapat diselesaikan",
  "microbiology.amendment.cancel": "Batalkan perubahan",
  "microbiology.amendment.cancelReason": "Alasan pembatalan",
  "microbiology.amendment.cancelled": "Amandemen dibatalkan; kasus terakhir kembali terkunci",
  "microbiology.amendment.correctsVersion": "Memperbaiki versi {number}",
  "microbiology.amendment.hint": "Perbaiki laporan akhir tanpa mengganti riwayat publikasinya.",
  "microbiology.amendment.history": "Riwayat Perubahan",
  "microbiology.amendment.inProgress.message": "Rekam koreksi tersebut, lalu setujui atau batalkan amandemen ini untuk mengunci kasus tersebut kembali.",
  "microbiology.amendment.inProgress.title": "Proses amandemen sedang dalam pengerjaan",
  "microbiology.amendment.noReportVersions": "Tidak ada versi laporan akhir yang tercatat",
  "microbiology.amendment.none": "Tidak ada amandemen yang tercatat",
  "microbiology.amendment.number": "Amandemen",
  "microbiology.amendment.numberValue": "Amendment {number}",
  "microbiology.amendment.open": "Amandemen terbuka",
  "microbiology.amendment.opened": "Perubahan telah dibuka; koreksi klinis kini telah diaktifkan",
  "microbiology.amendment.reason": "Alasan perubahan",
  "microbiology.amendment.release": "Menerbitkan laporan yang telah direvisi",
  "microbiology.amendment.released": "Laporan yang telah direvisi telah dirilis; kasus ini kembali terkunci",
  "microbiology.amendment.reportVersions": "Versi laporan yang telah diterbitkan",
  "microbiology.amendment.status": "Status",
  "microbiology.amendment.status.closed": "Tidak ada usulan amandemen yang diajukan",
  "microbiology.amendment.status.open": "Amandemen terbuka",
  "microbiology.amendment.title": "Perubahan",
  "microbiology.amendment.version": "Versi{number}",
  "microbiology.ast.antibiotic": "Antibiotik",
  "microbiology.ast.acceptResults": "Terima hasilnya",
  "microbiology.ast.acknowledgeFlags": "Mengetahui bendera yang telah ditinjau",
  "microbiology.ast.analyzer": "Alat",
  "microbiology.ast.analyzerOrganism": "Organisme yang dianalisis: {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "Kartu atau panel {card} · perangkat lunak {version}",
  "microbiology.ast.analyzerResolutionReason": "Alasan dan Tindakan Perbaikan",
  "microbiology.ast.actionError": "Aksi AST tidak dapat diselesaikan",
  "microbiology.ast.adjustPanel": "Sesuaikan panel",
  "microbiology.ast.orderedAntibiotics": "Antibiotik yang akan dilakukan pemeriksan terhadapnya",
  "microbiology.ast.actions": "Aksi",
  "microbiology.ast.applyOverride": "Terapkan penggantian",
  "microbiology.ast.attempt": "Upaya",
  "microbiology.ast.attemptMethod": "Metode percobaan",
  "microbiology.ast.attemptNumber": "Coba {number}",
  "microbiology.ast.attemptReason": "Alasan",
  "microbiology.ast.attemptScope": "Ruang Lingkup pengulangan",
  "microbiology.ast.attempts": "Upaya AST",
  "microbiology.ast.attemptType": "Jenis upaya",
  "microbiology.ast.awaitingAnalyzerResults": "Menunggu hasil dari Alat",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Hasil akan muncul secara otomatis saat alat analisis yang terhubung mengirimkannya. Peristiwa yang tidak cocok akan disimpan di bagian \"Masalah Impor Alat Analisis\".",
  "microbiology.ast.awaitingSetupCount": "{count} menunggu Pengaturan",
  "microbiology.ast.cardId": "Identitas kartu atau panel",
  "microbiology.ast.entryMode": "Entri Hasil",
  "microbiology.ast.entryMode.analyzer": "Alat analisis terhubung",
  "microbiology.ast.entryMode.manual": "Entri manual",
  "microbiology.ast.expertFlags": "Tanda peringatan dari ahli alat perlu ditinjau",
  "microbiology.ast.hideOriginal": "Sembunyikan riwayat",
  "microbiology.ast.historyTo": "ke",
  "microbiology.ast.interpretation": "Interpretasi",
  "microbiology.ast.instrumentInterpretation": "Alat Analisis: {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Batalkan dan mulai eksekusi baru",
  "microbiology.ast.includedInReport": "Termasuk dalam laporan",
  "microbiology.ast.initialAttemptReason": "Upaya pertama",
  "microbiology.ast.isolate": "Mengisolasi",
  "microbiology.ast.method": "Metode",
  "microbiology.ast.matchedBy": "Titik henti yang cocok",
  "microbiology.ast.measurement.mic": "MIC (ug/mL)",
  "microbiology.ast.measurement.zone": "Diameter zona (mm)",
  "microbiology.ast.noBreakpointGuidance": "Tidak ada titik potong standar. Tafsirkan hasil pengukuran ini sesuai dengan SOP setempat.",
  "microbiology.ast.noBreakpointTitle": "Diperlukan interpretasi lokal",
  "microbiology.ast.noIsolate": "Buat isolat sebelum merekam AST",
  "microbiology.ast.noSourceAttempt": "Upaya awal",
  "microbiology.ast.notIncludedInReport": "Tidak termasuk",
  "microbiology.ast.newAttempt": "Ulangi atau lakukan Pemeriksaan Ulang",
  "microbiology.ast.noRunsYet": "Tidak ada run",
  "microbiology.ast.antibioticToRepeat": "Antibiotik yang harus diminum kembali",
  "microbiology.ast.override": "Interpretasi yang menggantikan",
  "microbiology.ast.overrideHistory": "Riwayat penggantian",
  "microbiology.ast.optionsExpanded": "{section} opsi diperluas.",
  "microbiology.ast.overrideReason": "Alasan penggantian",
  "microbiology.ast.orderedPanel": "Dipesan panel AST",
  "microbiology.ast.organismMismatch": "Organisme yang dianalisis berbeda dari isolat kasus tersebut",
  "microbiology.ast.organismMismatchDetail": "Identitas alat analisis bersifat informatif. Periksa kembali ketidaksesuaian tersebut; isolat kasus yang telah dikonfirmasi tetap menjadi acuan yang sah.",
  "microbiology.ast.overrideQc": "Mengganti pengaturan bendera QC",
  "microbiology.ast.panel": "Panel AST",
  "microbiology.ast.panelAdjustmentReason": "Alasan penyesuaian panel",
  "microbiology.ast.panelProvenance.organismDefault": "Dipesan dari konfigurasi default organisme yang telah diidentifikasi",
  "microbiology.ast.rawValue": "Nilai Hasil",
  "microbiology.ast.qcFailed": "Pemeriksaan kualitas (QC) alat analisis gagal",
  "microbiology.ast.qcFailedDetail": "Referensi QC {reference}. Penerimaan hasil ditangguhkan hingga proses ini dinyatakan tidak sah atau seorang supervisor mencatat adanya pengecualian.",
  "microbiology.ast.replacementCardId": "Identitas kartu atau panel baru",
  "microbiology.ast.resultsReady": "Hasil analisis sudah siap untuk ditinjau",
  "microbiology.ast.resultsReadyDetail": "Periksa ketidaksesuaian, titik henti yang hilang, dan tanda peringatan dari ahli sebelum menerima hasil-hasil ini.",
  "microbiology.ast.runsComplete": "{complete} / {total} telah selesai dijalankan",
  "microbiology.ast.pendingIdentificationCount": "{count} Tertunda dalam identifikasi",
  "microbiology.ast.reasonForAttempt": "Alasan pengulangan atau Pemeriksaan Ulang",
  "microbiology.ast.recordReading": "Rekam hasil pengukuran AST",
  "microbiology.ast.reviewRun": "Tinjauan Pelaksanaan AST",
  "microbiology.ast.repeat": "Ulangi",
  "microbiology.ast.revertOverride": "Kembalikan ke versi asli",
  "microbiology.ast.revertReason": "Alasan membatalkan penggantian",
  "microbiology.ast.reporting": "Pelaporan",
  "microbiology.ast.retest": "Pemeriksaan Ulang",
  "microbiology.ast.selectAntibiotic": "Pilih antibiotik",
  "microbiology.ast.singleAntibiotic": "Antibiotik tunggal",
  "microbiology.ast.wholePanel": "Seluruh panel",
  "microbiology.ast.runStatus": "Status eksekusi AST",
  "microbiology.ast.startRun": "Mulai proses AST",
  "microbiology.ast.startAttempt": "Mulai upay{type}",
  "microbiology.ast.sourceAttempt": "Sumber",
  "microbiology.ast.source": "Sumber bacaan",
  "microbiology.ast.showOriginal": "Tampilkan teks asli",
  "microbiology.ast.title": "Manual AST",
  "microbiology.ast.useAttemptForReporting": "Gunakan tautan {number} untuk melaporkan",
  "microbiology.ast.useForReporting": "Digunakan untuk pelaporan laporan",
  "microbiology.ast.view": "Lihat",
  "microbiology.ast.viewAttempt": "Lihat upaya {number}",
  "microbiology.ast.viewing": "Lihat",
  "microbiology.ast.viewingAttempt": "Upaya akses {number}",
  "microbiology.critical.acknowledge": "Mengetahui",
  "microbiology.critical.followUp": "Perlu dilakukan tindak lanjut",
  "microbiology.critical.hint": "Catat callback hasil kritis dan ketahui secara langsung.",
  "microbiology.critical.log": "Catatan komunikasi",
  "microbiology.critical.logForIsolate": "Catat pemberitahuan kritis untuk {isolate}",
  "microbiology.critical.logNotification": "Catat notifikasi kritis",
  "microbiology.critical.method": "Metode komunikasi",
  "microbiology.critical.message": "Pesan",
  "microbiology.critical.messageRequired": "Pesan wajib diisi",
  "microbiology.critical.none": "Tidak ada komunikasi kritis yang tercatat",
  "microbiology.critical.recipient": "Penerima",
  "microbiology.critical.recipientContact": "Kontak penerima",
  "microbiology.critical.required": "Pilih tujuan, lalu masukkan nama penerima dan isi pesan.",
  "microbiology.critical.resolution": "Catatan Pemecahan Masalah",
  "microbiology.critical.resolutionRequired": "Catatan penyelesaian wajib sebelum mengakhiri komunikasi.",
  "microbiology.critical.close": "Komunikasi yang erat",
  "microbiology.critical.target": "Target hasil kritis",
  "microbiology.critical.targetId": "Catatan target",
  "microbiology.critical.title": "Komunikasi kritis",
  "microbiology.caseInfo.no": "Tidak",
  "microbiology.caseInfo.notProvided": "Tidak tersedia",
  "microbiology.caseInfo.summary": "Ringkasan informasi kasus",
  "microbiology.caseInfo.yes": "Ya",
  "microbiology.currentStep.open": "Buka {step}",
  "microbiology.currentStep.title": "Langkah saat ini",
  "microbiology.cultureAction.error": "Status kultur tidak dapat diperbarui.",
  "microbiology.cultureAction.noGrowth.confirm": "Pastikan tidak ada pertumbuhan",
  "microbiology.cultureAction.noGrowth.detail": "Pastikan bahwa masa inkubasi yang wajib dilakukan telah selesai dan tidak terdeteksi adanya pertumbuhan.",
  "microbiology.cultureAction.noGrowth.title": "Tanda budaya sebagai \"tidak ada pertumbuhan\"",
  "microbiology.cultureAction.positive.confirm": "Konfirmasi adanya sinyal positif",
  "microbiology.cultureAction.positive.detail": "Konfirmasi adanya hasil positif. Langkah selanjutnya adalah melakukan subkultur dan mencatat hasil pewarnaan Gram.",
  "microbiology.cultureAction.positive.title": "Marka kultur positif",
  "microbiology.nce.category": "Kategori",
  "microbiology.nce.configurationBlockerTitle": "Konfigurasi wajib",
  "microbiology.nce.configurationLoadError": "Kategori dan unit pelaporan NCE tidak dapat dimuat.",
  "microbiology.nce.critical": "Kritis",
  "microbiology.nce.description": "Deskripsi",
  "microbiology.nce.disposition": "Disposisi",
  "microbiology.nce.errorTitle": "Ketidaksesuaian tidak dapat dilaporkan",
  "microbiology.nce.flagOnly": "Hanya bendera",
  "microbiology.nce.immediateAction": "Aksi segera",
  "microbiology.nce.lostTypeMissing": "Konfigurasi Ketidaksesuaian NCE yang aktif tidak mencakup jenis “Spesimen Hilang”.",
  "microbiology.nce.major": "Mayor",
  "microbiology.nce.markLost": "Mark kalah",
  "microbiology.nce.markLostHint": "Rekam spesimen fisik tersebut sebagai hilang dan tolak pemeriksaan yang terpengaruh.",
  "microbiology.nce.markLostTitle": "Spesimen Tanda hilang",
  "microbiology.nce.minor": "Kecil",
  "microbiology.nce.rejectTests": "Tolak pemeriksaan yang terpengaruh",
  "microbiology.nce.retest": "Pemeriksaan Ulang AST",
  "microbiology.nce.retestLoadError": "Hasil AST yang telah ditinjau tidak dapat dimuat. Silakan coba lagi sebelum memilih \"Pemeriksaan Ulang AST\".",
  "microbiology.nce.sourceAstRun": "AST dijalankan untuk Pemeriksaan Ulang",
  "microbiology.nce.report": "Lapor KTS",
  "microbiology.nce.reportHint": "Rekam ketidaksesuaian pada spesimen ini dan tentukan tindakan yang akan diambil.",
  "microbiology.nce.reportingUnit": "Unit yang melapor",
  "microbiology.nce.reportTitle": "Laporan ketidaksesuaian",
  "microbiology.nce.required": "Pilih kategori, Unit yang melapor, dan tingkat keparahan, lalu berikan deskripsi.",
  "microbiology.nce.sectionTitle": "Ketidaksesuaian",
  "microbiology.nce.severity": "Keparahan",
  "microbiology.nce.submitError": "Ketidaksesuaian tersebut tidak dapat disimpan.",
  "microbiology.nce.title": "Judul",
  "microbiology.nce.type": "Jenis",
  "microbiology.isolate.identify": "Mengidentifikasi organisme",
  "microbiology.isolate.reidentify": "Identifikasi ulang",
  "microbiology.isolate.identified": "Telah diidentifikasi",
  "microbiology.isolate.pending": "Identifikasi tertunda",
  "microbiology.isolate.gramStain": "Pewarnaan Gram",
  "microbiology.isolate.colonyMorphology": "Morfologi koloni",
  "microbiology.isolate.identification": "Identifikasi",
  "microbiology.isolate.identificationMethod": "Metode ID",
  "microbiology.isolate.identificationConfidence": "Tingkat kepercayaan Identitas (%)",
  "microbiology.isolate.identificationChange": "{previous} ke {next}: {reason}",
  "microbiology.isolate.identificationHistory": "Riwayat identifikasi",
  "microbiology.isolate.identificationReason": "Alasan reidentifikasi",
  "microbiology.isolate.organism.select": "Pilih suatu organisme",
  "microbiology.isolate.unidentified": "Tidak teridentifikasi",
  "microbiology.ast.identificationRequired": "Identifikasi isolat tersebut sebelum melakukan uji sensitivitas antibiotik (AST).",
  "microbiology.next.createIsolate": "Inokulasi telah direkam. Tambah jika terjadi pertumbuhan yang signifikan, atau tanda kasus tersebut sebagai siap untuk penanganan tanpa pertumbuhan.",
  "microbiology.next.completeAmendment": "Perubahan sedang dalam proses. Catat koreksinya, tinjau laporan, lalu terbitkan versi yang telah diubah.",
  "microbiology.next.classifyWorkflow": "Pilihlah Alur Kerja dan Metode Budaya yang tepat sebelum memulai pekerjaan yang berkaitan dengan profil tertentu.",
  "microbiology.next.finalReleased": "Laporan akhir telah dirilis. Periksa kesiapan pengawasan sebelum Ekspor.",
  "microbiology.next.incubating": "Inkubasi. Tandai sampel sebagai positif jika terdeteksi adanya pertumbuhan, atau tandai sebagai tidak ada pertumbuhan jika masa inkubasi yang wajib dilakukan telah selesai.",
  "microbiology.next.subculturePositive": "Terdeteksi tanda positif. Lakukan subkultur pada botol tersebut dan rekam hasil pewarnaan Gram.",
  "microbiology.next.recordSetup": "Kasus telah diterima. Rekam pengaturan awal untuk memulai inkubasi.",
  "microbiology.next.release": "AST telah ditinjau. Konfirmasi bahwa laporan sudah siap dan terbitkan laporan akhir.",
  "microbiology.next.noGrowthRelease": "Tidak tercatat adanya pertumbuhan. Tinjau dan terbitkan laporan negatif akhir.",
  "microbiology.next.reviewAst": "Isolat telah tercatat. Selesai dan tinjau AST sebelum dirilis.",
  "microbiology.next.title": "Langkah Berikutnya",
  "microbiology.navigation.backToWorklist": "Kembali ke daftar tugas mikrobiologi",
  "microbiology.navigation.menu": "Mikrobiologi",
  "microbiology.navigation.worklist": "Daftar Pekerjaan Mikrobiologi",
  "microbiology.orderEntry.discardConfirm": "Abaikan detail",
  "microbiology.orderEntry.discardHeading": "Hapus alur kerja mikrobiologi?",
  "microbiology.orderEntry.discardMessage": "Jika uji kultur terakhir dihapus, rincian program mikrobiologi yang telah dimasukkan untuk pesanan ini akan terhapus.",
  "microbiology.orderEntry.programDerived": "Hasil mikrobiologi diperoleh dari uji kultur yang telah dipilih.",
  "microbiology.orderEntry.programDiscardHeading": "Apakah detail Mikrobiologi akan diabaikan?",
  "microbiology.orderEntry.programDiscardMessage": "Anda telah memasukkan detail Mikrobiologi. Jika Anda mengubah Program, data tersebut akan dihapus.",
  "order.context.workflowProgress": "Kemajuan alur kerja pesanan",
  "microbiology.orderEntry.hint": "Rincian ini disertakan bersama sampel kultur yang telah diteruskan sehingga laboratorium dapat langsung memulai pengaturan tanpa perlu memasukkan kembali konteks pemesanan.",
  "microbiology.orderEntry.incomplete": "Konfigurasikan Program Mikrobiologi sebelum menyimpan pesanan kultur ini.",
  "microbiology.orderEntry.programMissingMessage": "Program Mikrobiologi tidak dikonfigurasi untuk alur kerja pemesanan ini.",
  "microbiology.orderEntry.programMissingTitle": "Diperlukan konfigurasi program yang wajib",
  "microbiology.orderEntry.routingMessage": "Hal ini akan membuat Kasus Mikrobiologi untuk uji kultur dan uji kepekaan.",
  "microbiology.orderEntry.routingTitle": "Alur Kerja budaya telah dipilih",
  "microbiology.orderEntry.title": "Rincian Program Mikrobiologi",
  "microbiology.culturePurpose.clinical": "Diagnosis atau pengobatan klinis",
  "microbiology.culturePurpose.label": "Tujuan budaya",
  "microbiology.culturePurpose.screening": "Skrining aktif atau status pembawa",
  "microbiology.culturePurpose.unspecified": "Tidak ditentukan",
  "microbiology.orderDetail.antibioticExposure": "Pasien baru-baru ini mengonsumsi antibiotik (dalam 2 minggu terakhir)",
  "microbiology.orderDetail.admissionDate": "Tanggal masuk",
  "microbiology.orderDetail.admissionDateFuture": "Tanggal masuk tidak boleh berada di masa depan.",
  "microbiology.orderDetail.admissionDateHelper": "Tanggal masuk sebagai pasien rawat inap. Biarkan kosong jika tidak diketahui.",
  "microbiology.orderDetail.admissionDateOutpatient": "Pasien rawat jalan tidak dirawat inap — dicatat sebagai pasien dari masyarakat.",
  "microbiology.orderDetail.collectionDateContext": "Tanggal Pengambilan: {date}",
  "microbiology.orderDetail.collectionTimingHospital": "Data diambil pada {days} beberapa hari setelah masuk rumah sakit — data yang bersumber dari rumah sakit untuk keperluan pemantauan.",
  "microbiology.orderDetail.collectionTimingCommunity": "Diambil pada {days} hari setelah masuk rumah sakit — berasal dari masyarakat untuk keperluan pengawasan.",
  "microbiology.orderDetail.clinicalHistory": "Riwayat klinis",
  "microbiology.orderDetail.cultureMethod": "Protokol Budaya",
  "microbiology.orderDetail.hint": "Catat konteks pesanan yang diperlukan oleh laboratorium untuk pengaturan kultur dan tindak lanjut hasil kritis.",
  "microbiology.orderDetail.numberOfSets": "Jumlah set",
  "microbiology.orderDetail.numberOfSets.helper": "Grup sampel, seperti dua set kultur darah yang diambil dari lokasi yang berbeda. Bukan jumlah atau volume spesimen.",
  "microbiology.orderDetail.patientOrigin": "Asal pasien",
  "microbiology.orderDetail.protocolDerived": "Turunan",
  "microbiology.orderDetail.protocolHelper": "Dari hasil pemesanan pemeriksaan. Lakukan penyesuaian di ruang pemeriksaan jika hasil pemeriksaan berbeda.",
  "microbiology.orderDetail.protocolUnset": "Belum ditentukan — panitia akan memilih protokolnya",
  "microbiology.orderDetail.protocolUnsetTitle": "Protokol belum ditetapkan",
  "microbiology.orderDetail.save": "Simpan detail pesanan",
  "microbiology.orderDetail.title": "Rincian Pemesanan",
  "microbiology.patientOrigin.emergency": "Unit Gawat Darurat",
  "microbiology.patientOrigin.icu": "Unit perawatan intensif",
  "microbiology.patientOrigin.inpatient": "Ruang rawat inap",
  "microbiology.patientOrigin.other": "Lainnya",
  "microbiology.patientOrigin.outpatient": "Klinik rawat jalan",
  "microbiology.progress.ast": "Hasil AST",
  "microbiology.progress.caseInfo": "Informasi kasus",
  "microbiology.progress.inoculation": "Vaksinasi",
  "microbiology.progress.isolates": "Isolat",
  "microbiology.progress.reports": "Laporan",
  "microbiology.progress.review": "Tinjauan ahli",
  "microbiology.progress.timeline": "Garis Waktu",
  "microbiology.progress.title": "Perkembangan kasus",
  "microbiology.protocol.change": "Ubah protokol",
  "microbiology.protocol.error": "Protokol tidak dapat diubah",
  "microbiology.protocol.field": "Protokol kultur",
  "microbiology.protocol.helper": "Protokol tersebut mengatur media yang direncanakan dan resep inkubasi. Data inokulasi yang telah dicatat tidak akan pernah diubah.",
  "microbiology.protocol.inactive": "Inaktif",
  "microbiology.protocol.loading": "Protokol pemuatan",
  "microbiology.protocol.noChoices": "Tidak ada protokol aktif lainnya yang terkait dengan pemeriksaan dan alur kerja yang telah ditentukan ini.",
  "microbiology.protocol.noneMessage": "Tes yang dipesan tidak menyertakan opsi default. Silakan pilih protokol di meja kerja.",
  "microbiology.protocol.noneTitle": "Tidak ada protokol yang ditetapkan",
  "microbiology.protocol.placeholder": "Pilih Protokol",
  "microbiology.protocol.reason": "Alasan perubahan Protokol",
  "microbiology.protocol.save": "Simpan protokol",
  "microbiology.protocol.set": "Tetapkan Protokol",
  "microbiology.protocol.title": "Protokol kultur",
  "microbiology.protocol.updated": "Protokol telah diperbarui",
  "microbiology.case.timeline.protocolChanged": "Protokol kultur telah diubah dari {from} menjadi {to}: {reason}",
  "microbiology.workflowChange.apply": "Terapkan Alur Kerja",
  "microbiology.workflowChange.error": "Alur Kerja tidak dapat diubah",
  "microbiology.workflowChange.help": "Perbaiki Alur Kerja dan Metode Budaya sambil tetap mempertahankan Riwayat yang ada pada kasus ini.",
  "microbiology.workflowChange.methodPlaceholder": "Pilih Metode Kultur",
  "microbiology.workflowChange.preserveConfirmation": "Pertahankan pengaturan yang ada, isolasi, dan riwayat AST sesuai Alur Kerja yang telah diperbaiki",
  "microbiology.workflowChange.preserveWarning": "Kasus ini sudah memuat catatan klinis. Tahapan saat ini dan riwayat yang tercatat akan dipertahankan.",
  "microbiology.workflowChange.preserveWarningTitle": "Karya yang sudah ada akan dipertahankan",
  "microbiology.workflowChange.reason": "Alasan perubahan",
  "microbiology.workflowChange.requiredMessage": "Prosedur pengaturan kultur, isolasi spesimen, uji sensitivitas antibiotik (AST), dan laporan ditunda hingga kasus ini diklasifikasikan.",
  "microbiology.workflowChange.requiredTitle": "Klasifikasi Alur Kerja wajib",
  "microbiology.workflowChange.title": "Ubah alur kerja",
  "microbiology.workflowChange.unassignedHelp": "Klasifikasikan kasus ini sebelum memulai pengaturan kultur, isolasi sampel, uji sensitivitas antibiotik (AST), atau penyusunan laporan.",
  "microbiology.workflowChange.workflow": "Alur Kerja",
  "microbiology.workflowChange.workflowPlaceholder": "Pilih Alur Kerja",
  "microbiology.readiness.blocked": "Rilis final diblokir",
  "microbiology.readiness.ready": "Siap untuk dirilis secara resmi",
  "microbiology.reagentLots.blocked": "Diblokir: {reason}",
  "microbiology.reagentLots.context": "Konteks bangku",
  "microbiology.reagentLots.context.AST_SETUP": "Pengaturan AST",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Pengaturan budaya",
  "microbiology.reagentLots.empty": "Tidak ada reagen yang terkait dengan pemeriksaan ini.",
  "microbiology.reagentLots.fefo": "FEFO - gunakan yang pertama",
  "microbiology.reagentLots.fifo.tooltip": "Barang-barang diurutkan berdasarkan tanggal kedaluwarsa paling awal, kemudian berdasarkan tanggal penerimaan jika tanggal kedaluwarsa tidak tersedia.",
  "microbiology.reagentLots.hint": "Pilih nomor lot yang pasti digunakan untuk setiap reagen atau bahan habis pakai yang terkait.",
  "microbiology.reagentLots.history": "Catatan penggunaan lot",
  "microbiology.reagentLots.legend": "Lahan yang tersedia di {reagent}",
  "microbiology.reagentLots.lot": "Lot",
  "microbiology.reagentLots.noExpiry": "Tidak ada tanggal kedaluwarsa yang tercatat",
  "microbiology.reagentLots.noLots": "Tidak ada lot inventaris yang tersedia untuk reagen ini.",
  "microbiology.reagentLots.option": "{lot}, {quantity} {unit} tersedia, masa berlakunya berakhir pada {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Kuantitas per Pemeriksaan: {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} Lot {lot} telah kedaluwarsa; pilih lot lain.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} Lot {lot} sudah tidak tersedia dalam jumlah yang cukup; silakan pilih lot lainnya.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} Lot {lot} gagal QC; pilih lot yang telah lolos QC.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} Lot {lot} belum lolos pemeriksaan kualitas (QC); silakan pilih lot yang sudah lolos pemeriksaan kualitas (QC).",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} Lot {lot} sudah tidak tersedia lagi; silakan segarkan halaman dan pilih lot lainnya.",
  "microbiology.reagentLots.qc.FAILED": "QC gagal",
  "microbiology.reagentLots.qc.PASSED": "QC lolos",
  "microbiology.reagentLots.qc.PENDING": "QC tertunda",
  "microbiology.reagentLots.qc.QUARANTINED": "QC dikarantina",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Habis",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Kedaluwarsa",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Inaktif",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Kuantitas tidak mencukupi",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "QC gagal",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "Tidak lolos QC",
  "microbiology.reagentLots.reagent": "Reagen atau bahan habis pakai",
  "microbiology.reagentLots.recorded": "Rekam",
  "microbiology.reagentLots.role.PRIMARY": "Primer",
  "microbiology.reagentLots.role.SECONDARY": "Sekunder",
  "microbiology.reagentLots.scan.ambiguous": "Nomor lot tersebut cocok dengan lebih dari satu reagen yang terkait. Pilih lot tersebut dalam daftar reagennya.",
  "microbiology.reagentLots.scan.label": "Pindai atau masukkan nomor lot",
  "microbiology.reagentLots.scan.notFound": "Tidak ada bidang tanah yang terhubung yang sesuai dengan Nomor Lot tersebut.",
  "microbiology.reagentLots.scan.placeholder": "Pindai atau masukkan nomor lot yang pasti",
  "microbiology.reagentLots.scan.selected": "Lot dipilih {lot}.",
  "microbiology.reagentLots.status": "Status lot saat ini",
  "microbiology.reagentLots.status.ACTIVE": "Aktif",
  "microbiology.reagentLots.status.CONSUMED": "Habis",
  "microbiology.reagentLots.status.IN_USE": "Sedang Digunakan",
  "microbiology.reagentLots.title": "Ketertelusuran reagen dan nomor batch",
  "microbiology.reagentLots.used": "Kuantitas yang Digunakan",
  "microbiology.release.failed": "Laporan tersebut tidak dapat dipublikasikan. Periksa kembali persyaratannya, lalu coba lagi.",
  "microbiology.release.final": "Menerbitkan laporan akhir",
  "microbiology.release.finalReleased": "Laporan akhir telah dirilis",
  "microbiology.release.hint": "Hanya publikasikan laporan jika pemeriksaan kesiapan telah lolos.",
  "microbiology.release.mappingConfigured": "Pemetaan laporan pasien telah dikonfigurasi",
  "microbiology.release.mappingRequired": "Pemetaan laporan pasien wajib untuk rilis akhir",
  "microbiology.release.noReportableContent": "Tidak ada hasil uji mikrobiologi yang siap dilaporkan.",
  "microbiology.release.notEvaluated": "Kesiapan belum dievaluasi",
  "microbiology.release.patientReport": "Pratinjau laporan pasien",
  "microbiology.release.preliminary": "Menerbitkan laporan awal",
  "microbiology.release.readinessChecks": "Kesiapan rilis akhir",
  "microbiology.release.title": "Laporan kesiapan",
  "microbiology.release.viewPatientResults": "Lihat hasil pemeriksaan pasien",
  "microbiology.release.useAmendment": "Rilis versi yang telah diperbaiki dari Amandemen",
  "microbiology.release.whonetChecks": "Kesiapan WHONET",
  "microbiology.whonet.blocked": "Ekspor WHONET diblokir",
  "microbiology.whonet.ready": "Siap untuk ekspor ke WHONET",
  "microbiology.worklist.clearFilters": "Hapus filter",
  "microbiology.worklist.column.action": "Aksi",
  "microbiology.worklist.column.context": "Konteks",
  "microbiology.worklist.column.due": "Aksi yang semestinya",
  "microbiology.worklist.column.flags": "Bendera",
  "microbiology.worklist.column.isolate": "Mengisolasi",
  "microbiology.worklist.column.labNumber": "Lab #",
  "microbiology.worklist.column.lastActivity": "Aktivitas terakhir oleh",
  "microbiology.worklist.column.organism": "Organisme",
  "microbiology.worklist.column.panel": "Panel",
  "microbiology.worklist.column.patient": "Pasien",
  "microbiology.worklist.column.priority": "Prioritas",
  "microbiology.worklist.column.sample": "Contoh barang sampel",
  "microbiology.worklist.column.specimen": "Spesimen",
  "microbiology.worklist.column.stage": "Tahapan",
  "microbiology.worklist.column.started": "Dimulai",
  "microbiology.worklist.column.status": "Status",
  "microbiology.worklist.column.urgency": "Urgensi",
  "microbiology.worklist.column.workflow": "Alur Kerja",
  "microbiology.worklist.critical": "Komunikasi kritis",
  "microbiology.worklist.dueDetail.ast_entry": "Lakukan uji AST untuk isolat yang telah diidentifikasi.",
  "microbiology.worklist.dueDetail.ast_review": "Tinjau hasil uji kerentanan yang dilaporkan.",
  "microbiology.worklist.dueDetail.case_review": "Tinjau kesiapan laporan dan penerbitannya.",
  "microbiology.worklist.dueDetail.isolate_id": "Catat pertumbuhan dan identifikasi isolat tersebut.",
  "microbiology.worklist.dueDetail.incubating": "Hari ke-{day} dari {max}",
  "microbiology.worklist.dueDetail.setup": "Rekam langkah-langkah awal pengaturan kultur.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Lakukan kultur dan rekam hasil pewarnaan Gram.",
  "microbiology.worklist.empty.ast": "Tidak ada proses AST yang cocok. Kosongkan hasil pencarian atau pilih status yang lain.",
  "microbiology.worklist.empty.cultures": "Tidak ada budaya yang cocok. Kosongkan kriteria pencarian atau pilih status yang berbeda.",
  "microbiology.worklist.expertRulesUnavailable": "Penanda aturan ahli OpenELIS tersedia pada Fase 1B. Penanda yang dilaporkan oleh Alat akan ditampilkan jika ada.",
  "microbiology.worklist.filters": "Filter daftar pekerjaan",
  "microbiology.worklist.filter.allActions": "Semua aksi",
  "microbiology.worklist.filter.allStages": "Semua tahapan",
  "microbiology.worklist.filter.allUrgencies": "Semua tingkat urgensi",
  "microbiology.worklist.filter.allWorkflows": "Semua alur kerja",
  "microbiology.worklist.filter.activeAst": "Pekerjaan aktif",
  "microbiology.worklist.filter.astStatus": "Status AST",
  "microbiology.worklist.filter.dueAction": "Aksi yang semestinya",
  "microbiology.worklist.filter.reviewed": "Telah Ditinjau",
  "microbiology.worklist.filter.stage": "Tahapan",
  "microbiology.worklist.filter.urgency": "Urgensi",
  "microbiology.worklist.filter.workflow": "Alur Kerja",
  "microbiology.worklist.flagsUnavailable": "Aturan ahli (Fase 1B)",
  "microbiology.worklist.loadError.subtitle": "Antrean tidak dapat dimuat. Silakan segarkan halaman ini.",
  "microbiology.worklist.loadError.title": "Tidak dapat memuat daftar pekerjaan mikrobiologi",
  "microbiology.worklist.linkedWorkflows": "Terkait · Alur Kerja {count}",
  "microbiology.worklist.editAst": "Edit AST",
  "microbiology.worklist.grain.ast": "AST dijalankan",
  "microbiology.worklist.grain.cultures": "Budaya",
  "microbiology.worklist.notSet": "Belum ditentukan",
  "microbiology.worklist.notStarted": "Belum dimulai",
  "microbiology.worklist.markLost": "Mark kalah",
  "microbiology.worklist.markNoGrowth": "Tidak ada pertumbuhan",
  "microbiology.worklist.markPositive": "Tanda positif",
  "microbiology.worklist.openCase": "Kasus yang masih dalam proses",
  "microbiology.worklist.newAstAttempt": "Siapkan proses AST baru",
  "microbiology.worklist.newPositive": "Hasil positif baru",
  "microbiology.worklist.phase1b": "Tersedia pada Fase 1B",
  "microbiology.worklist.print": "Cetak daftar",
  "microbiology.worklist.qcDashboard": "Dasbor QC",
  "microbiology.worklist.queueStatus": "Antrian bersama",
  "microbiology.worklist.refresh": "Segarkan sekarang",
  "microbiology.worklist.rowActions": "Aksi baris",
  "microbiology.worklist.recentActivity.empty": "Tidak ada aktivitas mikrobiologi baru-baru ini.",
  "microbiology.worklist.recentActivity.title": "Aktivitas terbaru ({count})",
  "microbiology.worklist.resistance.hint": "Tanda peringatan yang dilaporkan oleh Alat analisis telah selesai hari ini; deteksi berdasarkan aturan ahli di OpenELIS masih berada pada Fase 1B.",
  "microbiology.worklist.resistance.title": "Level resistensi hari ini mencapai",
  "microbiology.worklist.search.ast": "Cari nomor registrasi laboratorium, pasien, isolat, organisme, atau panel",
  "microbiology.worklist.search.cultures": "Cari nomor registrasi laboratorium, pasien, spesimen, atau alur kerja",
  "microbiology.worklist.sharedQueue": "Antrian laboratorium bersama",
  "microbiology.worklist.siblings": "Alur Kerja antar saudara",
  "microbiology.worklist.setupAst": "Mengatur AST",
  "microbiology.worklist.sort": "Urutkan",
  "microbiology.worklist.sort.newest": "Aktivitas terbaru",
  "microbiology.worklist.sort.priority": "Prioritas",
  "microbiology.worklist.sort.workflow": "Alur Kerja",
  "microbiology.worklist.subtitle": "Prioritaskan kasus kultur berdasarkan tahapan alur kerja, tingkat urgensi, dan tindakan laboratorium yang wajib dilakukan.",
  "microbiology.worklist.summary.astReview": "Ulasan AST",
  "microbiology.worklist.summary.astInProgress": "Dalam pengerjaan",
  "microbiology.worklist.summary.astInQueue": "Sedang dalam antrian",
  "microbiology.worklist.summary.astPendingSetup": "Tertunda dalam pengaturan",
  "microbiology.worklist.summary.astResultsIn": "Hasil - tinjauan",
  "microbiology.worklist.summary.caseReview": "Siap untuk peninjauan kasus",
  "microbiology.worklist.summary.critical": "Tindak lanjut kritis yang masih terbuka",
  "microbiology.worklist.summary.growthDetected": "Terdeteksi adanya pertumbuhan",
  "microbiology.worklist.summary.hint": "Pilih antrian untuk memperbarui daftar kasus.",
  "microbiology.worklist.summary.identification": "Proses identifikasi sedang dalam pengerjaan",
  "microbiology.worklist.summary.incubating": "Inkubasi",
  "microbiology.worklist.summary.positive": "Positif",
  "microbiology.worklist.summary.expertFlags": "Tanda ahli (1B)",
  "microbiology.worklist.summary.title": "Pekerjaan yang memerlukan aksi",
  "microbiology.worklist.summary.totalPending": "Total yang masih tertunda",
  "microbiology.worklist.table.hint": "Kasus-kasus diurutkan berdasarkan tingkat urgensi dan aksi berikutnya yang wajib dilakukan.",
  "microbiology.worklist.table.astTitle": "AST dijalankan",
  "microbiology.worklist.table.title": "Kasus-kasus mikrobiologi yang masih terbuka",
  "microbiology.worklist.viewAudit": "Lihat hasil audit",
  "microbiology.worklist.viewReviewedAst": "Lihat AST yang telah ditinjau",
  "microbiology.worklist.whonetExport": "Ekspor ke WHONET",
  "microbiology.worklist.surveillance.title": "Ruang Lingkup pemantauan",
  "microbiology.worklist.surveillance.description": "Saring baris AST berdasarkan periode pelaporan dan bidang pengawasan terstruktur. Filter antrian operasional tidak mengubah populasi ekspor.",
  "microbiology.worklist.ast.automaticResults": "Hasil analisis akan muncul secara otomatis",
  "microbiology.worklist.ast.automaticResultsDetail": "Alat yang terhubung mengirimkan hasil secara langsung ke kasus tersebut. Peristiwa yang gagal atau tidak cocok disimpan dalam bagian \"Masalah Impor Analyzer\".",
  "microbiology.worklist.ast.awaitingResults": "Menunggu hasil dari Alat",
  "microbiology.worklist.ast.pendingIdentification": "Identifikasi tertunda",
  "microbiology.worklist.ast.resultsInBadge": "Hasilnya adalah",
  "microbiology.worklist.title": "Daftar Pekerjaan Mikrobiologi",
  "microbiology.worklist.updated": "Terbarui {seconds}detik yang lalu · penyegaran otomatis setiap 30 detik",
  "microbiology.admin.action.deactivate": "Nonaktifkan",
  "microbiology.admin.action.moveDown": "Geser ke bawah",
  "microbiology.admin.action.moveUp": "Geser ke atas",
  "microbiology.admin.action.reactivate": "Aktifkan Ulang",
  "microbiology.admin.actions": "Aksi baris",
  "microbiology.admin.antibiotics.add": "Tambah antibiotik",
  "microbiology.admin.antibiotics.description": "Istilah-istilah antimikroba yang digunakan oleh panel AST dan aturan titik ambang.",
  "microbiology.admin.antibiotics.edit": "Antibiotik",
  "microbiology.admin.antibiotics.title": "Antibiotik",
  "microbiology.admin.astPanels.add": "Tambah panel AST",
  "microbiology.admin.astPanels.antibiotic": "Antibiotik",
  "microbiology.admin.astPanels.behavior.always": "Selalu",
  "microbiology.admin.astPanels.behavior.cascade": "Cascade",
  "microbiology.admin.astPanels.behavior.resistant": "Hanya jika resisten",
  "microbiology.admin.astPanels.current": "Saat ini",
  "microbiology.admin.astPanels.confirmDeactivate": "Menetapkan versi publikasi {version} sebagai \"tidak tersedia\" untuk karya baru? Proses AST yang sudah berjalan akan tetap menggunakan versi panel aslinya.",
  "microbiology.admin.astPanels.confirmPublish": "Versi publikasi {version}? Proses AST yang sudah berjalan akan tetap menggunakan versi panel aslinya.",
  "microbiology.admin.astPanels.confirmTitle": "Konfirmasi publikasi panel",
  "microbiology.admin.astPanels.historical": "Sejarah",
  "microbiology.admin.astPanels.loadingEditor": "Proses pemuatan panel administrasi AST sedang berlangsung.",
  "microbiology.admin.astPanels.publishVersion": "Rilis versi baru",
  "microbiology.admin.astPanels.readOnly": "Versi historis ini hanya dapat dibaca. Buka versi terkini untuk mempublikasikan perubahan.",
  "microbiology.admin.astPanels.reportBehavior": "Laporkan perilaku",
  "microbiology.admin.astPanels.tier": "Tingkat",
  "microbiology.admin.astPanels.title": "Panel AST",
  "microbiology.admin.astPanels.version": "Versi",
  "microbiology.admin.astPanels.versionNotice": "Menyimpan akan membuat versi panel baru; proses AST yang sudah ada tetap mempertahankan versi aslinya.",
  "microbiology.admin.astPanels.viewVersion": "Lihat versi",
  "microbiology.admin.breakpoints.activate": "Aktifkan standar",
  "microbiology.admin.breakpoints.applyValid": "Terapkan baris yang valid",
  "microbiology.admin.breakpoints.archive": "Standar arsip",
  "microbiology.admin.breakpoints.archiveConfirm": "Standar ini akan tetap tersedia untuk proses AST historis, namun tidak dapat dipilih untuk pekerjaan baru.",
  "microbiology.admin.breakpoints.back": "Kembali ke standar",
  "microbiology.admin.breakpoints.breakpointType": "Jenis titik henti",
  "microbiology.admin.breakpoints.chooseFile": "Pilih file CSV",
  "microbiology.admin.breakpoints.correction.add": "Tambah koreksi lokal",
  "microbiology.admin.breakpoints.correction.edit": "Edit koreksi lokal",
  "microbiology.admin.breakpoints.count.imported": "{count} diimpor",
  "microbiology.admin.breakpoints.count.skipped": "{count} dilewati",
  "microbiology.admin.breakpoints.count.unchanged": "{count} tidak berubah",
  "microbiology.admin.breakpoints.count.valid": "{count} sah",
  "microbiology.admin.breakpoints.csv": "Titik Henti CSV",
  "microbiology.admin.breakpoints.description": "Standar titik henti yang dimuat dan versi yang aktif untuk eksekusi AST baru.",
  "microbiology.admin.breakpoints.detail": "Aturan titik henti",
  "microbiology.admin.breakpoints.downloadRejected": "Unduh baris yang ditolak",
  "microbiology.admin.breakpoints.effectiveDate": "Tanggal Efektif",
  "microbiology.admin.breakpoints.import": "Impor CSV",
  "microbiology.admin.breakpoints.intermediate": "Menengah",
  "microbiology.admin.breakpoints.intermediateLower": "Bagian tengah bawah",
  "microbiology.admin.breakpoints.intermediateUpper": "Tingkat menengah atas",
  "microbiology.admin.breakpoints.groupOption": "Grup: {name}",
  "microbiology.admin.breakpoints.method.all": "Semua metode",
  "microbiology.admin.breakpoints.method.zone": "Zona",
  "microbiology.admin.breakpoints.organism": "Organisme atau kelompok",
  "microbiology.admin.breakpoints.organismGroup": "Grup organisme",
  "microbiology.admin.breakpoints.publisher": "Penerbit",
  "microbiology.admin.breakpoints.resistant": "Tahan",
  "microbiology.admin.breakpoints.rowError": "Baris ke-{row}",
  "microbiology.admin.breakpoints.rules": "Aturan",
  "microbiology.admin.breakpoints.source": "Sumber",
  "microbiology.admin.breakpoints.source.imported": "Impor",
  "microbiology.admin.breakpoints.source.local": "Koreksi lokal",
  "microbiology.admin.breakpoints.source.manual": "Panduan",
  "microbiology.admin.breakpoints.specimen": "Konteks spesimen",
  "microbiology.admin.breakpoints.specimen.any": "Spesimen apa saja",
  "microbiology.admin.breakpoints.status.active": "Aktif",
  "microbiology.admin.breakpoints.status.archived": "Diarsipkan",
  "microbiology.admin.breakpoints.status.loaded": "Dimuat",
  "microbiology.admin.breakpoints.susceptible": "Rentan",
  "microbiology.admin.breakpoints.title": "Standar titik henti",
  "microbiology.admin.breakpoints.units": "Unit",
  "microbiology.admin.breakpoints.view": "Lihat Aturan",
  "microbiology.admin.filter.all": "Semua",
  "microbiology.admin.sort": "Urutkan",
  "microbiology.admin.sort.nameAsc": "Nama A-Z",
  "microbiology.admin.sort.nameDesc": "Nama Z-A",
  "microbiology.admin.cultureSetups.add": "Tambah pengaturan budaya",
  "microbiology.admin.cultureSetups.description": "Standar kultur yang terkait dengan metode laboratorium yang ada.",
  "microbiology.admin.cultureSetups.edit": "Pengaturan budaya",
  "microbiology.admin.cultureSetups.title": "Metode budidaya",
  "microbiology.admin.deactivate.impact": "{name} is used by {count, plural, one {# existing workflow record} other {# existing workflow records}}. Deactivation prevents new selection but preserves those historical references.",
  "microbiology.admin.deactivate.title": "Meninjau dampak penonaktifan",
  "microbiology.admin.deactivated": "Referensi sudah inaktif",
  "microbiology.admin.empty": "Tidak ada rekam referensi yang cocok",
  "microbiology.admin.error.save": "Catatan referensi tidak dapat disimpan.",
  "microbiology.admin.error.title": "Permintaan tidak dapat diselesaikan",
  "microbiology.admin.field.active": "Tersedia untuk menerima proyek baru",
  "microbiology.admin.field.atmosphere": "Pengaturan default Atmosphere",
  "microbiology.admin.field.class": "Kelas",
  "microbiology.admin.field.code": "Kode",
  "microbiology.admin.field.defaultPanel": "Panel AST bawaan",
  "microbiology.admin.field.defaultPanelId": "ID panel AST default",
  "microbiology.admin.field.gramStain": "Pewarnaan Gram",
  "microbiology.admin.field.group": "Grup organisme",
  "microbiology.admin.field.incubation": "Pengaturan default inkubasi",
  "microbiology.admin.field.incubationHours": "Interval pembacaan Rutin (jam)",
  "microbiology.admin.field.subcultureAtHours": "Subkultur pada (jam)",
  "microbiology.admin.field.maxIncubationDays": "Waktu inkubasi maksimum (hari)",
  "microbiology.admin.field.media": "Pengaturan default media",
  "microbiology.admin.field.method": "Metode",
  "microbiology.admin.field.methodId": "ID Metode",
  "microbiology.admin.field.name": "Nama",
  "microbiology.admin.field.notes": "Catatan",
  "microbiology.admin.field.oclCode": "Kode OCL",
  "microbiology.admin.field.reportableAnalyteId": "ID analit yang wajib dilaporkan",
  "microbiology.admin.field.route": "Rute",
  "microbiology.admin.field.shortName": "Nama singkat",
  "microbiology.admin.field.significance": "Makna awal",
  "microbiology.admin.field.whonetCode": "Kode WHONET",
  "microbiology.admin.field.workflow": "Alur Kerja",
  "microbiology.admin.organisms.add": "Tambahkan organisme",
  "microbiology.admin.organisms.description": "Istilah-istilah biologi yang digunakan oleh identifikasi kultur dan uji sensitivitas antibiotik (AST).",
  "microbiology.admin.organisms.edit": "Organisme",
  "microbiology.admin.organisms.title": "Organisme",
  "microbiology.admin.patientOrigins.description": "Pilihan asal pasien yang telah dikonfigurasi dan digunakan selama proses pemasukan pesanan mikrobiologi serta ekspor ke WHONET.",
  "microbiology.admin.patientOrigins.title": "Asal-usul pasien",
  "microbiology.admin.reactivated": "Referensi telah diaktifkan ulang",
  "microbiology.admin.route.both": "Pemberian melalui mulut dan infus",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "Oral",
  "microbiology.admin.route.topical": "Topikal",
  "microbiology.admin.saved": "Referensi telah disimpan",
  "microbiology.admin.search": "Cari data referensi",
  "microbiology.admin.sections": "Bagian referensi mikrobiologi",
  "microbiology.admin.significance.possible": "Patogen yang mungkin",
  "microbiology.admin.significance.rare": "Patogen langka",
  "microbiology.admin.significance.usually": "Biasanya signifikan",
  "microbiology.admin.status": "Status",
  "microbiology.admin.status.active": "Aktif",
  "microbiology.admin.status.all": "Semua status",
  "microbiology.admin.status.inactive": "Inaktif",
  "microbiology.admin.title": "Data referensi mikrobiologi",
  "microbiology.admin.workflow.all": "Semua alur kerja",
  "microbiology.workflow.bacteriology": "Bakteriologi",
  "microbiology.workflow.mycobacteriology": "Mikobakteriologi",
  "microbiology.workflow.mycology": "Mikologi",
  "microbiology.workflow.parasitology": "Parasitologi",
  "button.add": "Tambah",
  "button.remove": "Hapus",
  "sidenav.label.microbiology": "Mikrobiologi",
  "sidenav.label.microbiology.worklist": "Daftar Pekerjaan Mikrobiologi",
  "sidenav.label.microbiology.whonet": "Ekspor WHONET",
  "microbiology.whonet.title": "Ekspor WHONET",
  "microbiology.whonet.eyebrow": "Pemantauan bakteriologi rutin",
  "microbiology.whonet.subtitle": "Tinjau data kultur dan AST yang telah difinalisasi sebelum membuat berkas CSV surveilans OpenELIS terbaru untuk validasi WHONET.",
  "microbiology.whonet.progress": "Kemajuan ekspor WHONET",
  "microbiology.whonet.step.configure": "Konfigurasi",
  "microbiology.whonet.step.preview": "Pratinjau",
  "microbiology.whonet.step.generate": "Membuat",
  "microbiology.whonet.configure.title": "Konfigurasi ekspor",
  "microbiology.whonet.configure.description": "Pilih periode pelaporan dan isolat yang akan dimasukkan.",
  "microbiology.whonet.from": "Dari",
  "microbiology.whonet.to": "Kepada",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "Tanggal Selesai harus sama dengan atau setelah tanggal awal.",
  "microbiology.whonet.period.preset": "Periode pelaporan",
  "microbiology.whonet.period.thisMonth": "Bulan ini",
  "microbiology.whonet.period.lastMonth": "Bulan lalu",
  "microbiology.whonet.period.thisQuarter": "Triwulan ini",
  "microbiology.whonet.period.custom": "Kustom",
  "microbiology.whonet.source.worklist.title": "Ruang Lingkup yang disediakan oleh daftar kerja AST",
  "microbiology.whonet.source.worklist.description": "Periode pelaporan dan filter pengawasan terstruktur diambil dari daftar tugas AST. Keduanya masih dapat diedit di sini.",
  "microbiology.whonet.source.worklist.clear": "Kosongkan ruang lingkup daftar pekerjaan",
  "microbiology.whonet.significance": "Inklusi",
  "microbiology.whonet.significance.clinical": "Isolat yang signifikan secara klinis",
  "microbiology.whonet.significance.all": "Semua isolat",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Signifikan secara klinis",
  "microbiology.whonet.significance.CONTAMINANT": "Kontaminasi",
  "microbiology.whonet.significance.NORMAL_FLORA": "Flora normal",
  "microbiology.whonet.significance.UNKNOWN": "Tidak diklasifikasikan",
  "microbiology.whonet.culturePurpose.description": "Kultur klinis sudah termasuk secara default. Tambah populasi lain secara eksplisit jika pertanyaan surveilans mengharuskannya.",
  "microbiology.whonet.culturePurpose.includeScreening": "Sertakan skrining aktif atau kultur pembawa",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Sertakan budaya-budaya historis yang tujuannya tidak ditentukan",
  "microbiology.whonet.culturePurpose.title": "Tujuan budaya",
  "microbiology.whonet.filter.specimen": "Jenis Spesimen",
  "microbiology.whonet.filter.organism": "Organisme",
  "microbiology.whonet.filter.origin": "Asal-usul pasien",
  "microbiology.whonet.filter.any": "Apa saja",
  "microbiology.whonet.filter.choose": "Pilih nilai",
  "microbiology.whonet.dedup": "Penghapusan duplikasi",
  "microbiology.whonet.dedup.apply": "Terapkan seleksi \"isolasi terlebih dahulu\"",
  "microbiology.whonet.dedup.apply.help": "Gabungkan isolat yang berulang dari pasien dan mikroorganisme yang sama dalam rentang waktu yang dipilih.",
  "microbiology.whonet.dedup.advanced": "Sesuaikan kebijakan “isolasi terlebih dahulu”",
  "microbiology.whonet.dedup.window": "Panjang jendela",
  "microbiology.whonet.dedup.window.help": "Pengulangan tepat pada batas hari yang dipilih akan membuka jendela baru.",
  "microbiology.whonet.dedup.sevenDay": "7 hari",
  "microbiology.whonet.dedup.fourteenDay": "14 hari",
  "microbiology.whonet.dedup.thirtyDay": "30 hari",
  "microbiology.whonet.dedup.basis": "Tanggal pembukaan",
  "microbiology.whonet.dedup.basis.collection": "Tanggal Pengambilan Spesimen",
  "microbiology.whonet.dedup.basis.release": "Tanggal pengumuman hasil akhir",
  "microbiology.whonet.dedup.basis.help": "Pilih apakah jendela waktu tersebut mengacu pada pengambilan spesimen atau pengumuman Hasil Akhir. Periode pelaporan selalu mengacu pada tanggal pengambilan spesimen.",
  "microbiology.whonet.dedup.scope": "Ruang Lingkup sumber spesimen",
  "microbiology.whonet.dedup.scope.any": "Sumber spesimen apa saja",
  "microbiology.whonet.dedup.scope.same": "Hanya dari sumber spesimen yang sama",
  "microbiology.whonet.dedup.scope.help": "Apa saja sumber yang membandingkan pasien dan organisme di antara berbagai jenis spesimen; apa saja sumber yang membandingkan di dalam masing-masing jenis spesimen.",
  "microbiology.whonet.dedup.contaminants": "Singkirkan kemungkinan kontaminasi sebelum pemilihan",
  "microbiology.whonet.dedup.contaminants.help": "Hapus kemungkinan kontaminasi sebelum memilih isolat representatif pertama.",
  "microbiology.whonet.dedup.profile": "Profil kerentanan",
  "microbiology.whonet.dedup.profile.insensitive": "Abaikan perubahan S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Perlakukan S/I/R yang telah mengalami perubahan sebagai yang baru",
  "microbiology.whonet.dedup.profile.help": "Jumlah profil-sensitive selection menunjukkan pola S/I/R antibiotik yang telah ditinjau dan berbeda sebagai isolat baru dalam rentang waktu tersebut.",
  "microbiology.whonet.dedup.none": "Tidak ada deduplikasi",
  "microbiology.whonet.preview.action": "Pratinjau ekspor",
  "microbiology.whonet.preview.title": "Pratinjau",
  "microbiology.whonet.preview.description": "Jumlah dan baris ini akan digunakan saat file CSV dibuat.",
  "microbiology.whonet.generate.action": "Membuat File CSV",
  "microbiology.whonet.count.cases": "Kasus yang telah difinalisasi",
  "microbiology.whonet.count.clinicalPurpose": "Kultur klinis",
  "microbiology.whonet.count.screeningPurpose": "Kultur penyaringan",
  "microbiology.whonet.count.unspecifiedPurpose": "Budaya yang tidak disebutkan secara spesifik",
  "microbiology.whonet.count.purposeIncluded": "Setelah seleksi berdasarkan tujuan kultur",
  "microbiology.whonet.count.isolates": "Isolat yang ditemukan",
  "microbiology.whonet.count.specimen": "Setelah filter spesimen",
  "microbiology.whonet.count.organism": "Setelah filter organisme",
  "microbiology.whonet.count.origin": "Setelah filter asal",
  "microbiology.whonet.count.included": "Isolat yang termasuk di antaranya",
  "microbiology.whonet.count.deduplicated": "Setelah proses deduplikasi",
  "microbiology.whonet.count.mappable": "Isolat yang dapat dipetakan",
  "microbiology.whonet.count.rows": "Baris yang memenuhi syarat",
  "microbiology.whonet.count.excluded": "Baris yang dikecualikan",
  "microbiology.whonet.mapping.title": "Kesiapan pemetaan",
  "microbiology.whonet.mapping.excluded": "{count, plural, one {# row excluded} other {# rows excluded}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Perbaiki pemetaan organisme",
  "microbiology.whonet.mapping.fixAntibiotic": "Memperbaiki pemetaan antibiotik",
  "microbiology.whonet.mapping.fixSpecimen": "Memperbaiki pemetaan spesimen",
  "microbiology.whonet.table.title": "Baris AST yang memenuhi syarat",
  "microbiology.whonet.table.description": "Hasil pengukuran AST yang telah diperiksa dan layak untuk dilaporkan, beserta pemetaan yang wajib dilakukan oleh Ekspor ini.",
  "microbiology.whonet.table.accession": "No Registrasi",
  "microbiology.whonet.table.specimen": "Spesimen",
  "microbiology.whonet.table.organism": "Organisme",
  "microbiology.whonet.table.antibiotic": "Antibiotik",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Metode",
  "microbiology.whonet.error.title": "Ekspor WHONET tidak dapat diselesaikan",
  "microbiology.whonet.error.invalidRequest": "Periksa periode laporan dan opsi ekspor, lalu coba lagi.",
  "microbiology.whonet.error.blocked": "Tidak ada baris yang valid yang tersisa. Selesaikan masalah kesiapan yang tercantum sebelum membuat file CSV.",
  "microbiology.whonet.error.network": "Layanan ekspor tidak dapat diakses. Silakan coba lagi saat koneksi sudah tersedia.",
  "microbiology.whonet.error.generic": "Permintaan ekspor tidak dapat diselesaikan.",
  "microbiology.whonet.preview.loading": "Sedang menyiapkan pratinjau ekspor.",
  "microbiology.whonet.preview.announced": "Preview ready with {count, plural, one {# eligible row} other {# eligible rows}}.",
  "microbiology.whonet.generated.title": "CSV telah dibuat",
  "microbiology.whonet.generated.subtitle": "Ekspor yang telah diverifikasi telah diunduh dan ringkasan auditnya telah dicatat.",
  "catalog.import.title": "Import Catalog (CSV)",
  "catalog.import.description": "Load test catalog files without editing tests one at a time. Preview checks each file against the catalog as it stands and keeps nothing, so a row that needs a lab unit, specimen or test another file in the same upload creates is listed as skipped until you apply. Apply loads the files in order and saves them with the configuration, so the next restart loads exactly what you applied.",
  "catalog.import.dropzone": "Add CSV files",
  "catalog.import.preview": "Pratinjau",
  "catalog.import.apply": "Terapkan",
  "catalog.import.remove": "Hapus",
  "catalog.import.plan.title": "What these files would do",
  "catalog.import.result.title": "What was loaded",
  "catalog.import.column.file": "File",
  "catalog.import.column.domain": "Catalog area",
  "catalog.import.column.created": "Dibuat",
  "catalog.import.column.updated": "Terbarui",
  "catalog.import.column.skipped": "Skipped",
  "catalog.import.column.name": "Name in the file",
  "catalog.import.column.where": "Where it appeared",
  "catalog.import.column.use": "Use this record",
  "catalog.import.file.error": "This file could not be read",
  "catalog.import.applied": "The catalog files were applied.",
  "catalog.import.applied.partial": "Some catalog files were not loaded. The table says which, and why.",
  "catalog.import.apply.failed": "The catalog files were not applied.",
  "catalog.import.apply.hint": "Preview the files first. Apply opens once the preview shows no file errors.",
  "catalog.import.failed": "The catalog files could not be sent.",
  "catalog.import.unresolved.title": "Needs your decision",
  "catalog.import.unresolved.description": "Names the import could not match to a record. Point each one at the record it means, or skip it. Remembering a name resolves it by itself next time.",
  "catalog.import.unresolved.empty": "Nothing is waiting for a decision.",
  "catalog.import.remember": "Remember this name",
  "catalog.import.resolve": "Use",
  "catalog.import.skip": "Lewati",
  "sidenav.label.admin.catalogImport": "Import Catalog (CSV)",
  "reporting.design.subtitle": "Create a CSV for a new question or rerun a familiar report for a new period.",
  "reporting.design.overview": "Export overview",
  "reporting.design.newTitle": "Create a new export",
  "reporting.design.newHelp": "Choose the kind of report, the fields you need, and a reporting period. Your work remains available if you visit the queue or return later.",
  "reporting.design.savedTitle": "Use a saved report",
  "reporting.design.savedHelp": "Reuse saved fields and filters, then choose a fresh reporting period.",
  "reporting.design.start": "Start a new export",
  "reporting.design.continue": "Continue current export",
  "reporting.design.newExport": "New export",
  "reporting.design.useReport": "Use report",
  "reporting.design.savedFields": "{count} saved fields · reporting period is never saved",
  "reporting.design.steps": "Export steps",
  "reporting.design.chooseColumns": "Choose columns",
  "reporting.design.setFilters": "Set Filters",
  "reporting.design.reviewSubmit": "Review & Submit",
  "reporting.design.typeQuestion": "What kind of information do you need?",
  "reporting.design.typeHelp": "Choose one report type so every CSV row has a clear meaning. You can change the type until you select fields.",
  "reporting.design.type.SAMPLE_TESTING": "Sample & Testing",
  "reporting.design.type.REFERRALS": "Rujukan",
  "reporting.design.type.NON_CONFORMANCE": "Non-Conformance",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Orders, results, patients & turnaround times",
  "reporting.design.typeHelp.REFERRALS": "Tests referred to other labs · preserves returned results and pending referrals",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Rejected samples & non-conforming events · preserves linked specimens and separate occurrences",
  "reporting.design.pending": "Not yet connected",
  "reporting.design.building": "You’re building a {type} report.",
  "reporting.design.changeType": "Change type and clear fields",
  "reporting.design.chooseType": "Choose a report type to see its fields.",
  "reporting.design.configuredReports": "Configured reports",
  "reporting.design.chooseConfigured": "Choose a configured report",
  "reporting.design.available": "Available fields",
  "reporting.design.findField": "Find a field",
  "reporting.design.searchPlaceholder": "Search all fields and groups…",
  "reporting.design.clearSearch": "Clear search",
  "reporting.design.fieldCount": "{count} fields across {groups} groups",
  "reporting.design.matchCount": "{count} matching fields across {groups} groups",
  "reporting.design.expansion": "Expand or collapse field groups",
  "reporting.design.expandAll": "Expand all",
  "reporting.design.collapseAll": "Collapse all",
  "reporting.design.groupCount": "{added} / {total} added",
  "reporting.design.scrollCatalog": "Scrollable field catalog",
  "reporting.design.addShown": "Add all shown",
  "reporting.design.removeShown": "Remove shown",
  "reporting.design.addShownGroup": "Add all shown {group} fields",
  "reporting.design.removeShownGroup": "Remove all shown {group} fields",
  "reporting.design.addField": "Add {field}",
  "reporting.design.addedField": "Added {field}",
  "reporting.design.add": "+ Add",
  "reporting.design.added": "Added",
  "reporting.design.noFields": "No fields match your search.",
  "reporting.design.selectedCount": "Your CSV columns ({count})",
  "reporting.design.orderHelp": "Drag a handle to change column order, or use the arrows. Arrow keys move the focused handle; Home and End move it to the first or last position.",
  "reporting.design.columnOrder": "CSV columns in order",
  "reporting.design.drag": "Drag {field} to reorder",
  "reporting.design.move": "Move {field}",
  "reporting.design.emptyColumns": "Add fields to build your CSV.",
  "reporting.design.addedMessage": "{field} added. {count} columns.",
  "reporting.design.removedMessage": "{field} removed. {count} columns.",
  "reporting.design.columnViews": "Column builder views",
  "reporting.design.yourColumns": "Your columns ({count})",
  "reporting.design.csvPreview": "CSV preview",
  "reporting.design.previewHelp": "Column layout in the order it will appear in your downloaded CSV.",
  "reporting.design.scrollPreview": "Scrollable CSV preview",
  "reporting.design.nextFilters": "Next: Set Filters",
  "reporting.design.nextReview": "Next: Review & Submit",
  "reporting.design.scopeFilters": "Scope Filters (Optional)",
  "reporting.design.periodDays": "{count, plural, one {# day} other {# days}}",
  "reporting.design.moreFilters": "Show more filters",
  "reporting.design.hideFilters": "Hide more filters",
  "reporting.design.sampleStatus": "Sample Status",
  "reporting.design.referringSite": "Referring Site",
  "reporting.design.reviewConfiguration": "Review Configuration",
  "reporting.design.dateFilters": "Date Range and filters",
  "reporting.design.testStatus": "Test and status",
  "reporting.design.change": "Perubahan",
  "reporting.design.deliveryHelp": "Your CSV will be generated in the background. Download it here when ready, or return to My Report Queue.",
  "reporting.design.fileName": "Nama File",
  "reporting.design.customFileName": "Custom file name",
  "reporting.design.fileNamePending": "A file name is generated automatically. Custom names are not yet connected.",
  "reporting.design.saveLater": "Save these report settings for later",
  "reporting.design.saveSettings": "Save report settings",
  "reporting.design.queueHelp": "View and download your queued CSV exports.",
  "reporting.design.queue.jobName": "Job Name",
  "reporting.design.queue.report": "Laporan",
  "reporting.design.queue.size": "Rows / File Size",
  "reporting.design.queue.submitted": "Submitted At",
  "reporting.design.queuePending": "Active jobs refresh automatically. Retry failed exports, cancel queued work or rerun expired reports with fresh dates. Job deletion is not yet connected.",
  "reporting.design.details": "Rincian",
  "reporting.design.expires": "Available until {date}",
  "reporting.design.jobsShown": "Showing {count} jobs",
  "reporting.design.jobAction.EXPIRED": "Re-run",
  "reporting.design.labScope": "Lab Scope",
  "reporting.design.reviewFields": "Selected Fields ({count})",
  "reporting.recovery.cancelTitle": "Cancel export",
  "reporting.recovery.keepQueued": "Keep queued",
  "reporting.recovery.cancelHelp": "Cancel this queued export? If processing has already started, it will continue and you can return to its result.",
  "reporting.job.cannotCancel": "This export has already started or finished and cannot be cancelled.",
  "reporting.job.cannotRetry": "Only a failed export can be retried. Use the current job or start a new export.",
  "reporting.job.interrupted": "Processing was interrupted. Retry this export to generate a new file.",
  "reporting.job.claimLost": "This export is no longer assigned to the current worker. Return to the queue for its status.",
  "sidenav.section.main": "Main Menu",
  "sidenav.section.patientOrders": "Patient & Orders",
  "sidenav.section.administration": "Administrasi",
  "sidenav.workflow.orderTest": "Order Test",
  "sidenav.workflow.resultsValidation": "Results Validation",
  "sidenav.workflow.patientManagement": "Patient Management",
  "sidenav.moreTools": "More tools",
  "reporting.menu.otherReports": "Other reports",
  "reporting.menu.patientPrintQueue": "Patient Report Print Queue",
  "common.icon": "Icon",
  "menu.presentation.style": "Display as",
  "menu.presentation.item": "Menu item",
  "menu.presentation.section": "Section heading",
  "menu.configuration.managed": "Managed by instance configuration",
  "menu.configuration.description": "Update menu visibility, section headings and icons. Settings managed by this instance are read-only here.",
  "menu.configuration.loadError": "Menu settings could not be loaded.",
  "menu.configuration.saved": "Menu settings saved.",
  "menu.presentation.sectionHint": "Section headings group their child menu items without a link.",
  "menu.presentation.sectionIconHint": "Icons are shown on menu items, not section headings."
}
